! function() {
    "use strict";

    function a(b, d) {
        function e(a, b) {
            return function() {
                return a.apply(b, arguments)
            }
        }
        var f;
        if (d = d || {}, this.trackingClick = !1, this.trackingClickStart = 0, this.targetElement = null, this.touchStartX = 0, this.touchStartY = 0, this.lastTouchIdentifier = 0, this.touchBoundary = d.touchBoundary || 10, this.layer = b, this.tapDelay = d.tapDelay || 200, this.tapTimeout = d.tapTimeout || 700, !a.notNeeded(b)) {
            for (var g = ["onMouse", "onClick", "onTouchStart", "onTouchMove", "onTouchEnd", "onTouchCancel"], h = this, i = 0, j = g.length; i < j; i++) h[g[i]] = e(h[g[i]], h);
            c && (b.addEventListener("mouseover", this.onMouse, !0), b.addEventListener("mousedown", this.onMouse, !0), b.addEventListener("mouseup", this.onMouse, !0)), b.addEventListener("click", this.onClick, !0), b.addEventListener("touchstart", this.onTouchStart, !1), b.addEventListener("touchmove", this.onTouchMove, !1), b.addEventListener("touchend", this.onTouchEnd, !1), b.addEventListener("touchcancel", this.onTouchCancel, !1), Event.prototype.stopImmediatePropagation || (b.removeEventListener = function(a, c, d) {
                var e = Node.prototype.removeEventListener;
                "click" === a ? e.call(b, a, c.hijacked || c, d) : e.call(b, a, c, d)
            }, b.addEventListener = function(a, c, d) {
                var e = Node.prototype.addEventListener;
                "click" === a ? e.call(b, a, c.hijacked || (c.hijacked = function(a) {
                    a.propagationStopped || c(a)
                }), d) : e.call(b, a, c, d)
            }), "function" == typeof b.onclick && (f = b.onclick, b.addEventListener("click", function(a) {
                f(a)
            }, !1), b.onclick = null)
        }
    }
    var b = navigator.userAgent.indexOf("Windows Phone") >= 0,
        c = navigator.userAgent.indexOf("Android") > 0 && !b,
        d = /iP(ad|hone|od)/.test(navigator.userAgent) && !b,
        e = d && /OS 4_\d(_\d)?/.test(navigator.userAgent),
        f = d && /OS [6-7]_\d/.test(navigator.userAgent),
        g = navigator.userAgent.indexOf("BB10") > 0;
    a.prototype.needsClick = function(a) {
        switch (a.nodeName.toLowerCase()) {
            case "button":
            case "select":
            case "textarea":
                if (a.disabled) return !0;
                break;
            case "input":
                if (d && "file" === a.type || a.disabled) return !0;
                break;
            case "label":
            case "iframe":
            case "video":
                return !0
        }
        return /\bneedsclick\b/.test(a.className)
    }, a.prototype.needsFocus = function(a) {
        switch (a.nodeName.toLowerCase()) {
            case "textarea":
                return !0;
            case "select":
                return !c;
            case "input":
                switch (a.type) {
                    case "button":
                    case "checkbox":
                    case "file":
                    case "image":
                    case "radio":
                    case "submit":
                        return !1
                }
                return !a.disabled && !a.readOnly;
            default:
                return /\bneedsfocus\b/.test(a.className)
        }
    }, a.prototype.sendClick = function(a, b) {
        var c, d;
        document.activeElement && document.activeElement !== a && document.activeElement.blur(), d = b.changedTouches[0], c = document.createEvent("MouseEvents"), c.initMouseEvent(this.determineEventType(a), !0, !0, window, 1, d.screenX, d.screenY, d.clientX, d.clientY, !1, !1, !1, !1, 0, null), c.forwardedTouchEvent = !0, a.dispatchEvent(c)
    }, a.prototype.determineEventType = function(a) {
        return c && "select" === a.tagName.toLowerCase() ? "mousedown" : "click"
    }, a.prototype.focus = function(a) {
        var b;
        d && a.setSelectionRange && 0 !== a.type.indexOf("date") && "time" !== a.type && "month" !== a.type ? (b = a.value.length, a.setSelectionRange(b, b)) : a.focus()
    }, a.prototype.updateScrollParent = function(a) {
        var b, c;
        if (!(b = a.fastClickScrollParent) || !b.contains(a)) {
            c = a;
            do {
                if (c.scrollHeight > c.offsetHeight) {
                    b = c, a.fastClickScrollParent = c;
                    break
                }
                c = c.parentElement
            } while (c)
        }
        b && (b.fastClickLastScrollTop = b.scrollTop)
    }, a.prototype.getTargetElementFromEventTarget = function(a) {
        return a.nodeType === Node.TEXT_NODE ? a.parentNode : a
    }, a.prototype.onTouchStart = function(a) {
        var b, c, f;
        if (a.targetTouches.length > 1) return !0;
        if (b = this.getTargetElementFromEventTarget(a.target), c = a.targetTouches[0], d) {
            if (f = window.getSelection(), f.rangeCount && !f.isCollapsed) return !0;
            if (!e) {
                if (c.identifier && c.identifier === this.lastTouchIdentifier) return a.preventDefault(), !1;
                this.lastTouchIdentifier = c.identifier, this.updateScrollParent(b)
            }
        }
        return this.trackingClick = !0, this.trackingClickStart = a.timeStamp, this.targetElement = b, this.touchStartX = c.pageX, this.touchStartY = c.pageY, a.timeStamp - this.lastClickTime < this.tapDelay && a.preventDefault(), !0
    }, a.prototype.touchHasMoved = function(a) {
        var b = a.changedTouches[0],
            c = this.touchBoundary;
        return Math.abs(b.pageX - this.touchStartX) > c || Math.abs(b.pageY - this.touchStartY) > c
    }, a.prototype.onTouchMove = function(a) {
        return !this.trackingClick || ((this.targetElement !== this.getTargetElementFromEventTarget(a.target) || this.touchHasMoved(a)) && (this.trackingClick = !1, this.targetElement = null), !0)
    }, a.prototype.findControl = function(a) {
        return void 0 !== a.control ? a.control : a.htmlFor ? document.getElementById(a.htmlFor) : a.querySelector("button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea")
    }, a.prototype.onTouchEnd = function(a) {
        var b, g, h, i, j, k = this.targetElement;
        if (!this.trackingClick) return !0;
        if (a.timeStamp - this.lastClickTime < this.tapDelay) return this.cancelNextClick = !0, !0;
        if (a.timeStamp - this.trackingClickStart > this.tapTimeout) return !0;
        if (this.cancelNextClick = !1, this.lastClickTime = a.timeStamp, g = this.trackingClickStart, this.trackingClick = !1, this.trackingClickStart = 0, f && (j = a.changedTouches[0], k = document.elementFromPoint(j.pageX - window.pageXOffset, j.pageY - window.pageYOffset) || k, k.fastClickScrollParent = this.targetElement.fastClickScrollParent), "label" === (h = k.tagName.toLowerCase())) {
            if (b = this.findControl(k)) {
                if (this.focus(k), c) return !1;
                k = b
            }
        } else if (this.needsFocus(k)) return a.timeStamp - g > 100 || d && window.top !== window && "input" === h ? (this.targetElement = null, !1) : (this.focus(k), this.sendClick(k, a), d && "select" === h || (this.targetElement = null, a.preventDefault()), !1);
        return !(!d || e || !(i = k.fastClickScrollParent) || i.fastClickLastScrollTop === i.scrollTop) || (this.needsClick(k) || (a.preventDefault(), this.sendClick(k, a)), !1)
    }, a.prototype.onTouchCancel = function() {
        this.trackingClick = !1, this.targetElement = null
    }, a.prototype.onMouse = function(a) {
        return !this.targetElement || (!!a.forwardedTouchEvent || (!a.cancelable || (!(!this.needsClick(this.targetElement) || this.cancelNextClick) || (a.stopImmediatePropagation ? a.stopImmediatePropagation() : a.propagationStopped = !0, a.stopPropagation(), a.preventDefault(), !1))))
    }, a.prototype.onClick = function(a) {
        var b;
        return this.trackingClick ? (this.targetElement = null, this.trackingClick = !1, !0) : "submit" === a.target.type && 0 === a.detail || (b = this.onMouse(a), b || (this.targetElement = null), b)
    }, a.prototype.destroy = function() {
        var a = this.layer;
        c && (a.removeEventListener("mouseover", this.onMouse, !0), a.removeEventListener("mousedown", this.onMouse, !0), a.removeEventListener("mouseup", this.onMouse, !0)), a.removeEventListener("click", this.onClick, !0), a.removeEventListener("touchstart", this.onTouchStart, !1), a.removeEventListener("touchmove", this.onTouchMove, !1), a.removeEventListener("touchend", this.onTouchEnd, !1), a.removeEventListener("touchcancel", this.onTouchCancel, !1)
    }, a.notNeeded = function(a) {
        var b, d, e;
        if (void 0 === window.ontouchstart) return !0;
        if (d = +(/Chrome\/([0-9]+)/.exec(navigator.userAgent) || [, 0])[1]) {
            if (!c) return !0;
            if (b = document.querySelector("meta[name=viewport]")) {
                if (-1 !== b.content.indexOf("user-scalable=no")) return !0;
                if (d > 31 && document.documentElement.scrollWidth <= window.outerWidth) return !0
            }
        }
        if (g && (e = navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/), e[1] >= 10 && e[2] >= 3 && (b = document.querySelector("meta[name=viewport]")))) {
            if (-1 !== b.content.indexOf("user-scalable=no")) return !0;
            if (document.documentElement.scrollWidth <= window.outerWidth) return !0
        }
        return "none" === a.style.msTouchAction || "manipulation" === a.style.touchAction || (!!(+(/Firefox\/([0-9]+)/.exec(navigator.userAgent) || [, 0])[1] >= 27 && (b = document.querySelector("meta[name=viewport]")) && (-1 !== b.content.indexOf("user-scalable=no") || document.documentElement.scrollWidth <= window.outerWidth)) || ("none" === a.style.touchAction || "manipulation" === a.style.touchAction))
    }, a.attach = function(b, c) {
        return new a(b, c)
    }, "function" == typeof define && "object" == typeof define.amd && define.amd ? define(function() {
        return a
    }) : "undefined" != typeof module && module.exports ? (module.exports = a.attach, module.exports.FastClick = a) : window.FastClick = a
}(),
function(a) {
    "use strict";
    a.fn.fitVids = function(b) {
        var c = {
            customSelector: null
        };
        if (!document.getElementById("fit-vids-style")) {
            var d = document.head || document.getElementsByTagName("head")[0],
                e = document.createElement("div");
            e.innerHTML = '<p>x</p><style id="fit-vids-style">' + ".fluid-width-video-wrapper{width:100%;position:relative;padding:0;}.fluid-width-video-wrapper iframe,.fluid-width-video-wrapper object,.fluid-width-video-wrapper embed {position:absolute;top:0;left:0;width:100%;height:100%;}" + "</style>", d.appendChild(e.childNodes[1])
        }
        return b && a.extend(c, b), this.each(function() {
            var b = ["iframe[src*='player.vimeo.com']", "iframe[src*='youtube.com']", "iframe[src*='youtube-nocookie.com']", "iframe[src*='kickstarter.com'][src*='video.html']", "object", "embed"];
            c.customSelector && b.push(c.customSelector);
            var d = a(this).find(b.join(","));
            d = d.not("object object"), d.each(function() {
                var b = a(this);
                if (!("embed" === this.tagName.toLowerCase() && b.parent("object").length || b.parent(".fluid-width-video-wrapper").length)) {
                    var c = "object" === this.tagName.toLowerCase() || b.attr("height") && !isNaN(parseInt(b.attr("height"), 10)) ? parseInt(b.attr("height"), 10) : b.height(),
                        d = isNaN(parseInt(b.attr("width"), 10)) ? b.width() : parseInt(b.attr("width"), 10),
                        e = c / d;
                    if (!b.attr("id")) {
                        var f = "fitvid" + Math.floor(999999 * Math.random());
                        b.attr("id", f)
                    }
                    b.wrap('<div class="fluid-width-video-wrapper"></div>').parent(".fluid-width-video-wrapper").css("padding-top", 100 * e + "%"), b.removeAttr("height").removeAttr("width")
                }
            })
        })
    }
}(window.jQuery || window.Zepto),
function(a, b) {
    "function" == typeof define && define.amd ? define("jquery-bridget/jquery-bridget", ["jquery"], function(c) {
        return b(a, c)
    }) : "object" == typeof module && module.exports ? module.exports = b(a, require("jquery")) : a.jQueryBridget = b(a, a.jQuery)
}(window, function(a, b) {
    "use strict";

    function c(c, f, h) {
        function i(a, b, d) {
            var e, f = "$()." + c + '("' + b + '")';
            return a.each(function(a, i) {
                var j = h.data(i, c);
                if (!j) return void g(c + " not initialized. Cannot call methods, i.e. " + f);
                var k = j[b];
                if (!k || "_" == b.charAt(0)) return void g(f + " is not a valid method");
                var l = k.apply(j, d);
                e = void 0 === e ? l : e
            }), void 0 !== e ? e : a
        }

        function j(a, b) {
            a.each(function(a, d) {
                var e = h.data(d, c);
                e ? (e.option(b), e._init()) : (e = new f(d, b), h.data(d, c, e))
            })
        }(h = h || b || a.jQuery) && (f.prototype.option || (f.prototype.option = function(a) {
            h.isPlainObject(a) && (this.options = h.extend(!0, this.options, a))
        }), h.fn[c] = function(a) {
            if ("string" == typeof a) {
                return i(this, a, e.call(arguments, 1))
            }
            return j(this, a), this
        }, d(h))
    }

    function d(a) {
        !a || a && a.bridget || (a.bridget = c)
    }
    var e = Array.prototype.slice,
        f = a.console,
        g = void 0 === f ? function() {} : function(a) {
            f.error(a)
        };
    return d(b || a.jQuery), c
}),
function(a, b) {
    "function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", b) : "object" == typeof module && module.exports ? module.exports = b() : a.EvEmitter = b()
}("undefined" != typeof window ? window : this, function() {
    function a() {}
    var b = a.prototype;
    return b.on = function(a, b) {
        if (a && b) {
            var c = this._events = this._events || {},
                d = c[a] = c[a] || [];
            return -1 == d.indexOf(b) && d.push(b), this
        }
    }, b.once = function(a, b) {
        if (a && b) {
            this.on(a, b);
            var c = this._onceEvents = this._onceEvents || {};
            return (c[a] = c[a] || {})[b] = !0, this
        }
    }, b.off = function(a, b) {
        var c = this._events && this._events[a];
        if (c && c.length) {
            var d = c.indexOf(b);
            return -1 != d && c.splice(d, 1), this
        }
    }, b.emitEvent = function(a, b) {
        var c = this._events && this._events[a];
        if (c && c.length) {
            c = c.slice(0), b = b || [];
            for (var d = this._onceEvents && this._onceEvents[a], e = 0; e < c.length; e++) {
                var f = c[e];
                d && d[f] && (this.off(a, f), delete d[f]), f.apply(this, b)
            }
            return this
        }
    }, b.allOff = function() {
        delete this._events, delete this._onceEvents
    }, a
}),
function(a, b) {
    "function" == typeof define && define.amd ? define("get-size/get-size", b) : "object" == typeof module && module.exports ? module.exports = b() : a.getSize = b()
}(window, function() {
    "use strict";

    function a(a) {
        var b = parseFloat(a);
        return -1 == a.indexOf("%") && !isNaN(b) && b
    }

    function b() {}

    function c() {
        for (var a = {
                width: 0,
                height: 0,
                innerWidth: 0,
                innerHeight: 0,
                outerWidth: 0,
                outerHeight: 0
            }, b = 0; j > b; b++) {
            a[i[b]] = 0
        }
        return a
    }

    function d(a) {
        var b = getComputedStyle(a);
        return b || h("Style returned " + b + ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"), b
    }

    function e() {
        if (!k) {
            k = !0;
            var b = document.createElement("div");
            b.style.width = "200px", b.style.padding = "1px 2px 3px 4px", b.style.borderStyle = "solid", b.style.borderWidth = "1px 2px 3px 4px", b.style.boxSizing = "border-box";
            var c = document.body || document.documentElement;
            c.appendChild(b);
            var e = d(b);
            g = 200 == Math.round(a(e.width)), f.isBoxSizeOuter = g, c.removeChild(b)
        }
    }

    function f(b) {
        if (e(), "string" == typeof b && (b = document.querySelector(b)), b && "object" == typeof b && b.nodeType) {
            var f = d(b);
            if ("none" == f.display) return c();
            var h = {};
            h.width = b.offsetWidth, h.height = b.offsetHeight;
            for (var k = h.isBorderBox = "border-box" == f.boxSizing, l = 0; j > l; l++) {
                var m = i[l],
                    n = f[m],
                    o = parseFloat(n);
                h[m] = isNaN(o) ? 0 : o
            }
            var p = h.paddingLeft + h.paddingRight,
                q = h.paddingTop + h.paddingBottom,
                r = h.marginLeft + h.marginRight,
                s = h.marginTop + h.marginBottom,
                t = h.borderLeftWidth + h.borderRightWidth,
                u = h.borderTopWidth + h.borderBottomWidth,
                v = k && g,
                w = a(f.width);
            !1 !== w && (h.width = w + (v ? 0 : p + t));
            var x = a(f.height);
            return !1 !== x && (h.height = x + (v ? 0 : q + u)), h.innerWidth = h.width - (p + t), h.innerHeight = h.height - (q + u), h.outerWidth = h.width + r, h.outerHeight = h.height + s, h
        }
    }
    var g, h = "undefined" == typeof console ? b : function(a) {
            console.error(a)
        },
        i = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"],
        j = i.length,
        k = !1;
    return f
}),
function(a, b) {
    "use strict";
    "function" == typeof define && define.amd ? define("desandro-matches-selector/matches-selector", b) : "object" == typeof module && module.exports ? module.exports = b() : a.matchesSelector = b()
}(window, function() {
    "use strict";
    var a = function() {
        var a = window.Element.prototype;
        if (a.matches) return "matches";
        if (a.matchesSelector) return "matchesSelector";
        for (var b = ["webkit", "moz", "ms", "o"], c = 0; c < b.length; c++) {
            var d = b[c],
                e = d + "MatchesSelector";
            if (a[e]) return e
        }
    }();
    return function(b, c) {
        return b[a](c)
    }
}),
function(a, b) {
    "function" == typeof define && define.amd ? define("fizzy-ui-utils/utils", ["desandro-matches-selector/matches-selector"], function(c) {
        return b(a, c)
    }) : "object" == typeof module && module.exports ? module.exports = b(a, require("desandro-matches-selector")) : a.fizzyUIUtils = b(a, a.matchesSelector)
}(window, function(a, b) {
    var c = {};
    c.extend = function(a, b) {
        for (var c in b) a[c] = b[c];
        return a
    }, c.modulo = function(a, b) {
        return (a % b + b) % b
    };
    var d = Array.prototype.slice;
    c.makeArray = function(a) {
        return Array.isArray(a) ? a : null === a || void 0 === a ? [] : "object" == typeof a && "number" == typeof a.length ? d.call(a) : [a]
    }, c.removeFrom = function(a, b) {
        var c = a.indexOf(b); - 1 != c && a.splice(c, 1)
    }, c.getParent = function(a, c) {
        for (; a.parentNode && a != document.body;)
            if (a = a.parentNode, b(a, c)) return a
    }, c.getQueryElement = function(a) {
        return "string" == typeof a ? document.querySelector(a) : a
    }, c.handleEvent = function(a) {
        var b = "on" + a.type;
        this[b] && this[b](a)
    }, c.filterFindElements = function(a, d) {
        a = c.makeArray(a);
        var e = [];
        return a.forEach(function(a) {
            if (a instanceof HTMLElement) {
                if (!d) return void e.push(a);
                b(a, d) && e.push(a);
                for (var c = a.querySelectorAll(d), f = 0; f < c.length; f++) e.push(c[f])
            }
        }), e
    }, c.debounceMethod = function(a, b, c) {
        c = c || 100;
        var d = a.prototype[b],
            e = b + "Timeout";
        a.prototype[b] = function() {
            var a = this[e];
            clearTimeout(a);
            var b = arguments,
                f = this;
            this[e] = setTimeout(function() {
                d.apply(f, b), delete f[e]
            }, c)
        }
    }, c.docReady = function(a) {
        var b = document.readyState;
        "complete" == b || "interactive" == b ? setTimeout(a) : document.addEventListener("DOMContentLoaded", a)
    }, c.toDashed = function(a) {
        return a.replace(/(.)([A-Z])/g, function(a, b, c) {
            return b + "-" + c
        }).toLowerCase()
    };
    var e = a.console;
    return c.htmlInit = function(b, d) {
        c.docReady(function() {
            var f = c.toDashed(d),
                g = "data-" + f,
                h = document.querySelectorAll("[" + g + "]"),
                i = document.querySelectorAll(".js-" + f),
                j = c.makeArray(h).concat(c.makeArray(i)),
                k = g + "-options",
                l = a.jQuery;
            j.forEach(function(a) {
                var c, f = a.getAttribute(g) || a.getAttribute(k);
                try {
                    c = f && JSON.parse(f)
                } catch (b) {
                    return void(e && e.error("Error parsing " + g + " on " + a.className + ": " + b))
                }
                var h = new b(a, c);
                l && l.data(a, d, h)
            })
        })
    }, c
}),
function(a, b) {
    "function" == typeof define && define.amd ? define("outlayer/item", ["ev-emitter/ev-emitter", "get-size/get-size"], b) : "object" == typeof module && module.exports ? module.exports = b(require("ev-emitter"), require("get-size")) : (a.Outlayer = {}, a.Outlayer.Item = b(a.EvEmitter, a.getSize))
}(window, function(a, b) {
    "use strict";

    function c(a) {
        for (var b in a) return !1;
        return null, !0
    }

    function d(a, b) {
        a && (this.element = a, this.layout = b, this.position = {
            x: 0,
            y: 0
        }, this._create())
    }

    function e(a) {
        return a.replace(/([A-Z])/g, function(a) {
            return "-" + a.toLowerCase()
        })
    }
    var f = document.documentElement.style,
        g = "string" == typeof f.transition ? "transition" : "WebkitTransition",
        h = "string" == typeof f.transform ? "transform" : "WebkitTransform",
        i = {
            WebkitTransition: "webkitTransitionEnd",
            transition: "transitionend"
        } [g],
        j = {
            transform: h,
            transition: g,
            transitionDuration: g + "Duration",
            transitionProperty: g + "Property",
            transitionDelay: g + "Delay"
        },
        k = d.prototype = Object.create(a.prototype);
    k.constructor = d, k._create = function() {
        this._transn = {
            ingProperties: {},
            clean: {},
            onEnd: {}
        }, this.css({
            position: "absolute"
        })
    }, k.handleEvent = function(a) {
        var b = "on" + a.type;
        this[b] && this[b](a)
    }, k.getSize = function() {
        this.size = b(this.element)
    }, k.css = function(a) {
        var b = this.element.style;
        for (var c in a) {
            b[j[c] || c] = a[c]
        }
    }, k.getPosition = function() {
        var a = getComputedStyle(this.element),
            b = this.layout._getOption("originLeft"),
            c = this.layout._getOption("originTop"),
            d = a[b ? "left" : "right"],
            e = a[c ? "top" : "bottom"],
            f = parseFloat(d),
            g = parseFloat(e),
            h = this.layout.size; - 1 != d.indexOf("%") && (f = f / 100 * h.width), -1 != e.indexOf("%") && (g = g / 100 * h.height), f = isNaN(f) ? 0 : f, g = isNaN(g) ? 0 : g, f -= b ? h.paddingLeft : h.paddingRight, g -= c ? h.paddingTop : h.paddingBottom, this.position.x = f, this.position.y = g
    }, k.layoutPosition = function() {
        var a = this.layout.size,
            b = {},
            c = this.layout._getOption("originLeft"),
            d = this.layout._getOption("originTop"),
            e = c ? "paddingLeft" : "paddingRight",
            f = c ? "left" : "right",
            g = c ? "right" : "left",
            h = this.position.x + a[e];
        b[f] = this.getXValue(h), b[g] = "";
        var i = d ? "paddingTop" : "paddingBottom",
            j = d ? "top" : "bottom",
            k = d ? "bottom" : "top",
            l = this.position.y + a[i];
        b[j] = this.getYValue(l), b[k] = "", this.css(b), this.emitEvent("layout", [this])
    }, k.getXValue = function(a) {
        var b = this.layout._getOption("horizontal");
        return this.layout.options.percentPosition && !b ? a / this.layout.size.width * 100 + "%" : a + "px"
    }, k.getYValue = function(a) {
        var b = this.layout._getOption("horizontal");
        return this.layout.options.percentPosition && b ? a / this.layout.size.height * 100 + "%" : a + "px"
    }, k._transitionTo = function(a, b) {
        this.getPosition();
        var c = this.position.x,
            d = this.position.y,
            e = a == this.position.x && b == this.position.y;
        if (this.setPosition(a, b), e && !this.isTransitioning) return void this.layoutPosition();
        var f = a - c,
            g = b - d,
            h = {};
        h.transform = this.getTranslate(f, g), this.transition({
            to: h,
            onTransitionEnd: {
                transform: this.layoutPosition
            },
            isCleaning: !0
        })
    }, k.getTranslate = function(a, b) {
        var c = this.layout._getOption("originLeft"),
            d = this.layout._getOption("originTop");
        return a = c ? a : -a, b = d ? b : -b, "translate3d(" + a + "px, " + b + "px, 0)"
    }, k.goTo = function(a, b) {
        this.setPosition(a, b), this.layoutPosition()
    }, k.moveTo = k._transitionTo, k.setPosition = function(a, b) {
        this.position.x = parseFloat(a), this.position.y = parseFloat(b)
    }, k._nonTransition = function(a) {
        this.css(a.to), a.isCleaning && this._removeStyles(a.to);
        for (var b in a.onTransitionEnd) a.onTransitionEnd[b].call(this)
    }, k.transition = function(a) {
        if (!parseFloat(this.layout.options.transitionDuration)) return void this._nonTransition(a);
        var b = this._transn;
        for (var c in a.onTransitionEnd) b.onEnd[c] = a.onTransitionEnd[c];
        for (c in a.to) b.ingProperties[c] = !0, a.isCleaning && (b.clean[c] = !0);
        if (a.from) {
            this.css(a.from);
            this.element.offsetHeight;
            null
        }
        this.enableTransition(a.to), this.css(a.to), this.isTransitioning = !0
    };
    var l = "opacity," + e(h);
    k.enableTransition = function() {
        if (!this.isTransitioning) {
            var a = this.layout.options.transitionDuration;
            a = "number" == typeof a ? a + "ms" : a, this.css({
                transitionProperty: l,
                transitionDuration: a,
                transitionDelay: this.staggerDelay || 0
            }), this.element.addEventListener(i, this, !1)
        }
    }, k.onwebkitTransitionEnd = function(a) {
        this.ontransitionend(a)
    }, k.onotransitionend = function(a) {
        this.ontransitionend(a)
    };
    var m = {
        "-webkit-transform": "transform"
    };
    k.ontransitionend = function(a) {
        if (a.target === this.element) {
            var b = this._transn,
                d = m[a.propertyName] || a.propertyName;
            if (delete b.ingProperties[d], c(b.ingProperties) && this.disableTransition(), d in b.clean && (this.element.style[a.propertyName] = "", delete b.clean[d]), d in b.onEnd) {
                b.onEnd[d].call(this), delete b.onEnd[d]
            }
            this.emitEvent("transitionEnd", [this])
        }
    }, k.disableTransition = function() {
        this.removeTransitionStyles(), this.element.removeEventListener(i, this, !1), this.isTransitioning = !1
    }, k._removeStyles = function(a) {
        var b = {};
        for (var c in a) b[c] = "";
        this.css(b)
    };
    var n = {
        transitionProperty: "",
        transitionDuration: "",
        transitionDelay: ""
    };
    return k.removeTransitionStyles = function() {
        this.css(n)
    }, k.stagger = function(a) {
        a = isNaN(a) ? 0 : a, this.staggerDelay = a + "ms"
    }, k.removeElem = function() {
        this.element.parentNode.removeChild(this.element), this.css({
            display: ""
        }), this.emitEvent("remove", [this])
    }, k.remove = function() {
        return g && parseFloat(this.layout.options.transitionDuration) ? (this.once("transitionEnd", function() {
            this.removeElem()
        }), void this.hide()) : void this.removeElem()
    }, k.reveal = function() {
        delete this.isHidden, this.css({
            display: ""
        });
        var a = this.layout.options,
            b = {};
        b[this.getHideRevealTransitionEndProperty("visibleStyle")] = this.onRevealTransitionEnd, this.transition({
            from: a.hiddenStyle,
            to: a.visibleStyle,
            isCleaning: !0,
            onTransitionEnd: b
        })
    }, k.onRevealTransitionEnd = function() {
        this.isHidden || this.emitEvent("reveal")
    }, k.getHideRevealTransitionEndProperty = function(a) {
        var b = this.layout.options[a];
        if (b.opacity) return "opacity";
        for (var c in b) return c
    }, k.hide = function() {
        this.isHidden = !0, this.css({
            display: ""
        });
        var a = this.layout.options,
            b = {};
        b[this.getHideRevealTransitionEndProperty("hiddenStyle")] = this.onHideTransitionEnd, this.transition({
            from: a.visibleStyle,
            to: a.hiddenStyle,
            isCleaning: !0,
            onTransitionEnd: b
        })
    }, k.onHideTransitionEnd = function() {
        this.isHidden && (this.css({
            display: "none"
        }), this.emitEvent("hide"))
    }, k.destroy = function() {
        this.css({
            position: "",
            left: "",
            right: "",
            top: "",
            bottom: "",
            transition: "",
            transform: ""
        })
    }, d
}),
function(a, b) {
    "use strict";
    "function" == typeof define && define.amd ? define("outlayer/outlayer", ["ev-emitter/ev-emitter", "get-size/get-size", "fizzy-ui-utils/utils", "./item"], function(c, d, e, f) {
        return b(a, c, d, e, f)
    }) : "object" == typeof module && module.exports ? module.exports = b(a, require("ev-emitter"), require("get-size"), require("fizzy-ui-utils"), require("./item")) : a.Outlayer = b(a, a.EvEmitter, a.getSize, a.fizzyUIUtils, a.Outlayer.Item)
}(window, function(a, b, c, d, e) {
    "use strict";

    function f(a, b) {
        var c = d.getQueryElement(a);
        if (!c) return void(i && i.error("Bad element for " + this.constructor.namespace + ": " + (c || a)));
        this.element = c, j && (this.$element = j(this.element)), this.options = d.extend({}, this.constructor.defaults), this.option(b);
        var e = ++l;
        this.element.outlayerGUID = e, m[e] = this, this._create(), this._getOption("initLayout") && this.layout()
    }

    function g(a) {
        function b() {
            a.apply(this, arguments)
        }
        return b.prototype = Object.create(a.prototype), b.prototype.constructor = b, b
    }

    function h(a) {
        if ("number" == typeof a) return a;
        var b = a.match(/(^\d*\.?\d*)(\w*)/),
            c = b && b[1],
            d = b && b[2];
        return c.length ? (c = parseFloat(c)) * (o[d] || 1) : 0
    }
    var i = a.console,
        j = a.jQuery,
        k = function() {},
        l = 0,
        m = {};
    f.namespace = "outlayer", f.Item = e, f.defaults = {
        containerStyle: {
            position: "relative"
        },
        initLayout: !0,
        originLeft: !0,
        originTop: !0,
        resize: !0,
        resizeContainer: !0,
        transitionDuration: "0.4s",
        hiddenStyle: {
            opacity: 0,
            transform: "scale(0.001)"
        },
        visibleStyle: {
            opacity: 1,
            transform: "scale(1)"
        }
    };
    var n = f.prototype;
    d.extend(n, b.prototype), n.option = function(a) {
        d.extend(this.options, a)
    }, n._getOption = function(a) {
        var b = this.constructor.compatOptions[a];
        return b && void 0 !== this.options[b] ? this.options[b] : this.options[a]
    }, f.compatOptions = {
        initLayout: "isInitLayout",
        horizontal: "isHorizontal",
        layoutInstant: "isLayoutInstant",
        originLeft: "isOriginLeft",
        originTop: "isOriginTop",
        resize: "isResizeBound",
        resizeContainer: "isResizingContainer"
    }, n._create = function() {
        this.reloadItems(), this.stamps = [], this.stamp(this.options.stamp), d.extend(this.element.style, this.options.containerStyle), this._getOption("resize") && this.bindResize()
    }, n.reloadItems = function() {
        this.items = this._itemize(this.element.children)
    }, n._itemize = function(a) {
        for (var b = this._filterFindItemElements(a), c = this.constructor.Item, d = [], e = 0; e < b.length; e++) {
            var f = b[e],
                g = new c(f, this);
            d.push(g)
        }
        return d
    }, n._filterFindItemElements = function(a) {
        return d.filterFindElements(a, this.options.itemSelector)
    }, n.getItemElements = function() {
        return this.items.map(function(a) {
            return a.element
        })
    }, n.layout = function() {
        this._resetLayout(), this._manageStamps();
        var a = this._getOption("layoutInstant"),
            b = void 0 !== a ? a : !this._isLayoutInited;
        this.layoutItems(this.items, b), this._isLayoutInited = !0
    }, n._init = n.layout, n._resetLayout = function() {
        this.getSize()
    }, n.getSize = function() {
        this.size = c(this.element)
    }, n._getMeasurement = function(a, b) {
        var d, e = this.options[a];
        e ? ("string" == typeof e ? d = this.element.querySelector(e) : e instanceof HTMLElement && (d = e), this[a] = d ? c(d)[b] : e) : this[a] = 0
    }, n.layoutItems = function(a, b) {
        a = this._getItemsForLayout(a), this._layoutItems(a, b), this._postLayout()
    }, n._getItemsForLayout = function(a) {
        return a.filter(function(a) {
            return !a.isIgnored
        })
    }, n._layoutItems = function(a, b) {
        if (this._emitCompleteOnItems("layout", a), a && a.length) {
            var c = [];
            a.forEach(function(a) {
                var d = this._getItemLayoutPosition(a);
                d.item = a, d.isInstant = b || a.isLayoutInstant, c.push(d)
            }, this), this._processLayoutQueue(c)
        }
    }, n._getItemLayoutPosition = function() {
        return {
            x: 0,
            y: 0
        }
    }, n._processLayoutQueue = function(a) {
        this.updateStagger(), a.forEach(function(a, b) {
            this._positionItem(a.item, a.x, a.y, a.isInstant, b)
        }, this)
    }, n.updateStagger = function() {
        var a = this.options.stagger;
        return null === a || void 0 === a ? void(this.stagger = 0) : (this.stagger = h(a), this.stagger)
    }, n._positionItem = function(a, b, c, d, e) {
        d ? a.goTo(b, c) : (a.stagger(e * this.stagger), a.moveTo(b, c))
    }, n._postLayout = function() {
        this.resizeContainer()
    }, n.resizeContainer = function() {
        if (this._getOption("resizeContainer")) {
            var a = this._getContainerSize();
            a && (this._setContainerMeasure(a.width, !0), this._setContainerMeasure(a.height, !1))
        }
    }, n._getContainerSize = k, n._setContainerMeasure = function(a, b) {
        if (void 0 !== a) {
            var c = this.size;
            c.isBorderBox && (a += b ? c.paddingLeft + c.paddingRight + c.borderLeftWidth + c.borderRightWidth : c.paddingBottom + c.paddingTop + c.borderTopWidth + c.borderBottomWidth), a = Math.max(a, 0), this.element.style[b ? "width" : "height"] = a + "px"
        }
    }, n._emitCompleteOnItems = function(a, b) {
        function c() {
            e.dispatchEvent(a + "Complete", null, [b])
        }

        function d() {
            ++g == f && c()
        }
        var e = this,
            f = b.length;
        if (!b || !f) return void c();
        var g = 0;
        b.forEach(function(b) {
            b.once(a, d)
        })
    }, n.dispatchEvent = function(a, b, c) {
        var d = b ? [b].concat(c) : c;
        if (this.emitEvent(a, d), j)
            if (this.$element = this.$element || j(this.element), b) {
                var e = j.Event(b);
                e.type = a, this.$element.trigger(e, c)
            } else this.$element.trigger(a, c)
    }, n.ignore = function(a) {
        var b = this.getItem(a);
        b && (b.isIgnored = !0)
    }, n.unignore = function(a) {
        var b = this.getItem(a);
        b && delete b.isIgnored
    }, n.stamp = function(a) {
        (a = this._find(a)) && (this.stamps = this.stamps.concat(a), a.forEach(this.ignore, this))
    }, n.unstamp = function(a) {
        (a = this._find(a)) && a.forEach(function(a) {
            d.removeFrom(this.stamps, a), this.unignore(a)
        }, this)
    }, n._find = function(a) {
        return a ? ("string" == typeof a && (a = this.element.querySelectorAll(a)), a = d.makeArray(a)) : void 0
    }, n._manageStamps = function() {
        this.stamps && this.stamps.length && (this._getBoundingRect(), this.stamps.forEach(this._manageStamp, this))
    }, n._getBoundingRect = function() {
        var a = this.element.getBoundingClientRect(),
            b = this.size;
        this._boundingRect = {
            left: a.left + b.paddingLeft + b.borderLeftWidth,
            top: a.top + b.paddingTop + b.borderTopWidth,
            right: a.right - (b.paddingRight + b.borderRightWidth),
            bottom: a.bottom - (b.paddingBottom + b.borderBottomWidth)
        }
    }, n._manageStamp = k, n._getElementOffset = function(a) {
        var b = a.getBoundingClientRect(),
            d = this._boundingRect,
            e = c(a);
        return {
            left: b.left - d.left - e.marginLeft,
            top: b.top - d.top - e.marginTop,
            right: d.right - b.right - e.marginRight,
            bottom: d.bottom - b.bottom - e.marginBottom
        }
    }, n.handleEvent = d.handleEvent, n.bindResize = function() {
        a.addEventListener("resize", this), this.isResizeBound = !0
    }, n.unbindResize = function() {
        a.removeEventListener("resize", this), this.isResizeBound = !1
    }, n.onresize = function() {
        this.resize()
    }, d.debounceMethod(f, "onresize", 100), n.resize = function() {
        this.isResizeBound && this.needsResizeLayout() && this.layout()
    }, n.needsResizeLayout = function() {
        var a = c(this.element);
        return this.size && a && a.innerWidth !== this.size.innerWidth
    }, n.addItems = function(a) {
        var b = this._itemize(a);
        return b.length && (this.items = this.items.concat(b)), b
    }, n.appended = function(a) {
        var b = this.addItems(a);
        b.length && (this.layoutItems(b, !0), this.reveal(b))
    }, n.prepended = function(a) {
        var b = this._itemize(a);
        if (b.length) {
            var c = this.items.slice(0);
            this.items = b.concat(c), this._resetLayout(), this._manageStamps(), this.layoutItems(b, !0), this.reveal(b), this.layoutItems(c)
        }
    }, n.reveal = function(a) {
        if (this._emitCompleteOnItems("reveal", a), a && a.length) {
            var b = this.updateStagger();
            a.forEach(function(a, c) {
                a.stagger(c * b), a.reveal()
            })
        }
    }, n.hide = function(a) {
        if (this._emitCompleteOnItems("hide", a), a && a.length) {
            var b = this.updateStagger();
            a.forEach(function(a, c) {
                a.stagger(c * b), a.hide()
            })
        }
    }, n.revealItemElements = function(a) {
        var b = this.getItems(a);
        this.reveal(b)
    }, n.hideItemElements = function(a) {
        var b = this.getItems(a);
        this.hide(b)
    }, n.getItem = function(a) {
        for (var b = 0; b < this.items.length; b++) {
            var c = this.items[b];
            if (c.element == a) return c
        }
    }, n.getItems = function(a) {
        a = d.makeArray(a);
        var b = [];
        return a.forEach(function(a) {
            var c = this.getItem(a);
            c && b.push(c)
        }, this), b
    }, n.remove = function(a) {
        var b = this.getItems(a);
        this._emitCompleteOnItems("remove", b), b && b.length && b.forEach(function(a) {
            a.remove(), d.removeFrom(this.items, a)
        }, this)
    }, n.destroy = function() {
        var a = this.element.style;
        a.height = "", a.position = "", a.width = "", this.items.forEach(function(a) {
            a.destroy()
        }), this.unbindResize();
        var b = this.element.outlayerGUID;
        delete m[b], delete this.element.outlayerGUID, j && j.removeData(this.element, this.constructor.namespace)
    }, f.data = function(a) {
        a = d.getQueryElement(a);
        var b = a && a.outlayerGUID;
        return b && m[b]
    }, f.create = function(a, b) {
        var c = g(f);
        return c.defaults = d.extend({}, f.defaults), d.extend(c.defaults, b), c.compatOptions = d.extend({}, f.compatOptions), c.namespace = a, c.data = f.data, c.Item = g(e), d.htmlInit(c, a), j && j.bridget && j.bridget(a, c), c
    };
    var o = {
        ms: 1,
        s: 1e3
    };
    return f.Item = e, f
}),
function(a, b) {
    "function" == typeof define && define.amd ? define(["outlayer/outlayer", "get-size/get-size"], b) : "object" == typeof module && module.exports ? module.exports = b(require("outlayer"), require("get-size")) : a.Masonry = b(a.Outlayer, a.getSize)
}(window, function(a, b) {
    var c = a.create("masonry");
    c.compatOptions.fitWidth = "isFitWidth";
    var d = c.prototype;
    return d._resetLayout = function() {
        this.getSize(), this._getMeasurement("columnWidth", "outerWidth"), this._getMeasurement("gutter", "outerWidth"), this.measureColumns(), this.colYs = [];
        for (var a = 0; a < this.cols; a++) this.colYs.push(0);
        this.maxY = 0, this.horizontalColIndex = 0
    }, d.measureColumns = function() {
        if (this.getContainerWidth(), !this.columnWidth) {
            var a = this.items[0],
                c = a && a.element;
            this.columnWidth = c && b(c).outerWidth || this.containerWidth
        }
        var d = this.columnWidth += this.gutter,
            e = this.containerWidth + this.gutter,
            f = e / d,
            g = d - e % d,
            h = g && 1 > g ? "round" : "floor";
        f = Math[h](f), this.cols = Math.max(f, 1)
    }, d.getContainerWidth = function() {
        var a = this._getOption("fitWidth"),
            c = a ? this.element.parentNode : this.element,
            d = b(c);
        this.containerWidth = d && d.innerWidth
    }, d._getItemLayoutPosition = function(a) {
        a.getSize();
        var b = a.size.outerWidth % this.columnWidth,
            c = b && 1 > b ? "round" : "ceil",
            d = Math[c](a.size.outerWidth / this.columnWidth);
        d = Math.min(d, this.cols);
        for (var e = this.options.horizontalOrder ? "_getHorizontalColPosition" : "_getTopColPosition", f = this[e](d, a), g = {
                x: this.columnWidth * f.col,
                y: f.y
            }, h = f.y + a.size.outerHeight, i = d + f.col, j = f.col; i > j; j++) this.colYs[j] = h;
        return g
    }, d._getTopColPosition = function(a) {
        var b = this._getTopColGroup(a),
            c = Math.min.apply(Math, b);
        return {
            col: b.indexOf(c),
            y: c
        }
    }, d._getTopColGroup = function(a) {
        if (2 > a) return this.colYs;
        for (var b = [], c = this.cols + 1 - a, d = 0; c > d; d++) b[d] = this._getColGroupY(d, a);
        return b
    }, d._getColGroupY = function(a, b) {
        if (2 > b) return this.colYs[a];
        var c = this.colYs.slice(a, a + b);
        return Math.max.apply(Math, c)
    }, d._getHorizontalColPosition = function(a, b) {
        var c = this.horizontalColIndex % this.cols;
        c = a > 1 && c + a > this.cols ? 0 : c;
        var d = b.size.outerWidth && b.size.outerHeight;
        return this.horizontalColIndex = d ? c + a : this.horizontalColIndex, {
            col: c,
            y: this._getColGroupY(c, a)
        }
    }, d._manageStamp = function(a) {
        var c = b(a),
            d = this._getElementOffset(a),
            e = this._getOption("originLeft"),
            f = e ? d.left : d.right,
            g = f + c.outerWidth,
            h = Math.floor(f / this.columnWidth);
        h = Math.max(0, h);
        var i = Math.floor(g / this.columnWidth);
        i -= g % this.columnWidth ? 0 : 1, i = Math.min(this.cols - 1, i);
        for (var j = this._getOption("originTop"), k = (j ? d.top : d.bottom) + c.outerHeight, l = h; i >= l; l++) this.colYs[l] = Math.max(k, this.colYs[l])
    }, d._getContainerSize = function() {
        this.maxY = Math.max.apply(Math, this.colYs);
        var a = {
            height: this.maxY
        };
        return this._getOption("fitWidth") && (a.width = this._getContainerFitWidth()), a
    }, d._getContainerFitWidth = function() {
        for (var a = 0, b = this.cols; --b && 0 === this.colYs[b];) a++;
        return (this.cols - a) * this.columnWidth - this.gutter
    }, d.needsResizeLayout = function() {
        var a = this.containerWidth;
        return this.getContainerWidth(), a != this.containerWidth
    }, c
}),
function(a, b) {
    "function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", b) : "object" == typeof module && module.exports ? module.exports = b() : a.EvEmitter = b()
}("undefined" != typeof window ? window : this, function() {
    function a() {}
    var b = a.prototype;
    return b.on = function(a, b) {
        if (a && b) {
            var c = this._events = this._events || {},
                d = c[a] = c[a] || [];
            return -1 == d.indexOf(b) && d.push(b), this
        }
    }, b.once = function(a, b) {
        if (a && b) {
            this.on(a, b);
            var c = this._onceEvents = this._onceEvents || {};
            return (c[a] = c[a] || {})[b] = !0, this
        }
    }, b.off = function(a, b) {
        var c = this._events && this._events[a];
        if (c && c.length) {
            var d = c.indexOf(b);
            return -1 != d && c.splice(d, 1), this
        }
    }, b.emitEvent = function(a, b) {
        var c = this._events && this._events[a];
        if (c && c.length) {
            c = c.slice(0), b = b || [];
            for (var d = this._onceEvents && this._onceEvents[a], e = 0; e < c.length; e++) {
                var f = c[e];
                d && d[f] && (this.off(a, f), delete d[f]), f.apply(this, b)
            }
            return this
        }
    }, b.allOff = function() {
        delete this._events, delete this._onceEvents
    }, a
}),
function(a, b) {
    "use strict";
    "function" == typeof define && define.amd ? define(["ev-emitter/ev-emitter"], function(c) {
        return b(a, c)
    }) : "object" == typeof module && module.exports ? module.exports = b(a, require("ev-emitter")) : a.imagesLoaded = b(a, a.EvEmitter)
}("undefined" != typeof window ? window : this, function(a, b) {
    function c(a, b) {
        for (var c in b) a[c] = b[c];
        return a
    }

    function d(a) {
        return Array.isArray(a) ? a : "object" == typeof a && "number" == typeof a.length ? j.call(a) : [a]
    }

    function e(a, b, f) {
        if (!(this instanceof e)) return new e(a, b, f);
        var g = a;
        return "string" == typeof a && (g = document.querySelectorAll(a)), g ? (this.elements = d(g), this.options = c({}, this.options), "function" == typeof b ? f = b : c(this.options, b), f && this.on("always", f), this.getImages(), h && (this.jqDeferred = new h.Deferred), void setTimeout(this.check.bind(this))) : void i.error("Bad element for imagesLoaded " + (g || a))
    }

    function f(a) {
        this.img = a
    }

    function g(a, b) {
        this.url = a, this.element = b, this.img = new Image
    }
    var h = a.jQuery,
        i = a.console,
        j = Array.prototype.slice;
    e.prototype = Object.create(b.prototype), e.prototype.options = {}, e.prototype.getImages = function() {
        this.images = [], this.elements.forEach(this.addElementImages, this)
    }, e.prototype.addElementImages = function(a) {
        "IMG" == a.nodeName && this.addImage(a), !0 === this.options.background && this.addElementBackgroundImages(a);
        var b = a.nodeType;
        if (b && k[b]) {
            for (var c = a.querySelectorAll("img"), d = 0; d < c.length; d++) {
                var e = c[d];
                this.addImage(e)
            }
            if ("string" == typeof this.options.background) {
                var f = a.querySelectorAll(this.options.background);
                for (d = 0; d < f.length; d++) {
                    var g = f[d];
                    this.addElementBackgroundImages(g)
                }
            }
        }
    };
    var k = {
        1: !0,
        9: !0,
        11: !0
    };
    return e.prototype.addElementBackgroundImages = function(a) {
        var b = getComputedStyle(a);
        if (b)
            for (var c = /url\((['"])?(.*?)\1\)/gi, d = c.exec(b.backgroundImage); null !== d;) {
                var e = d && d[2];
                e && this.addBackground(e, a), d = c.exec(b.backgroundImage)
            }
    }, e.prototype.addImage = function(a) {
        var b = new f(a);
        this.images.push(b)
    }, e.prototype.addBackground = function(a, b) {
        var c = new g(a, b);
        this.images.push(c)
    }, e.prototype.check = function() {
        function a(a, c, d) {
            setTimeout(function() {
                b.progress(a, c, d)
            })
        }
        var b = this;
        return this.progressedCount = 0, this.hasAnyBroken = !1, this.images.length ? void this.images.forEach(function(b) {
            b.once("progress", a), b.check()
        }) : void this.complete()
    }, e.prototype.progress = function(a, b, c) {
        this.progressedCount++, this.hasAnyBroken = this.hasAnyBroken || !a.isLoaded, this.emitEvent("progress", [this, a, b]), this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, a), this.progressedCount == this.images.length && this.complete(), this.options.debug && i && i.log("progress: " + c, a, b)
    }, e.prototype.complete = function() {
        var a = this.hasAnyBroken ? "fail" : "done";
        if (this.isComplete = !0, this.emitEvent(a, [this]), this.emitEvent("always", [this]), this.jqDeferred) {
            var b = this.hasAnyBroken ? "reject" : "resolve";
            this.jqDeferred[b](this)
        }
    }, f.prototype = Object.create(b.prototype), f.prototype.check = function() {
        return this.getIsImageComplete() ? void this.confirm(0 !== this.img.naturalWidth, "naturalWidth") : (this.proxyImage = new Image, this.proxyImage.addEventListener("load", this), this.proxyImage.addEventListener("error", this), this.img.addEventListener("load", this), this.img.addEventListener("error", this), void(this.proxyImage.src = this.img.src))
    }, f.prototype.getIsImageComplete = function() {
        return this.img.complete && this.img.naturalWidth
    }, f.prototype.confirm = function(a, b) {
        this.isLoaded = a, this.emitEvent("progress", [this, this.img, b])
    }, f.prototype.handleEvent = function(a) {
        var b = "on" + a.type;
        this[b] && this[b](a)
    }, f.prototype.onload = function() {
        this.confirm(!0, "onload"), this.unbindEvents()
    }, f.prototype.onerror = function() {
        this.confirm(!1, "onerror"), this.unbindEvents()
    }, f.prototype.unbindEvents = function() {
        this.proxyImage.removeEventListener("load", this), this.proxyImage.removeEventListener("error", this), this.img.removeEventListener("load", this), this.img.removeEventListener("error", this)
    }, g.prototype = Object.create(f.prototype), g.prototype.check = function() {
        this.img.addEventListener("load", this), this.img.addEventListener("error", this), this.img.src = this.url, this.getIsImageComplete() && (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"), this.unbindEvents())
    }, g.prototype.unbindEvents = function() {
        this.img.removeEventListener("load", this), this.img.removeEventListener("error", this)
    }, g.prototype.confirm = function(a, b) {
        this.isLoaded = a, this.emitEvent("progress", [this, this.element, b])
    }, e.makeJQueryPlugin = function(b) {
        (b = b || a.jQuery) && (h = b, h.fn.imagesLoaded = function(a, b) {
            return new e(this, a, b).jqDeferred.promise(h(this))
        })
    }, e.makeJQueryPlugin(), e
}),
function(a) {
    a.isScrollToFixed = function(b) {
        return !!a(b).data("ScrollToFixed")
    }, a.ScrollToFixed = function(b, c) {
        function d() {
            x.trigger("preUnfixed.ScrollToFixed"), k(), x.trigger("unfixed.ScrollToFixed"), B = -1, y = x.offset().top, z = x.offset().left, q.options.offsets && (z += x.offset().left - x.position().left), -1 == A && (A = z), r = x.css("position"), w = !0, -1 != q.options.bottom && (x.trigger("preFixed.ScrollToFixed"), i(), x.trigger("fixed.ScrollToFixed"))
        }

        function e() {
            var a = q.options.limit;
            return a ? "function" == typeof a ? a.apply(x) : a : 0
        }

        function f() {
            return "fixed" === r
        }

        function g() {
            return "absolute" === r
        }

        function h() { 
          //console.log('h(): (f():' + f() +' || g():' + g() +')');
            return !(f() || g())
        }

        function i() {
            if (!f()) {
                var a = x[0].getBoundingClientRect();
                //jQuery('.announcement-bar-wrapper').css({top: jQuery('.brand-bar').outerHeight() +'px'});
                C.css({
                    display: x.css("display"),
                    width: a.width,
                    height: a.height,
                    float: x.css("float")
                }), cssOptions = {
                    "z-index": q.options.zIndex,
                    position: "fixed",
                    top: 0, /*jQuery('.announcement-bar-wrapper').height() + jQuery('.brand-bar').outerHeight(),*/ /*-1 == q.options.bottom ? m() : "",*/
                    bottom: -1 == q.options.bottom ? "" : q.options.bottom,
                    "margin-left": "0px"
                }, q.options.dontSetWidth || (cssOptions.width = x.css("width")), x.css(cssOptions), x.addClass(q.options.baseClassName), q.options.className && x.addClass(q.options.className), r = "fixed", jQuery('#fixed-header-spacer').height(jQuery('.brand-bar').outerHeight() + jQuery('.announcement-bar-wrapper').height() + jQuery('header#top').height())
            }
        }

        function j() {
            var a = e(),
                b = z;
            q.options.removeOffsets && (b = "", a -= y), cssOptions = {
                position: "absolute",
                top: a,
                left: b,
                "margin-left": "0px",
                bottom: ""
            }, q.options.dontSetWidth || (cssOptions.width = x.css("width")), x.css(cssOptions), r = "absolute"
        }

        function k() {
          //console.log('function k() called');
            //jQuery('.announcement-bar-wrapper').css({top: jQuery('.brand-bar').outerHeight() +'px'});
            h() || (B = -1, C.css("display", "none"), x.css({
                "z-index": v,
                width: "",
                position: s,
                left: "",
                top: 0, /*jQuery('.announcement-bar-wrapper').height() + jQuery('.brand-bar').outerHeight(),*/
                "margin-left": ""
            }), x.removeClass("scroll-to-fixed-fixed"), q.options.className && x.removeClass(q.options.className), r = null), jQuery('#fixed-header-spacer').height(jQuery('.brand-bar').outerHeight() + jQuery('.announcement-bar-wrapper').height() + jQuery('header#top').height())
        }

        function l(a) {
            a != B && (x.css("left", z - a), B = a)
        }

        function m() {
            var a = q.options.marginTop;
            return a ? "function" == typeof a ? a.apply(x) : a : 0
        }

        function n() {
            if (a.isScrollToFixed(x) && !x.is(":hidden")) {
                var b = w,
                    c = h();
                w ? h() && (y = x.offset().top, z = x.offset().left) : d();
                var n = a(window).scrollLeft(),
                    r = a(window).scrollTop(),
                    t = e();
                /*q.options.minWidth && a(window).width() < q.options.minWidth ? h() && b || (p(), x.trigger("preUnfixed.ScrollToFixed"), k(), x.trigger("unfixed.ScrollToFixed")) : q.options.maxWidth && a(window).width() > q.options.maxWidth ? h() && b || (p(), x.trigger("preUnfixed.ScrollToFixed"), k(), x.trigger("unfixed.ScrollToFixed")) : -1 == q.options.bottom ? t > 0 && r >= t - m() ? c || g() && b || (p(), x.trigger("preAbsolute.ScrollToFixed"), j(), x.trigger("unfixed.ScrollToFixed")) : r >= y - m() ? (f() && b || (p(), x.trigger("preFixed.ScrollToFixed"), i(), B = -1, x.trigger("fixed.ScrollToFixed")), l(n)) : h() && b || (p(), x.trigger("preUnfixed.ScrollToFixed"), k(), x.trigger("unfixed.ScrollToFixed")) : t > 0 ? r + a(window).height() - x.outerHeight(!0) >= t - (m() || -o()) ? f() && (p(), x.trigger("preUnfixed.ScrollToFixed"), "absolute" === s ? j() : k(), x.trigger("unfixed.ScrollToFixed")) : (f() || (p(), x.trigger("preFixed.ScrollToFixed"), i()), l(n), x.trigger("fixed.ScrollToFixed")) : l(n)*/

              //console.log('function n() called');
              (function () {
  if (q.options.minWidth && a(window).width() < q.options.minWidth) {
    return h() && b || (p(), x.trigger("preUnfixed.ScrollToFixed"), k(), x.trigger("unfixed.ScrollToFixed"));
  }
  return function () {
    if (q.options.maxWidth && a(window).width() > q.options.maxWidth) {
      return h() && b || (p(), x.trigger("preUnfixed.ScrollToFixed"), k(), x.trigger("unfixed.ScrollToFixed"));
    }
    return function () {
      if (-1 == q.options.bottom) {
        return function () {
          if (t > 0 && r >= t - m()) {
            return c || g() && b || (p(), x.trigger("preAbsolute.ScrollToFixed"), j(), x.trigger("unfixed.ScrollToFixed"));
          }
          return function () {
            //console.log(r+' >= '+y+' - '+m());
            if (r >= y - m()) {
              //console.log('n:5');
              return f() && b || (p(), x.trigger("preFixed.ScrollToFixed"), i(), B = -1, x.trigger("fixed.ScrollToFixed")), l(n);
            }
            //console.log('n:6');
            return h() && b || (p(), x.trigger("preUnfixed.ScrollToFixed"), k(), x.trigger("unfixed.ScrollToFixed"));
          }();
        }();
      }
      return function () {
        if (t > 0) {
          return function () {
            if (r + a(window).height() - x.outerHeight(!0) >= t - (m() || -o())) {
              return f() && (p(), x.trigger("preUnfixed.ScrollToFixed"), function () {
                if ("absolute" === s) {
                  return j();
                }
                return k();
              }(), x.trigger("unfixed.ScrollToFixed"));
            }
            return f() || (p(), x.trigger("preFixed.ScrollToFixed"), i()), l(n), x.trigger("fixed.ScrollToFixed");
          }();
        }
        return l(n);
      }();
    }();
  }();
})();

              
            }
        }

        function o() {
            return q.options.bottom ? q.options.bottom : 0
        }

        function p() {
            var a = x.css("position");
            "absolute" == a ? x.trigger("postAbsolute.ScrollToFixed") : "fixed" == a ? x.trigger("postFixed.ScrollToFixed") : x.trigger("postUnfixed.ScrollToFixed")
        }
        var q = this;
        q.$el = a(b), q.el = b, q.$el.data("ScrollToFixed", q);
        var r, s, t, u, v, w = !1,
            x = q.$el,
            y = 0,
            z = 0,
            A = -1,
            B = -1,
            C = null,
            D = function(a) {
                x.is(":visible") ? (w = !1, n()) : k()
            },
            E = function(a) {
                window.requestAnimationFrame ? requestAnimationFrame(n) : n()
            },
            F = function(a) {
                a = a || window.event, a.preventDefault && a.preventDefault(), a.returnValue = !1
            };
        q.init = function() {
            q.options = a.extend({}, a.ScrollToFixed.defaultOptions, c), v = x.css("z-index"), q.$el.css("z-index", q.options.zIndex), C = a("<div />"), r = x.css("position"), s = x.css("position"), t = x.css("float"), u = x.css("top"), h() && q.$el.after(C), a(window).bind("resize.ScrollToFixed", D), a(window).bind("scroll.ScrollToFixed", E), "ontouchmove" in window && a(window).bind("touchmove.ScrollToFixed", n), q.options.preFixed && x.bind("preFixed.ScrollToFixed", q.options.preFixed), q.options.postFixed && x.bind("postFixed.ScrollToFixed", q.options.postFixed), q.options.preUnfixed && x.bind("preUnfixed.ScrollToFixed", q.options.preUnfixed), q.options.postUnfixed && x.bind("postUnfixed.ScrollToFixed", q.options.postUnfixed), q.options.preAbsolute && x.bind("preAbsolute.ScrollToFixed", q.options.preAbsolute), q.options.postAbsolute && x.bind("postAbsolute.ScrollToFixed", q.options.postAbsolute), q.options.fixed && x.bind("fixed.ScrollToFixed", q.options.fixed), q.options.unfixed && x.bind("unfixed.ScrollToFixed", q.options.unfixed), q.options.spacerClass && C.addClass(q.options.spacerClass), x.bind("resize.ScrollToFixed", function() {
                C.height(x.height())
            }), x.bind("scroll.ScrollToFixed", function() {
                x.trigger("preUnfixed.ScrollToFixed"), k(), x.trigger("unfixed.ScrollToFixed"), n()
            }), x.bind("detach.ScrollToFixed", function(b) {
                F(b), x.trigger("preUnfixed.ScrollToFixed"), k(), x.trigger("unfixed.ScrollToFixed"), a(window).unbind("resize.ScrollToFixed", D), a(window).unbind("scroll.ScrollToFixed", E), x.unbind(".ScrollToFixed"), C.remove(), q.$el.removeData("ScrollToFixed")
            }), D()
        }, q.init()
    }, a.ScrollToFixed.defaultOptions = {
        marginTop: 0,
        limit: 0,
        bottom: -1,
        zIndex: 1e3,
        baseClassName: "scroll-to-fixed-fixed"
    }, a.fn.scrollToFixed = function(b) {
        return this.each(function() {
            new a.ScrollToFixed(this, b)
        })
    }
}(jQuery),
function(a) {
    "use strict";
    "function" == typeof define && define.amd ? define(["jquery"], a) : "undefined" != typeof exports ? module.exports = a(require("jquery")) : a(jQuery)
}(function(a) {
    "use strict";
    var b = window.Slick || {};
    b = function() {
        function b(b, d) {
            var e, f = this;
            f.defaults = {
                accessibility: !0,
                adaptiveHeight: !1,
                appendArrows: a(b),
                appendDots: a(b),
                arrows: !0,
                asNavFor: null,
                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                autoplay: !1,
                autoplaySpeed: 3e3,
                centerMode: !1,
                centerPadding: "50px",
                cssEase: "ease",
                customPaging: function(b, c) {
                    return a('<button type="button" />').text(c + 1)
                },
                dots: !1,
                dotsClass: "slick-dots",
                draggable: !0,
                easing: "linear",
                edgeFriction: .35,
                fade: !1,
                focusOnSelect: !1,
                focusOnChange: !1,
                infinite: !0,
                initialSlide: 0,
                lazyLoad: "ondemand",
                mobileFirst: !1,
                pauseOnHover: !0,
                pauseOnFocus: !0,
                pauseOnDotsHover: !1,
                respondTo: "window",
                responsive: null,
                rows: 1,
                rtl: !1,
                slide: "",
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: !0,
                swipeToSlide: !1,
                touchMove: !0,
                touchThreshold: 5,
                useCSS: !0,
                useTransform: !0,
                variableWidth: !1,
                vertical: !1,
                verticalSwiping: !1,
                waitForAnimate: !0,
                zIndex: 1e3
            }, f.initials = {
                animating: !1,
                dragging: !1,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                scrolling: !1,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: !1,
                slideOffset: 0,
                swipeLeft: null,
                swiping: !1,
                $list: null,
                touchObject: {},
                transformsEnabled: !1,
                unslicked: !1
            }, a.extend(f, f.initials), f.activeBreakpoint = null, f.animType = null, f.animProp = null, f.breakpoints = [], f.breakpointSettings = [], f.cssTransitions = !1, f.focussed = !1, f.interrupted = !1, f.hidden = "hidden", f.paused = !0, f.positionProp = null, f.respondTo = null, f.rowCount = 1, f.shouldClick = !0, f.$slider = a(b), f.$slidesCache = null, f.transformType = null, f.transitionType = null, f.visibilityChange = "visibilitychange", f.windowWidth = 0, f.windowTimer = null, e = a(b).data("slick") || {}, f.options = a.extend({}, f.defaults, d, e), f.currentSlide = f.options.initialSlide, f.originalSettings = f.options, void 0 !== document.mozHidden ? (f.hidden = "mozHidden", f.visibilityChange = "mozvisibilitychange") : void 0 !== document.webkitHidden && (f.hidden = "webkitHidden", f.visibilityChange = "webkitvisibilitychange"), f.autoPlay = a.proxy(f.autoPlay, f), f.autoPlayClear = a.proxy(f.autoPlayClear, f), f.autoPlayIterator = a.proxy(f.autoPlayIterator, f), f.changeSlide = a.proxy(f.changeSlide, f), f.clickHandler = a.proxy(f.clickHandler, f), f.selectHandler = a.proxy(f.selectHandler, f), f.setPosition = a.proxy(f.setPosition, f), f.swipeHandler = a.proxy(f.swipeHandler, f), f.dragHandler = a.proxy(f.dragHandler, f), f.keyHandler = a.proxy(f.keyHandler, f), f.instanceUid = c++, f.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/, f.registerBreakpoints(), f.init(!0)
        }
        var c = 0;
        return b
    }(), b.prototype.activateADA = function() {
        this.$slideTrack.find(".slick-active").attr({
            "aria-hidden": "false"
        }).find("a, input, button, select").attr({
            tabindex: "0"
        })
    }, b.prototype.addSlide = b.prototype.slickAdd = function(b, c, d) {
        var e = this;
        if ("boolean" == typeof c) d = c, c = null;
        else if (c < 0 || c >= e.slideCount) return !1;
        e.unload(), "number" == typeof c ? 0 === c && 0 === e.$slides.length ? a(b).appendTo(e.$slideTrack) : d ? a(b).insertBefore(e.$slides.eq(c)) : a(b).insertAfter(e.$slides.eq(c)) : !0 === d ? a(b).prependTo(e.$slideTrack) : a(b).appendTo(e.$slideTrack), e.$slides = e.$slideTrack.children(this.options.slide), e.$slideTrack.children(this.options.slide).detach(), e.$slideTrack.append(e.$slides), e.$slides.each(function(b, c) {
            a(c).attr("data-slick-index", b)
        }), e.$slidesCache = e.$slides, e.reinit()
    }, b.prototype.animateHeight = function() {
        var a = this;
        if (1 === a.options.slidesToShow && !0 === a.options.adaptiveHeight && !1 === a.options.vertical) {
            var b = a.$slides.eq(a.currentSlide).outerHeight(!0);
            a.$list.animate({
                height: b
            }, a.options.speed)
        }
    }, b.prototype.animateSlide = function(b, c) {
        var d = {},
            e = this;
        e.animateHeight(), !0 === e.options.rtl && !1 === e.options.vertical && (b = -b), !1 === e.transformsEnabled ? !1 === e.options.vertical ? e.$slideTrack.animate({
            left: b
        }, e.options.speed, e.options.easing, c) : e.$slideTrack.animate({
            top: b
        }, e.options.speed, e.options.easing, c) : !1 === e.cssTransitions ? (!0 === e.options.rtl && (e.currentLeft = -e.currentLeft), a({
            animStart: e.currentLeft
        }).animate({
            animStart: b
        }, {
            duration: e.options.speed,
            easing: e.options.easing,
            step: function(a) {
                a = Math.ceil(a), !1 === e.options.vertical ? (d[e.animType] = "translate(" + a + "px, 0px)", e.$slideTrack.css(d)) : (d[e.animType] = "translate(0px," + a + "px)", e.$slideTrack.css(d))
            },
            complete: function() {
                c && c.call()
            }
        })) : (e.applyTransition(), b = Math.ceil(b), !1 === e.options.vertical ? d[e.animType] = "translate3d(" + b + "px, 0px, 0px)" : d[e.animType] = "translate3d(0px," + b + "px, 0px)", e.$slideTrack.css(d), c && setTimeout(function() {
            e.disableTransition(), c.call()
        }, e.options.speed))
    }, b.prototype.getNavTarget = function() {
        var b = this,
            c = b.options.asNavFor;
        return c && null !== c && (c = a(c).not(b.$slider)), c
    }, b.prototype.asNavFor = function(b) {
        var c = this,
            d = c.getNavTarget();
        null !== d && "object" == typeof d && d.each(function() {
            var c = a(this).slick("getSlick");
            c.unslicked || c.slideHandler(b, !0)
        })
    }, b.prototype.applyTransition = function(a) {
        var b = this,
            c = {};
        !1 === b.options.fade ? c[b.transitionType] = b.transformType + " " + b.options.speed + "ms " + b.options.cssEase : c[b.transitionType] = "opacity " + b.options.speed + "ms " + b.options.cssEase, !1 === b.options.fade ? b.$slideTrack.css(c) : b.$slides.eq(a).css(c)
    }, b.prototype.autoPlay = function() {
        var a = this;
        a.autoPlayClear(), a.slideCount > a.options.slidesToShow && (a.autoPlayTimer = setInterval(a.autoPlayIterator, a.options.autoplaySpeed))
    }, b.prototype.autoPlayClear = function() {
        var a = this;
        a.autoPlayTimer && clearInterval(a.autoPlayTimer)
    }, b.prototype.autoPlayIterator = function() {
        var a = this,
            b = a.currentSlide + a.options.slidesToScroll;
        a.paused || a.interrupted || a.focussed || (!1 === a.options.infinite && (1 === a.direction && a.currentSlide + 1 === a.slideCount - 1 ? a.direction = 0 : 0 === a.direction && (b = a.currentSlide - a.options.slidesToScroll, a.currentSlide - 1 == 0 && (a.direction = 1))), a.slideHandler(b))
    }, b.prototype.buildArrows = function() {
        var b = this;
        !0 === b.options.arrows && (b.$prevArrow = a(b.options.prevArrow).addClass("slick-arrow"), b.$nextArrow = a(b.options.nextArrow).addClass("slick-arrow"), b.slideCount > b.options.slidesToShow ? (b.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), b.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), b.htmlExpr.test(b.options.prevArrow) && b.$prevArrow.prependTo(b.options.appendArrows), b.htmlExpr.test(b.options.nextArrow) && b.$nextArrow.appendTo(b.options.appendArrows), !0 !== b.options.infinite && b.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true")) : b.$prevArrow.add(b.$nextArrow).addClass("slick-hidden").attr({
            "aria-disabled": "true",
            tabindex: "-1"
        }))
    }, b.prototype.buildDots = function() {
        var b, c, d = this;
        if (!0 === d.options.dots && d.slideCount > d.options.slidesToShow) {
            for (d.$slider.addClass("slick-dotted"), c = a("<ul />").addClass(d.options.dotsClass), b = 0; b <= d.getDotCount(); b += 1) c.append(a("<li />").append(d.options.customPaging.call(this, d, b)));
            d.$dots = c.appendTo(d.options.appendDots), d.$dots.find("li").first().addClass("slick-active")
        }
    }, b.prototype.buildOut = function() {
        var b = this;
        b.$slides = b.$slider.children(b.options.slide + ":not(.slick-cloned)").addClass("slick-slide"), b.slideCount = b.$slides.length, b.$slides.each(function(b, c) {
            a(c).attr("data-slick-index", b).data("originalStyling", a(c).attr("style") || "")
        }), b.$slider.addClass("slick-slider"), b.$slideTrack = 0 === b.slideCount ? a('<div class="slick-track"/>').appendTo(b.$slider) : b.$slides.wrapAll('<div class="slick-track"/>').parent(), b.$list = b.$slideTrack.wrap('<div class="slick-list"/>').parent(), b.$slideTrack.css("opacity", 0), !0 !== b.options.centerMode && !0 !== b.options.swipeToSlide || (b.options.slidesToScroll = 1), a("img[data-lazy]", b.$slider).not("[src]").addClass("slick-loading"), b.setupInfinite(), b.buildArrows(), b.buildDots(), b.updateDots(), b.setSlideClasses("number" == typeof b.currentSlide ? b.currentSlide : 0), !0 === b.options.draggable && b.$list.addClass("draggable")
    }, b.prototype.buildRows = function() {
        var a, b, c, d, e, f, g, h = this;
        if (d = document.createDocumentFragment(), f = h.$slider.children(), h.options.rows > 0) {
            for (g = h.options.slidesPerRow * h.options.rows, e = Math.ceil(f.length / g), a = 0; a < e; a++) {
                var i = document.createElement("div");
                for (b = 0; b < h.options.rows; b++) {
                    var j = document.createElement("div");
                    for (c = 0; c < h.options.slidesPerRow; c++) {
                        var k = a * g + (b * h.options.slidesPerRow + c);
                        f.get(k) && j.appendChild(f.get(k))
                    }
                    i.appendChild(j)
                }
                d.appendChild(i)
            }
            h.$slider.empty().append(d), h.$slider.children().children().children().css({
                width: 100 / h.options.slidesPerRow + "%",
                display: "inline-block"
            })
        }
    }, b.prototype.checkResponsive = function(b, c) {
        var d, e, f, g = this,
            h = !1,
            i = g.$slider.width(),
            j = window.innerWidth || a(window).width();
        if ("window" === g.respondTo ? f = j : "slider" === g.respondTo ? f = i : "min" === g.respondTo && (f = Math.min(j, i)), g.options.responsive && g.options.responsive.length && null !== g.options.responsive) {
            e = null;
            for (d in g.breakpoints) g.breakpoints.hasOwnProperty(d) && (!1 === g.originalSettings.mobileFirst ? f < g.breakpoints[d] && (e = g.breakpoints[d]) : f > g.breakpoints[d] && (e = g.breakpoints[d]));
            null !== e ? null !== g.activeBreakpoint ? (e !== g.activeBreakpoint || c) && (g.activeBreakpoint = e, "unslick" === g.breakpointSettings[e] ? g.unslick(e) : (g.options = a.extend({}, g.originalSettings, g.breakpointSettings[e]), !0 === b && (g.currentSlide = g.options.initialSlide), g.refresh(b)), h = e) : (g.activeBreakpoint = e, "unslick" === g.breakpointSettings[e] ? g.unslick(e) : (g.options = a.extend({}, g.originalSettings, g.breakpointSettings[e]), !0 === b && (g.currentSlide = g.options.initialSlide), g.refresh(b)), h = e) : null !== g.activeBreakpoint && (g.activeBreakpoint = null, g.options = g.originalSettings, !0 === b && (g.currentSlide = g.options.initialSlide), g.refresh(b), h = e), b || !1 === h || g.$slider.trigger("breakpoint", [g, h])
        }
    }, b.prototype.changeSlide = function(b, c) {
        var d, e, f, g = this,
            h = a(b.currentTarget);
        switch (h.is("a") && b.preventDefault(), h.is("li") || (h = h.closest("li")), f = g.slideCount % g.options.slidesToScroll != 0, d = f ? 0 : (g.slideCount - g.currentSlide) % g.options.slidesToScroll, b.data.message) {
            case "previous":
                e = 0 === d ? g.options.slidesToScroll : g.options.slidesToShow - d, g.slideCount > g.options.slidesToShow && g.slideHandler(g.currentSlide - e, !1, c);
                break;
            case "next":
                e = 0 === d ? g.options.slidesToScroll : d, g.slideCount > g.options.slidesToShow && g.slideHandler(g.currentSlide + e, !1, c);
                break;
            case "index":
                var i = 0 === b.data.index ? 0 : b.data.index || h.index() * g.options.slidesToScroll;
                g.slideHandler(g.checkNavigable(i), !1, c), h.children().trigger("focus");
                break;
            default:
                return
        }
    }, b.prototype.checkNavigable = function(a) {
        var b, c, d = this;
        if (b = d.getNavigableIndexes(), c = 0, a > b[b.length - 1]) a = b[b.length - 1];
        else
            for (var e in b) {
                if (a < b[e]) {
                    a = c;
                    break
                }
                c = b[e]
            }
        return a
    }, b.prototype.cleanUpEvents = function() {
        var b = this;
        b.options.dots && null !== b.$dots && (a("li", b.$dots).off("click.slick", b.changeSlide).off("mouseenter.slick", a.proxy(b.interrupt, b, !0)).off("mouseleave.slick", a.proxy(b.interrupt, b, !1)), !0 === b.options.accessibility && b.$dots.off("keydown.slick", b.keyHandler)), b.$slider.off("focus.slick blur.slick"), !0 === b.options.arrows && b.slideCount > b.options.slidesToShow && (b.$prevArrow && b.$prevArrow.off("click.slick", b.changeSlide), b.$nextArrow && b.$nextArrow.off("click.slick", b.changeSlide), !0 === b.options.accessibility && (b.$prevArrow && b.$prevArrow.off("keydown.slick", b.keyHandler), b.$nextArrow && b.$nextArrow.off("keydown.slick", b.keyHandler))), b.$list.off("touchstart.slick mousedown.slick", b.swipeHandler), b.$list.off("touchmove.slick mousemove.slick", b.swipeHandler), b.$list.off("touchend.slick mouseup.slick", b.swipeHandler), b.$list.off("touchcancel.slick mouseleave.slick", b.swipeHandler), b.$list.off("click.slick", b.clickHandler), a(document).off(b.visibilityChange, b.visibility), b.cleanUpSlideEvents(), !0 === b.options.accessibility && b.$list.off("keydown.slick", b.keyHandler), !0 === b.options.focusOnSelect && a(b.$slideTrack).children().off("click.slick", b.selectHandler), a(window).off("orientationchange.slick.slick-" + b.instanceUid, b.orientationChange), a(window).off("resize.slick.slick-" + b.instanceUid, b.resize), a("[draggable!=true]", b.$slideTrack).off("dragstart", b.preventDefault), a(window).off("load.slick.slick-" + b.instanceUid, b.setPosition)
    }, b.prototype.cleanUpSlideEvents = function() {
        var b = this;
        b.$list.off("mouseenter.slick", a.proxy(b.interrupt, b, !0)), b.$list.off("mouseleave.slick", a.proxy(b.interrupt, b, !1))
    }, b.prototype.cleanUpRows = function() {
        var a, b = this;
        b.options.rows > 0 && (a = b.$slides.children().children(), a.removeAttr("style"), b.$slider.empty().append(a))
    }, b.prototype.clickHandler = function(a) {
        !1 === this.shouldClick && (a.stopImmediatePropagation(), a.stopPropagation(), a.preventDefault())
    }, b.prototype.destroy = function(b) {
        var c = this;
        c.autoPlayClear(), c.touchObject = {}, c.cleanUpEvents(), a(".slick-cloned", c.$slider).detach(), c.$dots && c.$dots.remove(), c.$prevArrow && c.$prevArrow.length && (c.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), c.htmlExpr.test(c.options.prevArrow) && c.$prevArrow.remove()), c.$nextArrow && c.$nextArrow.length && (c.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), c.htmlExpr.test(c.options.nextArrow) && c.$nextArrow.remove()), c.$slides && (c.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function() {
            a(this).attr("style", a(this).data("originalStyling"))
        }), c.$slideTrack.children(this.options.slide).detach(), c.$slideTrack.detach(), c.$list.detach(), c.$slider.append(c.$slides)), c.cleanUpRows(), c.$slider.removeClass("slick-slider"), c.$slider.removeClass("slick-initialized"), c.$slider.removeClass("slick-dotted"), c.unslicked = !0, b || c.$slider.trigger("destroy", [c])
    }, b.prototype.disableTransition = function(a) {
        var b = this,
            c = {};
        c[b.transitionType] = "", !1 === b.options.fade ? b.$slideTrack.css(c) : b.$slides.eq(a).css(c)
    }, b.prototype.fadeSlide = function(a, b) {
        var c = this;
        !1 === c.cssTransitions ? (c.$slides.eq(a).css({
            zIndex: c.options.zIndex
        }), c.$slides.eq(a).animate({
            opacity: 1
        }, c.options.speed, c.options.easing, b)) : (c.applyTransition(a), c.$slides.eq(a).css({
            opacity: 1,
            zIndex: c.options.zIndex
        }), b && setTimeout(function() {
            c.disableTransition(a), b.call()
        }, c.options.speed))
    }, b.prototype.fadeSlideOut = function(a) {
        var b = this;
        !1 === b.cssTransitions ? b.$slides.eq(a).animate({
            opacity: 0,
            zIndex: b.options.zIndex - 2
        }, b.options.speed, b.options.easing) : (b.applyTransition(a), b.$slides.eq(a).css({
            opacity: 0,
            zIndex: b.options.zIndex - 2
        }))
    }, b.prototype.filterSlides = b.prototype.slickFilter = function(a) {
        var b = this;
        null !== a && (b.$slidesCache = b.$slides, b.unload(), b.$slideTrack.children(this.options.slide).detach(), b.$slidesCache.filter(a).appendTo(b.$slideTrack), b.reinit())
    }, b.prototype.focusHandler = function() {
        var b = this;
        b.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*", function(c) {
            c.stopImmediatePropagation();
            var d = a(this);
            setTimeout(function() {
                b.options.pauseOnFocus && (b.focussed = d.is(":focus"), b.autoPlay())
            }, 0)
        })
    }, b.prototype.getCurrent = b.prototype.slickCurrentSlide = function() {
        return this.currentSlide
    }, b.prototype.getDotCount = function() {
        var a = this,
            b = 0,
            c = 0,
            d = 0;
        if (!0 === a.options.infinite)
            if (a.slideCount <= a.options.slidesToShow) ++d;
            else
                for (; b < a.slideCount;) ++d, b = c + a.options.slidesToScroll, c += a.options.slidesToScroll <= a.options.slidesToShow ? a.options.slidesToScroll : a.options.slidesToShow;
        else if (!0 === a.options.centerMode) d = a.slideCount;
        else if (a.options.asNavFor)
            for (; b < a.slideCount;) ++d, b = c + a.options.slidesToScroll, c += a.options.slidesToScroll <= a.options.slidesToShow ? a.options.slidesToScroll : a.options.slidesToShow;
        else d = 1 + Math.ceil((a.slideCount - a.options.slidesToShow) / a.options.slidesToScroll);
        return d - 1
    }, b.prototype.getLeft = function(a) {
        var b, c, d, e, f = this,
            g = 0;
        return f.slideOffset = 0, c = f.$slides.first().outerHeight(!0), !0 === f.options.infinite ? (f.slideCount > f.options.slidesToShow && (f.slideOffset = f.slideWidth * f.options.slidesToShow * -1, e = -1, !0 === f.options.vertical && !0 === f.options.centerMode && (2 === f.options.slidesToShow ? e = -1.5 : 1 === f.options.slidesToShow && (e = -2)), g = c * f.options.slidesToShow * e), f.slideCount % f.options.slidesToScroll != 0 && a + f.options.slidesToScroll > f.slideCount && f.slideCount > f.options.slidesToShow && (a > f.slideCount ? (f.slideOffset = (f.options.slidesToShow - (a - f.slideCount)) * f.slideWidth * -1, g = (f.options.slidesToShow - (a - f.slideCount)) * c * -1) : (f.slideOffset = f.slideCount % f.options.slidesToScroll * f.slideWidth * -1, g = f.slideCount % f.options.slidesToScroll * c * -1))) : a + f.options.slidesToShow > f.slideCount && (f.slideOffset = (a + f.options.slidesToShow - f.slideCount) * f.slideWidth, g = (a + f.options.slidesToShow - f.slideCount) * c), f.slideCount <= f.options.slidesToShow && (f.slideOffset = 0, g = 0), !0 === f.options.centerMode && f.slideCount <= f.options.slidesToShow ? f.slideOffset = f.slideWidth * Math.floor(f.options.slidesToShow) / 2 - f.slideWidth * f.slideCount / 2 : !0 === f.options.centerMode && !0 === f.options.infinite ? f.slideOffset += f.slideWidth * Math.floor(f.options.slidesToShow / 2) - f.slideWidth : !0 === f.options.centerMode && (f.slideOffset = 0, f.slideOffset += f.slideWidth * Math.floor(f.options.slidesToShow / 2)), b = !1 === f.options.vertical ? a * f.slideWidth * -1 + f.slideOffset : a * c * -1 + g, !0 === f.options.variableWidth && (d = f.slideCount <= f.options.slidesToShow || !1 === f.options.infinite ? f.$slideTrack.children(".slick-slide").eq(a) : f.$slideTrack.children(".slick-slide").eq(a + f.options.slidesToShow), b = !0 === f.options.rtl ? d[0] ? -1 * (f.$slideTrack.width() - d[0].offsetLeft - d.width()) : 0 : d[0] ? -1 * d[0].offsetLeft : 0, !0 === f.options.centerMode && (d = f.slideCount <= f.options.slidesToShow || !1 === f.options.infinite ? f.$slideTrack.children(".slick-slide").eq(a) : f.$slideTrack.children(".slick-slide").eq(a + f.options.slidesToShow + 1), b = !0 === f.options.rtl ? d[0] ? -1 * (f.$slideTrack.width() - d[0].offsetLeft - d.width()) : 0 : d[0] ? -1 * d[0].offsetLeft : 0, b += (f.$list.width() - d.outerWidth()) / 2)), b
    }, b.prototype.getOption = b.prototype.slickGetOption = function(a) {
        return this.options[a]
    }, b.prototype.getNavigableIndexes = function() {
        var a, b = this,
            c = 0,
            d = 0,
            e = [];
        for (!1 === b.options.infinite ? a = b.slideCount : (c = -1 * b.options.slidesToScroll, d = -1 * b.options.slidesToScroll, a = 2 * b.slideCount); c < a;) e.push(c), c = d + b.options.slidesToScroll, d += b.options.slidesToScroll <= b.options.slidesToShow ? b.options.slidesToScroll : b.options.slidesToShow;
        return e
    }, b.prototype.getSlick = function() {
        return this
    }, b.prototype.getSlideCount = function() {
        var b, c, d = this;
        return c = !0 === d.options.centerMode ? d.slideWidth * Math.floor(d.options.slidesToShow / 2) : 0, !0 === d.options.swipeToSlide ? (d.$slideTrack.find(".slick-slide").each(function(e, f) {
            if (f.offsetLeft - c + a(f).outerWidth() / 2 > -1 * d.swipeLeft) return b = f, !1
        }), Math.abs(a(b).attr("data-slick-index") - d.currentSlide) || 1) : d.options.slidesToScroll
    }, b.prototype.goTo = b.prototype.slickGoTo = function(a, b) {
        this.changeSlide({
            data: {
                message: "index",
                index: parseInt(a)
            }
        }, b)
    }, b.prototype.init = function(b) {
        var c = this;
        a(c.$slider).hasClass("slick-initialized") || (a(c.$slider).addClass("slick-initialized"), c.buildRows(), c.buildOut(), c.setProps(), c.startLoad(), c.loadSlider(), c.initializeEvents(), c.updateArrows(), c.updateDots(), c.checkResponsive(!0), c.focusHandler()), b && c.$slider.trigger("init", [c]), !0 === c.options.accessibility && c.initADA(), c.options.autoplay && (c.paused = !1, c.autoPlay())
    }, b.prototype.initADA = function() {
        var b = this,
            c = Math.ceil(b.slideCount / b.options.slidesToShow),
            d = b.getNavigableIndexes().filter(function(a) {
                return a >= 0 && a < b.slideCount
            });
        b.$slides.add(b.$slideTrack.find(".slick-cloned")).attr({
            "aria-hidden": "true",
            tabindex: "-1"
        }).find("a, input, button, select").attr({
            tabindex: "-1"
        }), null !== b.$dots && (b.$slides.not(b.$slideTrack.find(".slick-cloned")).each(function(c) {
            var e = d.indexOf(c);
            if (a(this).attr({
                    role: "tabpanel",
                    id: "slick-slide" + b.instanceUid + c,
                    tabindex: -1
                }), -1 !== e) {
                var f = "slick-slide-control" + b.instanceUid + e;
                a("#" + f).length && a(this).attr({
                    "aria-describedby": f
                })
            }
        }), b.$dots.attr("role", "tablist").find("li").each(function(e) {
            var f = d[e];
            a(this).attr({
                role: "presentation"
            }), a(this).find("button").first().attr({
                role: "tab",
                id: "slick-slide-control" + b.instanceUid + e,
                "aria-controls": "slick-slide" + b.instanceUid + f,
                "aria-label": e + 1 + " of " + c,
                "aria-selected": null,
                tabindex: "-1"
            })
        }).eq(b.currentSlide).find("button").attr({
            "aria-selected": "true",
            tabindex: "0"
        }).end());
        for (var e = b.currentSlide, f = e + b.options.slidesToShow; e < f; e++) b.options.focusOnChange ? b.$slides.eq(e).attr({
            tabindex: "0"
        }) : b.$slides.eq(e).removeAttr("tabindex");
        b.activateADA()
    }, b.prototype.initArrowEvents = function() {
        var a = this;
        !0 === a.options.arrows && a.slideCount > a.options.slidesToShow && (a.$prevArrow.off("click.slick").on("click.slick", {
            message: "previous"
        }, a.changeSlide), a.$nextArrow.off("click.slick").on("click.slick", {
            message: "next"
        }, a.changeSlide), !0 === a.options.accessibility && (a.$prevArrow.on("keydown.slick", a.keyHandler), a.$nextArrow.on("keydown.slick", a.keyHandler)))
    }, b.prototype.initDotEvents = function() {
        var b = this;
        !0 === b.options.dots && b.slideCount > b.options.slidesToShow && (a("li", b.$dots).on("click.slick", {
            message: "index"
        }, b.changeSlide), !0 === b.options.accessibility && b.$dots.on("keydown.slick", b.keyHandler)), !0 === b.options.dots && !0 === b.options.pauseOnDotsHover && b.slideCount > b.options.slidesToShow && a("li", b.$dots).on("mouseenter.slick", a.proxy(b.interrupt, b, !0)).on("mouseleave.slick", a.proxy(b.interrupt, b, !1))
    }, b.prototype.initSlideEvents = function() {
        var b = this;
        b.options.pauseOnHover && (b.$list.on("mouseenter.slick", a.proxy(b.interrupt, b, !0)), b.$list.on("mouseleave.slick", a.proxy(b.interrupt, b, !1)))
    }, b.prototype.initializeEvents = function() {
        var b = this;
        b.initArrowEvents(), b.initDotEvents(), b.initSlideEvents(), b.$list.on("touchstart.slick mousedown.slick", {
            action: "start"
        }, b.swipeHandler), b.$list.on("touchmove.slick mousemove.slick", {
            action: "move"
        }, b.swipeHandler), b.$list.on("touchend.slick mouseup.slick", {
            action: "end"
        }, b.swipeHandler), b.$list.on("touchcancel.slick mouseleave.slick", {
            action: "end"
        }, b.swipeHandler), b.$list.on("click.slick", b.clickHandler), a(document).on(b.visibilityChange, a.proxy(b.visibility, b)), !0 === b.options.accessibility && b.$list.on("keydown.slick", b.keyHandler), !0 === b.options.focusOnSelect && a(b.$slideTrack).children().on("click.slick", b.selectHandler), a(window).on("orientationchange.slick.slick-" + b.instanceUid, a.proxy(b.orientationChange, b)), a(window).on("resize.slick.slick-" + b.instanceUid, a.proxy(b.resize, b)), a("[draggable!=true]", b.$slideTrack).on("dragstart", b.preventDefault), a(window).on("load.slick.slick-" + b.instanceUid, b.setPosition), a(b.setPosition)
    }, b.prototype.initUI = function() {
        var a = this;
        !0 === a.options.arrows && a.slideCount > a.options.slidesToShow && (a.$prevArrow.show(), a.$nextArrow.show()), !0 === a.options.dots && a.slideCount > a.options.slidesToShow && a.$dots.show()
    }, b.prototype.keyHandler = function(a) {
        var b = this;
        a.target.tagName.match("TEXTAREA|INPUT|SELECT") || (37 === a.keyCode && !0 === b.options.accessibility ? b.changeSlide({
            data: {
                message: !0 === b.options.rtl ? "next" : "previous"
            }
        }) : 39 === a.keyCode && !0 === b.options.accessibility && b.changeSlide({
            data: {
                message: !0 === b.options.rtl ? "previous" : "next"
            }
        }))
    }, b.prototype.lazyLoad = function() {
        function b(b) {
            a("img[data-lazy]", b).each(function() {
                var b = a(this),
                    c = a(this).attr("data-lazy"),
                    d = a(this).attr("data-srcset"),
                    e = a(this).attr("data-sizes") || g.$slider.attr("data-sizes"),
                    f = document.createElement("img");
                f.onload = function() {
                    b.animate({
                        opacity: 0
                    }, 100, function() {
                        d && (b.attr("srcset", d), e && b.attr("sizes", e)), b.attr("src", c).animate({
                            opacity: 1
                        }, 200, function() {
                            b.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")
                        }), g.$slider.trigger("lazyLoaded", [g, b, c])
                    })
                }, f.onerror = function() {
                    b.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), g.$slider.trigger("lazyLoadError", [g, b, c])
                }, f.src = c
            })
        }
        var c, d, e, f, g = this;
        if (!0 === g.options.centerMode ? !0 === g.options.infinite ? (e = g.currentSlide + (g.options.slidesToShow / 2 + 1), f = e + g.options.slidesToShow + 2) : (e = Math.max(0, g.currentSlide - (g.options.slidesToShow / 2 + 1)), f = g.options.slidesToShow / 2 + 1 + 2 + g.currentSlide) : (e = g.options.infinite ? g.options.slidesToShow + g.currentSlide : g.currentSlide, f = Math.ceil(e + g.options.slidesToShow), !0 === g.options.fade && (e > 0 && e--, f <= g.slideCount && f++)), c = g.$slider.find(".slick-slide").slice(e, f), "anticipated" === g.options.lazyLoad)
            for (var h = e - 1, i = f, j = g.$slider.find(".slick-slide"), k = 0; k < g.options.slidesToScroll; k++) h < 0 && (h = g.slideCount - 1), c = c.add(j.eq(h)), c = c.add(j.eq(i)), h--, i++;
        b(c), g.slideCount <= g.options.slidesToShow ? (d = g.$slider.find(".slick-slide"), b(d)) : g.currentSlide >= g.slideCount - g.options.slidesToShow ? (d = g.$slider.find(".slick-cloned").slice(0, g.options.slidesToShow), b(d)) : 0 === g.currentSlide && (d = g.$slider.find(".slick-cloned").slice(-1 * g.options.slidesToShow), b(d))
    }, b.prototype.loadSlider = function() {
        var a = this;
        a.setPosition(), a.$slideTrack.css({
            opacity: 1
        }), a.$slider.removeClass("slick-loading"), a.initUI(), "progressive" === a.options.lazyLoad && a.progressiveLazyLoad()
    }, b.prototype.next = b.prototype.slickNext = function() {
        this.changeSlide({
            data: {
                message: "next"
            }
        })
    }, b.prototype.orientationChange = function() {
        var a = this;
        a.checkResponsive(), a.setPosition()
    }, b.prototype.pause = b.prototype.slickPause = function() {
        var a = this;
        a.autoPlayClear(), a.paused = !0
    }, b.prototype.play = b.prototype.slickPlay = function() {
        var a = this;
        a.autoPlay(), a.options.autoplay = !0, a.paused = !1, a.focussed = !1, a.interrupted = !1
    }, b.prototype.postSlide = function(b) {
        var c = this;
        if (!c.unslicked && (c.$slider.trigger("afterChange", [c, b]), c.animating = !1, c.slideCount > c.options.slidesToShow && c.setPosition(), c.swipeLeft = null, c.options.autoplay && c.autoPlay(), !0 === c.options.accessibility && (c.initADA(), c.options.focusOnChange))) {
            a(c.$slides.get(c.currentSlide)).attr("tabindex", 0).focus()
        }
    }, b.prototype.prev = b.prototype.slickPrev = function() {
        this.changeSlide({
            data: {
                message: "previous"
            }
        })
    }, b.prototype.preventDefault = function(a) {
        a.preventDefault()
    }, b.prototype.progressiveLazyLoad = function(b) {
        b = b || 1;
        var c, d, e, f, g, h = this,
            i = a("img[data-lazy]", h.$slider);
        i.length ? (c = i.first(), d = c.attr("data-lazy"), e = c.attr("data-srcset"), f = c.attr("data-sizes") || h.$slider.attr("data-sizes"), g = document.createElement("img"), g.onload = function() {
            e && (c.attr("srcset", e), f && c.attr("sizes", f)), c.attr("src", d).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"), !0 === h.options.adaptiveHeight && h.setPosition(), h.$slider.trigger("lazyLoaded", [h, c, d]), h.progressiveLazyLoad()
        }, g.onerror = function() {
            b < 3 ? setTimeout(function() {
                h.progressiveLazyLoad(b + 1)
            }, 500) : (c.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), h.$slider.trigger("lazyLoadError", [h, c, d]), h.progressiveLazyLoad())
        }, g.src = d) : h.$slider.trigger("allImagesLoaded", [h])
    }, b.prototype.refresh = function(b) {
        var c, d, e = this;
        d = e.slideCount - e.options.slidesToShow, !e.options.infinite && e.currentSlide > d && (e.currentSlide = d), e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0), c = e.currentSlide, e.destroy(!0), a.extend(e, e.initials, {
            currentSlide: c
        }), e.init(), b || e.changeSlide({
            data: {
                message: "index",
                index: c
            }
        }, !1)
    }, b.prototype.registerBreakpoints = function() {
        var b, c, d, e = this,
            f = e.options.responsive || null;
        if ("array" === a.type(f) && f.length) {
            e.respondTo = e.options.respondTo || "window";
            for (b in f)
                if (d = e.breakpoints.length - 1, f.hasOwnProperty(b)) {
                    for (c = f[b].breakpoint; d >= 0;) e.breakpoints[d] && e.breakpoints[d] === c && e.breakpoints.splice(d, 1), d--;
                    e.breakpoints.push(c), e.breakpointSettings[c] = f[b].settings
                } e.breakpoints.sort(function(a, b) {
                return e.options.mobileFirst ? a - b : b - a
            })
        }
    }, b.prototype.reinit = function() {
        var b = this;
        b.$slides = b.$slideTrack.children(b.options.slide).addClass("slick-slide"), b.slideCount = b.$slides.length, b.currentSlide >= b.slideCount && 0 !== b.currentSlide && (b.currentSlide = b.currentSlide - b.options.slidesToScroll), b.slideCount <= b.options.slidesToShow && (b.currentSlide = 0), b.registerBreakpoints(), b.setProps(), b.setupInfinite(), b.buildArrows(), b.updateArrows(), b.initArrowEvents(), b.buildDots(), b.updateDots(), b.initDotEvents(), b.cleanUpSlideEvents(), b.initSlideEvents(), b.checkResponsive(!1, !0), !0 === b.options.focusOnSelect && a(b.$slideTrack).children().on("click.slick", b.selectHandler), b.setSlideClasses("number" == typeof b.currentSlide ? b.currentSlide : 0), b.setPosition(), b.focusHandler(), b.paused = !b.options.autoplay, b.autoPlay(), b.$slider.trigger("reInit", [b])
    }, b.prototype.resize = function() {
        var b = this;
        a(window).width() !== b.windowWidth && (clearTimeout(b.windowDelay), b.windowDelay = window.setTimeout(function() {
            b.windowWidth = a(window).width(), b.checkResponsive(), b.unslicked || b.setPosition()
        }, 50))
    }, b.prototype.removeSlide = b.prototype.slickRemove = function(a, b, c) {
        var d = this;
        if ("boolean" == typeof a ? (b = a, a = !0 === b ? 0 : d.slideCount - 1) : a = !0 === b ? --a : a, d.slideCount < 1 || a < 0 || a > d.slideCount - 1) return !1;
        d.unload(), !0 === c ? d.$slideTrack.children().remove() : d.$slideTrack.children(this.options.slide).eq(a).remove(), d.$slides = d.$slideTrack.children(this.options.slide), d.$slideTrack.children(this.options.slide).detach(), d.$slideTrack.append(d.$slides), d.$slidesCache = d.$slides, d.reinit()
    }, b.prototype.setCSS = function(a) {
        var b, c, d = this,
            e = {};
        !0 === d.options.rtl && (a = -a), b = "left" == d.positionProp ? Math.ceil(a) + "px" : "0px", c = "top" == d.positionProp ? Math.ceil(a) + "px" : "0px", e[d.positionProp] = a, !1 === d.transformsEnabled ? d.$slideTrack.css(e) : (e = {}, !1 === d.cssTransitions ? (e[d.animType] = "translate(" + b + ", " + c + ")", d.$slideTrack.css(e)) : (e[d.animType] = "translate3d(" + b + ", " + c + ", 0px)", d.$slideTrack.css(e)))
    }, b.prototype.setDimensions = function() {
        var a = this;
        !1 === a.options.vertical ? !0 === a.options.centerMode && a.$list.css({
            padding: "0px " + a.options.centerPadding
        }) : (a.$list.height(a.$slides.first().outerHeight(!0) * a.options.slidesToShow), !0 === a.options.centerMode && a.$list.css({
            padding: a.options.centerPadding + " 0px"
        })), a.listWidth = a.$list.width(), a.listHeight = a.$list.height(), !1 === a.options.vertical && !1 === a.options.variableWidth ? (a.slideWidth = Math.ceil(a.listWidth / a.options.slidesToShow), a.$slideTrack.width(Math.ceil(a.slideWidth * a.$slideTrack.children(".slick-slide").length))) : !0 === a.options.variableWidth ? a.$slideTrack.width(5e3 * a.slideCount) : (a.slideWidth = Math.ceil(a.listWidth), a.$slideTrack.height(Math.ceil(a.$slides.first().outerHeight(!0) * a.$slideTrack.children(".slick-slide").length)));
        var b = a.$slides.first().outerWidth(!0) - a.$slides.first().width();
        !1 === a.options.variableWidth && a.$slideTrack.children(".slick-slide").width(a.slideWidth - b)
    }, b.prototype.setFade = function() {
        var b, c = this;
        c.$slides.each(function(d, e) {
            b = c.slideWidth * d * -1, !0 === c.options.rtl ? a(e).css({
                position: "relative",
                right: b,
                top: 0,
                zIndex: c.options.zIndex - 2,
                opacity: 0
            }) : a(e).css({
                position: "relative",
                left: b,
                top: 0,
                zIndex: c.options.zIndex - 2,
                opacity: 0
            })
        }), c.$slides.eq(c.currentSlide).css({
            zIndex: c.options.zIndex - 1,
            opacity: 1
        })
    }, b.prototype.setHeight = function() {
        var a = this;
        if (1 === a.options.slidesToShow && !0 === a.options.adaptiveHeight && !1 === a.options.vertical) {
            var b = a.$slides.eq(a.currentSlide).outerHeight(!0);
            a.$list.css("height", b)
        }
    }, b.prototype.setOption = b.prototype.slickSetOption = function() {
        var b, c, d, e, f, g = this,
            h = !1;
        if ("object" === a.type(arguments[0]) ? (d = arguments[0], h = arguments[1], f = "multiple") : "string" === a.type(arguments[0]) && (d = arguments[0], e = arguments[1], h = arguments[2], "responsive" === arguments[0] && "array" === a.type(arguments[1]) ? f = "responsive" : void 0 !== arguments[1] && (f = "single")), "single" === f) g.options[d] = e;
        else if ("multiple" === f) a.each(d, function(a, b) {
            g.options[a] = b
        });
        else if ("responsive" === f)
            for (c in e)
                if ("array" !== a.type(g.options.responsive)) g.options.responsive = [e[c]];
                else {
                    for (b = g.options.responsive.length - 1; b >= 0;) g.options.responsive[b].breakpoint === e[c].breakpoint && g.options.responsive.splice(b, 1), b--;
                    g.options.responsive.push(e[c])
                } h && (g.unload(), g.reinit())
    }, b.prototype.setPosition = function() {
        var a = this;
        a.setDimensions(), a.setHeight(), !1 === a.options.fade ? a.setCSS(a.getLeft(a.currentSlide)) : a.setFade(), a.$slider.trigger("setPosition", [a])
    }, b.prototype.setProps = function() {
        var a = this,
            b = document.body.style;
        a.positionProp = !0 === a.options.vertical ? "top" : "left", "top" === a.positionProp ? a.$slider.addClass("slick-vertical") : a.$slider.removeClass("slick-vertical"), void 0 === b.WebkitTransition && void 0 === b.MozTransition && void 0 === b.msTransition || !0 === a.options.useCSS && (a.cssTransitions = !0), a.options.fade && ("number" == typeof a.options.zIndex ? a.options.zIndex < 3 && (a.options.zIndex = 3) : a.options.zIndex = a.defaults.zIndex), void 0 !== b.OTransform && (a.animType = "OTransform", a.transformType = "-o-transform", a.transitionType = "OTransition", void 0 === b.perspectiveProperty && void 0 === b.webkitPerspective && (a.animType = !1)), void 0 !== b.MozTransform && (a.animType = "MozTransform", a.transformType = "-moz-transform", a.transitionType = "MozTransition", void 0 === b.perspectiveProperty && void 0 === b.MozPerspective && (a.animType = !1)), void 0 !== b.webkitTransform && (a.animType = "webkitTransform", a.transformType = "-webkit-transform", a.transitionType = "webkitTransition", void 0 === b.perspectiveProperty && void 0 === b.webkitPerspective && (a.animType = !1)), void 0 !== b.msTransform && (a.animType = "msTransform", a.transformType = "-ms-transform", a.transitionType = "msTransition", void 0 === b.msTransform && (a.animType = !1)), void 0 !== b.transform && !1 !== a.animType && (a.animType = "transform", a.transformType = "transform", a.transitionType = "transition"), a.transformsEnabled = a.options.useTransform && null !== a.animType && !1 !== a.animType
    }, b.prototype.setSlideClasses = function(a) {
        var b, c, d, e, f = this;
        if (c = f.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true"), f.$slides.eq(a).addClass("slick-current"), !0 === f.options.centerMode) {
            var g = f.options.slidesToShow % 2 == 0 ? 1 : 0;
            b = Math.floor(f.options.slidesToShow / 2), !0 === f.options.infinite && (a >= b && a <= f.slideCount - 1 - b ? f.$slides.slice(a - b + g, a + b + 1).addClass("slick-active").attr("aria-hidden", "false") : (d = f.options.slidesToShow + a, c.slice(d - b + 1 + g, d + b + 2).addClass("slick-active").attr("aria-hidden", "false")), 0 === a ? c.eq(c.length - 1 - f.options.slidesToShow).addClass("slick-center") : a === f.slideCount - 1 && c.eq(f.options.slidesToShow).addClass("slick-center")), f.$slides.eq(a).addClass("slick-center")
        } else a >= 0 && a <= f.slideCount - f.options.slidesToShow ? f.$slides.slice(a, a + f.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false") : c.length <= f.options.slidesToShow ? c.addClass("slick-active").attr("aria-hidden", "false") : (e = f.slideCount % f.options.slidesToShow, d = !0 === f.options.infinite ? f.options.slidesToShow + a : a, f.options.slidesToShow == f.options.slidesToScroll && f.slideCount - a < f.options.slidesToShow ? c.slice(d - (f.options.slidesToShow - e), d + e).addClass("slick-active").attr("aria-hidden", "false") : c.slice(d, d + f.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false"));
        "ondemand" !== f.options.lazyLoad && "anticipated" !== f.options.lazyLoad || f.lazyLoad()
    }, b.prototype.setupInfinite = function() {
        var b, c, d, e = this;
        if (!0 === e.options.fade && (e.options.centerMode = !1), !0 === e.options.infinite && !1 === e.options.fade && (c = null, e.slideCount > e.options.slidesToShow)) {
            for (d = !0 === e.options.centerMode ? e.options.slidesToShow + 1 : e.options.slidesToShow, b = e.slideCount; b > e.slideCount - d; b -= 1) c = b - 1, a(e.$slides[c]).clone(!0).attr("id", "").attr("data-slick-index", c - e.slideCount).prependTo(e.$slideTrack).addClass("slick-cloned");
            for (b = 0; b < d + e.slideCount; b += 1) c = b, a(e.$slides[c]).clone(!0).attr("id", "").attr("data-slick-index", c + e.slideCount).appendTo(e.$slideTrack).addClass("slick-cloned");
            e.$slideTrack.find(".slick-cloned").find("[id]").each(function() {
                a(this).attr("id", "")
            })
        }
    }, b.prototype.interrupt = function(a) {
        var b = this;
        a || b.autoPlay(), b.interrupted = a
    }, b.prototype.selectHandler = function(b) {
        var c = this,
            d = a(b.target).is(".slick-slide") ? a(b.target) : a(b.target).parents(".slick-slide"),
            e = parseInt(d.attr("data-slick-index"));
        if (e || (e = 0), c.slideCount <= c.options.slidesToShow) return void c.slideHandler(e, !1, !0);
        c.slideHandler(e)
    }, b.prototype.slideHandler = function(a, b, c) {
        var d, e, f, g, h, i = null,
            j = this;
        if (b = b || !1, !(!0 === j.animating && !0 === j.options.waitForAnimate || !0 === j.options.fade && j.currentSlide === a)) {
            if (!1 === b && j.asNavFor(a), d = a, i = j.getLeft(d), g = j.getLeft(j.currentSlide), j.currentLeft = null === j.swipeLeft ? g : j.swipeLeft, !1 === j.options.infinite && !1 === j.options.centerMode && (a < 0 || a > j.getDotCount() * j.options.slidesToScroll)) return void(!1 === j.options.fade && (d = j.currentSlide, !0 !== c && j.slideCount > j.options.slidesToShow ? j.animateSlide(g, function() {
                j.postSlide(d)
            }) : j.postSlide(d)));
            if (!1 === j.options.infinite && !0 === j.options.centerMode && (a < 0 || a > j.slideCount - j.options.slidesToScroll)) return void(!1 === j.options.fade && (d = j.currentSlide, !0 !== c && j.slideCount > j.options.slidesToShow ? j.animateSlide(g, function() {
                j.postSlide(d)
            }) : j.postSlide(d)));
            if (j.options.autoplay && clearInterval(j.autoPlayTimer), e = d < 0 ? j.slideCount % j.options.slidesToScroll != 0 ? j.slideCount - j.slideCount % j.options.slidesToScroll : j.slideCount + d : d >= j.slideCount ? j.slideCount % j.options.slidesToScroll != 0 ? 0 : d - j.slideCount : d, j.animating = !0, j.$slider.trigger("beforeChange", [j, j.currentSlide, e]), f = j.currentSlide, j.currentSlide = e, j.setSlideClasses(j.currentSlide), j.options.asNavFor && (h = j.getNavTarget(), h = h.slick("getSlick"), h.slideCount <= h.options.slidesToShow && h.setSlideClasses(j.currentSlide)), j.updateDots(), j.updateArrows(), !0 === j.options.fade) return !0 !== c ? (j.fadeSlideOut(f), j.fadeSlide(e, function() {
                j.postSlide(e)
            })) : j.postSlide(e), void j.animateHeight();
            !0 !== c && j.slideCount > j.options.slidesToShow ? j.animateSlide(i, function() {
                j.postSlide(e)
            }) : j.postSlide(e)
        }
    }, b.prototype.startLoad = function() {
        var a = this;
        !0 === a.options.arrows && a.slideCount > a.options.slidesToShow && (a.$prevArrow.hide(), a.$nextArrow.hide()), !0 === a.options.dots && a.slideCount > a.options.slidesToShow && a.$dots.hide(), a.$slider.addClass("slick-loading")
    }, b.prototype.swipeDirection = function() {
        var a, b, c, d, e = this;
        return a = e.touchObject.startX - e.touchObject.curX, b = e.touchObject.startY - e.touchObject.curY, c = Math.atan2(b, a), d = Math.round(180 * c / Math.PI), d < 0 && (d = 360 - Math.abs(d)), d <= 45 && d >= 0 ? !1 === e.options.rtl ? "left" : "right" : d <= 360 && d >= 315 ? !1 === e.options.rtl ? "left" : "right" : d >= 135 && d <= 225 ? !1 === e.options.rtl ? "right" : "left" : !0 === e.options.verticalSwiping ? d >= 35 && d <= 135 ? "down" : "up" : "vertical"
    }, b.prototype.swipeEnd = function(a) {
        var b, c, d = this;
        if (d.dragging = !1, d.swiping = !1, d.scrolling) return d.scrolling = !1, !1;
        if (d.interrupted = !1, d.shouldClick = !(d.touchObject.swipeLength > 10), void 0 === d.touchObject.curX) return !1;
        if (!0 === d.touchObject.edgeHit && d.$slider.trigger("edge", [d, d.swipeDirection()]), d.touchObject.swipeLength >= d.touchObject.minSwipe) {
            switch (c = d.swipeDirection()) {
                case "left":
                case "down":
                    b = d.options.swipeToSlide ? d.checkNavigable(d.currentSlide + d.getSlideCount()) : d.currentSlide + d.getSlideCount(), d.currentDirection = 0;
                    break;
                case "right":
                case "up":
                    b = d.options.swipeToSlide ? d.checkNavigable(d.currentSlide - d.getSlideCount()) : d.currentSlide - d.getSlideCount(), d.currentDirection = 1
            }
            "vertical" != c && (d.slideHandler(b), d.touchObject = {}, d.$slider.trigger("swipe", [d, c]))
        } else d.touchObject.startX !== d.touchObject.curX && (d.slideHandler(d.currentSlide), d.touchObject = {})
    }, b.prototype.swipeHandler = function(a) {
        var b = this;
        if (!(!1 === b.options.swipe || "ontouchend" in document && !1 === b.options.swipe || !1 === b.options.draggable && -1 !== a.type.indexOf("mouse"))) switch (b.touchObject.fingerCount = a.originalEvent && void 0 !== a.originalEvent.touches ? a.originalEvent.touches.length : 1, b.touchObject.minSwipe = b.listWidth / b.options.touchThreshold, !0 === b.options.verticalSwiping && (b.touchObject.minSwipe = b.listHeight / b.options.touchThreshold), a.data.action) {
            case "start":
                b.swipeStart(a);
                break;
            case "move":
                b.swipeMove(a);
                break;
            case "end":
                b.swipeEnd(a)
        }
    }, b.prototype.swipeMove = function(a) {
        var b, c, d, e, f, g, h = this;
        return f = void 0 !== a.originalEvent ? a.originalEvent.touches : null, !(!h.dragging || h.scrolling || f && 1 !== f.length) && (b = h.getLeft(h.currentSlide), h.touchObject.curX = void 0 !== f ? f[0].pageX : a.clientX, h.touchObject.curY = void 0 !== f ? f[0].pageY : a.clientY, h.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(h.touchObject.curX - h.touchObject.startX, 2))), g = Math.round(Math.sqrt(Math.pow(h.touchObject.curY - h.touchObject.startY, 2))), !h.options.verticalSwiping && !h.swiping && g > 4 ? (h.scrolling = !0, !1) : (!0 === h.options.verticalSwiping && (h.touchObject.swipeLength = g), c = h.swipeDirection(), void 0 !== a.originalEvent && h.touchObject.swipeLength > 4 && (h.swiping = !0, a.preventDefault()), e = (!1 === h.options.rtl ? 1 : -1) * (h.touchObject.curX > h.touchObject.startX ? 1 : -1), !0 === h.options.verticalSwiping && (e = h.touchObject.curY > h.touchObject.startY ? 1 : -1), d = h.touchObject.swipeLength, h.touchObject.edgeHit = !1, !1 === h.options.infinite && (0 === h.currentSlide && "right" === c || h.currentSlide >= h.getDotCount() && "left" === c) && (d = h.touchObject.swipeLength * h.options.edgeFriction, h.touchObject.edgeHit = !0), !1 === h.options.vertical ? h.swipeLeft = b + d * e : h.swipeLeft = b + d * (h.$list.height() / h.listWidth) * e, !0 === h.options.verticalSwiping && (h.swipeLeft = b + d * e), !0 !== h.options.fade && !1 !== h.options.touchMove && (!0 === h.animating ? (h.swipeLeft = null, !1) : void h.setCSS(h.swipeLeft))))
    }, b.prototype.swipeStart = function(a) {
        var b, c = this;
        if (c.interrupted = !0, 1 !== c.touchObject.fingerCount || c.slideCount <= c.options.slidesToShow) return c.touchObject = {}, !1;
        void 0 !== a.originalEvent && void 0 !== a.originalEvent.touches && (b = a.originalEvent.touches[0]), c.touchObject.startX = c.touchObject.curX = void 0 !== b ? b.pageX : a.clientX, c.touchObject.startY = c.touchObject.curY = void 0 !== b ? b.pageY : a.clientY, c.dragging = !0
    }, b.prototype.unfilterSlides = b.prototype.slickUnfilter = function() {
        var a = this;
        null !== a.$slidesCache && (a.unload(), a.$slideTrack.children(this.options.slide).detach(), a.$slidesCache.appendTo(a.$slideTrack), a.reinit())
    }, b.prototype.unload = function() {
        var b = this;
        a(".slick-cloned", b.$slider).remove(), b.$dots && b.$dots.remove(), b.$prevArrow && b.htmlExpr.test(b.options.prevArrow) && b.$prevArrow.remove(), b.$nextArrow && b.htmlExpr.test(b.options.nextArrow) && b.$nextArrow.remove(), b.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "")
    }, b.prototype.unslick = function(a) {
        var b = this;
        b.$slider.trigger("unslick", [b, a]), b.destroy()
    }, b.prototype.updateArrows = function() {
        var a = this;
        Math.floor(a.options.slidesToShow / 2), !0 === a.options.arrows && a.slideCount > a.options.slidesToShow && !a.options.infinite && (a.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), a.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), 0 === a.currentSlide ? (a.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"), a.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : a.currentSlide >= a.slideCount - a.options.slidesToShow && !1 === a.options.centerMode ? (a.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), a.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : a.currentSlide >= a.slideCount - 1 && !0 === a.options.centerMode && (a.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), a.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")))
    }, b.prototype.updateDots = function() {
        var a = this;
        null !== a.$dots && (a.$dots.find("li").removeClass("slick-active").end(), a.$dots.find("li").eq(Math.floor(a.currentSlide / a.options.slidesToScroll)).addClass("slick-active"))
    }, b.prototype.visibility = function() {
        var a = this;
        a.options.autoplay && (document[a.hidden] ? a.interrupted = !0 : a.interrupted = !1)
    }, a.fn.slick = function() {
        var a, c, d = this,
            e = arguments[0],
            f = Array.prototype.slice.call(arguments, 1),
            g = d.length;
        for (a = 0; a < g; a++)
            if ("object" == typeof e || void 0 === e ? d[a].slick = new b(d[a], e) : c = d[a].slick[e].apply(d[a].slick, f), void 0 !== c) return c;
        return d
    }
}),
function(a) {
    "function" == typeof define && define.amd ? define(["jquery"], a) : a("object" == typeof exports ? require("jquery") : window.jQuery || window.Zepto)
}(function(a) {
    var b, c, d, e, f, g, h = "Close",
        i = "BeforeClose",
        j = "MarkupParse",
        k = "Open",
        l = "Change",
        m = "mfp",
        n = "." + m,
        o = "mfp-ready",
        p = "mfp-removing",
        q = "mfp-prevent-close",
        r = function() {},
        s = !!window.jQuery,
        t = a(window),
        u = function(a, c) {
            b.ev.on(m + a + n, c)
        },
        v = function(b, c, d, e) {
            var f = document.createElement("div");
            return f.className = "mfp-" + b, d && (f.innerHTML = d), e ? c && c.appendChild(f) : (f = a(f), c && f.appendTo(c)), f
        },
        w = function(c, d) {
            b.ev.triggerHandler(m + c, d), b.st.callbacks && (c = c.charAt(0).toLowerCase() + c.slice(1), b.st.callbacks[c] && b.st.callbacks[c].apply(b, a.isArray(d) ? d : [d]))
        },
        x = function(c) {
            return c === g && b.currTemplate.closeBtn || (b.currTemplate.closeBtn = a(b.st.closeMarkup.replace("%title%", b.st.tClose)), g = c), b.currTemplate.closeBtn
        },
        y = function() {
            a.magnificPopup.instance || (b = new r, b.init(), a.magnificPopup.instance = b)
        },
        z = function() {
            var a = document.createElement("p").style,
                b = ["ms", "O", "Moz", "Webkit"];
            if (void 0 !== a.transition) return !0;
            for (; b.length;)
                if (b.pop() + "Transition" in a) return !0;
            return !1
        };
    r.prototype = {
        constructor: r,
        init: function() {
            var c = navigator.appVersion;
            b.isLowIE = b.isIE8 = document.all && !document.addEventListener, b.isAndroid = /android/gi.test(c), b.isIOS = /iphone|ipad|ipod/gi.test(c), b.supportsTransition = z(), b.probablyMobile = b.isAndroid || b.isIOS || /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent), d = a(document), b.popupsCache = {}
        },
        open: function(c) {
            var e;
            if (!1 === c.isObj) {
                b.items = c.items.toArray(), b.index = 0;
                var g, h = c.items;
                for (e = 0; e < h.length; e++)
                    if (g = h[e], g.parsed && (g = g.el[0]), g === c.el[0]) {
                        b.index = e;
                        break
                    }
            } else b.items = a.isArray(c.items) ? c.items : [c.items], b.index = c.index || 0;
            if (b.isOpen) return void b.updateItemHTML();
            b.types = [], f = "", c.mainEl && c.mainEl.length ? b.ev = c.mainEl.eq(0) : b.ev = d, c.key ? (b.popupsCache[c.key] || (b.popupsCache[c.key] = {}), b.currTemplate = b.popupsCache[c.key]) : b.currTemplate = {}, b.st = a.extend(!0, {}, a.magnificPopup.defaults, c), b.fixedContentPos = "auto" === b.st.fixedContentPos ? !b.probablyMobile : b.st.fixedContentPos, b.st.modal && (b.st.closeOnContentClick = !1, b.st.closeOnBgClick = !1, b.st.showCloseBtn = !1, b.st.enableEscapeKey = !1), b.bgOverlay || (b.bgOverlay = v("bg").on("click" + n, function() {
                b.close()
            }), b.wrap = v("wrap").attr("tabindex", -1).on("click" + n, function(a) {
                b._checkIfClose(a.target) && b.close()
            }), b.container = v("container", b.wrap)), b.contentContainer = v("content"), b.st.preloader && (b.preloader = v("preloader", b.container, b.st.tLoading));
            var i = a.magnificPopup.modules;
            for (e = 0; e < i.length; e++) {
                var l = i[e];
                l = l.charAt(0).toUpperCase() + l.slice(1), b["init" + l].call(b)
            }
            w("BeforeOpen"), b.st.showCloseBtn && (b.st.closeBtnInside ? (u(j, function(a, b, c, d) {
                c.close_replaceWith = x(d.type)
            }), f += " mfp-close-btn-in") : b.wrap.append(x())), b.st.alignTop && (f += " mfp-align-top"), b.fixedContentPos ? b.wrap.css({
                overflow: b.st.overflowY,
                overflowX: "hidden",
                overflowY: b.st.overflowY
            }) : b.wrap.css({
                top: t.scrollTop(),
                position: "absolute"
            }), (!1 === b.st.fixedBgPos || "auto" === b.st.fixedBgPos && !b.fixedContentPos) && b.bgOverlay.css({
                height: d.height(),
                position: "absolute"
            }), b.st.enableEscapeKey && d.on("keyup" + n, function(a) {
                27 === a.keyCode && b.close()
            }), t.on("resize" + n, function() {
                b.updateSize()
            }), b.st.closeOnContentClick || (f += " mfp-auto-cursor"), f && b.wrap.addClass(f);
            var m = b.wH = t.height(),
                p = {};
            if (b.fixedContentPos && b._hasScrollBar(m)) {
                var q = b._getScrollbarSize();
                q && (p.marginRight = q)
            }
            b.fixedContentPos && (b.isIE7 ? a("body, html").css("overflow", "hidden") : p.overflow = "hidden");
            var r = b.st.mainClass;
            return b.isIE7 && (r += " mfp-ie7"), r && b._addClassToMFP(r), b.updateItemHTML(), w("BuildControls"), a("html").css(p), b.bgOverlay.add(b.wrap).prependTo(b.st.prependTo || a(document.body)), b._lastFocusedEl = document.activeElement, setTimeout(function() {
                b.content ? (b._addClassToMFP(o), b._setFocus()) : b.bgOverlay.addClass(o), d.on("focusin" + n, b._onFocusIn)
            }, 16), b.isOpen = !0, b.updateSize(m), w(k), c
        },
        close: function() {
            b.isOpen && (w(i), b.isOpen = !1, b.st.removalDelay && !b.isLowIE && b.supportsTransition ? (b._addClassToMFP(p), setTimeout(function() {
                b._close()
            }, b.st.removalDelay)) : b._close())
        },
        _close: function() {
            w(h);
            var c = p + " " + o + " ";
            if (b.bgOverlay.detach(), b.wrap.detach(), b.container.empty(), b.st.mainClass && (c += b.st.mainClass + " "), b._removeClassFromMFP(c), b.fixedContentPos) {
                var e = {
                    marginRight: ""
                };
                b.isIE7 ? a("body, html").css("overflow", "") : e.overflow = "", a("html").css(e)
            }
            d.off("keyup" + n + " focusin" + n), b.ev.off(n), b.wrap.attr("class", "mfp-wrap").removeAttr("style"), b.bgOverlay.attr("class", "mfp-bg"), b.container.attr("class", "mfp-container"), !b.st.showCloseBtn || b.st.closeBtnInside && !0 !== b.currTemplate[b.currItem.type] || b.currTemplate.closeBtn && b.currTemplate.closeBtn.detach(), b.st.autoFocusLast && b._lastFocusedEl && a(b._lastFocusedEl).focus(), b.currItem = null, b.content = null, b.currTemplate = null, b.prevHeight = 0, w("AfterClose")
        },
        updateSize: function(a) {
            if (b.isIOS) {
                var c = document.documentElement.clientWidth / window.innerWidth,
                    d = window.innerHeight * c;
                b.wrap.css("height", d), b.wH = d
            } else b.wH = a || t.height();
            b.fixedContentPos || b.wrap.css("height", b.wH), w("Resize")
        },
        updateItemHTML: function() {
            var c = b.items[b.index];
            b.contentContainer.detach(), b.content && b.content.detach(), c.parsed || (c = b.parseEl(b.index));
            var d = c.type;
            if (w("BeforeChange", [b.currItem ? b.currItem.type : "", d]), b.currItem = c, !b.currTemplate[d]) {
                var f = !!b.st[d] && b.st[d].markup;
                w("FirstMarkupParse", f), b.currTemplate[d] = !f || a(f)
            }
            e && e !== c.type && b.container.removeClass("mfp-" + e + "-holder");
            var g = b["get" + d.charAt(0).toUpperCase() + d.slice(1)](c, b.currTemplate[d]);
            b.appendContent(g, d), c.preloaded = !0, w(l, c), e = c.type, b.container.prepend(b.contentContainer), w("AfterChange")
        },
        appendContent: function(a, c) {
            b.content = a, a ? b.st.showCloseBtn && b.st.closeBtnInside && !0 === b.currTemplate[c] ? b.content.find(".mfp-close").length || b.content.append(x()) : b.content = a : b.content = "", w("BeforeAppend"), b.container.addClass("mfp-" + c + "-holder"), b.contentContainer.append(b.content)
        },
        parseEl: function(c) {
            var d, e = b.items[c];
            if (e.tagName ? e = {
                    el: a(e)
                } : (d = e.type, e = {
                    data: e,
                    src: e.src
                }), e.el) {
                for (var f = b.types, g = 0; g < f.length; g++)
                    if (e.el.hasClass("mfp-" + f[g])) {
                        d = f[g];
                        break
                    } e.src = e.el.attr("data-mfp-src"), e.src || (e.src = e.el.attr("href"))
            }
            return e.type = d || b.st.type || "inline", e.index = c, e.parsed = !0, b.items[c] = e, w("ElementParse", e), b.items[c]
        },
        addGroup: function(a, c) {
            var d = function(d) {
                d.mfpEl = this, b._openClick(d, a, c)
            };
            c || (c = {});
            var e = "click.magnificPopup";
            c.mainEl = a, c.items ? (c.isObj = !0, a.off(e).on(e, d)) : (c.isObj = !1, c.delegate ? a.off(e).on(e, c.delegate, d) : (c.items = a, a.off(e).on(e, d)))
        },
        _openClick: function(c, d, e) {
            if ((void 0 !== e.midClick ? e.midClick : a.magnificPopup.defaults.midClick) || !(2 === c.which || c.ctrlKey || c.metaKey || c.altKey || c.shiftKey)) {
                var f = void 0 !== e.disableOn ? e.disableOn : a.magnificPopup.defaults.disableOn;
                if (f)
                    if (a.isFunction(f)) {
                        if (!f.call(b)) return !0
                    } else if (t.width() < f) return !0;
                c.type && (c.preventDefault(), b.isOpen && c.stopPropagation()), e.el = a(c.mfpEl), e.delegate && (e.items = d.find(e.delegate)), b.open(e)
            }
        },
        updateStatus: function(a, d) {
            if (b.preloader) {
                c !== a && b.container.removeClass("mfp-s-" + c), d || "loading" !== a || (d = b.st.tLoading);
                var e = {
                    status: a,
                    text: d
                };
                w("UpdateStatus", e), a = e.status, d = e.text, b.preloader.html(d), b.preloader.find("a").on("click", function(a) {
                    a.stopImmediatePropagation()
                }), b.container.addClass("mfp-s-" + a), c = a
            }
        },
        _checkIfClose: function(c) {
            if (!a(c).hasClass(q)) {
                var d = b.st.closeOnContentClick,
                    e = b.st.closeOnBgClick;
                if (d && e) return !0;
                if (!b.content || a(c).hasClass("mfp-close") || b.preloader && c === b.preloader[0]) return !0;
                if (c === b.content[0] || a.contains(b.content[0], c)) {
                    if (d) return !0
                } else if (e && a.contains(document, c)) return !0;
                return !1
            }
        },
        _addClassToMFP: function(a) {
            b.bgOverlay.addClass(a), b.wrap.addClass(a)
        },
        _removeClassFromMFP: function(a) {
            this.bgOverlay.removeClass(a), b.wrap.removeClass(a)
        },
        _hasScrollBar: function(a) {
            return (b.isIE7 ? d.height() : document.body.scrollHeight) > (a || t.height())
        },
        _setFocus: function() {
            (b.st.focus ? b.content.find(b.st.focus).eq(0) : b.wrap).focus()
        },
        _onFocusIn: function(c) {
            return c.target === b.wrap[0] || a.contains(b.wrap[0], c.target) ? void 0 : (b._setFocus(), !1)
        },
        _parseMarkup: function(b, c, d) {
            var e;
            d.data && (c = a.extend(d.data, c)), w(j, [b, c, d]), a.each(c, function(c, d) {
                if (void 0 === d || !1 === d) return !0;
                if (e = c.split("_"), e.length > 1) {
                    var f = b.find(n + "-" + e[0]);
                    if (f.length > 0) {
                        var g = e[1];
                        "replaceWith" === g ? f[0] !== d[0] && f.replaceWith(d) : "img" === g ? f.is("img") ? f.attr("src", d) : f.replaceWith(a("<img>").attr("src", d).attr("class", f.attr("class"))) : f.attr(e[1], d)
                    }
                } else b.find(n + "-" + c).html(d)
            })
        },
        _getScrollbarSize: function() {
            if (void 0 === b.scrollbarSize) {
                var a = document.createElement("div");
                a.style.cssText = "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;", document.body.appendChild(a), b.scrollbarSize = a.offsetWidth - a.clientWidth, document.body.removeChild(a)
            }
            return b.scrollbarSize
        }
    }, a.magnificPopup = {
        instance: null,
        proto: r.prototype,
        modules: [],
        open: function(b, c) {
            return y(), b = b ? a.extend(!0, {}, b) : {}, b.isObj = !0, b.index = c || 0, this.instance.open(b)
        },
        close: function() {
            return a.magnificPopup.instance && a.magnificPopup.instance.close()
        },
        registerModule: function(b, c) {
            c.options && (a.magnificPopup.defaults[b] = c.options), a.extend(this.proto, c.proto),
                this.modules.push(b)
        },
        defaults: {
            disableOn: 0,
            key: null,
            midClick: !1,
            mainClass: "",
            preloader: !0,
            focus: "",
            closeOnContentClick: !1,
            closeOnBgClick: !0,
            closeBtnInside: !0,
            showCloseBtn: !0,
            enableEscapeKey: !0,
            modal: !1,
            alignTop: !1,
            removalDelay: 0,
            prependTo: null,
            fixedContentPos: "auto",
            fixedBgPos: "auto",
            overflowY: "auto",
            closeMarkup: '<button title="%title%" type="button" class="mfp-close">&#215;</button>',
            tClose: "Close (Esc)",
            tLoading: "Loading...",
            autoFocusLast: !0
        }
    }, a.fn.magnificPopup = function(c) {
        y();
        var d = a(this);
        if ("string" == typeof c)
            if ("open" === c) {
                var e, f = s ? d.data("magnificPopup") : d[0].magnificPopup,
                    g = parseInt(arguments[1], 10) || 0;
                f.items ? e = f.items[g] : (e = d, f.delegate && (e = e.find(f.delegate)), e = e.eq(g)), b._openClick({
                    mfpEl: e
                }, d, f)
            } else b.isOpen && b[c].apply(b, Array.prototype.slice.call(arguments, 1));
        else c = a.extend(!0, {}, c), s ? d.data("magnificPopup", c) : d[0].magnificPopup = c, b.addGroup(d, c);
        return d
    };
    var A, B, C, D = "inline",
        E = function() {
            C && (B.after(C.addClass(A)).detach(), C = null)
        };
    a.magnificPopup.registerModule(D, {
        options: {
            hiddenClass: "hide",
            markup: "",
            tNotFound: "Content not found"
        },
        proto: {
            initInline: function() {
                b.types.push(D), u(h + "." + D, function() {
                    E()
                })
            },
            getInline: function(c, d) {
                if (E(), c.src) {
                    var e = b.st.inline,
                        f = a(c.src);
                    if (f.length) {
                        var g = f[0].parentNode;
                        g && g.tagName && (B || (A = e.hiddenClass, B = v(A), A = "mfp-" + A), C = f.after(B).detach().removeClass(A)), b.updateStatus("ready")
                    } else b.updateStatus("error", e.tNotFound), f = a("<div>");
                    return c.inlineElement = f, f
                }
                return b.updateStatus("ready"), b._parseMarkup(d, {}, c), d
            }
        }
    });
    var F, G = "ajax",
        H = function() {
            F && a(document.body).removeClass(F)
        },
        I = function() {
            H(), b.req && b.req.abort()
        };
    a.magnificPopup.registerModule(G, {
        options: {
            settings: null,
            cursor: "mfp-ajax-cur",
            tError: '<a href="%url%">The content</a> could not be loaded.'
        },
        proto: {
            initAjax: function() {
                b.types.push(G), F = b.st.ajax.cursor, u(h + "." + G, I), u("BeforeChange." + G, I)
            },
            getAjax: function(c) {
                F && a(document.body).addClass(F), b.updateStatus("loading");
                var d = a.extend({
                    url: c.src,
                    success: function(d, e, f) {
                        var g = {
                            data: d,
                            xhr: f
                        };
                        w("ParseAjax", g), b.appendContent(a(g.data), G), c.finished = !0, H(), b._setFocus(), setTimeout(function() {
                            b.wrap.addClass(o)
                        }, 16), b.updateStatus("ready"), w("AjaxContentAdded")
                    },
                    error: function() {
                        H(), c.finished = c.loadError = !0, b.updateStatus("error", b.st.ajax.tError.replace("%url%", c.src))
                    }
                }, b.st.ajax.settings);
                return b.req = a.ajax(d), ""
            }
        }
    });
    var J, K = function(c) {
        if (c.data && void 0 !== c.data.title) return c.data.title;
        var d = b.st.image.titleSrc;
        if (d) {
            if (a.isFunction(d)) return d.call(b, c);
            if (c.el) return c.el.attr(d) || ""
        }
        return ""
    };
    a.magnificPopup.registerModule("image", {
        options: {
            markup: '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',
            cursor: "mfp-zoom-out-cur",
            titleSrc: "title",
            verticalFit: !0,
            tError: '<a href="%url%">The image</a> could not be loaded.'
        },
        proto: {
            initImage: function() {
                var c = b.st.image,
                    d = ".image";
                b.types.push("image"), u(k + d, function() {
                    "image" === b.currItem.type && c.cursor && a(document.body).addClass(c.cursor)
                }), u(h + d, function() {
                    c.cursor && a(document.body).removeClass(c.cursor), t.off("resize" + n)
                }), u("Resize" + d, b.resizeImage), b.isLowIE && u("AfterChange", b.resizeImage)
            },
            resizeImage: function() {
                var a = b.currItem;
                if (a && a.img && b.st.image.verticalFit) {
                    var c = 0;
                    b.isLowIE && (c = parseInt(a.img.css("padding-top"), 10) + parseInt(a.img.css("padding-bottom"), 10)), a.img.css("max-height", b.wH - c)
                }
            },
            _onImageHasSize: function(a) {
                a.img && (a.hasSize = !0, J && clearInterval(J), a.isCheckingImgSize = !1, w("ImageHasSize", a), a.imgHidden && (b.content && b.content.removeClass("mfp-loading"), a.imgHidden = !1))
            },
            findImageSize: function(a) {
                var c = 0,
                    d = a.img[0],
                    e = function(f) {
                        J && clearInterval(J), J = setInterval(function() {
                            return d.naturalWidth > 0 ? void b._onImageHasSize(a) : (c > 200 && clearInterval(J), c++, void(3 === c ? e(10) : 40 === c ? e(50) : 100 === c && e(500)))
                        }, f)
                    };
                e(1)
            },
            getImage: function(c, d) {
                var e = 0,
                    f = function() {
                        c && (c.img[0].complete ? (c.img.off(".mfploader"), c === b.currItem && (b._onImageHasSize(c), b.updateStatus("ready")), c.hasSize = !0, c.loaded = !0, w("ImageLoadComplete")) : (e++, 200 > e ? setTimeout(f, 100) : g()))
                    },
                    g = function() {
                        c && (c.img.off(".mfploader"), c === b.currItem && (b._onImageHasSize(c), b.updateStatus("error", h.tError.replace("%url%", c.src))), c.hasSize = !0, c.loaded = !0, c.loadError = !0)
                    },
                    h = b.st.image,
                    i = d.find(".mfp-img");
                if (i.length) {
                    var j = document.createElement("img");
                    j.className = "mfp-img", c.el && c.el.find("img").length && (j.alt = c.el.find("img").attr("alt")), c.img = a(j).on("load.mfploader", f).on("error.mfploader", g), j.src = c.src, i.is("img") && (c.img = c.img.clone()), j = c.img[0], j.naturalWidth > 0 ? c.hasSize = !0 : j.width || (c.hasSize = !1)
                }
                return b._parseMarkup(d, {
                    title: K(c),
                    img_replaceWith: c.img
                }, c), b.resizeImage(), c.hasSize ? (J && clearInterval(J), c.loadError ? (d.addClass("mfp-loading"), b.updateStatus("error", h.tError.replace("%url%", c.src))) : (d.removeClass("mfp-loading"), b.updateStatus("ready")), d) : (b.updateStatus("loading"), c.loading = !0, c.hasSize || (c.imgHidden = !0, d.addClass("mfp-loading"), b.findImageSize(c)), d)
            }
        }
    });
    var L, M = function() {
        return void 0 === L && (L = void 0 !== document.createElement("p").style.MozTransform), L
    };
    a.magnificPopup.registerModule("zoom", {
        options: {
            enabled: !1,
            easing: "ease-in-out",
            duration: 300,
            opener: function(a) {
                return a.is("img") ? a : a.find("img")
            }
        },
        proto: {
            initZoom: function() {
                var a, c = b.st.zoom,
                    d = ".zoom";
                if (c.enabled && b.supportsTransition) {
                    var e, f, g = c.duration,
                        j = function(a) {
                            var b = a.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),
                                d = "all " + c.duration / 1e3 + "s " + c.easing,
                                e = {
                                    position: "fixed",
                                    zIndex: 9999,
                                    left: 0,
                                    top: 0,
                                    "-webkit-backface-visibility": "hidden"
                                },
                                f = "transition";
                            return e["-webkit-" + f] = e["-moz-" + f] = e["-o-" + f] = e[f] = d, b.css(e), b
                        },
                        k = function() {
                            b.content.css("visibility", "visible")
                        };
                    u("BuildControls" + d, function() {
                        if (b._allowZoom()) {
                            if (clearTimeout(e), b.content.css("visibility", "hidden"), !(a = b._getItemToZoom())) return void k();
                            f = j(a), f.css(b._getOffset()), b.wrap.append(f), e = setTimeout(function() {
                                f.css(b._getOffset(!0)), e = setTimeout(function() {
                                    k(), setTimeout(function() {
                                        f.remove(), a = f = null, w("ZoomAnimationEnded")
                                    }, 16)
                                }, g)
                            }, 16)
                        }
                    }), u(i + d, function() {
                        if (b._allowZoom()) {
                            if (clearTimeout(e), b.st.removalDelay = g, !a) {
                                if (!(a = b._getItemToZoom())) return;
                                f = j(a)
                            }
                            f.css(b._getOffset(!0)), b.wrap.append(f), b.content.css("visibility", "hidden"), setTimeout(function() {
                                f.css(b._getOffset())
                            }, 16)
                        }
                    }), u(h + d, function() {
                        b._allowZoom() && (k(), f && f.remove(), a = null)
                    })
                }
            },
            _allowZoom: function() {
                return "image" === b.currItem.type
            },
            _getItemToZoom: function() {
                return !!b.currItem.hasSize && b.currItem.img
            },
            _getOffset: function(c) {
                var d;
                d = c ? b.currItem.img : b.st.zoom.opener(b.currItem.el || b.currItem);
                var e = d.offset(),
                    f = parseInt(d.css("padding-top"), 10),
                    g = parseInt(d.css("padding-bottom"), 10);
                e.top -= a(window).scrollTop() - f;
                var h = {
                    width: d.width(),
                    height: (s ? d.innerHeight() : d[0].offsetHeight) - g - f
                };
                return M() ? h["-moz-transform"] = h.transform = "translate(" + e.left + "px," + e.top + "px)" : (h.left = e.left, h.top = e.top), h
            }
        }
    });
    var N = "iframe",
        O = "//about:blank",
        P = function(a) {
            if (b.currTemplate[N]) {
                var c = b.currTemplate[N].find("iframe");
                c.length && (a || (c[0].src = O), b.isIE8 && c.css("display", a ? "block" : "none"))
            }
        };
    a.magnificPopup.registerModule(N, {
        options: {
            markup: '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',
            srcAction: "iframe_src",
            patterns: {
                youtube: {
                    index: "youtube.com",
                    id: "v=",
                    src: "//www.youtube.com/embed/%id%?autoplay=1&rel=0"
                },
                vimeo: {
                    index: "vimeo.com/",
                    id: "/",
                    src: "//player.vimeo.com/video/%id%?autoplay=1"
                },
                gmaps: {
                    index: "//maps.google.",
                    src: "%id%&output=embed"
                }
            }
        },
        proto: {
            initIframe: function() {
                b.types.push(N), u("BeforeChange", function(a, b, c) {
                    b !== c && (b === N ? P() : c === N && P(!0))
                }), u(h + "." + N, function() {
                    P()
                })
            },
            getIframe: function(c, d) {
                var e = c.src,
                    f = b.st.iframe;
                a.each(f.patterns, function() {
                    return e.indexOf(this.index) > -1 ? (this.id && (e = "string" == typeof this.id ? e.substr(e.lastIndexOf(this.id) + this.id.length, e.length) : this.id.call(this, e)), e = this.src.replace("%id%", e), !1) : void 0
                });
                var g = {};
                return f.srcAction && (g[f.srcAction] = e), b._parseMarkup(d, g, c), b.updateStatus("ready"), d
            }
        }
    });
    var Q = function(a) {
            var c = b.items.length;
            return a > c - 1 ? a - c : 0 > a ? c + a : a
        },
        R = function(a, b, c) {
            return a.replace(/%curr%/gi, b + 1).replace(/%total%/gi, c)
        };
    a.magnificPopup.registerModule("gallery", {
        options: {
            enabled: !1,
            arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
            preload: [0, 2],
            navigateByImgClick: !0,
            arrows: !0,
            tPrev: "Previous (Left arrow key)",
            tNext: "Next (Right arrow key)",
            tCounter: "%curr% of %total%"
        },
        proto: {
            initGallery: function() {
                var c = b.st.gallery,
                    e = ".mfp-gallery";
                return b.direction = !0, !(!c || !c.enabled) && (f += " mfp-gallery", u(k + e, function() {
                    c.navigateByImgClick && b.wrap.on("click" + e, ".mfp-img", function() {
                        return b.items.length > 1 ? (b.next(), !1) : void 0
                    }), d.on("keydown" + e, function(a) {
                        37 === a.keyCode ? b.prev() : 39 === a.keyCode && b.next()
                    })
                }), u("UpdateStatus" + e, function(a, c) {
                    c.text && (c.text = R(c.text, b.currItem.index, b.items.length))
                }), u(j + e, function(a, d, e, f) {
                    var g = b.items.length;
                    e.counter = g > 1 ? R(c.tCounter, f.index, g) : ""
                }), u("BuildControls" + e, function() {
                    if (b.items.length > 1 && c.arrows && !b.arrowLeft) {
                        var d = c.arrowMarkup,
                            e = b.arrowLeft = a(d.replace(/%title%/gi, c.tPrev).replace(/%dir%/gi, "left")).addClass(q),
                            f = b.arrowRight = a(d.replace(/%title%/gi, c.tNext).replace(/%dir%/gi, "right")).addClass(q);
                        e.click(function() {
                            b.prev()
                        }), f.click(function() {
                            b.next()
                        }), b.container.append(e.add(f))
                    }
                }), u(l + e, function() {
                    b._preloadTimeout && clearTimeout(b._preloadTimeout), b._preloadTimeout = setTimeout(function() {
                        b.preloadNearbyImages(), b._preloadTimeout = null
                    }, 16)
                }), void u(h + e, function() {
                    d.off(e), b.wrap.off("click" + e), b.arrowRight = b.arrowLeft = null
                }))
            },
            next: function() {
                b.direction = !0, b.index = Q(b.index + 1), b.updateItemHTML()
            },
            prev: function() {
                b.direction = !1, b.index = Q(b.index - 1), b.updateItemHTML()
            },
            goTo: function(a) {
                b.direction = a >= b.index, b.index = a, b.updateItemHTML()
            },
            preloadNearbyImages: function() {
                var a, c = b.st.gallery.preload,
                    d = Math.min(c[0], b.items.length),
                    e = Math.min(c[1], b.items.length);
                for (a = 1; a <= (b.direction ? e : d); a++) b._preloadItem(b.index + a);
                for (a = 1; a <= (b.direction ? d : e); a++) b._preloadItem(b.index - a)
            },
            _preloadItem: function(c) {
                if (c = Q(c), !b.items[c].preloaded) {
                    var d = b.items[c];
                    d.parsed || (d = b.parseEl(c)), w("LazyLoad", d), "image" === d.type && (d.img = a('<img class="mfp-img" />').on("load.mfploader", function() {
                        d.hasSize = !0
                    }).on("error.mfploader", function() {
                        d.hasSize = !0, d.loadError = !0, w("LazyLoadError", d)
                    }).attr("src", d.src)), d.preloaded = !0
                }
            }
        }
    });
    var S = "retina";
    a.magnificPopup.registerModule(S, {
        options: {
            replaceSrc: function(a) {
                return a.src.replace(/\.\w+$/, function(a) {
                    return "@2x" + a
                })
            },
            ratio: 1
        },
        proto: {
            initRetina: function() {
                if (window.devicePixelRatio > 1) {
                    var a = b.st.retina,
                        c = a.ratio;
                    (c = isNaN(c) ? c() : c) > 1 && (u("ImageHasSize." + S, function(a, b) {
                        b.img.css({
                            "max-width": b.img[0].naturalWidth / c,
                            width: "100%"
                        })
                    }), u("ElementParse." + S, function(b, d) {
                        d.src = a.replaceSrc(d, c)
                    }))
                }
            }
        }
    }), y()
}), "object" == typeof navigator && function(a, b) {
        "object" == typeof exports && "undefined" != typeof module ? module.exports = b() : "function" == typeof define && define.amd ? define("Plyr", b) : a.Plyr = b()
    }(this, function() {
        "use strict";

        function a(a, b) {
            return a(b = {
                exports: {}
            }, b.exports), b.exports
        }

        function b(a) {
            var b, c;
            this.promise = new a(function(a, d) {
                if (void 0 !== b || void 0 !== c) throw TypeError("Bad Promise constructor");
                b = a, c = d
            }), this.resolve = ka(b), this.reject = ka(c)
        }

        function c(a, b, c) {
            var d = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
                e = this,
                f = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4],
                g = arguments.length > 5 && void 0 !== arguments[5] && arguments[5];
            if (a && "addEventListener" in a && !Qf.empty(b) && Qf.function(c)) {
                var h = b.split(" "),
                    i = g;
                Rf && (i = {
                    passive: f,
                    capture: g
                }), h.forEach(function(b) {
                    e && e.eventListeners && d && e.eventListeners.push({
                        element: a,
                        type: b,
                        callback: c,
                        options: i
                    }), a[d ? "addEventListener" : "removeEventListener"](b, c, i)
                })
            }
        }

        function d(a) {
            var b = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
                d = arguments[2],
                e = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3],
                f = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
            c.call(this, a, b, d, !0, e, f)
        }

        function e(a) {
            var b = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
                d = arguments[2],
                e = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3],
                f = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
            c.call(this, a, b, d, !1, e, f)
        }

        function f(a) {
            var b = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
                d = arguments[2],
                f = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3],
                g = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
            c.call(this, a, b, function c() {
                e(a, b, c, f, g);
                for (var h = arguments.length, i = Array(h), j = 0; j < h; j++) i[j] = arguments[j];
                d.apply(this, i)
            }, !0, f, g)
        }

        function g(a) {
            var b = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
                c = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
                d = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
            if (Qf.element(a) && !Qf.empty(b)) {
                var e = new CustomEvent(b, {
                    bubbles: c,
                    detail: Object.assign({}, d, {
                        plyr: this
                    })
                });
                a.dispatchEvent(e)
            }
        }

        function h(a, b) {
            var c = a.length ? a : [a];
            Array.from(c).reverse().forEach(function(a, c) {
                var d = c > 0 ? b.cloneNode(!0) : b,
                    e = a.parentNode,
                    f = a.nextSibling;
                d.appendChild(a), f ? e.insertBefore(d, f) : e.appendChild(d)
            })
        }

        function i(a, b) {
            Qf.element(a) && !Qf.empty(b) && Object.entries(b).filter(function(a) {
                var b = Vf(a, 2)[1];
                return !Qf.nullOrUndefined(b)
            }).forEach(function(b) {
                var c = Vf(b, 2),
                    d = c[0],
                    e = c[1];
                return a.setAttribute(d, e)
            })
        }

        function j(a, b, c) {
            var d = document.createElement(a);
            return Qf.object(b) && i(d, b), Qf.string(c) && (d.innerText = c), d
        }

        function k(a, b, c, d) {
            b.appendChild(j(a, c, d))
        }

        function l(a) {
            Qf.nodeList(a) || Qf.array(a) ? Array.from(a).forEach(l) : Qf.element(a) && Qf.element(a.parentNode) && a.parentNode.removeChild(a)
        }

        function m(a) {
            for (var b = a.childNodes.length; b > 0;) a.removeChild(a.lastChild), b -= 1
        }

        function n(a, b) {
            return Qf.element(b) && Qf.element(b.parentNode) && Qf.element(a) ? (b.parentNode.replaceChild(a, b), a) : null
        }

        function o(a, b) {
            if (!Qf.string(a) || Qf.empty(a)) return {};
            var c = {},
                d = b;
            return a.split(",").forEach(function(a) {
                var b = a.trim(),
                    e = b.replace(".", ""),
                    f = b.replace(/[[\]]/g, "").split("="),
                    g = f[0],
                    h = f.length > 1 ? f[1].replace(/["']/g, "") : "";
                switch (b.charAt(0)) {
                    case ".":
                        Qf.object(d) && Qf.string(d.class) && (d.class += " " + e), c.class = e;
                        break;
                    case "#":
                        c.id = b.replace("#", "");
                        break;
                    case "[":
                        c[g] = h
                }
            }), c
        }

        function p(a, b) {
            if (Qf.element(a)) {
                var c = b;
                Qf.boolean(c) || (c = !a.hasAttribute("hidden")), c ? a.setAttribute("hidden", "") : a.removeAttribute("hidden")
            }
        }

        function q(a, b, c) {
            if (Qf.element(a)) {
                var d = "toggle";
                return void 0 !== c && (d = c ? "add" : "remove"), a.classList[d](b), a.classList.contains(b)
            }
            return null
        }

        function r(a, b) {
            return Qf.element(a) && a.classList.contains(b)
        }

        function s(a, b) {
            var c = {
                Element: Element
            };
            return (c.matches || c.webkitMatchesSelector || c.mozMatchesSelector || c.msMatchesSelector || function() {
                return Array.from(document.querySelectorAll(b)).includes(this)
            }).call(a, b)
        }

        function t(a) {
            return this.elements.container.querySelectorAll(a)
        }

        function u(a) {
            return this.elements.container.querySelector(a)
        }

        function v() {
            var a = document.activeElement;
            return a = a && a !== document.body ? document.querySelector(":focus") : null
        }

        function w(a, b) {
            return b.split(".").reduce(function(a, b) {
                return a && a[b]
            }, a)
        }

        function x() {
            for (var a = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, b = arguments.length, c = Array(b > 1 ? b - 1 : 0), d = 1; d < b; d++) c[d - 1] = arguments[d];
            if (!c.length) return a;
            var e = c.shift();
            return Qf.object(e) ? (Object.keys(e).forEach(function(b) {
                Qf.object(e[b]) ? (Object.keys(a).includes(b) || Object.assign(a, Uf({}, b, {})), x(a[b], e[b])) : Object.assign(a, Uf({}, b, e[b]))
            }), x.apply(void 0, [a].concat(c))) : a
        }

        function y(a) {
            for (var b = arguments.length, c = Array(b > 1 ? b - 1 : 0), d = 1; d < b; d++) c[d - 1] = arguments[d];
            return Qf.empty(a) ? a : a.toString().replace(/{(\d+)}/g, function(a, b) {
                return c[b].toString()
            })
        }

        function z() {
            var a = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
                b = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
                c = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "";
            return a.replace(new RegExp(b.toString().replace(/([.*+?^=!:${}()|[\]\/\\])/g, "\\$1"), "g"), c.toString())
        }

        function A() {
            return (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "").toString().replace(/\w\S*/g, function(a) {
                return a.charAt(0).toUpperCase() + a.substr(1).toLowerCase()
            })
        }

        function B() {
            var a = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "").toString();
            return (a = function() {
                var a = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "").toString();
                return a = z(a, "-", " "), a = z(a, "_", " "), z(a = A(a), " ", "")
            }(a)).charAt(0).toLowerCase() + a.slice(1)
        }

        function C(a) {
            var b = document.createElement("div");
            return b.appendChild(a), b.innerHTML
        }

        function D(a) {
            return Qf.array(a) ? a.filter(function(b, c) {
                return a.indexOf(b) === c
            }) : a
        }

        function E(a) {
            var b = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "text";
            return new Promise(function(c, d) {
                try {
                    var e = new XMLHttpRequest;
                    if (!("withCredentials" in e)) return;
                    e.addEventListener("load", function() {
                        if ("text" === b) try {
                            c(JSON.parse(e.responseText))
                        } catch (a) {
                            c(e.responseText)
                        } else c(e.response)
                    }), e.addEventListener("error", function() {
                        throw new Error(e.status)
                    }), e.open("GET", a, !0), e.responseType = b, e.send()
                } catch (a) {
                    d(a)
                }
            })
        }

        function F(a, b) {
            if (Qf.string(a)) {
                var c = Qf.string(b),
                    d = function() {
                        return null !== document.getElementById(b)
                    },
                    e = function(a, b) {
                        a.innerHTML = b, c && d() || document.body.insertAdjacentElement("afterbegin", a)
                    };
                if (!c || !d()) {
                    var f = ag.supported,
                        g = document.createElement("div");
                    if (g.setAttribute("hidden", ""), c && g.setAttribute("id", b), f) {
                        var h = window.localStorage.getItem("cache-" + b);
                        if (null !== h) {
                            var i = JSON.parse(h);
                            e(g, i.content)
                        }
                    }
                    E(a).then(function(a) {
                        Qf.empty(a) || (f && window.localStorage.setItem("cache-" + b, JSON.stringify({
                            content: a
                        })), e(g, a))
                    }).catch(function() {})
                }
            }
        }

        function G() {
            var a = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
                b = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
                c = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
            if (!Qf.number(a)) return G(null, b, c);
            var d = function(a) {
                    return ("0" + a).slice(-2)
                },
                e = bg(a),
                f = cg(a),
                g = dg(a);
            return b || e > 0 ? e += ":" : e = "", (c && a > 0 ? "-" : "") + e + d(f) + ":" + d(g)
        }

        function H(a) {
            var b = a;
            if (!(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1]) {
                var c = document.createElement("a");
                c.href = b, b = c.href
            }
            try {
                return new URL(b)
            } catch (a) {
                return null
            }
        }

        function I(a) {
            var b = new URLSearchParams;
            return Qf.object(a) && Object.entries(a).forEach(function(a) {
                var c = Vf(a, 2),
                    d = c[0],
                    e = c[1];
                b.set(d, e)
            }), b
        }

        function J() {
            if (this.enabled) {
                var a = this.player.elements.buttons.fullscreen;
                Qf.element(a) && (a.pressed = this.active), g.call(this.player, this.target, this.active ? "enterfullscreen" : "exitfullscreen", !0), Xf.isIos || function() {
                    var a = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
                        b = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                    if (Qf.element(a)) {
                        var d = t.call(this, "button:not(:disabled), input:not(:disabled), [tabindex]"),
                            e = d[0],
                            f = d[d.length - 1];
                        c.call(this, this.elements.container, "keydown", function(a) {
                            if ("Tab" === a.key && 9 === a.keyCode) {
                                var b = v();
                                b !== f || a.shiftKey ? b === e && a.shiftKey && (f.focus(), a.preventDefault()) : (e.focus(), a.preventDefault())
                            }
                        }, b, !1)
                    }
                }.call(this.player, this.target, this.active)
            }
        }

        function K() {
            var a = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
            a ? this.scrollPosition = {
                x: window.scrollX || 0,
                y: window.scrollY || 0
            } : window.scrollTo(this.scrollPosition.x, this.scrollPosition.y), document.body.style.overflow = a ? "hidden" : "", q(this.target, this.player.config.classNames.fullscreen.fallback, a), J.call(this)
        }

        function L(a) {
            var b = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
            return new Promise(function(c, d) {
                var e = new Image,
                    f = function() {
                        delete e.onload, delete e.onerror, (e.naturalWidth >= b ? c : d)(e)
                    };
                Object.assign(e, {
                    onload: f,
                    onerror: f,
                    src: a
                })
            })
        }

        function M(a) {
            return new Promise(function(b, c) {
                og(a, {
                    success: b,
                    error: c
                })
            })
        }

        function N(a) {
            a && !this.embed.hasPlayed && (this.embed.hasPlayed = !0), this.media.paused === a && (this.media.paused = !a, g.call(this, this.media, a ? "play" : "pause"))
        }

        function O(a) {
            var b = Object.entries({
                hd2160: 2160,
                hd1440: 1440,
                hd1080: 1080,
                hd720: 720,
                large: 480,
                medium: 360,
                small: 240,
                tiny: 144
            }).find(function(b) {
                return b.includes(a)
            });
            return b ? b.find(function(b) {
                return b !== a
            }) : "default"
        }

        function P(a) {
            a && !this.embed.hasPlayed && (this.embed.hasPlayed = !0), this.media.paused === a && (this.media.paused = !a, g.call(this, this.media, a ? "play" : "pause"))
        }
        var Q = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {},
            R = a(function(a) {
                var b = a.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
                "number" == typeof __g && (__g = b)
            }),
            S = a(function(a) {
                var b = a.exports = {
                    version: "2.5.3"
                };
                "number" == typeof __e && (__e = b)
            }),
            T = (S.version, function(a) {
                return "object" == typeof a ? null !== a : "function" == typeof a
            }),
            U = function(a) {
                if (!T(a)) throw TypeError(a + " is not an object!");
                return a
            },
            V = function(a) {
                try {
                    return !!a()
                } catch (a) {
                    return !0
                }
            },
            W = !V(function() {
                return 7 != Object.defineProperty({}, "a", {
                    get: function() {
                        return 7
                    }
                }).a
            }),
            X = R.document,
            Y = T(X) && T(X.createElement),
            Z = function(a) {
                return Y ? X.createElement(a) : {}
            },
            $ = !W && !V(function() {
                return 7 != Object.defineProperty(Z("div"), "a", {
                    get: function() {
                        return 7
                    }
                }).a
            }),
            _ = function(a, b) {
                if (!T(a)) return a;
                var c, d;
                if (b && "function" == typeof(c = a.toString) && !T(d = c.call(a))) return d;
                if ("function" == typeof(c = a.valueOf) && !T(d = c.call(a))) return d;
                if (!b && "function" == typeof(c = a.toString) && !T(d = c.call(a))) return d;
                throw TypeError("Can't convert object to primitive value")
            },
            aa = Object.defineProperty,
            ba = {
                f: W ? Object.defineProperty : function(a, b, c) {
                    if (U(a), b = _(b, !0), U(c), $) try {
                        return aa(a, b, c)
                    } catch (a) {}
                    if ("get" in c || "set" in c) throw TypeError("Accessors not supported!");
                    return "value" in c && (a[b] = c.value), a
                }
            },
            ca = function(a, b) {
                return {
                    enumerable: !(1 & a),
                    configurable: !(2 & a),
                    writable: !(4 & a),
                    value: b
                }
            },
            da = W ? function(a, b, c) {
                return ba.f(a, b, ca(1, c))
            } : function(a, b, c) {
                return a[b] = c, a
            },
            ea = {}.hasOwnProperty,
            fa = function(a, b) {
                return ea.call(a, b)
            },
            ga = 0,
            ha = Math.random(),
            ia = function(a) {
                return "Symbol(".concat(void 0 === a ? "" : a, ")_", (++ga + ha).toString(36))
            },
            ja = a(function(a) {
                var b = ia("src"),
                    c = Function.toString,
                    d = ("" + c).split("toString");
                S.inspectSource = function(a) {
                    return c.call(a)
                }, (a.exports = function(a, c, e, f) {
                    var g = "function" == typeof e;
                    g && (fa(e, "name") || da(e, "name", c)), a[c] !== e && (g && (fa(e, b) || da(e, b, a[c] ? "" + a[c] : d.join(String(c)))), a === R ? a[c] = e : f ? a[c] ? a[c] = e : da(a, c, e) : (delete a[c], da(a, c, e)))
                })(Function.prototype, "toString", function() {
                    return "function" == typeof this && this[b] || c.call(this)
                })
            }),
            ka = function(a) {
                if ("function" != typeof a) throw TypeError(a + " is not a function!");
                return a
            },
            la = function(a, b, c) {
                if (ka(a), void 0 === b) return a;
                switch (c) {
                    case 1:
                        return function(c) {
                            return a.call(b, c)
                        };
                    case 2:
                        return function(c, d) {
                            return a.call(b, c, d)
                        };
                    case 3:
                        return function(c, d, e) {
                            return a.call(b, c, d, e)
                        }
                }
                return function() {
                    return a.apply(b, arguments)
                }
            },
            ma = function(a, b, c) {
                var d, e, f, g, h = a & ma.F,
                    i = a & ma.G,
                    j = a & ma.S,
                    k = a & ma.P,
                    l = a & ma.B,
                    m = i ? R : j ? R[b] || (R[b] = {}) : (R[b] || {}).prototype,
                    n = i ? S : S[b] || (S[b] = {}),
                    o = n.prototype || (n.prototype = {});
                for (d in i && (c = b), c) f = ((e = !h && m && void 0 !== m[d]) ? m : c)[d], g = l && e ? la(f, R) : k && "function" == typeof f ? la(Function.call, f) : f, m && ja(m, d, f, a & ma.U), n[d] != f && da(n, d, g), k && o[d] != f && (o[d] = f)
            };
        R.core = S, ma.F = 1, ma.G = 2, ma.S = 4, ma.P = 8, ma.B = 16, ma.W = 32, ma.U = 64, ma.R = 128;
        for (var na, oa = ma, pa = ia("typed_array"), qa = ia("view"), ra = !(!R.ArrayBuffer || !R.DataView), sa = ra, ta = 0, ua = "Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array".split(","); ta < 9;)(na = R[ua[ta++]]) ? (da(na.prototype, pa, !0), da(na.prototype, qa, !0)) : sa = !1;
        var va = {
                ABV: ra,
                CONSTR: sa,
                TYPED: pa,
                VIEW: qa
            },
            wa = function(a, b, c) {
                for (var d in b) ja(a, d, b[d], c);
                return a
            },
            xa = function(a, b, c, d) {
                if (!(a instanceof b) || void 0 !== d && d in a) throw TypeError(c + ": incorrect invocation!");
                return a
            },
            ya = Math.ceil,
            za = Math.floor,
            Aa = function(a) {
                return isNaN(a = +a) ? 0 : (a > 0 ? za : ya)(a)
            },
            Ba = Math.min,
            Ca = function(a) {
                return a > 0 ? Ba(Aa(a), 9007199254740991) : 0
            },
            Da = function(a) {
                if (void 0 === a) return 0;
                var b = Aa(a),
                    c = Ca(b);
                if (b !== c) throw RangeError("Wrong length!");
                return c
            },
            Ea = {}.toString,
            Fa = function(a) {
                return Ea.call(a).slice(8, -1)
            },
            Ga = Object("z").propertyIsEnumerable(0) ? Object : function(a) {
                return "String" == Fa(a) ? a.split("") : Object(a)
            },
            Ha = function(a) {
                if (null == a) throw TypeError("Can't call method on  " + a);
                return a
            },
            Ia = function(a) {
                return Ga(Ha(a))
            },
            Ja = Math.max,
            Ka = Math.min,
            La = function(a, b) {
                return (a = Aa(a)) < 0 ? Ja(a + b, 0) : Ka(a, b)
            },
            Ma = function(a) {
                return function(b, c, d) {
                    var e, f = Ia(b),
                        g = Ca(f.length),
                        h = La(d, g);
                    if (a && c != c) {
                        for (; g > h;)
                            if ((e = f[h++]) != e) return !0
                    } else
                        for (; g > h; h++)
                            if ((a || h in f) && f[h] === c) return a || h || 0;
                    return !a && -1
                }
            },
            Na = R["__core-js_shared__"] || (R["__core-js_shared__"] = {}),
            Oa = function(a) {
                return Na[a] || (Na[a] = {})
            },
            Pa = Oa("keys"),
            Qa = function(a) {
                return Pa[a] || (Pa[a] = ia(a))
            },
            Ra = Ma(!1),
            Sa = Qa("IE_PROTO"),
            Ta = function(a, b) {
                var c, d = Ia(a),
                    e = 0,
                    f = [];
                for (c in d) c != Sa && fa(d, c) && f.push(c);
                for (; b.length > e;) fa(d, c = b[e++]) && (~Ra(f, c) || f.push(c));
                return f
            },
            Ua = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(","),
            Va = Ua.concat("length", "prototype"),
            Wa = {
                f: Object.getOwnPropertyNames || function(a) {
                    return Ta(a, Va)
                }
            },
            Xa = function(a) {
                return Object(Ha(a))
            },
            Ya = function(a) {
                for (var b = Xa(this), c = Ca(b.length), d = arguments.length, e = La(d > 1 ? arguments[1] : void 0, c), f = d > 2 ? arguments[2] : void 0, g = void 0 === f ? c : La(f, c); g > e;) b[e++] = a;
                return b
            },
            Za = a(function(a) {
                var b = Oa("wks"),
                    c = R.Symbol,
                    d = "function" == typeof c;
                (a.exports = function(a) {
                    return b[a] || (b[a] = d && c[a] || (d ? c : ia)("Symbol." + a))
                }).store = b
            }),
            $a = ba.f,
            _a = Za("toStringTag"),
            ab = function(a, b, c) {
                a && !fa(a = c ? a : a.prototype, _a) && $a(a, _a, {
                    configurable: !0,
                    value: b
                })
            },
            bb = a(function(a, b) {
                function c(a, b, c) {
                    var d, e, f, g = new Array(c),
                        h = 8 * c - b - 1,
                        i = (1 << h) - 1,
                        j = i >> 1,
                        k = 23 === b ? y(2, -24) - y(2, -77) : 0,
                        l = 0,
                        m = a < 0 || 0 === a && 1 / a < 0 ? 1 : 0;
                    for ((a = x(a)) != a || a === v ? (e = a != a ? 1 : 0, d = i) : (d = z(A(a) / B), a * (f = y(2, -d)) < 1 && (d--, f *= 2), (a += d + j >= 1 ? k / f : k * y(2, 1 - j)) * f >= 2 && (d++, f /= 2), d + j >= i ? (e = 0, d = i) : d + j >= 1 ? (e = (a * f - 1) * y(2, b), d += j) : (e = a * y(2, j - 1) * y(2, b), d = 0)); b >= 8; g[l++] = 255 & e, e /= 256, b -= 8);
                    for (d = d << b | e, h += b; h > 0; g[l++] = 255 & d, d /= 256, h -= 8);
                    return g[--l] |= 128 * m, g
                }

                function d(a, b, c) {
                    var d, e = 8 * c - b - 1,
                        f = (1 << e) - 1,
                        g = f >> 1,
                        h = e - 7,
                        i = c - 1,
                        j = a[i--],
                        k = 127 & j;
                    for (j >>= 7; h > 0; k = 256 * k + a[i], i--, h -= 8);
                    for (d = k & (1 << -h) - 1, k >>= -h, h += b; h > 0; d = 256 * d + a[i], i--, h -= 8);
                    if (0 === k) k = 1 - g;
                    else {
                        if (k === f) return d ? NaN : j ? -v : v;
                        d += y(2, b), k -= g
                    }
                    return (j ? -1 : 1) * d * y(2, k - b)
                }

                function e(a) {
                    return a[3] << 24 | a[2] << 16 | a[1] << 8 | a[0]
                }

                function f(a) {
                    return [255 & a]
                }

                function g(a) {
                    return [255 & a, a >> 8 & 255]
                }

                function h(a) {
                    return [255 & a, a >> 8 & 255, a >> 16 & 255, a >> 24 & 255]
                }

                function i(a) {
                    return c(a, 52, 8)
                }

                function j(a) {
                    return c(a, 23, 4)
                }

                function k(a, b, c) {
                    o(a[p], b, {
                        get: function() {
                            return this[c]
                        }
                    })
                }

                function l(a, b, c, d) {
                    var e = Da(+c);
                    if (e + b > a[D]) throw u(q);
                    var f = a[C]._b,
                        g = e + a[E],
                        h = f.slice(g, g + b);
                    return d ? h : h.reverse()
                }

                function m(a, b, c, d, e, f) {
                    var g = Da(+c);
                    if (g + b > a[D]) throw u(q);
                    for (var h = a[C]._b, i = g + a[E], j = d(+e), k = 0; k < b; k++) h[i + k] = j[f ? k : b - k - 1]
                }
                var n = Wa.f,
                    o = ba.f,
                    p = "prototype",
                    q = "Wrong index!",
                    r = R.ArrayBuffer,
                    s = R.DataView,
                    t = R.Math,
                    u = R.RangeError,
                    v = R.Infinity,
                    w = r,
                    x = t.abs,
                    y = t.pow,
                    z = t.floor,
                    A = t.log,
                    B = t.LN2,
                    C = W ? "_b" : "buffer",
                    D = W ? "_l" : "byteLength",
                    E = W ? "_o" : "byteOffset";
                if (va.ABV) {
                    if (!V(function() {
                            r(1)
                        }) || !V(function() {
                            new r(-1)
                        }) || V(function() {
                            return new r, new r(1.5), new r(NaN), "ArrayBuffer" != r.name
                        })) {
                        for (var F, G = (r = function(a) {
                                return xa(this, r), new w(Da(a))
                            })[p] = w[p], H = n(w), I = 0; H.length > I;)(F = H[I++]) in r || da(r, F, w[F]);
                        G.constructor = r
                    }
                    var J = new s(new r(2)),
                        K = s[p].setInt8;
                    J.setInt8(0, 2147483648), J.setInt8(1, 2147483649), !J.getInt8(0) && J.getInt8(1) || wa(s[p], {
                        setInt8: function(a, b) {
                            K.call(this, a, b << 24 >> 24)
                        },
                        setUint8: function(a, b) {
                            K.call(this, a, b << 24 >> 24)
                        }
                    }, !0)
                } else r = function(a) {
                    xa(this, r, "ArrayBuffer");
                    var b = Da(a);
                    this._b = Ya.call(new Array(b), 0), this[D] = b
                }, s = function(a, b, c) {
                    xa(this, s, "DataView"), xa(a, r, "DataView");
                    var d = a[D],
                        e = Aa(b);
                    if (e < 0 || e > d) throw u("Wrong offset!");
                    if (e + (c = void 0 === c ? d - e : Ca(c)) > d) throw u("Wrong length!");
                    this[C] = a, this[E] = e, this[D] = c
                }, W && (k(r, "byteLength", "_l"), k(s, "buffer", "_b"), k(s, "byteLength", "_l"), k(s, "byteOffset", "_o")), wa(s[p], {
                    getInt8: function(a) {
                        return l(this, 1, a)[0] << 24 >> 24
                    },
                    getUint8: function(a) {
                        return l(this, 1, a)[0]
                    },
                    getInt16: function(a) {
                        var b = l(this, 2, a, arguments[1]);
                        return (b[1] << 8 | b[0]) << 16 >> 16
                    },
                    getUint16: function(a) {
                        var b = l(this, 2, a, arguments[1]);
                        return b[1] << 8 | b[0]
                    },
                    getInt32: function(a) {
                        return e(l(this, 4, a, arguments[1]))
                    },
                    getUint32: function(a) {
                        return e(l(this, 4, a, arguments[1])) >>> 0
                    },
                    getFloat32: function(a) {
                        return d(l(this, 4, a, arguments[1]), 23, 4)
                    },
                    getFloat64: function(a) {
                        return d(l(this, 8, a, arguments[1]), 52, 8)
                    },
                    setInt8: function(a, b) {
                        m(this, 1, a, f, b)
                    },
                    setUint8: function(a, b) {
                        m(this, 1, a, f, b)
                    },
                    setInt16: function(a, b) {
                        m(this, 2, a, g, b, arguments[2])
                    },
                    setUint16: function(a, b) {
                        m(this, 2, a, g, b, arguments[2])
                    },
                    setInt32: function(a, b) {
                        m(this, 4, a, h, b, arguments[2])
                    },
                    setUint32: function(a, b) {
                        m(this, 4, a, h, b, arguments[2])
                    },
                    setFloat32: function(a, b) {
                        m(this, 4, a, j, b, arguments[2])
                    },
                    setFloat64: function(a, b) {
                        m(this, 8, a, i, b, arguments[2])
                    }
                });
                ab(r, "ArrayBuffer"), ab(s, "DataView"), da(s[p], va.VIEW, !0), b.ArrayBuffer = r, b.DataView = s
            }),
            cb = Za("species"),
            db = function(a, b) {
                var c, d = U(a).constructor;
                return void 0 === d || null == (c = U(d)[cb]) ? b : ka(c)
            },
            eb = Za("species"),
            fb = function(a) {
                var b = R[a];
                W && b && !b[eb] && ba.f(b, eb, {
                    configurable: !0,
                    get: function() {
                        return this
                    }
                })
            },
            gb = R.ArrayBuffer,
            hb = bb.ArrayBuffer,
            ib = bb.DataView,
            jb = va.ABV && gb.isView,
            kb = hb.prototype.slice,
            lb = va.VIEW;
        oa(oa.G + oa.W + oa.F * (gb !== hb), {
            ArrayBuffer: hb
        }), oa(oa.S + oa.F * !va.CONSTR, "ArrayBuffer", {
            isView: function(a) {
                return jb && jb(a) || T(a) && lb in a
            }
        }), oa(oa.P + oa.U + oa.F * V(function() {
            return !new hb(2).slice(1, void 0).byteLength
        }), "ArrayBuffer", {
            slice: function(a, b) {
                if (void 0 !== kb && void 0 === b) return kb.call(U(this), a);
                for (var c = U(this).byteLength, d = La(a, c), e = La(void 0 === b ? c : b, c), f = new(db(this, hb))(Ca(e - d)), g = new ib(this), h = new ib(f), i = 0; d < e;) h.setUint8(i++, g.getUint8(d++));
                return f
            }
        }), fb("ArrayBuffer");
        var mb = Za("toStringTag"),
            nb = "Arguments" == Fa(function() {
                return arguments
            }()),
            ob = function(a) {
                var b, c, d;
                return void 0 === a ? "Undefined" : null === a ? "Null" : "string" == typeof(c = function(a, b) {
                    try {
                        return a[b]
                    } catch (a) {}
                }(b = Object(a), mb)) ? c : nb ? Fa(b) : "Object" == (d = Fa(b)) && "function" == typeof b.callee ? "Arguments" : d
            },
            pb = {},
            qb = Za("iterator"),
            rb = Array.prototype,
            sb = function(a) {
                return void 0 !== a && (pb.Array === a || rb[qb] === a)
            },
            tb = Object.keys || function(a) {
                return Ta(a, Ua)
            },
            ub = W ? Object.defineProperties : function(a, b) {
                U(a);
                for (var c, d = tb(b), e = d.length, f = 0; e > f;) ba.f(a, c = d[f++], b[c]);
                return a
            },
            vb = R.document,
            wb = vb && vb.documentElement,
            xb = Qa("IE_PROTO"),
            yb = function() {},
            zb = function() {
                var a, b = Z("iframe"),
                    c = Ua.length;
                for (b.style.display = "none", wb.appendChild(b), b.src = "javascript:", (a = b.contentWindow.document).open(), a.write("<script>document.F=Object<\/script>"), a.close(), zb = a.F; c--;) delete zb.prototype[Ua[c]];
                return zb()
            },
            Ab = Object.create || function(a, b) {
                var c;
                return null !== a ? (yb.prototype = U(a), c = new yb, yb.prototype = null, c[xb] = a) : c = zb(), void 0 === b ? c : ub(c, b)
            },
            Bb = Qa("IE_PROTO"),
            Cb = Object.prototype,
            Db = Object.getPrototypeOf || function(a) {
                return a = Xa(a), fa(a, Bb) ? a[Bb] : "function" == typeof a.constructor && a instanceof a.constructor ? a.constructor.prototype : a instanceof Object ? Cb : null
            },
            Eb = Za("iterator"),
            Fb = S.getIteratorMethod = function(a) {
                if (null != a) return a[Eb] || a["@@iterator"] || pb[ob(a)]
            },
            Gb = Array.isArray || function(a) {
                return "Array" == Fa(a)
            },
            Hb = Za("species"),
            Ib = function(a, b) {
                return new(function(a) {
                    var b;
                    return Gb(a) && ("function" != typeof(b = a.constructor) || b !== Array && !Gb(b.prototype) || (b = void 0), T(b) && null === (b = b[Hb]) && (b = void 0)), void 0 === b ? Array : b
                }(a))(b)
            },
            Jb = function(a, b) {
                var c = 1 == a,
                    d = 2 == a,
                    e = 3 == a,
                    f = 4 == a,
                    g = 6 == a,
                    h = 5 == a || g,
                    i = b || Ib;
                return function(b, j, k) {
                    for (var l, m, n = Xa(b), o = Ga(n), p = la(j, k, 3), q = Ca(o.length), r = 0, s = c ? i(b, q) : d ? i(b, 0) : void 0; q > r; r++)
                        if ((h || r in o) && (m = p(l = o[r], r, n), a))
                            if (c) s[r] = m;
                            else if (m) switch (a) {
                        case 3:
                            return !0;
                        case 5:
                            return l;
                        case 6:
                            return r;
                        case 2:
                            s.push(l)
                    } else if (f) return !1;
                    return g ? -1 : e || f ? f : s
                }
            },
            Kb = Za("unscopables"),
            Lb = Array.prototype;
        null == Lb[Kb] && da(Lb, Kb, {});
        var Mb = function(a) {
                Lb[Kb][a] = !0
            },
            Nb = function(a, b) {
                return {
                    value: b,
                    done: !!a
                }
            },
            Ob = {};
        da(Ob, Za("iterator"), function() {
            return this
        });
        var Pb = function(a, b, c) {
                a.prototype = Ab(Ob, {
                    next: ca(1, c)
                }), ab(a, b + " Iterator")
            },
            Qb = Za("iterator"),
            Rb = !([].keys && "next" in [].keys()),
            Sb = function() {
                return this
            },
            Tb = function(a, b, c, d, e, f, g) {
                Pb(c, b, d);
                var h, i, j, k = function(a) {
                        if (!Rb && a in o) return o[a];
                        switch (a) {
                            case "keys":
                            case "values":
                                return function() {
                                    return new c(this, a)
                                }
                        }
                        return function() {
                            return new c(this, a)
                        }
                    },
                    l = b + " Iterator",
                    m = "values" == e,
                    n = !1,
                    o = a.prototype,
                    p = o[Qb] || o["@@iterator"] || e && o[e],
                    q = !Rb && p || k(e),
                    r = e ? m ? k("entries") : q : void 0,
                    s = "Array" == b && o.entries || p;
                if (s && (j = Db(s.call(new a))) !== Object.prototype && j.next && (ab(j, l, !0), fa(j, Qb) || da(j, Qb, Sb)), m && p && "values" !== p.name && (n = !0, q = function() {
                        return p.call(this)
                    }), (Rb || n || !o[Qb]) && da(o, Qb, q), pb[b] = q, pb[l] = Sb, e)
                    if (h = {
                            values: m ? q : k("values"),
                            keys: f ? q : k("keys"),
                            entries: r
                        }, g)
                        for (i in h) i in o || ja(o, i, h[i]);
                    else oa(oa.P + oa.F * (Rb || n), b, h);
                return h
            },
            Ub = Tb(Array, "Array", function(a, b) {
                this._t = Ia(a), this._i = 0, this._k = b
            }, function() {
                var a = this._t,
                    b = this._k,
                    c = this._i++;
                return !a || c >= a.length ? (this._t = void 0, Nb(1)) : Nb(0, "keys" == b ? c : "values" == b ? a[c] : [c, a[c]])
            }, "values");
        pb.Arguments = pb.Array, Mb("keys"), Mb("values"), Mb("entries");
        var Vb = Za("iterator"),
            Wb = !1;
        try {
            [7][Vb]().return = function() {
                Wb = !0
            }
        } catch (Q) {}
        var Xb = function(a, b) {
                if (!b && !Wb) return !1;
                var c = !1;
                try {
                    var d = [7],
                        e = d[Vb]();
                    e.next = function() {
                        return {
                            done: c = !0
                        }
                    }, d[Vb] = function() {
                        return e
                    }, a(d)
                } catch (a) {}
                return c
            },
            Yb = [].copyWithin || function(a, b) {
                var c = Xa(this),
                    d = Ca(c.length),
                    e = La(a, d),
                    f = La(b, d),
                    g = arguments.length > 2 ? arguments[2] : void 0,
                    h = Math.min((void 0 === g ? d : La(g, d)) - f, d - e),
                    i = 1;
                for (f < e && e < f + h && (i = -1, f += h - 1, e += h - 1); h-- > 0;) f in c ? c[e] = c[f] : delete c[e], e += i, f += i;
                return c
            },
            Zb = {
                f: {}.propertyIsEnumerable
            },
            $b = Object.getOwnPropertyDescriptor,
            _b = {
                f: W ? $b : function(a, b) {
                    if (a = Ia(a), b = _(b, !0), $) try {
                        return $b(a, b)
                    } catch (a) {}
                    if (fa(a, b)) return ca(!Zb.f.call(a, b), a[b])
                }
            },
            ac = a(function(a) {
                if (W) {
                    var b = R,
                        c = V,
                        d = oa,
                        e = va,
                        f = bb,
                        g = la,
                        h = xa,
                        i = ca,
                        j = da,
                        k = wa,
                        l = Aa,
                        m = Ca,
                        n = Da,
                        o = La,
                        p = _,
                        q = fa,
                        r = ob,
                        s = T,
                        t = Xa,
                        u = sb,
                        v = Ab,
                        w = Db,
                        x = Wa.f,
                        y = Fb,
                        z = ia,
                        A = Za,
                        B = Jb,
                        C = Ma,
                        D = db,
                        E = Ub,
                        F = pb,
                        G = Xb,
                        H = fb,
                        I = Ya,
                        J = Yb,
                        K = ba,
                        L = _b,
                        M = K.f,
                        N = L.f,
                        O = b.RangeError,
                        P = b.TypeError,
                        Q = b.Uint8Array,
                        S = Array.prototype,
                        U = f.ArrayBuffer,
                        X = f.DataView,
                        Y = B(0),
                        Z = B(2),
                        $ = B(3),
                        aa = B(4),
                        ea = B(5),
                        ga = B(6),
                        ha = C(!0),
                        ja = C(!1),
                        ka = E.values,
                        ma = E.keys,
                        na = E.entries,
                        pa = S.lastIndexOf,
                        qa = S.reduce,
                        ra = S.reduceRight,
                        sa = S.join,
                        ta = S.sort,
                        ua = S.slice,
                        ya = S.toString,
                        za = S.toLocaleString,
                        Ba = A("iterator"),
                        Ea = A("toStringTag"),
                        Fa = z("typed_constructor"),
                        Ga = z("def_constructor"),
                        Ha = e.CONSTR,
                        Ia = e.TYPED,
                        Ja = e.VIEW,
                        Ka = B(1, function(a, b) {
                            return Ra(D(a, a[Ga]), b)
                        }),
                        Na = c(function() {
                            return 1 === new Q(new Uint16Array([1]).buffer)[0]
                        }),
                        Oa = !!Q && !!Q.prototype.set && c(function() {
                            new Q(1).set({})
                        }),
                        Pa = function(a, b) {
                            var c = l(a);
                            if (c < 0 || c % b) throw O("Wrong offset!");
                            return c
                        },
                        Qa = function(a) {
                            if (s(a) && Ia in a) return a;
                            throw P(a + " is not a typed array!")
                        },
                        Ra = function(a, b) {
                            if (!(s(a) && Fa in a)) throw P("It is not a typed array constructor!");
                            return new a(b)
                        },
                        Sa = function(a, b) {
                            return Ta(D(a, a[Ga]), b)
                        },
                        Ta = function(a, b) {
                            for (var c = 0, d = b.length, e = Ra(a, d); d > c;) e[c] = b[c++];
                            return e
                        },
                        Ua = function(a, b, c) {
                            M(a, b, {
                                get: function() {
                                    return this._d[c]
                                }
                            })
                        },
                        Va = function(a) {
                            var b, c, d, e, f, h, i = t(a),
                                j = arguments.length,
                                k = j > 1 ? arguments[1] : void 0,
                                l = void 0 !== k,
                                n = y(i);
                            if (null != n && !u(n)) {
                                for (h = n.call(i), d = [], b = 0; !(f = h.next()).done; b++) d.push(f.value);
                                i = d
                            }
                            for (l && j > 2 && (k = g(k, arguments[2], 2)), b = 0, c = m(i.length), e = Ra(this, c); c > b; b++) e[b] = l ? k(i[b], b) : i[b];
                            return e
                        },
                        $a = function() {
                            for (var a = 0, b = arguments.length, c = Ra(this, b); b > a;) c[a] = arguments[a++];
                            return c
                        },
                        _a = !!Q && c(function() {
                            za.call(new Q(1))
                        }),
                        ab = function() {
                            return za.apply(_a ? ua.call(Qa(this)) : Qa(this), arguments)
                        },
                        cb = {
                            copyWithin: function(a, b) {
                                return J.call(Qa(this), a, b, arguments.length > 2 ? arguments[2] : void 0)
                            },
                            every: function(a) {
                                return aa(Qa(this), a, arguments.length > 1 ? arguments[1] : void 0)
                            },
                            fill: function(a) {
                                return I.apply(Qa(this), arguments)
                            },
                            filter: function(a) {
                                return Sa(this, Z(Qa(this), a, arguments.length > 1 ? arguments[1] : void 0))
                            },
                            find: function(a) {
                                return ea(Qa(this), a, arguments.length > 1 ? arguments[1] : void 0)
                            },
                            findIndex: function(a) {
                                return ga(Qa(this), a, arguments.length > 1 ? arguments[1] : void 0)
                            },
                            forEach: function(a) {
                                Y(Qa(this), a, arguments.length > 1 ? arguments[1] : void 0)
                            },
                            indexOf: function(a) {
                                return ja(Qa(this), a, arguments.length > 1 ? arguments[1] : void 0)
                            },
                            includes: function(a) {
                                return ha(Qa(this), a, arguments.length > 1 ? arguments[1] : void 0)
                            },
                            join: function(a) {
                                return sa.apply(Qa(this), arguments)
                            },
                            lastIndexOf: function(a) {
                                return pa.apply(Qa(this), arguments)
                            },
                            map: function(a) {
                                return Ka(Qa(this), a, arguments.length > 1 ? arguments[1] : void 0)
                            },
                            reduce: function(a) {
                                return qa.apply(Qa(this), arguments)
                            },
                            reduceRight: function(a) {
                                return ra.apply(Qa(this), arguments)
                            },
                            reverse: function() {
                                for (var a, b = Qa(this).length, c = Math.floor(b / 2), d = 0; d < c;) a = this[d], this[d++] = this[--b], this[b] = a;
                                return this
                            },
                            some: function(a) {
                                return $(Qa(this), a, arguments.length > 1 ? arguments[1] : void 0)
                            },
                            sort: function(a) {
                                return ta.call(Qa(this), a)
                            },
                            subarray: function(a, b) {
                                var c = Qa(this),
                                    d = c.length,
                                    e = o(a, d);
                                return new(D(c, c[Ga]))(c.buffer, c.byteOffset + e * c.BYTES_PER_ELEMENT, m((void 0 === b ? d : o(b, d)) - e))
                            }
                        },
                        eb = function(a, b) {
                            return Sa(this, ua.call(Qa(this), a, b))
                        },
                        gb = function(a) {
                            Qa(this);
                            var b = Pa(arguments[1], 1),
                                c = this.length,
                                d = t(a),
                                e = m(d.length),
                                f = 0;
                            if (e + b > c) throw O("Wrong length!");
                            for (; f < e;) this[b + f] = d[f++]
                        },
                        hb = {
                            entries: function() {
                                return na.call(Qa(this))
                            },
                            keys: function() {
                                return ma.call(Qa(this))
                            },
                            values: function() {
                                return ka.call(Qa(this))
                            }
                        },
                        ib = function(a, b) {
                            return s(a) && a[Ia] && "symbol" != typeof b && b in a && String(+b) == String(b)
                        },
                        jb = function(a, b) {
                            return ib(a, b = p(b, !0)) ? i(2, a[b]) : N(a, b)
                        },
                        kb = function(a, b, c) {
                            return !(ib(a, b = p(b, !0)) && s(c) && q(c, "value")) || q(c, "get") || q(c, "set") || c.configurable || q(c, "writable") && !c.writable || q(c, "enumerable") && !c.enumerable ? M(a, b, c) : (a[b] = c.value, a)
                        };
                    Ha || (L.f = jb, K.f = kb), d(d.S + d.F * !Ha, "Object", {
                        getOwnPropertyDescriptor: jb,
                        defineProperty: kb
                    }), c(function() {
                        ya.call({})
                    }) && (ya = za = function() {
                        return sa.call(this)
                    });
                    var lb = k({}, cb);
                    k(lb, hb), j(lb, Ba, hb.values), k(lb, {
                        slice: eb,
                        set: gb,
                        constructor: function() {},
                        toString: ya,
                        toLocaleString: ab
                    }), Ua(lb, "buffer", "b"), Ua(lb, "byteOffset", "o"), Ua(lb, "byteLength", "l"), Ua(lb, "length", "e"), M(lb, Ea, {
                        get: function() {
                            return this[Ia]
                        }
                    }), a.exports = function(a, f, g, i) {
                        var k = a + ((i = !!i) ? "Clamped" : "") + "Array",
                            l = "get" + a,
                            o = "set" + a,
                            p = b[k],
                            q = p || {},
                            t = p && w(p),
                            u = !p || !e.ABV,
                            y = {},
                            z = p && p.prototype,
                            A = function(a, b) {
                                M(a, b, {
                                    get: function() {
                                        return function(a, b) {
                                            var c = a._d;
                                            return c.v[l](b * f + c.o, Na)
                                        }(this, b)
                                    },
                                    set: function(a) {
                                        return function(a, b, c) {
                                            var d = a._d;
                                            i && (c = (c = Math.round(c)) < 0 ? 0 : c > 255 ? 255 : 255 & c), d.v[o](b * f + d.o, c, Na)
                                        }(this, b, a)
                                    },
                                    enumerable: !0
                                })
                            };
                        u ? (p = g(function(a, b, c, d) {
                            h(a, p, k, "_d");
                            var e, g, i, l, o = 0,
                                q = 0;
                            if (s(b)) {
                                if (!(b instanceof U || "ArrayBuffer" == (l = r(b)) || "SharedArrayBuffer" == l)) return Ia in b ? Ta(p, b) : Va.call(p, b);
                                e = b, q = Pa(c, f);
                                var t = b.byteLength;
                                if (void 0 === d) {
                                    if (t % f) throw O("Wrong length!");
                                    if ((g = t - q) < 0) throw O("Wrong length!")
                                } else if ((g = m(d) * f) + q > t) throw O("Wrong length!");
                                i = g / f
                            } else i = n(b), e = new U(g = i * f);
                            for (j(a, "_d", {
                                    b: e,
                                    o: q,
                                    l: g,
                                    e: i,
                                    v: new X(e)
                                }); o < i;) A(a, o++)
                        }), z = p.prototype = v(lb), j(z, "constructor", p)) : c(function() {
                            p(1)
                        }) && c(function() {
                            new p(-1)
                        }) && G(function(a) {
                            new p, new p(null), new p(1.5), new p(a)
                        }, !0) || (p = g(function(a, b, c, d) {
                            var e;
                            return h(a, p, k), s(b) ? b instanceof U || "ArrayBuffer" == (e = r(b)) || "SharedArrayBuffer" == e ? void 0 !== d ? new q(b, Pa(c, f), d) : void 0 !== c ? new q(b, Pa(c, f)) : new q(b) : Ia in b ? Ta(p, b) : Va.call(p, b) : new q(n(b))
                        }), Y(t !== Function.prototype ? x(q).concat(x(t)) : x(q), function(a) {
                            a in p || j(p, a, q[a])
                        }), p.prototype = z, z.constructor = p);
                        var B = z[Ba],
                            C = !!B && ("values" == B.name || null == B.name),
                            D = hb.values;
                        j(p, Fa, !0), j(z, Ia, k), j(z, Ja, !0), j(z, Ga, p), (i ? new p(1)[Ea] == k : Ea in z) || M(z, Ea, {
                            get: function() {
                                return k
                            }
                        }), y[k] = p, d(d.G + d.W + d.F * (p != q), y), d(d.S, k, {
                            BYTES_PER_ELEMENT: f
                        }), d(d.S + d.F * c(function() {
                            q.of.call(p, 1)
                        }), k, {
                            from: Va,
                            of: $a
                        }), "BYTES_PER_ELEMENT" in z || j(z, "BYTES_PER_ELEMENT", f), d(d.P, k, cb), H(k), d(d.P + d.F * Oa, k, {
                            set: gb
                        }), d(d.P + d.F * !C, k, hb), z.toString != ya && (z.toString = ya), d(d.P + d.F * c(function() {
                            new p(1).slice()
                        }), k, {
                            slice: eb
                        }), d(d.P + d.F * (c(function() {
                            return [1, 2].toLocaleString() != new p([1, 2]).toLocaleString()
                        }) || !c(function() {
                            z.toLocaleString.call([1, 2])
                        })), k, {
                            toLocaleString: ab
                        }), F[k] = C ? B : D, C || j(z, Ba, D)
                    }
                } else a.exports = function() {}
            });
        ac("Int8", 1, function(a) {
            return function(b, c, d) {
                return a(this, b, c, d)
            }
        }), ac("Uint8", 1, function(a) {
            return function(b, c, d) {
                return a(this, b, c, d)
            }
        }), ac("Uint8", 1, function(a) {
            return function(b, c, d) {
                return a(this, b, c, d)
            }
        }, !0), ac("Int16", 2, function(a) {
            return function(b, c, d) {
                return a(this, b, c, d)
            }
        }), ac("Uint16", 2, function(a) {
            return function(b, c, d) {
                return a(this, b, c, d)
            }
        }), ac("Int32", 4, function(a) {
            return function(b, c, d) {
                return a(this, b, c, d)
            }
        }), ac("Uint32", 4, function(a) {
            return function(b, c, d) {
                return a(this, b, c, d)
            }
        }), ac("Float32", 4, function(a) {
            return function(b, c, d) {
                return a(this, b, c, d)
            }
        }), ac("Float64", 8, function(a) {
            return function(b, c, d) {
                return a(this, b, c, d)
            }
        });
        var bc = function(a, b, c, d) {
                try {
                    return d ? b(U(c)[0], c[1]) : b(c)
                } catch (b) {
                    var e = a.return;
                    throw void 0 !== e && U(e.call(a)), b
                }
            },
            cc = a(function(a) {
                var b = {},
                    c = {},
                    d = a.exports = function(a, d, e, f, g) {
                        var h, i, j, k, l = g ? function() {
                                return a
                            } : Fb(a),
                            m = la(e, f, d ? 2 : 1),
                            n = 0;
                        if ("function" != typeof l) throw TypeError(a + " is not iterable!");
                        if (sb(l)) {
                            for (h = Ca(a.length); h > n; n++)
                                if ((k = d ? m(U(i = a[n])[0], i[1]) : m(a[n])) === b || k === c) return k
                        } else
                            for (j = l.call(a); !(i = j.next()).done;)
                                if ((k = bc(j, m, i.value, d)) === b || k === c) return k
                    };
                d.BREAK = b, d.RETURN = c
            }),
            dc = a(function(a) {
                var b = ia("meta"),
                    c = ba.f,
                    d = 0,
                    e = Object.isExtensible || function() {
                        return !0
                    },
                    f = !V(function() {
                        return e(Object.preventExtensions({}))
                    }),
                    g = function(a) {
                        c(a, b, {
                            value: {
                                i: "O" + ++d,
                                w: {}
                            }
                        })
                    },
                    h = a.exports = {
                        KEY: b,
                        NEED: !1,
                        fastKey: function(a, c) {
                            if (!T(a)) return "symbol" == typeof a ? a : ("string" == typeof a ? "S" : "P") + a;
                            if (!fa(a, b)) {
                                if (!e(a)) return "F";
                                if (!c) return "E";
                                g(a)
                            }
                            return a[b].i
                        },
                        getWeak: function(a, c) {
                            if (!fa(a, b)) {
                                if (!e(a)) return !0;
                                if (!c) return !1;
                                g(a)
                            }
                            return a[b].w
                        },
                        onFreeze: function(a) {
                            return f && h.NEED && e(a) && !fa(a, b) && g(a), a
                        }
                    }
            }),
            ec = (dc.KEY, dc.NEED, dc.fastKey, dc.getWeak, dc.onFreeze, function(a, b) {
                if (!T(a) || a._t !== b) throw TypeError("Incompatible receiver, " + b + " required!");
                return a
            }),
            fc = ba.f,
            gc = dc.fastKey,
            hc = W ? "_s" : "size",
            ic = function(a, b) {
                var c, d = gc(b);
                if ("F" !== d) return a._i[d];
                for (c = a._f; c; c = c.n)
                    if (c.k == b) return c
            },
            jc = {
                getConstructor: function(a, b, c, d) {
                    var e = a(function(a, f) {
                        xa(a, e, b, "_i"), a._t = b, a._i = Ab(null), a._f = void 0, a._l = void 0, a[hc] = 0, null != f && cc(f, c, a[d], a)
                    });
                    return wa(e.prototype, {
                        clear: function() {
                            for (var a = ec(this, b), c = a._i, d = a._f; d; d = d.n) d.r = !0, d.p && (d.p = d.p.n = void 0), delete c[d.i];
                            a._f = a._l = void 0, a[hc] = 0
                        },
                        delete: function(a) {
                            var c = ec(this, b),
                                d = ic(c, a);
                            if (d) {
                                var e = d.n,
                                    f = d.p;
                                delete c._i[d.i], d.r = !0, f && (f.n = e), e && (e.p = f), c._f == d && (c._f = e), c._l == d && (c._l = f), c[hc]--
                            }
                            return !!d
                        },
                        forEach: function(a) {
                            ec(this, b);
                            for (var c, d = la(a, arguments.length > 1 ? arguments[1] : void 0, 3); c = c ? c.n : this._f;)
                                for (d(c.v, c.k, this); c && c.r;) c = c.p
                        },
                        has: function(a) {
                            return !!ic(ec(this, b), a)
                        }
                    }), W && fc(e.prototype, "size", {
                        get: function() {
                            return ec(this, b)[hc]
                        }
                    }), e
                },
                def: function(a, b, c) {
                    var d, e, f = ic(a, b);
                    return f ? f.v = c : (a._l = f = {
                        i: e = gc(b, !0),
                        k: b,
                        v: c,
                        p: d = a._l,
                        n: void 0,
                        r: !1
                    }, a._f || (a._f = f), d && (d.n = f), a[hc]++, "F" !== e && (a._i[e] = f)), a
                },
                getEntry: ic,
                setStrong: function(a, b, c) {
                    Tb(a, b, function(a, c) {
                        this._t = ec(a, b), this._k = c, this._l = void 0
                    }, function() {
                        for (var a = this._k, b = this._l; b && b.r;) b = b.p;
                        return this._t && (this._l = b = b ? b.n : this._t._f) ? Nb(0, "keys" == a ? b.k : "values" == a ? b.v : [b.k, b.v]) : (this._t = void 0, Nb(1))
                    }, c ? "entries" : "values", !c, !0), fb(b)
                }
            },
            kc = function(a, b) {
                if (U(a), !T(b) && null !== b) throw TypeError(b + ": can't set as prototype!")
            },
            lc = {
                set: Object.setPrototypeOf || ("__proto__" in {} ? function(a, b, c) {
                    try {
                        (c = la(Function.call, _b.f(Object.prototype, "__proto__").set, 2))(a, []), b = !(a instanceof Array)
                    } catch (a) {
                        b = !0
                    }
                    return function(a, d) {
                        return kc(a, d), b ? a.__proto__ = d : c(a, d), a
                    }
                }({}, !1) : void 0),
                check: kc
            },
            mc = lc.set,
            nc = function(a, b, c, d, e, f) {
                var g = R[a],
                    h = g,
                    i = e ? "set" : "add",
                    j = h && h.prototype,
                    k = {},
                    l = function(a) {
                        var b = j[a];
                        ja(j, a, "delete" == a ? function(a) {
                            return !(f && !T(a)) && b.call(this, 0 === a ? 0 : a)
                        } : "has" == a ? function(a) {
                            return !(f && !T(a)) && b.call(this, 0 === a ? 0 : a)
                        } : "get" == a ? function(a) {
                            return f && !T(a) ? void 0 : b.call(this, 0 === a ? 0 : a)
                        } : "add" == a ? function(a) {
                            return b.call(this, 0 === a ? 0 : a), this
                        } : function(a, c) {
                            return b.call(this, 0 === a ? 0 : a, c), this
                        })
                    };
                if ("function" == typeof h && (f || j.forEach && !V(function() {
                        (new h).entries().next()
                    }))) {
                    var m = new h,
                        n = m[i](f ? {} : -0, 1) != m,
                        o = V(function() {
                            m.has(1)
                        }),
                        p = Xb(function(a) {
                            new h(a)
                        }),
                        q = !f && V(function() {
                            for (var a = new h, b = 5; b--;) a[i](b, b);
                            return !a.has(-0)
                        });
                    p || ((h = b(function(b, c) {
                        xa(b, h, a);
                        var d = function(a, b, c) {
                            var d, e = b.constructor;
                            return e !== c && "function" == typeof e && (d = e.prototype) !== c.prototype && T(d) && mc && mc(a, d), a
                        }(new g, b, h);
                        return null != c && cc(c, e, d[i], d), d
                    })).prototype = j, j.constructor = h), (o || q) && (l("delete"), l("has"), e && l("get")), (q || n) && l(i), f && j.clear && delete j.clear
                } else h = d.getConstructor(b, a, e, i), wa(h.prototype, c), dc.NEED = !0;
                return ab(h, a), k[a] = h, oa(oa.G + oa.W + oa.F * (h != g), k), f || d.setStrong(h, a, e), h
            },
            oc = (nc("Map", function(a) {
                return function() {
                    return a(this, arguments.length > 0 ? arguments[0] : void 0)
                }
            }, {
                get: function(a) {
                    var b = jc.getEntry(ec(this, "Map"), a);
                    return b && b.v
                },
                set: function(a, b) {
                    return jc.def(ec(this, "Map"), 0 === a ? 0 : a, b)
                }
            }, jc, !0), nc("Set", function(a) {
                return function() {
                    return a(this, arguments.length > 0 ? arguments[0] : void 0)
                }
            }, {
                add: function(a) {
                    return jc.def(ec(this, "Set"), a = 0 === a ? 0 : a, a)
                }
            }, jc), {
                f: Object.getOwnPropertySymbols
            }),
            pc = Object.assign,
            qc = !pc || V(function() {
                var a = {},
                    b = {},
                    c = Symbol(),
                    d = "abcdefghijklmnopqrst";
                return a[c] = 7, d.split("").forEach(function(a) {
                    b[a] = a
                }), 7 != pc({}, a)[c] || Object.keys(pc({}, b)).join("") != d
            }) ? function(a, b) {
                for (var c = Xa(a), d = arguments.length, e = 1, f = oc.f, g = Zb.f; d > e;)
                    for (var h, i = Ga(arguments[e++]), j = f ? tb(i).concat(f(i)) : tb(i), k = j.length, l = 0; k > l;) g.call(i, h = j[l++]) && (c[h] = i[h]);
                return c
            } : pc,
            rc = dc.getWeak,
            sc = Jb(5),
            tc = Jb(6),
            uc = 0,
            vc = function(a) {
                return a._l || (a._l = new wc)
            },
            wc = function() {
                this.a = []
            },
            xc = function(a, b) {
                return sc(a.a, function(a) {
                    return a[0] === b
                })
            };
        wc.prototype = {
            get: function(a) {
                var b = xc(this, a);
                if (b) return b[1]
            },
            has: function(a) {
                return !!xc(this, a)
            },
            set: function(a, b) {
                var c = xc(this, a);
                c ? c[1] = b : this.a.push([a, b])
            },
            delete: function(a) {
                var b = tc(this.a, function(b) {
                    return b[0] === a
                });
                return ~b && this.a.splice(b, 1), !!~b
            }
        };
        var yc = {
            getConstructor: function(a, b, c, d) {
                var e = a(function(a, f) {
                    xa(a, e, b, "_i"), a._t = b, a._i = uc++, a._l = void 0, null != f && cc(f, c, a[d], a)
                });
                return wa(e.prototype, {
                    delete: function(a) {
                        if (!T(a)) return !1;
                        var c = rc(a);
                        return !0 === c ? vc(ec(this, b)).delete(a) : c && fa(c, this._i) && delete c[this._i]
                    },
                    has: function(a) {
                        if (!T(a)) return !1;
                        var c = rc(a);
                        return !0 === c ? vc(ec(this, b)).has(a) : c && fa(c, this._i)
                    }
                }), e
            },
            def: function(a, b, c) {
                var d = rc(U(b), !0);
                return !0 === d ? vc(a).set(b, c) : d[a._i] = c, a
            },
            ufstore: vc
        };
        a(function(a) {
            var b, c = Jb(0),
                d = dc.getWeak,
                e = Object.isExtensible,
                f = yc.ufstore,
                g = {},
                h = function(a) {
                    return function() {
                        return a(this, arguments.length > 0 ? arguments[0] : void 0)
                    }
                },
                i = {
                    get: function(a) {
                        if (T(a)) {
                            var b = d(a);
                            return !0 === b ? f(ec(this, "WeakMap")).get(a) : b ? b[this._i] : void 0
                        }
                    },
                    set: function(a, b) {
                        return yc.def(ec(this, "WeakMap"), a, b)
                    }
                },
                j = a.exports = nc("WeakMap", h, i, yc, !0, !0);
            V(function() {
                return 7 != (new j).set((Object.freeze || Object)(g), 7).get(g)
            }) && (b = yc.getConstructor(h, "WeakMap"), qc(b.prototype, i), dc.NEED = !0, c(["delete", "has", "get", "set"], function(a) {
                var c = j.prototype,
                    d = c[a];
                ja(c, a, function(c, f) {
                    if (T(c) && !e(c)) {
                        this._f || (this._f = new b);
                        var g = this._f[a](c, f);
                        return "set" == a ? this : g
                    }
                    return d.call(this, c, f)
                })
            }))
        }), nc("WeakSet", function(a) {
            return function() {
                return a(this, arguments.length > 0 ? arguments[0] : void 0)
            }
        }, {
            add: function(a) {
                return yc.def(ec(this, "WeakSet"), a, !0)
            }
        }, yc, !1, !0);
        var zc = (R.Reflect || {}).apply,
            Ac = Function.apply;
        oa(oa.S + oa.F * !V(function() {
            zc(function() {})
        }), "Reflect", {
            apply: function(a, b, c) {
                var d = ka(a),
                    e = U(c);
                return zc ? zc(d, b, e) : Ac.call(d, b, e)
            }
        });
        var Bc = function(a, b, c) {
                var d = void 0 === c;
                switch (b.length) {
                    case 0:
                        return d ? a() : a.call(c);
                    case 1:
                        return d ? a(b[0]) : a.call(c, b[0]);
                    case 2:
                        return d ? a(b[0], b[1]) : a.call(c, b[0], b[1]);
                    case 3:
                        return d ? a(b[0], b[1], b[2]) : a.call(c, b[0], b[1], b[2]);
                    case 4:
                        return d ? a(b[0], b[1], b[2], b[3]) : a.call(c, b[0], b[1], b[2], b[3])
                }
                return a.apply(c, b)
            },
            Cc = [].slice,
            Dc = {},
            Ec = Function.bind || function(a) {
                var b = ka(this),
                    c = Cc.call(arguments, 1),
                    d = function() {
                        var e = c.concat(Cc.call(arguments));
                        return this instanceof d ? function(a, b, c) {
                            if (!(b in Dc)) {
                                for (var d = [], e = 0; e < b; e++) d[e] = "a[" + e + "]";
                                Dc[b] = Function("F,a", "return new F(" + d.join(",") + ")")
                            }
                            return Dc[b](a, c)
                        }(b, e.length, e) : Bc(b, e, a)
                    };
                return T(b.prototype) && (d.prototype = b.prototype), d
            },
            Fc = (R.Reflect || {}).construct,
            Gc = V(function() {
                function a() {}
                return !(Fc(function() {}, [], a) instanceof a)
            }),
            Hc = !V(function() {
                Fc(function() {})
            });
        oa(oa.S + oa.F * (Gc || Hc), "Reflect", {
            construct: function(a, b) {
                ka(a), U(b);
                var c = arguments.length < 3 ? a : ka(arguments[2]);
                if (Hc && !Gc) return Fc(a, b, c);
                if (a == c) {
                    switch (b.length) {
                        case 0:
                            return new a;
                        case 1:
                            return new a(b[0]);
                        case 2:
                            return new a(b[0], b[1]);
                        case 3:
                            return new a(b[0], b[1], b[2]);
                        case 4:
                            return new a(b[0], b[1], b[2], b[3])
                    }
                    var d = [null];
                    return d.push.apply(d, b), new(Ec.apply(a, d))
                }
                var e = c.prototype,
                    f = Ab(T(e) ? e : Object.prototype),
                    g = Function.apply.call(a, f, b);
                return T(g) ? g : f
            }
        }), oa(oa.S + oa.F * V(function() {
            Reflect.defineProperty(ba.f({}, 1, {
                value: 1
            }), 1, {
                value: 2
            })
        }), "Reflect", {
            defineProperty: function(a, b, c) {
                U(a), b = _(b, !0), U(c);
                try {
                    return ba.f(a, b, c), !0
                } catch (a) {
                    return !1
                }
            }
        });
        var Ic = _b.f;
        oa(oa.S, "Reflect", {
            deleteProperty: function(a, b) {
                var c = Ic(U(a), b);
                return !(c && !c.configurable) && delete a[b]
            }
        }), oa(oa.S, "Reflect", {
            get: function a(b, c) {
                var d, e, f = arguments.length < 3 ? b : arguments[2];
                return U(b) === f ? b[c] : (d = _b.f(b, c)) ? fa(d, "value") ? d.value : void 0 !== d.get ? d.get.call(f) : void 0 : T(e = Db(b)) ? a(e, c, f) : void 0
            }
        }), oa(oa.S, "Reflect", {
            getOwnPropertyDescriptor: function(a, b) {
                return _b.f(U(a), b)
            }
        }), oa(oa.S, "Reflect", {
            getPrototypeOf: function(a) {
                return Db(U(a))
            }
        }), oa(oa.S, "Reflect", {
            has: function(a, b) {
                return b in a
            }
        });
        var Jc = Object.isExtensible;
        oa(oa.S, "Reflect", {
            isExtensible: function(a) {
                return U(a), !Jc || Jc(a)
            }
        });
        var Kc = R.Reflect,
            Lc = Kc && Kc.ownKeys || function(a) {
                var b = Wa.f(U(a)),
                    c = oc.f;
                return c ? b.concat(c(a)) : b
            };
        oa(oa.S, "Reflect", {
            ownKeys: Lc
        });
        var Mc = Object.preventExtensions;
        oa(oa.S, "Reflect", {
            preventExtensions: function(a) {
                U(a);
                try {
                    return Mc && Mc(a), !0
                } catch (a) {
                    return !1
                }
            }
        }), oa(oa.S, "Reflect", {
            set: function a(b, c, d) {
                var e, f, g = arguments.length < 4 ? b : arguments[3],
                    h = _b.f(U(b), c);
                if (!h) {
                    if (T(f = Db(b))) return a(f, c, d, g);
                    h = ca(0)
                }
                return fa(h, "value") ? !(!1 === h.writable || !T(g) || ((e = _b.f(g, c) || ca(0)).value = d, ba.f(g, c, e), 0)) : void 0 !== h.set && (h.set.call(g, d), !0)
            }
        }), lc && oa(oa.S, "Reflect", {
            setPrototypeOf: function(a, b) {
                lc.check(a, b);
                try {
                    return lc.set(a, b), !0
                } catch (a) {
                    return !1
                }
            }
        });
        var Nc, Oc, Pc, Qc = R.process,
            Rc = R.setImmediate,
            Sc = R.clearImmediate,
            Tc = R.MessageChannel,
            Uc = R.Dispatch,
            Vc = 0,
            Wc = {},
            Xc = function() {
                var a = +this;
                if (Wc.hasOwnProperty(a)) {
                    var b = Wc[a];
                    delete Wc[a], b()
                }
            },
            Yc = function(a) {
                Xc.call(a.data)
            };
        Rc && Sc || (Rc = function(a) {
            for (var b = [], c = 1; arguments.length > c;) b.push(arguments[c++]);
            return Wc[++Vc] = function() {
                Bc("function" == typeof a ? a : Function(a), b)
            }, Nc(Vc), Vc
        }, Sc = function(a) {
            delete Wc[a]
        }, "process" == Fa(Qc) ? Nc = function(a) {
            Qc.nextTick(la(Xc, a, 1))
        } : Uc && Uc.now ? Nc = function(a) {
            Uc.now(la(Xc, a, 1))
        } : Tc ? (Pc = (Oc = new Tc).port2, Oc.port1.onmessage = Yc, Nc = la(Pc.postMessage, Pc, 1)) : R.addEventListener && "function" == typeof postMessage && !R.importScripts ? (Nc = function(a) {
            R.postMessage(a + "", "*")
        }, R.addEventListener("message", Yc, !1)) : Nc = "onreadystatechange" in Z("script") ? function(a) {
            wb.appendChild(Z("script")).onreadystatechange = function() {
                wb.removeChild(this), Xc.call(a)
            }
        } : function(a) {
            setTimeout(la(Xc, a, 1), 0)
        });
        var Zc, $c, _c, ad, bd = {
                set: Rc,
                clear: Sc
            },
            cd = bd.set,
            dd = R.MutationObserver || R.WebKitMutationObserver,
            ed = R.process,
            fd = R.Promise,
            gd = "process" == Fa(ed),
            hd = {
                f: function(a) {
                    return new b(a)
                }
            },
            id = function(a) {
                try {
                    return {
                        e: !1,
                        v: a()
                    }
                } catch (a) {
                    return {
                        e: !0,
                        v: a
                    }
                }
            },
            jd = bd.set,
            kd = function() {
                var a, b, c, d = function() {
                    var d, e;
                    for (gd && (d = ed.domain) && d.exit(); a;) {
                        e = a.fn, a = a.next;
                        try {
                            e()
                        } catch (d) {
                            throw a ? c() : b = void 0, d
                        }
                    }
                    b = void 0, d && d.enter()
                };
                if (gd) c = function() {
                    ed.nextTick(d)
                };
                else if (!dd || R.navigator && R.navigator.standalone)
                    if (fd && fd.resolve) {
                        var e = fd.resolve();
                        c = function() {
                            e.then(d)
                        }
                    } else c = function() {
                        cd.call(R, d)
                    };
                else {
                    var f = !0,
                        g = document.createTextNode("");
                    new dd(d).observe(g, {
                        characterData: !0
                    }), c = function() {
                        g.data = f = !f
                    }
                }
                return function(d) {
                    var e = {
                        fn: d,
                        next: void 0
                    };
                    b && (b.next = e), a || (a = e, c()), b = e
                }
            }(),
            ld = R.TypeError,
            md = R.process,
            nd = R.Promise,
            od = "process" == ob(md),
            pd = function() {},
            qd = $c = hd.f,
            rd = !! function() {
                try {
                    var a = nd.resolve(1),
                        b = (a.constructor = {})[Za("species")] = function(a) {
                            a(pd, pd)
                        };
                    return (od || "function" == typeof PromiseRejectionEvent) && a.then(pd) instanceof b
                } catch (a) {}
            }(),
            sd = function(a) {
                var b;
                return !(!T(a) || "function" != typeof(b = a.then)) && b
            },
            td = function(a, b) {
                if (!a._n) {
                    a._n = !0;
                    var c = a._c;
                    kd(function() {
                        for (var d = a._v, e = 1 == a._s, f = 0, g = function(b) {
                                var c, f, g = e ? b.ok : b.fail,
                                    h = b.resolve,
                                    i = b.reject,
                                    j = b.domain;
                                try {
                                    g ? (e || (2 == a._h && wd(a), a._h = 1), !0 === g ? c = d : (j && j.enter(), c = g(d), j && j.exit()), c === b.promise ? i(ld("Promise-chain cycle")) : (f = sd(c)) ? f.call(c, h, i) : h(c)) : i(d)
                                } catch (a) {
                                    i(a)
                                }
                            }; c.length > f;) g(c[f++]);
                        a._c = [], a._n = !1, b && !a._h && ud(a)
                    })
                }
            },
            ud = function(a) {
                jd.call(R, function() {
                    var b, c, d, e = a._v,
                        f = vd(a);
                    if (f && (b = id(function() {
                            od ? md.emit("unhandledRejection", e, a) : (c = R.onunhandledrejection) ? c({
                                promise: a,
                                reason: e
                            }) : (d = R.console) && d.error && d.error("Unhandled promise rejection", e)
                        }), a._h = od || vd(a) ? 2 : 1), a._a = void 0, f && b.e) throw b.v
                })
            },
            vd = function(a) {
                return 1 !== a._h && 0 === (a._a || a._c).length
            },
            wd = function(a) {
                jd.call(R, function() {
                    var b;
                    od ? md.emit("rejectionHandled", a) : (b = R.onrejectionhandled) && b({
                        promise: a,
                        reason: a._v
                    })
                })
            },
            xd = function(a) {
                var b = this;
                b._d || (b._d = !0, (b = b._w || b)._v = a, b._s = 2, b._a || (b._a = b._c.slice()), td(b, !0))
            },
            yd = function(a) {
                var b, c = this;
                if (!c._d) {
                    c._d = !0, c = c._w || c;
                    try {
                        if (c === a) throw ld("Promise can't be resolved itself");
                        (b = sd(a)) ? kd(function() {
                            var d = {
                                _w: c,
                                _d: !1
                            };
                            try {
                                b.call(a, la(yd, d, 1), la(xd, d, 1))
                            } catch (a) {
                                xd.call(d, a)
                            }
                        }): (c._v = a, c._s = 1, td(c, !1))
                    } catch (a) {
                        xd.call({
                            _w: c,
                            _d: !1
                        }, a)
                    }
                }
            };
        rd || (nd = function(a) {
            xa(this, nd, "Promise", "_h"), ka(a), Zc.call(this);
            try {
                a(la(yd, this, 1), la(xd, this, 1))
            } catch (a) {
                xd.call(this, a)
            }
        }, (Zc = function(a) {
            this._c = [], this._a = void 0, this._s = 0, this._d = !1, this._v = void 0, this._h = 0, this._n = !1
        }).prototype = wa(nd.prototype, {
            then: function(a, b) {
                var c = qd(db(this, nd));
                return c.ok = "function" != typeof a || a, c.fail = "function" == typeof b && b, c.domain = od ? md.domain : void 0, this._c.push(c), this._a && this._a.push(c), this._s && td(this, !1), c.promise
            },
            catch: function(a) {
                return this.then(void 0, a)
            }
        }), _c = function() {
            var a = new Zc;
            this.promise = a, this.resolve = la(yd, a, 1), this.reject = la(xd, a, 1)
        }, hd.f = qd = function(a) {
            return a === nd || a === ad ? new _c(a) : $c(a)
        }), oa(oa.G + oa.W + oa.F * !rd, {
            Promise: nd
        }), ab(nd, "Promise"), fb("Promise"), ad = S.Promise, oa(oa.S + oa.F * !rd, "Promise", {
            reject: function(a) {
                var b = qd(this);
                return (0, b.reject)(a), b.promise
            }
        }), oa(oa.S + oa.F * !rd, "Promise", {
            resolve: function(a) {
                return function(a, b) {
                    if (U(a), T(b) && b.constructor === a) return b;
                    var c = hd.f(a);
                    return (0, c.resolve)(b), c.promise
                }(this, a)
            }
        }), oa(oa.S + oa.F * !(rd && Xb(function(a) {
            nd.all(a).catch(pd)
        })), "Promise", {
            all: function(a) {
                var b = this,
                    c = qd(b),
                    d = c.resolve,
                    e = c.reject,
                    f = id(function() {
                        var c = [],
                            f = 0,
                            g = 1;
                        cc(a, !1, function(a) {
                            var h = f++,
                                i = !1;
                            c.push(void 0), g++, b.resolve(a).then(function(a) {
                                i || (i = !0, c[h] = a, --g || d(c))
                            }, e)
                        }), --g || d(c)
                    });
                return f.e && e(f.v), c.promise
            },
            race: function(a) {
                var b = this,
                    c = qd(b),
                    d = c.reject,
                    e = id(function() {
                        cc(a, !1, function(a) {
                            b.resolve(a).then(c.resolve, d)
                        })
                    });
                return e.e && d(e.v), c.promise
            }
        });
        var zd = {
                f: Za
            },
            Ad = ba.f,
            Bd = function(a) {
                var b = S.Symbol || (S.Symbol = R.Symbol || {});
                "_" == a.charAt(0) || a in b || Ad(b, a, {
                    value: zd.f(a)
                })
            },
            Cd = Wa.f,
            Dd = {}.toString,
            Ed = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [],
            Fd = {
                f: function(a) {
                    return Ed && "[object Window]" == Dd.call(a) ? function(a) {
                        try {
                            return Cd(a)
                        } catch (a) {
                            return Ed.slice()
                        }
                    }(a) : Cd(Ia(a))
                }
            },
            Gd = dc.KEY,
            Hd = _b.f,
            Id = ba.f,
            Jd = Fd.f,
            Kd = R.Symbol,
            Ld = R.JSON,
            Md = Ld && Ld.stringify,
            Nd = Za("_hidden"),
            Od = Za("toPrimitive"),
            Pd = {}.propertyIsEnumerable,
            Qd = Oa("symbol-registry"),
            Rd = Oa("symbols"),
            Sd = Oa("op-symbols"),
            Td = Object.prototype,
            Ud = "function" == typeof Kd,
            Vd = R.QObject,
            Wd = !Vd || !Vd.prototype || !Vd.prototype.findChild,
            Xd = W && V(function() {
                return 7 != Ab(Id({}, "a", {
                    get: function() {
                        return Id(this, "a", {
                            value: 7
                        }).a
                    }
                })).a
            }) ? function(a, b, c) {
                var d = Hd(Td, b);
                d && delete Td[b], Id(a, b, c), d && a !== Td && Id(Td, b, d)
            } : Id,
            Yd = function(a) {
                var b = Rd[a] = Ab(Kd.prototype);
                return b._k = a, b
            },
            Zd = Ud && "symbol" == typeof Kd.iterator ? function(a) {
                return "symbol" == typeof a
            } : function(a) {
                return a instanceof Kd
            },
            $d = function(a, b, c) {
                return a === Td && $d(Sd, b, c), U(a), b = _(b, !0), U(c), fa(Rd, b) ? (c.enumerable ? (fa(a, Nd) && a[Nd][b] && (a[Nd][b] = !1), c = Ab(c, {
                    enumerable: ca(0, !1)
                })) : (fa(a, Nd) || Id(a, Nd, ca(1, {})), a[Nd][b] = !0), Xd(a, b, c)) : Id(a, b, c)
            },
            _d = function(a, b) {
                U(a);
                for (var c, d = function(a) {
                        var b = tb(a),
                            c = oc.f;
                        if (c)
                            for (var d, e = c(a), f = Zb.f, g = 0; e.length > g;) f.call(a, d = e[g++]) && b.push(d);
                        return b
                    }(b = Ia(b)), e = 0, f = d.length; f > e;) $d(a, c = d[e++], b[c]);
                return a
            },
            ae = function(a) {
                var b = Pd.call(this, a = _(a, !0));
                return !(this === Td && fa(Rd, a) && !fa(Sd, a)) && (!(b || !fa(this, a) || !fa(Rd, a) || fa(this, Nd) && this[Nd][a]) || b)
            },
            be = function(a, b) {
                if (a = Ia(a), b = _(b, !0), a !== Td || !fa(Rd, b) || fa(Sd, b)) {
                    var c = Hd(a, b);
                    return !c || !fa(Rd, b) || fa(a, Nd) && a[Nd][b] || (c.enumerable = !0), c
                }
            },
            ce = function(a) {
                for (var b, c = Jd(Ia(a)), d = [], e = 0; c.length > e;) fa(Rd, b = c[e++]) || b == Nd || b == Gd || d.push(b);
                return d
            },
            de = function(a) {
                for (var b, c = a === Td, d = Jd(c ? Sd : Ia(a)), e = [], f = 0; d.length > f;) !fa(Rd, b = d[f++]) || c && !fa(Td, b) || e.push(Rd[b]);
                return e
            };
        Ud || (ja((Kd = function() {
            if (this instanceof Kd) throw TypeError("Symbol is not a constructor!");
            var a = ia(arguments.length > 0 ? arguments[0] : void 0),
                b = function(c) {
                    this === Td && b.call(Sd, c), fa(this, Nd) && fa(this[Nd], a) && (this[Nd][a] = !1), Xd(this, a, ca(1, c))
                };
            return W && Wd && Xd(Td, a, {
                configurable: !0,
                set: b
            }), Yd(a)
        }).prototype, "toString", function() {
            return this._k
        }), _b.f = be, ba.f = $d, Wa.f = Fd.f = ce, Zb.f = ae, oc.f = de, W && ja(Td, "propertyIsEnumerable", ae, !0), zd.f = function(a) {
            return Yd(Za(a))
        }), oa(oa.G + oa.W + oa.F * !Ud, {
            Symbol: Kd
        });
        for (var ee = "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), fe = 0; ee.length > fe;) Za(ee[fe++]);
        for (var ge = tb(Za.store), he = 0; ge.length > he;) Bd(ge[he++]);
        oa(oa.S + oa.F * !Ud, "Symbol", {
            for: function(a) {
                return fa(Qd, a += "") ? Qd[a] : Qd[a] = Kd(a)
            },
            keyFor: function(a) {
                if (!Zd(a)) throw TypeError(a + " is not a symbol!");
                for (var b in Qd)
                    if (Qd[b] === a) return b
            },
            useSetter: function() {
                Wd = !0
            },
            useSimple: function() {
                Wd = !1
            }
        }), oa(oa.S + oa.F * !Ud, "Object", {
            create: function(a, b) {
                return void 0 === b ? Ab(a) : _d(Ab(a), b)
            },
            defineProperty: $d,
            defineProperties: _d,
            getOwnPropertyDescriptor: be,
            getOwnPropertyNames: ce,
            getOwnPropertySymbols: de
        }), Ld && oa(oa.S + oa.F * (!Ud || V(function() {
            var a = Kd();
            return "[null]" != Md([a]) || "{}" != Md({
                a: a
            }) || "{}" != Md(Object(a))
        })), "JSON", {
            stringify: function(a) {
                for (var b, c, d = [a], e = 1; arguments.length > e;) d.push(arguments[e++]);
                if (c = b = d[1], (T(b) || void 0 !== a) && !Zd(a)) return Gb(b) || (b = function(a, b) {
                    if ("function" == typeof c && (b = c.call(this, a, b)), !Zd(b)) return b
                }), d[1] = b, Md.apply(Ld, d)
            }
        }), Kd.prototype[Od] || da(Kd.prototype, Od, Kd.prototype.valueOf), ab(Kd, "Symbol"), ab(Math, "Math", !0), ab(R.JSON, "JSON", !0);
        var ie = function(a, b) {
                var c = (S.Object || {})[a] || Object[a],
                    d = {};
                d[a] = b(c), oa(oa.S + oa.F * V(function() {
                    c(1)
                }), "Object", d)
            },
            je = dc.onFreeze;
        ie("freeze", function(a) {
            return function(b) {
                return a && T(b) ? a(je(b)) : b
            }
        });
        var ke = dc.onFreeze;
        ie("seal", function(a) {
            return function(b) {
                return a && T(b) ? a(ke(b)) : b
            }
        });
        var le = dc.onFreeze;
        ie("preventExtensions", function(a) {
            return function(b) {
                return a && T(b) ? a(le(b)) : b
            }
        }), ie("isFrozen", function(a) {
            return function(b) {
                return !T(b) || !!a && a(b)
            }
        }), ie("isSealed", function(a) {
            return function(b) {
                return !T(b) || !!a && a(b)
            }
        }), ie("isExtensible", function(a) {
            return function(b) {
                return !!T(b) && (!a || a(b))
            }
        });
        var me = _b.f;
        ie("getOwnPropertyDescriptor", function() {
            return function(a, b) {
                return me(Ia(a), b)
            }
        }), ie("getPrototypeOf", function() {
            return function(a) {
                return Db(Xa(a))
            }
        }), ie("keys", function() {
            return function(a) {
                return tb(Xa(a))
            }
        }), ie("getOwnPropertyNames", function() {
            return Fd.f
        }), oa(oa.S + oa.F, "Object", {
            assign: qc
        });
        var ne = Object.is || function(a, b) {
            return a === b ? 0 !== a || 1 / a == 1 / b : a != a && b != b
        };
        oa(oa.S, "Object", {
            is: ne
        });
        var oe = ba.f,
            pe = Function.prototype,
            qe = /^\s*function ([^ (]*)/;
        "name" in pe || W && oe(pe, "name", {
            configurable: !0,
            get: function() {
                try {
                    return ("" + this).match(qe)[1]
                } catch (a) {
                    return ""
                }
            }
        }), oa(oa.S, "String", {
            raw: function(a) {
                for (var b = Ia(a.raw), c = Ca(b.length), d = arguments.length, e = [], f = 0; c > f;) e.push(String(b[f++])), f < d && e.push(String(arguments[f]));
                return e.join("")
            }
        });
        var re = String.fromCharCode,
            se = String.fromCodePoint;
        oa(oa.S + oa.F * (!!se && 1 != se.length), "String", {
            fromCodePoint: function(a) {
                for (var b, c = [], d = arguments.length, e = 0; d > e;) {
                    if (b = +arguments[e++], La(b, 1114111) !== b) throw RangeError(b + " is not a valid code point");
                    c.push(b < 65536 ? re(b) : re(55296 + ((b -= 65536) >> 10), b % 1024 + 56320))
                }
                return c.join("")
            }
        });
        var te, ue = (te = !1, function(a, b) {
            var c, d, e = String(Ha(a)),
                f = Aa(b),
                g = e.length;
            return f < 0 || f >= g ? te ? "" : void 0 : (c = e.charCodeAt(f)) < 55296 || c > 56319 || f + 1 === g || (d = e.charCodeAt(f + 1)) < 56320 || d > 57343 ? te ? e.charAt(f) : c : te ? e.slice(f, f + 2) : d - 56320 + (c - 55296 << 10) + 65536
        });
        oa(oa.P, "String", {
            codePointAt: function(a) {
                return ue(this, a)
            }
        });
        var ve = function(a) {
            var b = String(Ha(this)),
                c = "",
                d = Aa(a);
            if (d < 0 || d == 1 / 0) throw RangeError("Count can't be negative");
            for (; d > 0;
                (d >>>= 1) && (b += b)) 1 & d && (c += b);
            return c
        };
        oa(oa.P, "String", {
            repeat: ve
        });
        var we = Za("match"),
            xe = function(a) {
                var b;
                return T(a) && (void 0 !== (b = a[we]) ? !!b : "RegExp" == Fa(a))
            },
            ye = function(a, b, c) {
                if (xe(b)) throw TypeError("String#" + c + " doesn't accept regex!");
                return String(Ha(a))
            },
            ze = Za("match"),
            Ae = function(a) {
                var b = /./;
                try {
                    "/./" [a](b)
                } catch (c) {
                    try {
                        return b[ze] = !1, !"/./" [a](b)
                    } catch (a) {}
                }
                return !0
            },
            Be = "".startsWith;
        oa(oa.P + oa.F * Ae("startsWith"), "String", {
            startsWith: function(a) {
                var b = ye(this, a, "startsWith"),
                    c = Ca(Math.min(arguments.length > 1 ? arguments[1] : void 0, b.length)),
                    d = String(a);
                return Be ? Be.call(b, d, c) : b.slice(c, c + d.length) === d
            }
        });
        var Ce = "".endsWith;
        oa(oa.P + oa.F * Ae("endsWith"), "String", {
            endsWith: function(a) {
                var b = ye(this, a, "endsWith"),
                    c = arguments.length > 1 ? arguments[1] : void 0,
                    d = Ca(b.length),
                    e = void 0 === c ? d : Math.min(Ca(c), d),
                    f = String(a);
                return Ce ? Ce.call(b, f, e) : b.slice(e - f.length, e) === f
            }
        }), oa(oa.P + oa.F * Ae("includes"), "String", {
            includes: function(a) {
                return !!~ye(this, a, "includes").indexOf(a, arguments.length > 1 ? arguments[1] : void 0)
            }
        }), W && "g" != /./g.flags && ba.f(RegExp.prototype, "flags", {
            configurable: !0,
            get: function() {
                var a = U(this),
                    b = "";
                return a.global && (b += "g"), a.ignoreCase && (b += "i"), a.multiline && (b += "m"), a.unicode && (b += "u"), a.sticky && (b += "y"), b
            }
        });
        var De = function(a, b, c) {
            var d = Za(a),
                e = c(Ha, d, "" [a]),
                f = e[0],
                g = e[1];
            V(function() {
                var b = {};
                return b[d] = function() {
                    return 7
                }, 7 != "" [a](b)
            }) && (ja(String.prototype, a, f), da(RegExp.prototype, d, 2 == b ? function(a, b) {
                return g.call(a, this, b)
            } : function(a) {
                return g.call(a, this)
            }))
        };
        De("match", 1, function(a, b, c) {
            return [function(c) {
                var d = a(this),
                    e = null == c ? void 0 : c[b];
                return void 0 !== e ? e.call(c, d) : new RegExp(c)[b](String(d))
            }, c]
        }), De("replace", 2, function(a, b, c) {
            return [function(d, e) {
                var f = a(this),
                    g = null == d ? void 0 : d[b];
                return void 0 !== g ? g.call(d, f, e) : c.call(String(f), d, e)
            }, c]
        }), De("split", 2, function(a, b, c) {
            var d = xe,
                e = c,
                f = [].push;
            if ("c" == "abbc".split(/(b)*/)[1] || 4 != "test".split(/(?:)/, -1).length || 2 != "ab".split(/(?:ab)*/).length || 4 != ".".split(/(.?)(.?)/).length || ".".split(/()()/).length > 1 || "".split(/.?/).length) {
                var g = void 0 === /()??/.exec("")[1];
                c = function(a, b) {
                    var c = String(this);
                    if (void 0 === a && 0 === b) return [];
                    if (!d(a)) return e.call(c, a, b);
                    var h, i, j, k, l, m = [],
                        n = (a.ignoreCase ? "i" : "") + (a.multiline ? "m" : "") + (a.unicode ? "u" : "") + (a.sticky ? "y" : ""),
                        o = 0,
                        p = void 0 === b ? 4294967295 : b >>> 0,
                        q = new RegExp(a.source, n + "g");
                    for (g || (h = new RegExp("^" + q.source + "$(?!\\s)", n));
                        (i = q.exec(c)) && !((j = i.index + i[0].length) > o && (m.push(c.slice(o, i.index)), !g && i.length > 1 && i[0].replace(h, function() {
                            for (l = 1; l < arguments.length - 2; l++) void 0 === arguments[l] && (i[l] = void 0)
                        }), i.length > 1 && i.index < c.length && f.apply(m, i.slice(1)), k = i[0].length, o = j, m.length >= p));) q.lastIndex === i.index && q.lastIndex++;
                    return o === c.length ? !k && q.test("") || m.push("") : m.push(c.slice(o)), m.length > p ? m.slice(0, p) : m
                }
            } else "0".split(void 0, 0).length && (c = function(a, b) {
                return void 0 === a && 0 === b ? [] : e.call(this, a, b)
            });
            return [function(d, e) {
                var f = a(this),
                    g = null == d ? void 0 : d[b];
                return void 0 !== g ? g.call(d, f, e) : c.call(String(f), d, e)
            }, c]
        }), De("search", 1, function(a, b, c) {
            return [function(c) {
                var d = a(this),
                    e = null == c ? void 0 : c[b];
                return void 0 !== e ? e.call(c, d) : new RegExp(c)[b](String(d))
            }, c]
        });
        var Ee = function(a, b, c) {
            b in a ? ba.f(a, b, ca(0, c)) : a[b] = c
        };
        oa(oa.S + oa.F * !Xb(function(a) {}), "Array", {
            from: function(a) {
                var b, c, d, e, f = Xa(a),
                    g = "function" == typeof this ? this : Array,
                    h = arguments.length,
                    i = h > 1 ? arguments[1] : void 0,
                    j = void 0 !== i,
                    k = 0,
                    l = Fb(f);
                if (j && (i = la(i, h > 2 ? arguments[2] : void 0, 2)), null == l || g == Array && sb(l))
                    for (c = new g(b = Ca(f.length)); b > k; k++) Ee(c, k, j ? i(f[k], k) : f[k]);
                else
                    for (e = l.call(f), c = new g; !(d = e.next()).done; k++) Ee(c, k, j ? bc(e, i, [d.value, k], !0) : d.value);
                return c.length = k, c
            }
        }), oa(oa.S + oa.F * V(function() {
            function a() {}
            return !(Array.of.call(a) instanceof a)
        }), "Array", {
            of: function() {
                for (var a = 0, b = arguments.length, c = new("function" == typeof this ? this : Array)(b); b > a;) Ee(c, a, arguments[a++]);
                return c.length = b, c
            }
        }), oa(oa.P, "Array", {
            copyWithin: Yb
        }), Mb("copyWithin");
        var Fe = Jb(5),
            Ge = !0;
        "find" in [] && Array(1).find(function() {
            Ge = !1
        }), oa(oa.P + oa.F * Ge, "Array", {
            find: function(a) {
                return Fe(this, a, arguments.length > 1 ? arguments[1] : void 0)
            }
        }), Mb("find");
        var He = Jb(6),
            Ie = !0;
        "findIndex" in [] && Array(1).findIndex(function() {
            Ie = !1
        }), oa(oa.P + oa.F * Ie, "Array", {
            findIndex: function(a) {
                return He(this, a, arguments.length > 1 ? arguments[1] : void 0)
            }
        }), Mb("findIndex"), oa(oa.P, "Array", {
            fill: Ya
        }), Mb("fill");
        var Je = R.isFinite;
        oa(oa.S, "Number", {
            isFinite: function(a) {
                return "number" == typeof a && Je(a)
            }
        });
        var Ke = Math.floor,
            Le = function(a) {
                return !T(a) && isFinite(a) && Ke(a) === a
            };
        oa(oa.S, "Number", {
            isInteger: Le
        });
        var Me = Math.abs;
        oa(oa.S, "Number", {
            isSafeInteger: function(a) {
                return Le(a) && Me(a) <= 9007199254740991
            }
        }), oa(oa.S, "Number", {
            isNaN: function(a) {
                return a != a
            }
        }), oa(oa.S, "Number", {
            EPSILON: Math.pow(2, -52)
        }), oa(oa.S, "Number", {
            MIN_SAFE_INTEGER: -9007199254740991
        }), oa(oa.S, "Number", {
            MAX_SAFE_INTEGER: 9007199254740991
        });
        var Ne = Math.log1p || function(a) {
                return (a = +a) > -1e-8 && a < 1e-8 ? a - a * a / 2 : Math.log(1 + a)
            },
            Oe = Math.sqrt,
            Pe = Math.acosh;
        oa(oa.S + oa.F * !(Pe && 710 == Math.floor(Pe(Number.MAX_VALUE)) && Pe(1 / 0) == 1 / 0), "Math", {
            acosh: function(a) {
                return (a = +a) < 1 ? NaN : a > 94906265.62425156 ? Math.log(a) + Math.LN2 : Ne(a - 1 + Oe(a - 1) * Oe(a + 1))
            }
        });
        var Qe = Math.asinh;
        oa(oa.S + oa.F * !(Qe && 1 / Qe(0) > 0), "Math", {
            asinh: function a(b) {
                return isFinite(b = +b) && 0 != b ? b < 0 ? -a(-b) : Math.log(b + Math.sqrt(b * b + 1)) : b
            }
        });
        var Re = Math.atanh;
        oa(oa.S + oa.F * !(Re && 1 / Re(-0) < 0), "Math", {
            atanh: function(a) {
                return 0 == (a = +a) ? a : Math.log((1 + a) / (1 - a)) / 2
            }
        });
        var Se = Math.sign || function(a) {
            return 0 == (a = +a) || a != a ? a : a < 0 ? -1 : 1
        };
        oa(oa.S, "Math", {
            cbrt: function(a) {
                return Se(a = +a) * Math.pow(Math.abs(a), 1 / 3)
            }
        }), oa(oa.S, "Math", {
            clz32: function(a) {
                return (a >>>= 0) ? 31 - Math.floor(Math.log(a + .5) * Math.LOG2E) : 32
            }
        });
        var Te = Math.exp;
        oa(oa.S, "Math", {
            cosh: function(a) {
                return (Te(a = +a) + Te(-a)) / 2
            }
        });
        var Ue = Math.expm1,
            Ve = !Ue || Ue(10) > 22025.465794806718 || Ue(10) < 22025.465794806718 || -2e-17 != Ue(-2e-17) ? function(a) {
                return 0 == (a = +a) ? a : a > -1e-6 && a < 1e-6 ? a + a * a / 2 : Math.exp(a) - 1
            } : Ue;
        oa(oa.S + oa.F * (Ve != Math.expm1), "Math", {
            expm1: Ve
        });
        var We = Math.pow,
            Xe = We(2, -52),
            Ye = We(2, -23),
            Ze = We(2, 127) * (2 - Ye),
            $e = We(2, -126),
            _e = Math.fround || function(a) {
                var b, c, d = Math.abs(a),
                    e = Se(a);
                return d < $e ? e * (d / $e / Ye + 1 / Xe - 1 / Xe) * $e * Ye : (c = (b = (1 + Ye / Xe) * d) - (b - d)) > Ze || c != c ? e * (1 / 0) : e * c
            };
        oa(oa.S, "Math", {
            fround: _e
        });
        var af = Math.abs;
        oa(oa.S, "Math", {
            hypot: function(a, b) {
                for (var c, d, e = 0, f = 0, g = arguments.length, h = 0; f < g;) h < (c = af(arguments[f++])) ? (e = e * (d = h / c) * d + 1, h = c) : e += c > 0 ? (d = c / h) * d : c;
                return h === 1 / 0 ? 1 / 0 : h * Math.sqrt(e)
            }
        });
        var bf = Math.imul;
        oa(oa.S + oa.F * V(function() {
            return -5 != bf(4294967295, 5) || 2 != bf.length
        }), "Math", {
            imul: function(a, b) {
                var c = +a,
                    d = +b,
                    e = 65535 & c,
                    f = 65535 & d;
                return 0 | e * f + ((65535 & c >>> 16) * f + e * (65535 & d >>> 16) << 16 >>> 0)
            }
        }), oa(oa.S, "Math", {
            log1p: Ne
        }), oa(oa.S, "Math", {
            log10: function(a) {
                return Math.log(a) * Math.LOG10E
            }
        }), oa(oa.S, "Math", {
            log2: function(a) {
                return Math.log(a) / Math.LN2
            }
        }), oa(oa.S, "Math", {
            sign: Se
        });
        var cf = Math.exp;
        oa(oa.S + oa.F * V(function() {
            return -2e-17 != !Math.sinh(-2e-17)
        }), "Math", {
            sinh: function(a) {
                return Math.abs(a = +a) < 1 ? (Ve(a) - Ve(-a)) / 2 : (cf(a - 1) - cf(-a - 1)) * (Math.E / 2)
            }
        });
        var df = Math.exp;
        oa(oa.S, "Math", {
            tanh: function(a) {
                var b = Ve(a = +a),
                    c = Ve(-a);
                return b == 1 / 0 ? 1 : c == 1 / 0 ? -1 : (b - c) / (df(a) + df(-a))
            }
        }), oa(oa.S, "Math", {
            trunc: function(a) {
                return (a > 0 ? Math.floor : Math.ceil)(a)
            }
        });
        var ef = Ma(!0);
        oa(oa.P, "Array", {
            includes: function(a) {
                return ef(this, a, arguments.length > 1 ? arguments[1] : void 0)
            }
        }), Mb("includes");
        var ff = Zb.f,
            gf = function(a) {
                return function(b) {
                    for (var c, d = Ia(b), e = tb(d), f = e.length, g = 0, h = []; f > g;) ff.call(d, c = e[g++]) && h.push(a ? [c, d[c]] : d[c]);
                    return h
                }
            },
            hf = gf(!1);
        oa(oa.S, "Object", {
            values: function(a) {
                return hf(a)
            }
        });
        var jf = gf(!0);
        oa(oa.S, "Object", {
            entries: function(a) {
                return jf(a)
            }
        }), oa(oa.S, "Object", {
            getOwnPropertyDescriptors: function(a) {
                for (var b, c, d = Ia(a), e = _b.f, f = Lc(d), g = {}, h = 0; f.length > h;) void 0 !== (c = e(d, b = f[h++])) && Ee(g, b, c);
                return g
            }
        });
        var kf = function(a, b, c, d) {
                var e = String(Ha(a)),
                    f = e.length,
                    g = void 0 === c ? " " : String(c),
                    h = Ca(b);
                if (h <= f || "" == g) return e;
                var i = h - f,
                    j = ve.call(g, Math.ceil(i / g.length));
                return j.length > i && (j = j.slice(0, i)), d ? j + e : e + j
            },
            lf = R.navigator,
            mf = lf && lf.userAgent || "";
        oa(oa.P + oa.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(mf), "String", {
            padStart: function(a) {
                return kf(this, a, arguments.length > 1 ? arguments[1] : void 0, !0)
            }
        }), oa(oa.P + oa.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(mf), "String", {
            padEnd: function(a) {
                return kf(this, a, arguments.length > 1 ? arguments[1] : void 0, !1)
            }
        });
        var nf = [].slice,
            of = /MSIE .\./.test(mf),
            pf = function(a) {
                return function(b, c) {
                    var d = arguments.length > 2,
                        e = !!d && nf.call(arguments, 2);
                    return a(d ? function() {
                        ("function" == typeof b ? b : Function(b)).apply(this, e)
                    } : b, c)
                }
            };
        oa(oa.G + oa.B + oa.F * of, {
            setTimeout: pf(R.setTimeout),
            setInterval: pf(R.setInterval)
        }), oa(oa.G + oa.B, {
            setImmediate: bd.set,
            clearImmediate: bd.clear
        });
        for (var qf = Za("iterator"), rf = Za("toStringTag"), sf = pb.Array, tf = {
                CSSRuleList: !0,
                CSSStyleDeclaration: !1,
                CSSValueList: !1,
                ClientRectList: !1,
                DOMRectList: !1,
                DOMStringList: !1,
                DOMTokenList: !0,
                DataTransferItemList: !1,
                FileList: !1,
                HTMLAllCollection: !1,
                HTMLCollection: !1,
                HTMLFormElement: !1,
                HTMLSelectElement: !1,
                MediaList: !0,
                MimeTypeArray: !1,
                NamedNodeMap: !1,
                NodeList: !0,
                PaintRequestList: !1,
                Plugin: !1,
                PluginArray: !1,
                SVGLengthList: !1,
                SVGNumberList: !1,
                SVGPathSegList: !1,
                SVGPointList: !1,
                SVGStringList: !1,
                SVGTransformList: !1,
                SourceBufferList: !1,
                StyleSheetList: !0,
                TextTrackCueList: !1,
                TextTrackList: !1,
                TouchList: !1
            }, uf = tb(tf), vf = 0; vf < uf.length; vf++) {
            var wf, xf = uf[vf],
                yf = tf[xf],
                zf = R[xf],
                Af = zf && zf.prototype;
            if (Af && (Af[qf] || da(Af, qf, sf), Af[rf] || da(Af, rf, xf), pb[xf] = sf, yf))
                for (wf in Ub) Af[wf] || ja(Af, wf, Ub[wf], !0)
        }
        a(function(a) {
            ! function(b) {
                function c(a, b, c, f) {
                    var g = b && b.prototype instanceof e ? b : e,
                        h = Object.create(g.prototype),
                        i = new m(f || []);
                    return h._invoke = function(a, b, c) {
                        var e = x;
                        return function(f, g) {
                            if (e === z) throw new Error("Generator is already running");
                            if (e === A) {
                                if ("throw" === f) throw g;
                                return o()
                            }
                            for (c.method = f, c.arg = g;;) {
                                var h = c.delegate;
                                if (h) {
                                    var i = j(h, c);
                                    if (i) {
                                        if (i === B) continue;
                                        return i
                                    }
                                }
                                if ("next" === c.method) c.sent = c._sent = c.arg;
                                else if ("throw" === c.method) {
                                    if (e === x) throw e = A, c.arg;
                                    c.dispatchException(c.arg)
                                } else "return" === c.method && c.abrupt("return", c.arg);
                                e = z;
                                var k = d(a, b, c);
                                if ("normal" === k.type) {
                                    if (e = c.done ? A : y, k.arg === B) continue;
                                    return {
                                        value: k.arg,
                                        done: c.done
                                    }
                                }
                                "throw" === k.type && (e = A, c.method = "throw", c.arg = k.arg)
                            }
                        }
                    }(a, c, i), h
                }

                function d(a, b, c) {
                    try {
                        return {
                            type: "normal",
                            arg: a.call(b, c)
                        }
                    } catch (a) {
                        return {
                            type: "throw",
                            arg: a
                        }
                    }
                }

                function e() {}

                function f() {}

                function g() {}

                function h(a) {
                    ["next", "throw", "return"].forEach(function(b) {
                        a[b] = function(a) {
                            return this._invoke(b, a)
                        }
                    })
                }

                function i(a) {
                    function c(b, e, f, g) {
                        var h = d(a[b], a, e);
                        if ("throw" !== h.type) {
                            var i = h.arg,
                                j = i.value;
                            return j && "object" == typeof j && r.call(j, "__await") ? Promise.resolve(j.__await).then(function(a) {
                                c("next", a, f, g)
                            }, function(a) {
                                c("throw", a, f, g)
                            }) : Promise.resolve(j).then(function(a) {
                                i.value = a, f(i)
                            }, g)
                        }
                        g(h.arg)
                    }
                    var e;
                    "object" == typeof b.process && b.process.domain && (c = b.process.domain.bind(c)), this._invoke = function(a, b) {
                        function d() {
                            return new Promise(function(d, e) {
                                c(a, b, d, e)
                            })
                        }
                        return e = e ? e.then(d, d) : d()
                    }
                }

                function j(a, b) {
                    var c = a.iterator[b.method];
                    if (c === p) {
                        if (b.delegate = null, "throw" === b.method) {
                            if (a.iterator.return && (b.method = "return", b.arg = p, j(a, b), "throw" === b.method)) return B;
                            b.method = "throw", b.arg = new TypeError("The iterator does not provide a 'throw' method")
                        }
                        return B
                    }
                    var e = d(c, a.iterator, b.arg);
                    if ("throw" === e.type) return b.method = "throw", b.arg = e.arg, b.delegate = null, B;
                    var f = e.arg;
                    return f ? f.done ? (b[a.resultName] = f.value, b.next = a.nextLoc, "return" !== b.method && (b.method = "next", b.arg = p), b.delegate = null, B) : f : (b.method = "throw", b.arg = new TypeError("iterator result is not an object"), b.delegate = null, B)
                }

                function k(a) {
                    var b = {
                        tryLoc: a[0]
                    };
                    1 in a && (b.catchLoc = a[1]), 2 in a && (b.finallyLoc = a[2], b.afterLoc = a[3]), this.tryEntries.push(b)
                }

                function l(a) {
                    var b = a.completion || {};
                    b.type = "normal", delete b.arg, a.completion = b
                }

                function m(a) {
                    this.tryEntries = [{
                        tryLoc: "root"
                    }], a.forEach(k, this), this.reset(!0)
                }

                function n(a) {
                    if (a) {
                        var b = a[t];
                        if (b) return b.call(a);
                        if ("function" == typeof a.next) return a;
                        if (!isNaN(a.length)) {
                            var c = -1,
                                d = function b() {
                                    for (; ++c < a.length;)
                                        if (r.call(a, c)) return b.value = a[c], b.done = !1, b;
                                    return b.value = p, b.done = !0, b
                                };
                            return d.next = d
                        }
                    }
                    return {
                        next: o
                    }
                }

                function o() {
                    return {
                        value: p,
                        done: !0
                    }
                }
                var p, q = Object.prototype,
                    r = q.hasOwnProperty,
                    s = "function" == typeof Symbol ? Symbol : {},
                    t = s.iterator || "@@iterator",
                    u = s.asyncIterator || "@@asyncIterator",
                    v = s.toStringTag || "@@toStringTag",
                    w = b.regeneratorRuntime;
                if (w) a.exports = w;
                else {
                    (w = b.regeneratorRuntime = a.exports).wrap = c;
                    var x = "suspendedStart",
                        y = "suspendedYield",
                        z = "executing",
                        A = "completed",
                        B = {},
                        C = {};
                    C[t] = function() {
                        return this
                    };
                    var D = Object.getPrototypeOf,
                        E = D && D(D(n([])));
                    E && E !== q && r.call(E, t) && (C = E);
                    var F = g.prototype = e.prototype = Object.create(C);
                    f.prototype = F.constructor = g, g.constructor = f, g[v] = f.displayName = "GeneratorFunction", w.isGeneratorFunction = function(a) {
                        var b = "function" == typeof a && a.constructor;
                        return !!b && (b === f || "GeneratorFunction" === (b.displayName || b.name))
                    }, w.mark = function(a) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(a, g) : (a.__proto__ = g, v in a || (a[v] = "GeneratorFunction")), a.prototype = Object.create(F), a
                    }, w.awrap = function(a) {
                        return {
                            __await: a
                        }
                    }, h(i.prototype), i.prototype[u] = function() {
                        return this
                    }, w.AsyncIterator = i, w.async = function(a, b, d, e) {
                        var f = new i(c(a, b, d, e));
                        return w.isGeneratorFunction(b) ? f : f.next().then(function(a) {
                            return a.done ? a.value : f.next()
                        })
                    }, h(F), F[v] = "Generator", F[t] = function() {
                        return this
                    }, F.toString = function() {
                        return "[object Generator]"
                    }, w.keys = function(a) {
                        var b = [];
                        for (var c in a) b.push(c);
                        return b.reverse(),
                            function c() {
                                for (; b.length;) {
                                    var d = b.pop();
                                    if (d in a) return c.value = d, c.done = !1, c
                                }
                                return c.done = !0, c
                            }
                    }, w.values = n, m.prototype = {
                        constructor: m,
                        reset: function(a) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = p, this.done = !1, this.delegate = null, this.method = "next", this.arg = p, this.tryEntries.forEach(l), !a)
                                for (var b in this) "t" === b.charAt(0) && r.call(this, b) && !isNaN(+b.slice(1)) && (this[b] = p)
                        },
                        stop: function() {
                            this.done = !0;
                            var a = this.tryEntries[0].completion;
                            if ("throw" === a.type) throw a.arg;
                            return this.rval
                        },
                        dispatchException: function(a) {
                            function b(b, d) {
                                return f.type = "throw", f.arg = a, c.next = b, d && (c.method = "next", c.arg = p), !!d
                            }
                            if (this.done) throw a;
                            for (var c = this, d = this.tryEntries.length - 1; d >= 0; --d) {
                                var e = this.tryEntries[d],
                                    f = e.completion;
                                if ("root" === e.tryLoc) return b("end");
                                if (e.tryLoc <= this.prev) {
                                    var g = r.call(e, "catchLoc"),
                                        h = r.call(e, "finallyLoc");
                                    if (g && h) {
                                        if (this.prev < e.catchLoc) return b(e.catchLoc, !0);
                                        if (this.prev < e.finallyLoc) return b(e.finallyLoc)
                                    } else if (g) {
                                        if (this.prev < e.catchLoc) return b(e.catchLoc, !0)
                                    } else {
                                        if (!h) throw new Error("try statement without catch or finally");
                                        if (this.prev < e.finallyLoc) return b(e.finallyLoc)
                                    }
                                }
                            }
                        },
                        abrupt: function(a, b) {
                            for (var c = this.tryEntries.length - 1; c >= 0; --c) {
                                var d = this.tryEntries[c];
                                if (d.tryLoc <= this.prev && r.call(d, "finallyLoc") && this.prev < d.finallyLoc) {
                                    var e = d;
                                    break
                                }
                            }
                            e && ("break" === a || "continue" === a) && e.tryLoc <= b && b <= e.finallyLoc && (e = null);
                            var f = e ? e.completion : {};
                            return f.type = a, f.arg = b, e ? (this.method = "next", this.next = e.finallyLoc, B) : this.complete(f)
                        },
                        complete: function(a, b) {
                            if ("throw" === a.type) throw a.arg;
                            return "break" === a.type || "continue" === a.type ? this.next = a.arg : "return" === a.type ? (this.rval = this.arg = a.arg, this.method = "return", this.next = "end") : "normal" === a.type && b && (this.next = b), B
                        },
                        finish: function(a) {
                            for (var b = this.tryEntries.length - 1; b >= 0; --b) {
                                var c = this.tryEntries[b];
                                if (c.finallyLoc === a) return this.complete(c.completion, c.afterLoc), l(c), B
                            }
                        },
                        catch: function(a) {
                            for (var b = this.tryEntries.length - 1; b >= 0; --b) {
                                var c = this.tryEntries[b];
                                if (c.tryLoc === a) {
                                    var d = c.completion;
                                    if ("throw" === d.type) {
                                        var e = d.arg;
                                        l(c)
                                    }
                                    return e
                                }
                            }
                            throw new Error("illegal catch attempt")
                        },
                        delegateYield: function(a, b, c) {
                            return this.delegate = {
                                iterator: n(a),
                                resultName: b,
                                nextLoc: c
                            }, "next" === this.method && (this.arg = p), B
                        }
                    }
                }
            }("object" == typeof Q ? Q : "object" == typeof window ? window : "object" == typeof self ? self : Q)
        });
        try {
            var Bf = new window.CustomEvent("test");
            if (Bf.preventDefault(), !0 !== Bf.defaultPrevented) throw new Error("Could not prevent default")
        } catch (Q) {
            var Cf = function(a, b) {
                var c, d;
                return b = b || {
                    bubbles: !1,
                    cancelable: !1,
                    detail: void 0
                }, (c = document.createEvent("CustomEvent")).initCustomEvent(a, b.bubbles, b.cancelable, b.detail), d = c.preventDefault, c.preventDefault = function() {
                    d.call(this);
                    try {
                        Object.defineProperty(this, "defaultPrevented", {
                            get: function() {
                                return !0
                            }
                        })
                    } catch (a) {
                        this.defaultPrevented = !0
                    }
                }, c
            };
            Cf.prototype = window.Event.prototype, window.CustomEvent = Cf
        }! function(a) {
            var b = function() {
                    try {
                        return !!Symbol.iterator
                    } catch (a) {
                        return !1
                    }
                }(),
                c = function(a) {
                    var c = {
                        next: function() {
                            var b = a.shift();
                            return {
                                done: void 0 === b,
                                value: b
                            }
                        }
                    };
                    return b && (c[Symbol.iterator] = function() {
                        return c
                    }), c
                },
                d = function(a) {
                    return encodeURIComponent(a).replace(/%20/g, "+")
                },
                e = function(a) {
                    return decodeURIComponent(a).replace(/\+/g, " ")
                };
            "URLSearchParams" in a && "a=1" === new URLSearchParams("?a=1").toString() || function() {
                var f = function(a) {
                        if (Object.defineProperty(this, "_entries", {
                                value: {}
                            }), "string" == typeof a) {
                            if ("" !== a)
                                for (var b, c = (a = a.replace(/^\?/, "")).split("&"), d = 0; d < c.length; d++) b = c[d].split("="), this.append(e(b[0]), b.length > 1 ? e(b[1]) : "")
                        } else if (a instanceof f) {
                            var g = this;
                            a.forEach(function(a, b) {
                                g.append(a, b)
                            })
                        }
                    },
                    g = f.prototype;
                g.append = function(a, b) {
                    a in this._entries ? this._entries[a].push(b.toString()) : this._entries[a] = [b.toString()]
                }, g.delete = function(a) {
                    delete this._entries[a]
                }, g.get = function(a) {
                    return a in this._entries ? this._entries[a][0] : null
                }, g.getAll = function(a) {
                    return a in this._entries ? this._entries[a].slice(0) : []
                }, g.has = function(a) {
                    return a in this._entries
                }, g.set = function(a, b) {
                    this._entries[a] = [b.toString()]
                }, g.forEach = function(a, b) {
                    var c;
                    for (var d in this._entries)
                        if (this._entries.hasOwnProperty(d)) {
                            c = this._entries[d];
                            for (var e = 0; e < c.length; e++) a.call(b, c[e], d, this)
                        }
                }, g.keys = function() {
                    var a = [];
                    return this.forEach(function(b, c) {
                        a.push(c)
                    }), c(a)
                }, g.values = function() {
                    var a = [];
                    return this.forEach(function(b) {
                        a.push(b)
                    }), c(a)
                }, g.entries = function() {
                    var a = [];
                    return this.forEach(function(b, c) {
                        a.push([c, b])
                    }), c(a)
                }, b && (g[Symbol.iterator] = g.entries), g.toString = function() {
                    var a = "";
                    return this.forEach(function(b, c) {
                        a.length > 0 && (a += "&"), a += d(c) + "=" + d(b)
                    }), a
                }, a.URLSearchParams = f
            }()
        }(void 0 !== Q ? Q : "undefined" != typeof window ? window : "undefined" != typeof self ? self : Q),
        function(a) {
            if (function() {
                    try {
                        var a = new URL("b", "http://a");
                        return a.pathname = "c%20d", "http://a/c%20d" === a.href && a.searchParams
                    } catch (a) {
                        return !1
                    }
                }() || function() {
                    var b = a.URL,
                        c = function(a, b) {
                            "string" != typeof a && (a = String(a));
                            var c = document.implementation.createHTMLDocument("");
                            if (window.doc = c, b) {
                                var d = c.createElement("base");
                                d.href = b, c.head.appendChild(d)
                            }
                            var e = c.createElement("a");
                            if (e.href = a, c.body.appendChild(e), e.href = e.href, ":" === e.protocol || !/:/.test(e.href)) throw new TypeError("Invalid URL");
                            Object.defineProperty(this, "_anchorElement", {
                                value: e
                            })
                        },
                        d = c.prototype;
                    ["hash", "host", "hostname", "port", "protocol", "search"].forEach(function(a) {
                        ! function(a) {
                            Object.defineProperty(d, a, {
                                get: function() {
                                    return this._anchorElement[a]
                                },
                                set: function(b) {
                                    this._anchorElement[a] = b
                                },
                                enumerable: !0
                            })
                        }(a)
                    }), Object.defineProperties(d, {
                        toString: {
                            get: function() {
                                var a = this;
                                return function() {
                                    return a.href
                                }
                            }
                        },
                        href: {
                            get: function() {
                                return this._anchorElement.href.replace(/\?$/, "")
                            },
                            set: function(a) {
                                this._anchorElement.href = a
                            },
                            enumerable: !0
                        },
                        pathname: {
                            get: function() {
                                return this._anchorElement.pathname.replace(/(^\/?)/, "/")
                            },
                            set: function(a) {
                                this._anchorElement.pathname = a
                            },
                            enumerable: !0
                        },
                        origin: {
                            get: function() {
                                var a = {
                                        "http:": 80,
                                        "https:": 443,
                                        "ftp:": 21
                                    } [this._anchorElement.protocol],
                                    b = this._anchorElement.port != a && "" !== this._anchorElement.port;
                                return this._anchorElement.protocol + "//" + this._anchorElement.hostname + (b ? ":" + this._anchorElement.port : "")
                            },
                            enumerable: !0
                        },
                        password: {
                            get: function() {
                                return ""
                            },
                            set: function(a) {},
                            enumerable: !0
                        },
                        username: {
                            get: function() {
                                return ""
                            },
                            set: function(a) {},
                            enumerable: !0
                        },
                        searchParams: {
                            get: function() {
                                var a = new URLSearchParams(this.search),
                                    b = this;
                                return ["append", "delete", "set"].forEach(function(c) {
                                    var d = a[c];
                                    a[c] = function() {
                                        d.apply(a, arguments), b.search = a.toString()
                                    }
                                }), a
                            },
                            enumerable: !0
                        }
                    }), c.createObjectURL = function(a) {
                        return b.createObjectURL.apply(b, arguments)
                    }, c.revokeObjectURL = function(a) {
                        return b.revokeObjectURL.apply(b, arguments)
                    }, a.URL = c
                }(), void 0 !== a.location && !("origin" in a.location)) {
                var b = function() {
                    return a.location.protocol + "//" + a.location.hostname + (a.location.port ? ":" + a.location.port : "")
                };
                try {
                    Object.defineProperty(a.location, "origin", {
                        get: b,
                        enumerable: !0
                    })
                } catch (c) {
                    setInterval(function() {
                        a.location.origin = b()
                    }, 100)
                }
            }
        }(void 0 !== Q ? Q : "undefined" != typeof window ? window : "undefined" != typeof self ? self : Q);
        var Df, Ef, Ff, Gf, Hf, If = function(a) {
                return null != a ? a.constructor : null
            },
            Jf = function(a, b) {
                return Boolean(a && b && a instanceof b)
            },
            Kf = function(a) {
                return null == a
            },
            Lf = function(a) {
                return If(a) === Object
            },
            Mf = function(a) {
                return If(a) === String
            },
            Nf = function(a) {
                return Array.isArray(a)
            },
            Of = function(a) {
                return Jf(a, NodeList)
            },
            Pf = function(a) {
                return Kf(a) || (Mf(a) || Nf(a) || Of(a)) && !a.length || Lf(a) && !Object.keys(a).length
            },
            Qf = {
                nullOrUndefined: Kf,
                object: Lf,
                number: function(a) {
                    return If(a) === Number && !Number.isNaN(a)
                },
                string: Mf,
                boolean: function(a) {
                    return If(a) === Boolean
                },
                function: function(a) {
                    return If(a) === Function
                },
                array: Nf,
                weakMap: function(a) {
                    return Jf(a, WeakMap)
                },
                nodeList: Of,
                element: function(a) {
                    return Jf(a, Element)
                },
                textNode: function(a) {
                    return If(a) === Text
                },
                event: function(a) {
                    return Jf(a, Event)
                },
                cue: function(a) {
                    return Jf(a, window.TextTrackCue) || Jf(a, window.VTTCue)
                },
                track: function(a) {
                    return Jf(a, TextTrack) || !Kf(a) && Mf(a.kind)
                },
                url: function(a) {
                    if (Jf(a, window.URL)) return !0;
                    var b = a;
                    a.startsWith("http://") && a.startsWith("https://") || (b = "http://" + a);
                    try {
                        return !Pf(new URL(b).hostname)
                    } catch (a) {
                        return !1
                    }
                },
                empty: Pf
            },
            Rf = function() {
                var a = !1;
                try {
                    var b = Object.defineProperty({}, "passive", {
                        get: function() {
                            return a = !0, null
                        }
                    });
                    window.addEventListener("test", null, b), window.removeEventListener("test", null, b)
                } catch (a) {}
                return a
            }(),
            Sf = function(a, b) {
                if (!(a instanceof b)) throw new TypeError("Cannot call a class as a function")
            },
            Tf = function() {
                function a(a, b) {
                    for (var c = 0; c < b.length; c++) {
                        var d = b[c];
                        d.enumerable = d.enumerable || !1, d.configurable = !0, "value" in d && (d.writable = !0), Object.defineProperty(a, d.key, d)
                    }
                }
                return function(b, c, d) {
                    return c && a(b.prototype, c), d && a(b, d), b
                }
            }(),
            Uf = function(a, b, c) {
                return b in a ? Object.defineProperty(a, b, {
                    value: c,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : a[b] = c, a
            },
            Vf = function() {
                return function(a, b) {
                    if (Array.isArray(a)) return a;
                    if (Symbol.iterator in Object(a)) return function(a, b) {
                        var c = [],
                            d = !0,
                            e = !1,
                            f = void 0;
                        try {
                            for (var g, h = a[Symbol.iterator](); !(d = (g = h.next()).done) && (c.push(g.value), !b || c.length !== b); d = !0);
                        } catch (a) {
                            e = !0, f = a
                        } finally {
                            try {
                                !d && h.return && h.return()
                            } finally {
                                if (e) throw f
                            }
                        }
                        return c
                    }(a, b);
                    throw new TypeError("Invalid attempt to destructure non-iterable instance")
                }
            }(),
            Wf = (Df = document.createElement("span"), Ef = {
                WebkitTransition: "webkitTransitionEnd",
                MozTransition: "transitionend",
                OTransition: "oTransitionEnd otransitionend",
                transition: "transitionend"
            }, Ff = Object.keys(Ef).find(function(a) {
                return void 0 !== Df.style[a]
            }), !!Qf.string(Ff) && Ef[Ff]),
            Xf = {
                isIE: !!document.documentMode,
                isWebkit: "WebkitAppearance" in document.documentElement.style && !/Edge/.test(navigator.userAgent),
                isIPhone: /(iPhone|iPod)/gi.test(navigator.platform),
                isIos: /(iPad|iPhone|iPod)/gi.test(navigator.platform)
            },
            Yf = {
                "audio/ogg": "vorbis",
                "audio/wav": "1",
                "video/webm": "vp8, vorbis",
                "video/mp4": "avc1.42E01E, mp4a.40.2",
                "video/ogg": "theora"
            },
            Zf = {
                audio: "canPlayType" in document.createElement("audio"),
                video: "canPlayType" in document.createElement("video"),
                check: function(a, b, c) {
                    var d = Xf.isIPhone && c && Zf.playsinline,
                        e = Zf[a] || "html5" !== b;
                    return {
                        api: e,
                        ui: e && Zf.rangeInput && ("video" !== a || !Xf.isIPhone || d)
                    }
                },
                pip: !Xf.isIPhone && Qf.function(j("video").webkitSetPresentationMode),
                airplay: Qf.function(window.WebKitPlaybackTargetAvailabilityEvent),
                playsinline: "playsInline" in document.createElement("video"),
                mime: function(a) {
                    var b = a.split("/"),
                        c = Vf(b, 1)[0];
                    if (!this.isHTML5 || c !== this.type) return !1;
                    var d = void 0;
                    a && a.includes("codecs=") ? d = a : "audio/mpeg" === a ? d = "audio/mpeg;" : a in Yf && (d = a + '; codecs="' + Yf[a] + '"');
                    try {
                        return Boolean(d && this.media.canPlayType(d).replace(/no/, ""))
                    } catch (a) {
                        return !1
                    }
                },
                textTracks: "textTracks" in document.createElement("video"),
                rangeInput: (Gf = document.createElement("input"), Gf.type = "range", "range" === Gf.type),
                touch: "ontouchstart" in document.documentElement,
                transitions: !1 !== Wf,
                reducedMotion: "matchMedia" in window && window.matchMedia("(prefers-reduced-motion)").matches
            },
            $f = {
                getSources: function() {
                    var a = this;
                    return this.isHTML5 ? Array.from(this.media.querySelectorAll("source")).filter(function(b) {
                        return Zf.mime.call(a, b.getAttribute("type"))
                    }) : []
                },
                getQualityOptions: function() {
                    return $f.getSources.call(this).map(function(a) {
                        return Number(a.getAttribute("size"))
                    }).filter(Boolean)
                },
                extend: function() {
                    if (this.isHTML5) {
                        var a = this;
                        Object.defineProperty(a.media, "quality", {
                            get: function() {
                                var b = $f.getSources.call(a).find(function(b) {
                                    return b.getAttribute("src") === a.source
                                });
                                return b && Number(b.getAttribute("size"))
                            },
                            set: function(b) {
                                var c = $f.getSources.call(a).find(function(a) {
                                    return Number(a.getAttribute("size")) === b
                                });
                                if (c) {
                                    var d = a.media,
                                        e = d.currentTime,
                                        f = d.paused,
                                        h = d.preload,
                                        i = d.readyState;
                                    a.media.src = c.getAttribute("src"), ("none" !== h || i) && (a.once("loadedmetadata", function() {
                                        a.currentTime = e, f || a.play()
                                    }), a.media.load()), g.call(a, a.media, "qualitychange", !1, {
                                        quality: b
                                    })
                                }
                            }
                        })
                    }
                },
                cancelRequests: function() {
                    this.isHTML5 && (l($f.getSources.call(this)), this.media.setAttribute("src", this.config.blankVideo), this.media.load(), this.debug.log("Cancelled network requests"))
                }
            },
            _f = function() {
                var a = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
                    b = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                if (Qf.empty(a) || Qf.empty(b)) return "";
                var c = w(b.i18n, a);
                if (Qf.empty(c)) return "";
                var d = {
                    "{seektime}": b.seekTime,
                    "{title}": b.title
                };
                return Object.entries(d).forEach(function(a) {
                    var b = Vf(a, 2),
                        d = b[0],
                        e = b[1];
                    c = z(c, d, e)
                }), c
            },
            ag = function() {
                function a(b) {
                    Sf(this, a), this.enabled = b.config.storage.enabled, this.key = b.config.storage.key
                }
                return Tf(a, [{
                    key: "get",
                    value: function(b) {
                        if (!a.supported || !this.enabled) return null;
                        var c = window.localStorage.getItem(this.key);
                        if (Qf.empty(c)) return null;
                        var d = JSON.parse(c);
                        return Qf.string(b) && b.length ? d[b] : d
                    }
                }, {
                    key: "set",
                    value: function(b) {
                        if (a.supported && this.enabled && Qf.object(b)) {
                            var c = this.get();
                            Qf.empty(c) && (c = {}), x(c, b), window.localStorage.setItem(this.key, JSON.stringify(c))
                        }
                    }
                }], [{
                    key: "supported",
                    get: function() {
                        try {
                            return "localStorage" in window && (window.localStorage.setItem("___test", "___test"), window.localStorage.removeItem("___test"), !0)
                        } catch (a) {
                            return !1
                        }
                    }
                }]), a
            }(),
            bg = function(a) {
                return parseInt(a / 60 / 60 % 60, 10)
            },
            cg = function(a) {
                return parseInt(a / 60 % 60, 10)
            },
            dg = function(a) {
                return parseInt(a % 60, 10)
            },
            eg = {
                getIconUrl: function() {
                    var a = new URL(this.config.iconUrl, window.location).host !== window.location.host || Xf.isIE && !window.svg4everybody;
                    return {
                        url: this.config.iconUrl,
                        cors: a
                    }
                },
                findElements: function() {
                    try {
                        return this.elements.controls = u.call(this, this.config.selectors.controls.wrapper), this.elements.buttons = {
                            play: t.call(this, this.config.selectors.buttons.play),
                            pause: u.call(this, this.config.selectors.buttons.pause),
                            restart: u.call(this, this.config.selectors.buttons.restart),
                            rewind: u.call(this, this.config.selectors.buttons.rewind),
                            fastForward: u.call(this, this.config.selectors.buttons.fastForward),
                            mute: u.call(this, this.config.selectors.buttons.mute),
                            pip: u.call(this, this.config.selectors.buttons.pip),
                            airplay: u.call(this, this.config.selectors.buttons.airplay),
                            settings: u.call(this, this.config.selectors.buttons.settings),
                            captions: u.call(this, this.config.selectors.buttons.captions),
                            fullscreen: u.call(this, this.config.selectors.buttons.fullscreen)
                        }, this.elements.progress = u.call(this, this.config.selectors.progress), this.elements.inputs = {
                            seek: u.call(this, this.config.selectors.inputs.seek),
                            volume: u.call(this, this.config.selectors.inputs.volume)
                        }, this.elements.display = {
                            buffer: u.call(this, this.config.selectors.display.buffer),
                            currentTime: u.call(this, this.config.selectors.display.currentTime),
                            duration: u.call(this, this.config.selectors.display.duration)
                        }, Qf.element(this.elements.progress) && (this.elements.display.seekTooltip = this.elements.progress.querySelector("." + this.config.classNames.tooltip)), !0
                    } catch (a) {
                        return this.debug.warn("It looks like there is a problem with your custom controls HTML", a), this.toggleNativeControls(!0), !1
                    }
                },
                createIcon: function(a, b) {
                    var c = eg.getIconUrl.call(this),
                        d = (c.cors ? "" : c.url) + "#" + this.config.iconPrefix,
                        e = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                    i(e, x(b, {
                        role: "presentation",
                        focusable: "false"
                    }));
                    var f = document.createElementNS("http://www.w3.org/2000/svg", "use"),
                        g = d + "-" + a;
                    return "href" in f ? f.setAttributeNS("http://www.w3.org/1999/xlink", "href", g) : f.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", g), e.appendChild(f), e
                },
                createLabel: function(a) {
                    var b = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                        c = {
                            pip: "PIP",
                            airplay: "AirPlay"
                        } [a] || _f(a, this.config);
                    return j("span", Object.assign({}, b, {
                        class: [b.class, this.config.classNames.hidden].filter(Boolean).join(" ")
                    }), c)
                },
                createBadge: function(a) {
                    if (Qf.empty(a)) return null;
                    var b = j("span", {
                        class: this.config.classNames.menu.value
                    });
                    return b.appendChild(j("span", {
                        class: this.config.classNames.menu.badge
                    }, a)), b
                },
                createButton: function(a, b) {
                    var c = j("button"),
                        d = Object.assign({}, b),
                        e = B(a),
                        f = !1,
                        g = void 0,
                        h = void 0,
                        k = void 0,
                        l = void 0;
                    switch ("type" in d || (d.type = "button"), "class" in d ? d.class.includes(this.config.classNames.control) || (d.class += " " + this.config.classNames.control) : d.class = this.config.classNames.control, a) {
                        case "play":
                            f = !0, g = "play", k = "pause", h = "play", l = "pause";
                            break;
                        case "mute":
                            f = !0, g = "mute", k = "unmute", h = "volume", l = "muted";
                            break;
                        case "captions":
                            f = !0, g = "enableCaptions", k = "disableCaptions", h = "captions-off", l = "captions-on";
                            break;
                        case "fullscreen":
                            f = !0, g = "enterFullscreen", k = "exitFullscreen", h = "enter-fullscreen", l = "exit-fullscreen";
                            break;
                        case "play-large":
                            d.class += " " + this.config.classNames.control + "--overlaid", e = "play", g = "play", h = "play";
                            break;
                        default:
                            g = e, h = a
                    }
                    f ? (c.appendChild(eg.createIcon.call(this, l, {
                        class: "icon--pressed"
                    })), c.appendChild(eg.createIcon.call(this, h, {
                        class: "icon--not-pressed"
                    })), c.appendChild(eg.createLabel.call(this, k, {
                        class: "label--pressed"
                    })), c.appendChild(eg.createLabel.call(this, g, {
                        class: "label--not-pressed"
                    }))) : (c.appendChild(eg.createIcon.call(this, h)), c.appendChild(eg.createLabel.call(this, g))), x(d, o(this.config.selectors.buttons[e], d)), i(c, d), "play" === e ? (Qf.array(this.elements.buttons[e]) || (this.elements.buttons[e] = []), this.elements.buttons[e].push(c)) : this.elements.buttons[e] = c;
                    var m = this.config.classNames.controlPressed;
                    return Object.defineProperty(c, "pressed", {
                        enumerable: !0,
                        get: function() {
                            return r(c, m)
                        },
                        set: function() {
                            var a = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                            q(c, m, a)
                        }
                    }), c
                },
                createRange: function(a, b) {
                    var c = j("input", x(o(this.config.selectors.inputs[a]), {
                        type: "range",
                        min: 0,
                        max: 100,
                        step: .01,
                        value: 0,
                        autocomplete: "off",
                        role: "slider",
                        "aria-label": _f(a, this.config),
                        "aria-valuemin": 0,
                        "aria-valuemax": 100,
                        "aria-valuenow": 0
                    }, b));
                    return this.elements.inputs[a] = c, eg.updateRangeFill.call(this, c), c
                },
                createProgress: function(a, b) {
                    var c = j("progress", x(o(this.config.selectors.display[a]), {
                        min: 0,
                        max: 100,
                        value: 0,
                        role: "presentation",
                        "aria-hidden": !0
                    }, b));
                    if ("volume" !== a) {
                        c.appendChild(j("span", null, "0"));
                        var d = {
                                played: "played",
                                buffer: "buffered"
                            } [a],
                            e = d ? _f(d, this.config) : "";
                        c.innerText = "% " + e.toLowerCase()
                    }
                    return this.elements.display[a] = c, c
                },
                createTime: function(a) {
                    var b = o(this.config.selectors.display[a]),
                        c = j("div", x(b, {
                            class: "plyr__time " + b.class,
                            "aria-label": _f(a, this.config)
                        }), "00:00");
                    return this.elements.display[a] = c, c
                },
                createMenuItem: function(a) {
                    var b = a.value,
                        c = a.list,
                        d = a.type,
                        e = a.title,
                        f = a.badge,
                        g = void 0 === f ? null : f,
                        h = a.checked,
                        i = void 0 !== h && h,
                        k = j("li"),
                        l = j("label", {
                            class: this.config.classNames.control
                        }),
                        m = j("input", x(o(this.config.selectors.inputs[d]), {
                            type: "radio",
                            name: "plyr-" + d,
                            value: b,
                            checked: i,
                            class: "plyr__sr-only"
                        })),
                        n = j("span", {
                            hidden: ""
                        });
                    l.appendChild(m), l.appendChild(n), l.insertAdjacentHTML("beforeend", e), Qf.element(g) && l.appendChild(g), k.appendChild(l), c.appendChild(k)
                },
                formatTime: function() {
                    var a = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
                        b = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                    return Qf.number(a) ? G(a, bg(this.duration) > 0, b) : a
                },
                updateTimeDisplay: function() {
                    var a = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
                        b = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
                        c = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                    Qf.element(a) && Qf.number(b) && (a.innerText = eg.formatTime(b, c))
                },
                updateVolume: function() {
                    this.supported.ui && (Qf.element(this.elements.inputs.volume) && eg.setRange.call(this, this.elements.inputs.volume, this.muted ? 0 : this.volume), Qf.element(this.elements.buttons.mute) && (this.elements.buttons.mute.pressed = this.muted || 0 === this.volume))
                },
                setRange: function(a) {
                    var b = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                    Qf.element(a) && (a.value = b, eg.updateRangeFill.call(this, a))
                },
                updateProgress: function(a) {
                    var b = this;
                    if (this.supported.ui && Qf.event(a)) {
                        var c, d, e = 0;
                        if (a) switch (a.type) {
                            case "timeupdate":
                            case "seeking":
                            case "seeked":
                                c = this.currentTime, d = this.duration, e = 0 === c || 0 === d || Number.isNaN(c) || Number.isNaN(d) ? 0 : (c / d * 100).toFixed(2), "timeupdate" === a.type && eg.setRange.call(this, this.elements.inputs.seek, e);
                                break;
                            case "playing":
                            case "progress":
                                ! function(a, c) {
                                    var d = Qf.number(c) ? c : 0,
                                        e = Qf.element(a) ? a : b.elements.display.buffer;
                                    if (Qf.element(e)) {
                                        e.value = d;
                                        var f = e.getElementsByTagName("span")[0];
                                        Qf.element(f) && (f.childNodes[0].nodeValue = d)
                                    }
                                }(this.elements.display.buffer, 100 * this.buffered)
                        }
                    }
                },
                updateRangeFill: function(a) {
                    var b = Qf.event(a) ? a.target : a;
                    if (Qf.element(b) && "range" === b.getAttribute("type")) {
                        if (s(b, this.config.selectors.inputs.seek)) {
                            b.setAttribute("aria-valuenow", this.currentTime);
                            var c = eg.formatTime(this.currentTime),
                                d = eg.formatTime(this.duration),
                                e = _f("seekLabel", this.config);
                            b.setAttribute("aria-valuetext", e.replace("{currentTime}", c).replace("{duration}", d))
                        } else if (s(b, this.config.selectors.inputs.volume)) {
                            var f = 100 * b.value;
                            b.setAttribute("aria-valuenow", f), b.setAttribute("aria-valuetext", f + "%")
                        } else b.setAttribute("aria-valuenow", b.value);
                        Xf.isWebkit && b.style.setProperty("--value", b.value / b.max * 100 + "%")
                    }
                },
                updateSeekTooltip: function(a) {
                    var b = this;
                    if (this.config.tooltips.seek && Qf.element(this.elements.inputs.seek) && Qf.element(this.elements.display.seekTooltip) && 0 !== this.duration) {
                        var c = 0,
                            d = this.elements.progress.getBoundingClientRect(),
                            e = this.config.classNames.tooltip + "--visible",
                            f = function(a) {
                                q(b.elements.display.seekTooltip, e, a)
                            };
                        if (this.touch) f(!1);
                        else {
                            if (Qf.event(a)) c = 100 / d.width * (a.pageX - d.left);
                            else {
                                if (!r(this.elements.display.seekTooltip, e)) return;
                                c = parseFloat(this.elements.display.seekTooltip.style.left, 10)
                            }
                            c < 0 ? c = 0 : c > 100 && (c = 100), eg.updateTimeDisplay.call(this, this.elements.display.seekTooltip, this.duration / 100 * c), this.elements.display.seekTooltip.style.left = c + "%", Qf.event(a) && ["mouseenter", "mouseleave"].includes(a.type) && f("mouseenter" === a.type)
                        }
                    }
                },
                timeUpdate: function(a) {
                    var b = !Qf.element(this.elements.display.duration) && this.config.invertTime;
                    eg.updateTimeDisplay.call(this, this.elements.display.currentTime, b ? this.duration - this.currentTime : this.currentTime, b), a && "timeupdate" === a.type && this.media.seeking || eg.updateProgress.call(this, a)
                },
                durationUpdate: function() {
                    if (this.supported.ui && (this.config.invertTime || !this.currentTime)) {
                        if (this.duration >= Math.pow(2, 32)) return p(this.elements.display.currentTime, !0), void p(this.elements.progress, !0);
                        Qf.element(this.elements.inputs.seek) && this.elements.inputs.seek.setAttribute("aria-valuemax", this.duration);
                        var a = Qf.element(this.elements.display.duration);
                        !a && this.config.displayDuration && this.paused && eg.updateTimeDisplay.call(this, this.elements.display.currentTime, this.duration), a && eg.updateTimeDisplay.call(this, this.elements.display.duration, this.duration), eg.updateSeekTooltip.call(this)
                    }
                },
                toggleTab: function(a, b) {
                    p(this.elements.settings.tabs[a], !b)
                },
                setQualityMenu: function(a) {
                    var b = this;
                    if (Qf.element(this.elements.settings.panes.quality)) {
                        var c = this.elements.settings.panes.quality.querySelector("ul");
                        Qf.array(a) && (this.options.quality = D(a).filter(function(a) {
                            return b.config.quality.options.includes(a)
                        }));
                        var d = !Qf.empty(this.options.quality) && this.options.quality.length > 1;
                        eg.toggleTab.call(this, "quality", d), eg.checkMenu.call(this), d && (m(c), this.options.quality.sort(function(a, c) {
                            var d = b.config.quality.options;
                            return d.indexOf(a) > d.indexOf(c) ? 1 : -1
                        }).forEach(function(a) {
                            eg.createMenuItem.call(b, {
                                value: a,
                                list: c,
                                type: "quality",
                                title: eg.getLabel.call(b, "quality", a),
                                badge: function(a) {
                                    var c = _f("qualityBadge." + a, b.config);
                                    return c.length ? eg.createBadge.call(b, c) : null
                                }(a)
                            })
                        }), eg.updateSetting.call(this, "quality", c))
                    }
                },
                getLabel: function(a, b) {
                    switch (a) {
                        case "speed":
                            return 1 === b ? _f("normal", this.config) : b + "&times;";
                        case "quality":
                            if (Qf.number(b)) {
                                var c = _f("qualityLabel." + b, this.config);
                                return c.length ? c : b + "p"
                            }
                            return A(b);
                        case "captions":
                            return fg.getLabel.call(this);
                        default:
                            return null
                    }
                },
                updateSetting: function(a, b, c) {
                    var d = this.elements.settings.panes[a],
                        e = null,
                        f = b;
                    if ("captions" === a) e = this.currentTrack;
                    else {
                        if (e = Qf.empty(c) ? this[a] : c, Qf.empty(e) && (e = this.config[a].default), !Qf.empty(this.options[a]) && !this.options[a].includes(e)) return void this.debug.warn("Unsupported value of '" + e + "' for " + a);
                        if (!this.config[a].options.includes(e)) return void this.debug.warn("Disabled value of '" + e + "' for " + a)
                    }
                    if (Qf.element(f) || (f = d && d.querySelector("ul")), Qf.element(f)) {
                        this.elements.settings.tabs[a].querySelector("." + this.config.classNames.menu.value).innerHTML = eg.getLabel.call(this, a, e);
                        var g = f && f.querySelector('input[value="' + e + '"]');
                        Qf.element(g) && (g.checked = !0)
                    }
                },
                setCaptionsMenu: function() {
                    var a = this,
                        b = this.elements.settings.panes.captions.querySelector("ul"),
                        c = fg.getTracks.call(this);
                    if (eg.toggleTab.call(this, "captions", c.length), m(b), eg.checkMenu.call(this), c.length) {
                        var d = c.map(function(c, d) {
                            return {
                                value: d,
                                checked: a.captions.toggled && a.currentTrack === d,
                                title: fg.getLabel.call(a, c),
                                badge: c.language && eg.createBadge.call(a, c.language.toUpperCase()),
                                list: b,
                                type: "language"
                            }
                        });
                        d.unshift({
                            value: -1,
                            checked: !this.captions.toggled,
                            title: _f("disabled", this.config),
                            list: b,
                            type: "language"
                        }), d.forEach(eg.createMenuItem.bind(this)), eg.updateSetting.call(this, "captions", b)
                    }
                },
                setSpeedMenu: function(a) {
                    var b = this;
                    if (this.config.controls.includes("settings") && this.config.settings.includes("speed") && Qf.element(this.elements.settings.panes.speed)) {
                        Qf.array(a) ? this.options.speed = a : (this.isHTML5 || this.isVimeo) && (this.options.speed = [.5, .75, 1, 1.25, 1.5, 1.75, 2]), this.options.speed = this.options.speed.filter(function(a) {
                            return b.config.speed.options.includes(a)
                        });
                        var c = !Qf.empty(this.options.speed) && this.options.speed.length > 1;
                        if (eg.toggleTab.call(this, "speed", c), eg.checkMenu.call(this), c) {
                            var d = this.elements.settings.panes.speed.querySelector("ul");
                            m(d), this.options.speed.forEach(function(a) {
                                eg.createMenuItem.call(b, {
                                    value: a,
                                    list: d,
                                    type: "speed",
                                    title: eg.getLabel.call(b, "speed", a)
                                })
                            }), eg.updateSetting.call(this, "speed", d)
                        }
                    }
                },
                checkMenu: function() {
                    var a = this.elements.settings.tabs,
                        b = !Qf.empty(a) && Object.values(a).some(function(a) {
                            return !a.hidden
                        });
                    p(this.elements.settings.menu, !b)
                },
                toggleMenu: function(a) {
                    var b = this.elements.settings.form,
                        c = this.elements.buttons.settings;
                    if (Qf.element(b) && Qf.element(c)) {
                        var d = Qf.boolean(a) ? a : Qf.element(b) && b.hasAttribute("hidden");
                        if (Qf.event(a)) {
                            var e = Qf.element(b) && b.contains(a.target),
                                f = a.target === this.elements.buttons.settings;
                            if (e || !e && !f && d) return;
                            f && a.stopPropagation()
                        }
                        Qf.element(c) && c.setAttribute("aria-expanded", d), Qf.element(b) && (p(b, !d), q(this.elements.container, this.config.classNames.menu.open, d), d ? b.removeAttribute("tabindex") : b.setAttribute("tabindex", -1))
                    }
                },
                getTabSize: function(a) {
                    var b = a.cloneNode(!0);
                    b.style.position = "absolute", b.style.opacity = 0, b.removeAttribute("hidden"), Array.from(b.querySelectorAll("input[name]")).forEach(function(a) {
                        var b = a.getAttribute("name");
                        a.setAttribute("name", b + "-clone")
                    }), a.parentNode.appendChild(b);
                    var c = b.scrollWidth,
                        d = b.scrollHeight;
                    return l(b), {
                        width: c,
                        height: d
                    }
                },
                showTab: function() {
                    var a = this,
                        b = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
                        c = this.elements.settings.menu,
                        f = document.getElementById(b);
                    if (Qf.element(f) && "tabpanel" === f.getAttribute("role")) {
                        var g = c.querySelector('[role="tabpanel"]:not([hidden])'),
                            h = g.parentNode;
                        if (Array.from(c.querySelectorAll('[aria-controls="' + g.getAttribute("id") + '"]')).forEach(function(a) {
                                a.setAttribute("aria-expanded", !1)
                            }), Zf.transitions && !Zf.reducedMotion) {
                            h.style.width = g.scrollWidth + "px", h.style.height = g.scrollHeight + "px";
                            var i = eg.getTabSize.call(this, f);
                            d.call(this, h, Wf, function b(c) {
                                c.target === h && ["width", "height"].includes(c.propertyName) && (h.style.width = "", h.style.height = "", e.call(a, h, Wf, b))
                            }), h.style.width = i.width + "px", h.style.height = i.height + "px"
                        }
                        p(g, !0), g.setAttribute("tabindex", -1), p(f, !1);
                        var j = t.call(this, '[aria-controls="' + b + '"]');
                        Array.from(j).forEach(function(a) {
                            a.setAttribute("aria-expanded", !0)
                        }), f.removeAttribute("tabindex"), f.querySelectorAll("button:not(:disabled), input:not(:disabled), [tabindex]")[0].focus()
                    }
                },
                create: function(a) {
                    var b = this;
                    if (Qf.empty(this.config.controls)) return null;
                    var c = j("div", o(this.config.selectors.controls.wrapper));
                    if (this.config.controls.includes("restart") && c.appendChild(eg.createButton.call(this, "restart")), this.config.controls.includes("rewind") && c.appendChild(eg.createButton.call(this, "rewind")), this.config.controls.includes("play") && c.appendChild(eg.createButton.call(this, "play")), this.config.controls.includes("fast-forward") && c.appendChild(eg.createButton.call(this, "fast-forward")), this.config.controls.includes("progress")) {
                        var d = j("div", o(this.config.selectors.progress));
                        if (d.appendChild(eg.createRange.call(this, "seek", {
                                id: "plyr-seek-" + a.id
                            })), d.appendChild(eg.createProgress.call(this, "buffer")), this.config.tooltips.seek) {
                            var e = j("span", {
                                class: this.config.classNames.tooltip
                            }, "00:00");
                            d.appendChild(e), this.elements.display.seekTooltip = e
                        }
                        this.elements.progress = d, c.appendChild(this.elements.progress)
                    }
                    if (this.config.controls.includes("current-time") && c.appendChild(eg.createTime.call(this, "currentTime")), this.config.controls.includes("duration") && c.appendChild(eg.createTime.call(this, "duration")), this.config.controls.includes("mute") && c.appendChild(eg.createButton.call(this, "mute")), this.config.controls.includes("volume")) {
                        var f = j("div", {
                                class: "plyr__volume"
                            }),
                            g = {
                                max: 1,
                                step: .05,
                                value: this.config.volume
                            };
                        f.appendChild(eg.createRange.call(this, "volume", x(g, {
                            id: "plyr-volume-" + a.id
                        }))), this.elements.volume = f, c.appendChild(f)
                    }
                    if (this.config.controls.includes("captions") && c.appendChild(eg.createButton.call(this, "captions")), this.config.controls.includes("settings") && !Qf.empty(this.config.settings)) {
                        var h = j("div", {
                            class: "plyr__menu",
                            hidden: ""
                        });
                        h.appendChild(eg.createButton.call(this, "settings", {
                            id: "plyr-settings-toggle-" + a.id,
                            "aria-haspopup": !0,
                            "aria-controls": "plyr-settings-" + a.id,
                            "aria-expanded": !1
                        }));
                        var i = j("form", {
                                class: "plyr__menu__container",
                                id: "plyr-settings-" + a.id,
                                hidden: "",
                                "aria-labelled-by": "plyr-settings-toggle-" + a.id,
                                role: "tablist",
                                tabindex: -1
                            }),
                            k = j("div"),
                            l = j("div", {
                                id: "plyr-settings-" + a.id + "-home",
                                "aria-labelled-by": "plyr-settings-toggle-" + a.id,
                                role: "tabpanel"
                            }),
                            m = j("ul", {
                                role: "tablist"
                            });
                        this.config.settings.forEach(function(c) {
                            var d = j("li", {
                                    role: "tab",
                                    hidden: ""
                                }),
                                e = j("button", x(o(b.config.selectors.buttons.settings), {
                                    type: "button",
                                    class: b.config.classNames.control + " " + b.config.classNames.control + "--forward",
                                    id: "plyr-settings-" + a.id + "-" + c + "-tab",
                                    "aria-haspopup": !0,
                                    "aria-controls": "plyr-settings-" + a.id + "-" + c,
                                    "aria-expanded": !1
                                }), _f(c, b.config)),
                                f = j("span", {
                                    class: b.config.classNames.menu.value
                                });
                            f.innerHTML = a[c], e.appendChild(f), d.appendChild(e), m.appendChild(d), b.elements.settings.tabs[c] = d
                        }), l.appendChild(m), k.appendChild(l), this.config.settings.forEach(function(c) {
                            var d = j("div", {
                                    id: "plyr-settings-" + a.id + "-" + c,
                                    hidden: "",
                                    "aria-labelled-by": "plyr-settings-" + a.id + "-" + c + "-tab",
                                    role: "tabpanel",
                                    tabindex: -1
                                }),
                                e = j("button", {
                                    type: "button",
                                    class: b.config.classNames.control + " " + b.config.classNames.control + "--back",
                                    "aria-haspopup": !0,
                                    "aria-controls": "plyr-settings-" + a.id + "-home",
                                    "aria-expanded": !1
                                }, _f(c, b.config));
                            d.appendChild(e);
                            var f = j("ul");
                            d.appendChild(f), k.appendChild(d), b.elements.settings.panes[c] = d
                        }), i.appendChild(k), h.appendChild(i), c.appendChild(h), this.elements.settings.form = i, this.elements.settings.menu = h
                    }
                    return this.config.controls.includes("pip") && Zf.pip && c.appendChild(eg.createButton.call(this, "pip")), this.config.controls.includes("airplay") && Zf.airplay && c.appendChild(eg.createButton.call(this, "airplay")), this.config.controls.includes("fullscreen") && c.appendChild(eg.createButton.call(this, "fullscreen")), this.config.controls.includes("play-large") && this.elements.container.appendChild(eg.createButton.call(this, "play-large")), this.elements.controls = c, this.isHTML5 && eg.setQualityMenu.call(this, $f.getQualityOptions.call(this)), eg.setSpeedMenu.call(this), c
                },
                inject: function() {
                    var a = this;
                    if (this.config.loadSprite) {
                        var b = eg.getIconUrl.call(this);
                        b.cors && F(b.url, "sprite-plyr")
                    }
                    this.id = Math.floor(1e4 * Math.random());
                    var c = null;
                    this.elements.controls = null;
                    var d = {
                            id: this.id,
                            seektime: this.config.seekTime,
                            title: this.config.title
                        },
                        e = !0;
                    Qf.string(this.config.controls) || Qf.element(this.config.controls) ? c = this.config.controls : Qf.function(this.config.controls) ? c = this.config.controls.call(this, d) : (c = eg.create.call(this, {
                        id: this.id,
                        seektime: this.config.seekTime,
                        speed: this.speed,
                        quality: this.quality,
                        captions: fg.getLabel.call(this)
                    }), e = !1);
                    var f = function(a) {
                        var b = a;
                        return Object.entries(d).forEach(function(a) {
                            var c = Vf(a, 2),
                                d = c[0],
                                e = c[1];
                            b = z(b, "{" + d + "}", e)
                        }), b
                    };
                    e && (Qf.string(this.config.controls) ? c = f(c) : Qf.element(c) && (c.innerHTML = f(c.innerHTML)));
                    var g, h = void 0;
                    if (Qf.string(this.config.selectors.controls.container) && (h = document.querySelector(this.config.selectors.controls.container)), Qf.element(h) || (h = this.elements.container), Qf.element(c) ? h.appendChild(c) : c && h.insertAdjacentHTML("beforeend", c), Qf.element(this.elements.controls) || eg.findElements.call(this), window.navigator.userAgent.includes("Edge") && (g = h, setTimeout(function() {
                            p(g, !0), g.offsetHeight, p(g, !1)
                        }, 0)), this.config.tooltips.controls) {
                        var i = this.config,
                            j = i.classNames,
                            k = i.selectors,
                            l = k.controls.wrapper + " " + k.labels + " ." + j.hidden,
                            m = t.call(this, l);
                        Array.from(m).forEach(function(b) {
                            q(b, a.config.classNames.hidden, !1), q(b, a.config.classNames.tooltip, !0)
                        })
                    }
                }
            },
            fg = {
                setup: function() {
                    if (this.supported.ui)
                        if (!this.isVideo || this.isYouTube || this.isHTML5 && !Zf.textTracks) Qf.array(this.config.controls) && this.config.controls.includes("settings") && this.config.settings.includes("captions") && eg.setCaptionsMenu.call(this);
                        else {
                            var a, b;
                            if (Qf.element(this.elements.captions) || (this.elements.captions = j("div", o(this.config.selectors.captions)), a = this.elements.captions, (b = this.elements.wrapper).parentNode.insertBefore(a, b.nextSibling)), Xf.isIE && window.URL) {
                                var c = this.media.querySelectorAll("track");
                                Array.from(c).forEach(function(a) {
                                    var b = a.getAttribute("src"),
                                        c = H(b);
                                    null !== c && c.hostname !== window.top.location.href.hostname && ["http:", "https:"].includes(c.protocol) && E(b, "blob").then(function(b) {
                                        a.setAttribute("src", window.URL.createObjectURL(b))
                                    }).catch(function() {
                                        l(a)
                                    })
                                })
                            }
                            var e = D(Array.from(navigator.languages || navigator.userLanguage).map(function(a) {
                                    return a.split("-")[0]
                                })),
                                f = (this.storage.get("language") || this.config.captions.language || "auto").toLowerCase();
                            "auto" === f && (f = Vf(e, 1)[0]);
                            var g = this.storage.get("captions");
                            if (Qf.boolean(g) || (g = this.config.captions.active), Object.assign(this.captions, {
                                    toggled: !1,
                                    active: g,
                                    language: f,
                                    languages: e
                                }), this.isHTML5) {
                                var h = this.config.captions.update ? "addtrack removetrack" : "removetrack";
                                d.call(this, this.media.textTracks, h, fg.update.bind(this))
                            }
                            setTimeout(fg.update.bind(this), 0)
                        }
                },
                update: function() {
                    var a = this,
                        b = fg.getTracks.call(this, !0),
                        c = this.captions,
                        e = c.active,
                        f = c.language,
                        g = c.meta,
                        h = c.currentTrackNode,
                        i = Boolean(b.find(function(a) {
                            return a.language === f
                        }));
                    this.isHTML5 && this.isVideo && b.filter(function(a) {
                        return !g.get(a)
                    }).forEach(function(b) {
                        a.debug.log("Track added", b), g.set(b, {
                            default: "showing" === b.mode
                        }), b.mode = "hidden", d.call(a, b, "cuechange", function() {
                            return fg.updateCues.call(a)
                        })
                    }), (i && this.language !== f || !b.includes(h)) && (fg.setLanguage.call(this, f), fg.toggle.call(this, e && i)), q(this.elements.container, this.config.classNames.captions.enabled, !Qf.empty(b)), (this.config.controls || []).includes("settings") && this.config.settings.includes("captions") && eg.setCaptionsMenu.call(this)
                },
                toggle: function(a) {
                    var b = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                    if (this.supported.ui) {
                        var c = this.captions.toggled,
                            d = this.config.classNames.captions.active,
                            e = Qf.nullOrUndefined(a) ? !c : a;
                        if (e !== c) {
                            if (b || (this.captions.active = e, this.storage.set({
                                    captions: e
                                })), !this.language && e && !b) {
                                var f = fg.getTracks.call(this),
                                    h = fg.findTrack.call(this, [this.captions.language].concat(function(a) {
                                        if (Array.isArray(a)) {
                                            for (var b = 0, c = Array(a.length); b < a.length; b++) c[b] = a[b];
                                            return c
                                        }
                                        return Array.from(a)
                                    }(this.captions.languages)), !0);
                                return this.captions.language = h.language, void fg.set.call(this, f.indexOf(h))
                            }
                            this.elements.buttons.captions && (this.elements.buttons.captions.pressed = e), q(this.elements.container, d, e), this.captions.toggled = e, eg.updateSetting.call(this, "captions"), g.call(this, this.media, e ? "captionsenabled" : "captionsdisabled")
                        }
                    }
                },
                set: function(a) {
                    var b = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
                        c = fg.getTracks.call(this);
                    if (-1 !== a)
                        if (Qf.number(a))
                            if (a in c) {
                                if (this.captions.currentTrack !== a) {
                                    this.captions.currentTrack = a;
                                    var d = c[a],
                                        e = (d || {}).language;
                                    this.captions.currentTrackNode = d, eg.updateSetting.call(this, "captions"), b || (this.captions.language = e, this.storage.set({
                                        language: e
                                    })), this.isVimeo && this.embed.enableTextTrack(e), g.call(this, this.media, "languagechange")
                                }
                                fg.toggle.call(this, !0, b), this.isHTML5 && this.isVideo && fg.updateCues.call(this)
                            } else this.debug.warn("Track not found", a);
                    else this.debug.warn("Invalid caption argument", a);
                    else fg.toggle.call(this, !1, b)
                },
                setLanguage: function(a) {
                    var b = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                    if (Qf.string(a)) {
                        var c = a.toLowerCase();
                        this.captions.language = c;
                        var d = fg.getTracks.call(this),
                            e = fg.findTrack.call(this, [c]);
                        fg.set.call(this, d.indexOf(e), b)
                    } else this.debug.warn("Invalid language argument", a)
                },
                getTracks: function() {
                    var a = this,
                        b = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                    return Array.from((this.media || {}).textTracks || []).filter(function(c) {
                        return !a.isHTML5 || b || a.captions.meta.has(c)
                    }).filter(function(a) {
                        return ["captions", "subtitles"].includes(a.kind)
                    })
                },
                findTrack: function(a) {
                    var b = this,
                        c = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
                        d = fg.getTracks.call(this),
                        e = function(a) {
                            return Number((b.captions.meta.get(a) || {}).default)
                        },
                        f = Array.from(d).sort(function(a, b) {
                            return e(b) - e(a)
                        }),
                        g = void 0;
                    return a.every(function(a) {
                        return !(g = f.find(function(b) {
                            return b.language === a
                        }))
                    }), g || (c ? f[0] : void 0)
                },
                getCurrentTrack: function() {
                    return fg.getTracks.call(this)[this.currentTrack]
                },
                getLabel: function(a) {
                    var b = a;
                    return !Qf.track(b) && Zf.textTracks && this.captions.toggled && (b = fg.getCurrentTrack.call(this)), Qf.track(b) ? Qf.empty(b.label) ? Qf.empty(b.language) ? _f("enabled", this.config) : a.language.toUpperCase() : b.label : _f("disabled", this.config)
                },
                updateCues: function(a) {
                    if (this.supported.ui)
                        if (Qf.element(this.elements.captions))
                            if (Qf.nullOrUndefined(a) || Array.isArray(a)) {
                                var b = a;
                                if (!b) {
                                    var c = fg.getCurrentTrack.call(this);
                                    b = Array.from((c || {}).activeCues || []).map(function(a) {
                                        return a.getCueAsHTML()
                                    }).map(C)
                                }
                                var d = b.map(function(a) {
                                    return a.trim()
                                }).join("\n");
                                if (d !== this.elements.captions.innerHTML) {
                                    m(this.elements.captions);
                                    var e = j("span", o(this.config.selectors.caption));
                                    e.innerHTML = d, this.elements.captions.appendChild(e), g.call(this, this.media, "cuechange")
                                }
                            } else this.debug.warn("updateCues: Invalid input", a);
                    else this.debug.warn("No captions element to render to")
                }
            },
            gg = {
                enabled: !0,
                title: "",
                debug: !1,
                autoplay: !1,
                autopause: !0,
                playsinline: !0,
                seekTime: 10,
                volume: 1,
                muted: !1,
                duration: null,
                displayDuration: !0,
                invertTime: !0,
                toggleInvert: !0,
                ratio: "16:9",
                clickToPlay: !0,
                hideControls: !0,
                resetOnEnd: !1,
                disableContextMenu: !0,
                loadSprite: !0,
                iconPrefix: "plyr",
                iconUrl: "https://cdn.plyr.io/3.3.12/plyr.svg",
                blankVideo: "https://cdn.plyr.io/static/blank.mp4",
                quality: {
                    default: 576,
                    options: [4320, 2880, 2160, 1440, 1080, 720, 576, 480, 360, 240, "default"]
                },
                loop: {
                    active: !1
                },
                speed: {
                    selected: 1,
                    options: [.5, .75, 1, 1.25, 1.5, 1.75, 2]
                },
                keyboard: {
                    focused: !0,
                    global: !1
                },
                tooltips: {
                    controls: !1,
                    seek: !0
                },
                captions: {
                    active: !1,
                    language: "auto",
                    update: !1
                },
                fullscreen: {
                    enabled: !0,
                    fallback: !0,
                    iosNative: !1
                },
                storage: {
                    enabled: !0,
                    key: "plyr"
                },
                controls: ["play-large", "play", "progress", "current-time", "mute", "volume", "captions", "settings", "pip", "airplay", "fullscreen"],
                settings: ["captions", "quality", "speed"],
                i18n: {
                    restart: "Restart",
                    rewind: "Rewind {seektime}s",
                    play: "Play",
                    pause: "Pause",
                    fastForward: "Forward {seektime}s",
                    seek: "Seek",
                    seekLabel: "{currentTime} of {duration}",
                    played: "Played",
                    buffered: "Buffered",
                    currentTime: "Current time",
                    duration: "Duration",
                    volume: "Volume",
                    mute: "Mute",
                    unmute: "Unmute",
                    enableCaptions: "Enable captions",
                    disableCaptions: "Disable captions",
                    enterFullscreen: "Enter fullscreen",
                    exitFullscreen: "Exit fullscreen",
                    frameTitle: "Player for {title}",
                    captions: "Captions",
                    settings: "Settings",
                    menuBack: "Go back to previous menu",
                    speed: "Speed",
                    normal: "Normal",
                    quality: "Quality",
                    loop: "Loop",
                    start: "Start",
                    end: "End",
                    all: "All",
                    reset: "Reset",
                    disabled: "Disabled",
                    enabled: "Enabled",
                    advertisement: "Ad",
                    qualityBadge: {
                        2160: "4K",
                        1440: "HD",
                        1080: "HD",
                        720: "HD",
                        576: "SD",
                        480: "SD"
                    }
                },
                urls: {
                    vimeo: {
                        sdk: "https://player.vimeo.com/api/player.js",
                        iframe: "https://player.vimeo.com/video/{0}?{1}",
                        api: "https://vimeo.com/api/v2/video/{0}.json"
                    },
                    youtube: {
                        sdk: "https://www.youtube.com/iframe_api",
                        api: "https://www.googleapis.com/youtube/v3/videos?id={0}&key={1}&fields=items(snippet(title))&part=snippet"
                    },
                    googleIMA: {
                        sdk: "https://imasdk.googleapis.com/js/sdkloader/ima3.js"
                    }
                },
                listeners: {
                    seek: null,
                    play: null,
                    pause: null,
                    restart: null,
                    rewind: null,
                    fastForward: null,
                    mute: null,
                    volume: null,
                    captions: null,
                    fullscreen: null,
                    pip: null,
                    airplay: null,
                    speed: null,
                    quality: null,
                    loop: null,
                    language: null
                },
                events: ["ended", "progress", "stalled", "playing", "waiting", "canplay", "canplaythrough", "loadstart", "loadeddata", "loadedmetadata", "timeupdate", "volumechange", "play", "pause", "error", "seeking", "seeked", "emptied", "ratechange", "cuechange", "enterfullscreen", "exitfullscreen", "captionsenabled", "captionsdisabled", "languagechange", "controlshidden", "controlsshown", "ready", "statechange", "qualitychange", "qualityrequested", "adsloaded", "adscontentpause", "adscontentresume", "adstarted", "adsmidpoint", "adscomplete", "adsallcomplete", "adsimpression", "adsclick"],
                selectors: {
                    editable: "input, textarea, select, [contenteditable]",
                    container: ".plyr",
                    controls: {
                        container: null,
                        wrapper: ".plyr__controls"
                    },
                    labels: "[data-plyr]",
                    buttons: {
                        play: '[data-plyr="play"]',
                        pause: '[data-plyr="pause"]',
                        restart: '[data-plyr="restart"]',
                        rewind: '[data-plyr="rewind"]',
                        fastForward: '[data-plyr="fast-forward"]',
                        mute: '[data-plyr="mute"]',
                        captions: '[data-plyr="captions"]',
                        fullscreen: '[data-plyr="fullscreen"]',
                        pip: '[data-plyr="pip"]',
                        airplay: '[data-plyr="airplay"]',
                        settings: '[data-plyr="settings"]',
                        loop: '[data-plyr="loop"]'
                    },
                    inputs: {
                        seek: '[data-plyr="seek"]',
                        volume: '[data-plyr="volume"]',
                        speed: '[data-plyr="speed"]',
                        language: '[data-plyr="language"]',
                        quality: '[data-plyr="quality"]'
                    },
                    display: {
                        currentTime: ".plyr__time--current",
                        duration: ".plyr__time--duration",
                        buffer: ".plyr__progress__buffer",
                        loop: ".plyr__progress__loop",
                        volume: ".plyr__volume--display"
                    },
                    progress: ".plyr__progress",
                    captions: ".plyr__captions",
                    caption: ".plyr__caption",
                    menu: {
                        quality: ".js-plyr__menu__list--quality"
                    }
                },
                classNames: {
                    type: "plyr--{0}",
                    provider: "plyr--{0}",
                    video: "plyr__video-wrapper",
                    embed: "plyr__video-embed",
                    embedContainer: "plyr__video-embed__container",
                    poster: "plyr__poster",
                    posterEnabled: "plyr__poster-enabled",
                    ads: "plyr__ads",
                    control: "plyr__control",
                    controlPressed: "plyr__control--pressed",
                    playing: "plyr--playing",
                    paused: "plyr--paused",
                    stopped: "plyr--stopped",
                    loading: "plyr--loading",
                    hover: "plyr--hover",
                    tooltip: "plyr__tooltip",
                    cues: "plyr__cues",
                    hidden: "plyr__sr-only",
                    hideControls: "plyr--hide-controls",
                    isIos: "plyr--is-ios",
                    isTouch: "plyr--is-touch",
                    uiSupported: "plyr--full-ui",
                    noTransition: "plyr--no-transition",
                    menu: {
                        value: "plyr__menu__value",
                        badge: "plyr__badge",
                        open: "plyr--menu-open"
                    },
                    captions: {
                        enabled: "plyr--captions-enabled",
                        active: "plyr--captions-active"
                    },
                    fullscreen: {
                        enabled: "plyr--fullscreen-enabled",
                        fallback: "plyr--fullscreen-fallback"
                    },
                    pip: {
                        supported: "plyr--pip-supported",
                        active: "plyr--pip-active"
                    },
                    airplay: {
                        supported: "plyr--airplay-supported",
                        active: "plyr--airplay-active"
                    },
                    tabFocus: "plyr__tab-focus"
                },
                attributes: {
                    embed: {
                        provider: "data-plyr-provider",
                        id: "data-plyr-embed-id"
                    }
                },
                keys: {
                    google: null
                },
                ads: {
                    enabled: !1,
                    publisherId: ""
                }
            },
            hg = {
                html5: "html5",
                youtube: "youtube",
                vimeo: "vimeo"
            },
            ig = {
                audio: "audio",
                video: "video"
            },
            jg = function() {},
            kg = function() {
                function a() {
                    var b = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                    Sf(this, a), this.enabled = window.console && b, this.enabled && this.log("Debugging enabled")
                }
                return Tf(a, [{
                    key: "log",
                    get: function() {
                        return this.enabled ? Function.prototype.bind.call(console.log, console) : jg
                    }
                }, {
                    key: "warn",
                    get: function() {
                        return this.enabled ? Function.prototype.bind.call(console.warn, console) : jg
                    }
                }, {
                    key: "error",
                    get: function() {
                        return this.enabled ? Function.prototype.bind.call(console.error, console) : jg
                    }
                }]), a
            }(),
            lg = function() {
                function a(b) {
                    var c = this;
                    Sf(this, a), this.player = b, this.prefix = a.prefix, this.property = a.property, this.scrollPosition = {
                        x: 0,
                        y: 0
                    }, d.call(this.player, document, "ms" === this.prefix ? "MSFullscreenChange" : this.prefix + "fullscreenchange", function() {
                        J.call(c)
                    }), d.call(this.player, this.player.elements.container, "dblclick", function(a) {
                        Qf.element(c.player.elements.controls) && c.player.elements.controls.contains(a.target) || c.toggle()
                    }), this.update()
                }
                return Tf(a, [{
                    key: "update",
                    value: function() {
                        this.enabled ? this.player.debug.log((a.native ? "Native" : "Fallback") + " fullscreen enabled") : this.player.debug.log("Fullscreen not supported and fallback disabled"), q(this.player.elements.container, this.player.config.classNames.fullscreen.enabled, this.enabled)
                    }
                }, {
                    key: "enter",
                    value: function() {
                        this.enabled && (Xf.isIos && this.player.config.fullscreen.iosNative ? this.player.playing && this.target.webkitEnterFullscreen() : a.native ? this.prefix ? Qf.empty(this.prefix) || this.target[this.prefix + "Request" + this.property]() : this.target.requestFullscreen() : K.call(this, !0))
                    }
                }, {
                    key: "exit",
                    value: function() {
                        if (this.enabled)
                            if (Xf.isIos && this.player.config.fullscreen.iosNative) this.target.webkitExitFullscreen(), this.player.play();
                            else if (a.native)
                            if (this.prefix) {
                                if (!Qf.empty(this.prefix)) {
                                    var b = "moz" === this.prefix ? "Cancel" : "Exit";
                                    document["" + this.prefix + b + this.property]()
                                }
                            } else(document.cancelFullScreen || document.exitFullscreen).call(document);
                        else K.call(this, !1)
                    }
                }, {
                    key: "toggle",
                    value: function() {
                        this.active ? this.exit() : this.enter()
                    }
                }, {
                    key: "enabled",
                    get: function() {
                        return (a.native || this.player.config.fullscreen.fallback) && this.player.config.fullscreen.enabled && this.player.supported.ui && this.player.isVideo
                    }
                }, {
                    key: "active",
                    get: function() {
                        return !!this.enabled && (a.native ? (this.prefix ? document["" + this.prefix + this.property + "Element"] : document.fullscreenElement) === this.target : r(this.target, this.player.config.classNames.fullscreen.fallback))
                    }
                }, {
                    key: "target",
                    get: function() {
                        return Xf.isIos && this.player.config.fullscreen.iosNative ? this.player.media : this.player.elements.container
                    }
                }], [{
                    key: "native",
                    get: function() {
                        return !!(document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled)
                    }
                }, {
                    key: "prefix",
                    get: function() {
                        if (Qf.function(document.exitFullscreen)) return "";
                        var a = "";
                        return ["webkit", "moz", "ms"].some(function(b) {
                            return !(!Qf.function(document[b + "ExitFullscreen"]) && !Qf.function(document[b + "CancelFullScreen"]) || (a = b, 0))
                        }), a
                    }
                }, {
                    key: "property",
                    get: function() {
                        return "moz" === this.prefix ? "FullScreen" : "Fullscreen"
                    }
                }]), a
            }(),
            mg = {
                addStyleHook: function() {
                    q(this.elements.container, this.config.selectors.container.replace(".", ""), !0), q(this.elements.container, this.config.classNames.uiSupported, this.supported.ui)
                },
                toggleNativeControls: function() {
                    arguments.length > 0 && void 0 !== arguments[0] && arguments[0] && this.isHTML5 ? this.media.setAttribute("controls", "") : this.media.removeAttribute("controls")
                },
                build: function() {
                    var a = this;
                    if (this.listeners.media(), !this.supported.ui) return this.debug.warn("Basic support only for " + this.provider + " " + this.type), void mg.toggleNativeControls.call(this, !0);
                    Qf.element(this.elements.controls) || (eg.inject.call(this), this.listeners.controls()), mg.toggleNativeControls.call(this), this.isHTML5 && fg.setup.call(this), this.volume = null, this.muted = null, this.speed = null, this.loop = null, this.quality = null, eg.updateVolume.call(this), eg.timeUpdate.call(this), mg.checkPlaying.call(this), q(this.elements.container, this.config.classNames.pip.supported, Zf.pip && this.isHTML5 && this.isVideo), q(this.elements.container, this.config.classNames.airplay.supported, Zf.airplay && this.isHTML5), q(this.elements.container, this.config.classNames.isIos, Xf.isIos), q(this.elements.container, this.config.classNames.isTouch, this.touch), this.ready = !0, setTimeout(function() {
                        g.call(a, a.media, "ready")
                    }, 0), mg.setTitle.call(this), this.poster && mg.setPoster.call(this, this.poster, !1).catch(function() {}), this.config.duration && eg.durationUpdate.call(this)
                },
                setTitle: function() {
                    var a = _f("play", this.config);
                    if (Qf.string(this.config.title) && !Qf.empty(this.config.title) && (a += ", " + this.config.title), Array.from(this.elements.buttons.play || []).forEach(function(b) {
                            b.setAttribute("aria-label", a)
                        }), this.isEmbed) {
                        var b = u.call(this, "iframe");
                        if (!Qf.element(b)) return;
                        var c = Qf.empty(this.config.title) ? "video" : this.config.title,
                            d = _f("frameTitle", this.config);
                        b.setAttribute("title", d.replace("{title}", c))
                    }
                },
                togglePoster: function(a) {
                    q(this.elements.container, this.config.classNames.posterEnabled, a)
                },
                setPoster: function(a) {
                    var b = this;
                    return arguments.length > 1 && void 0 !== arguments[1] && !arguments[1] || !this.poster ? (this.media.setAttribute("poster", a), function() {
                        var a = this;
                        return new Promise(function(b) {
                            return a.ready ? setTimeout(b, 0) : d.call(a, a.elements.container, "ready", b)
                        }).then(function() {})
                    }.call(this).then(function() {
                        return L(a)
                    }).catch(function(c) {
                        throw a === b.poster && mg.togglePoster.call(b, !1), c
                    }).then(function() {
                        if (a !== b.poster) throw new Error("setPoster cancelled by later call to setPoster")
                    }).then(function() {
                        return Object.assign(b.elements.poster.style, {
                            backgroundImage: "url('" + a + "')",
                            backgroundSize: ""
                        }), mg.togglePoster.call(b, !0), a
                    })) : Promise.reject(new Error("Poster already set"))
                },
                checkPlaying: function(a) {
                    var b = this;
                    q(this.elements.container, this.config.classNames.playing, this.playing), q(this.elements.container, this.config.classNames.paused, this.paused), q(this.elements.container, this.config.classNames.stopped, this.stopped), Array.from(this.elements.buttons.play || []).forEach(function(a) {
                        a.pressed = b.playing
                    }), Qf.event(a) && "timeupdate" === a.type || mg.toggleControls.call(this)
                },
                checkLoading: function(a) {
                    var b = this;
                    this.loading = ["stalled", "waiting"].includes(a.type), clearTimeout(this.timers.loading), this.timers.loading = setTimeout(function() {
                        q(b.elements.container, b.config.classNames.loading, b.loading), mg.toggleControls.call(b)
                    }, this.loading ? 250 : 0)
                },
                toggleControls: function(a) {
                    var b = this.elements.controls;
                    b && this.config.hideControls && this.toggleControls(Boolean(a || this.loading || this.paused || b.pressed || b.hover))
                }
            },
            ng = function() {
                function a(b) {
                    Sf(this, a), this.player = b, this.lastKey = null, this.handleKey = this.handleKey.bind(this), this.toggleMenu = this.toggleMenu.bind(this), this.firstTouch = this.firstTouch.bind(this)
                }
                return Tf(a, [{
                    key: "handleKey",
                    value: function(a) {
                        var b = this,
                            c = a.keyCode ? a.keyCode : a.which,
                            d = "keydown" === a.type,
                            e = d && c === this.lastKey;
                        if (!(a.altKey || a.ctrlKey || a.metaKey || a.shiftKey) && Qf.number(c))
                            if (d) {
                                var f = v();
                                if (Qf.element(f) && f !== this.player.elements.inputs.seek && s(f, this.player.config.selectors.editable)) return;
                                switch ([32, 37, 38, 39, 40, 48, 49, 50, 51, 52, 53, 54, 56, 57, 67, 70, 73, 75, 76, 77, 79].includes(c) && (a.preventDefault(), a.stopPropagation()), c) {
                                    case 48:
                                    case 49:
                                    case 50:
                                    case 51:
                                    case 52:
                                    case 53:
                                    case 54:
                                    case 55:
                                    case 56:
                                    case 57:
                                        e || (b.player.currentTime = b.player.duration / 10 * (c - 48));
                                        break;
                                    case 32:
                                    case 75:
                                        e || this.player.togglePlay();
                                        break;
                                    case 38:
                                        this.player.increaseVolume(.1);
                                        break;
                                    case 40:
                                        this.player.decreaseVolume(.1);
                                        break;
                                    case 77:
                                        e || (this.player.muted = !this.player.muted);
                                        break;
                                    case 39:
                                        this.player.forward();
                                        break;
                                    case 37:
                                        this.player.rewind();
                                        break;
                                    case 70:
                                        this.player.fullscreen.toggle();
                                        break;
                                    case 67:
                                        e || this.player.toggleCaptions();
                                        break;
                                    case 76:
                                        this.player.loop = !this.player.loop
                                }!this.player.fullscreen.enabled && this.player.fullscreen.active && 27 === c && this.player.fullscreen.toggle(), this.lastKey = c
                            } else this.lastKey = null
                    }
                }, {
                    key: "toggleMenu",
                    value: function(a) {
                        eg.toggleMenu.call(this.player, a)
                    }
                }, {
                    key: "firstTouch",
                    value: function() {
                        this.player.touch = !0, q(this.player.elements.container, this.player.config.classNames.isTouch, !0)
                    }
                }, {
                    key: "global",
                    value: function() {
                        var a = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                        this.player.config.keyboard.global && c.call(this.player, window, "keydown keyup", this.handleKey, a, !1), c.call(this.player, document.body, "click", this.toggleMenu, a), f.call(this.player, document.body, "touchstart", this.firstTouch)
                    }
                }, {
                    key: "container",
                    value: function() {
                        var a = this;
                        !this.player.config.keyboard.global && this.player.config.keyboard.focused && d.call(this.player, this.player.elements.container, "keydown keyup", this.handleKey, !1), d.call(this.player, this.player.elements.container, "focusout", function(b) {
                            q(b.target, a.player.config.classNames.tabFocus, !1)
                        }), d.call(this.player, this.player.elements.container, "keydown", function(b) {
                            9 === b.keyCode && setTimeout(function() {
                                q(v(), a.player.config.classNames.tabFocus, !0)
                            }, 0)
                        }), d.call(this.player, this.player.elements.container, "mousemove mouseleave touchstart touchmove enterfullscreen exitfullscreen", function(b) {
                            var c = a.player.elements.controls;
                            "enterfullscreen" === b.type && (c.pressed = !1, c.hover = !1);
                            var d = 0;
                            ["touchstart", "touchmove", "mousemove"].includes(b.type) && (mg.toggleControls.call(a.player, !0), d = a.player.touch ? 3e3 : 2e3), clearTimeout(a.player.timers.controls), a.player.timers.controls = setTimeout(function() {
                                return mg.toggleControls.call(a.player, !1)
                            }, d)
                        })
                    }
                }, {
                    key: "media",
                    value: function() {
                        var a = this;
                        if (d.call(this.player, this.player.media, "timeupdate seeking seeked", function(b) {
                                return eg.timeUpdate.call(a.player, b)
                            }), d.call(this.player, this.player.media, "durationchange loadeddata loadedmetadata", function(b) {
                                return eg.durationUpdate.call(a.player, b)
                            }), d.call(this.player, this.player.media, "canplay", function() {
                                p(a.player.elements.volume, !a.player.hasAudio), p(a.player.elements.buttons.mute, !a.player.hasAudio)
                            }), d.call(this.player, this.player.media, "ended", function() {
                                a.player.isHTML5 && a.player.isVideo && a.player.config.resetOnEnd && a.player.restart()
                            }), d.call(this.player, this.player.media, "progress playing seeking seeked", function(b) {
                                return eg.updateProgress.call(a.player, b)
                            }), d.call(this.player, this.player.media, "volumechange", function(b) {
                                return eg.updateVolume.call(a.player, b)
                            }), d.call(this.player, this.player.media, "playing play pause ended emptied timeupdate", function(b) {
                                return mg.checkPlaying.call(a.player, b)
                            }), d.call(this.player, this.player.media, "waiting canplay seeked playing", function(b) {
                                return mg.checkLoading.call(a.player, b)
                            }), d.call(this.player, this.player.media, "playing", function() {
                                a.player.ads && a.player.ads.enabled && !a.player.ads.initialized && a.player.ads.managerPromise.then(function() {
                                    return a.player.ads.play()
                                }).catch(function() {
                                    return a.player.play()
                                })
                            }), this.player.supported.ui && this.player.config.clickToPlay && !this.player.isAudio) {
                            var b = u.call(this.player, "." + this.player.config.classNames.video);
                            if (!Qf.element(b)) return;
                            d.call(this.player, b, "click", function() {
                                a.player.config.hideControls && a.player.touch && !a.player.paused || (a.player.paused ? a.player.play() : a.player.ended ? (a.player.restart(), a.player.play()) : a.player.pause())
                            })
                        }
                        this.player.supported.ui && this.player.config.disableContextMenu && d.call(this.player, this.player.elements.wrapper, "contextmenu", function(a) {
                            a.preventDefault()
                        }, !1), d.call(this.player, this.player.media, "volumechange", function() {
                            a.player.storage.set({
                                volume: a.player.volume,
                                muted: a.player.muted
                            })
                        }), d.call(this.player, this.player.media, "ratechange", function() {
                            eg.updateSetting.call(a.player, "speed"), a.player.storage.set({
                                speed: a.player.speed
                            })
                        }), d.call(this.player, this.player.media, "qualityrequested", function(b) {
                            a.player.storage.set({
                                quality: b.detail.quality
                            })
                        }), d.call(this.player, this.player.media, "qualitychange", function(b) {
                            eg.updateSetting.call(a.player, "quality", null, b.detail.quality)
                        });
                        var c = this.player.config.events.concat(["keyup", "keydown"]).join(" ");
                        d.call(this.player, this.player.media, c, function(b) {
                            var c = b.detail,
                                d = void 0 === c ? {} : c;
                            "error" === b.type && (d = a.player.media.error), g.call(a.player, a.player.elements.container, b.type, !0, d)
                        })
                    }
                }, {
                    key: "controls",
                    value: function() {
                        var a = this,
                            b = Xf.isIE ? "change" : "input",
                            c = function(b, c, d) {
                                var e = a.player.config.listeners[d],
                                    f = !0;
                                Qf.function(e) && (f = e.call(a.player, b)), f && Qf.function(c) && c.call(a.player, b)
                            },
                            e = function(b, e, f, g) {
                                var h = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4],
                                    i = a.player.config.listeners[g],
                                    j = Qf.function(i);
                                d.call(a.player, b, e, function(a) {
                                    return c(a, f, g)
                                }, h && !j)
                            };
                        this.player.elements.buttons.play && Array.from(this.player.elements.buttons.play).forEach(function(b) {
                            e(b, "click", a.player.togglePlay, "play")
                        }), e(this.player.elements.buttons.restart, "click", this.player.restart, "restart"), e(this.player.elements.buttons.rewind, "click", this.player.rewind, "rewind"), e(this.player.elements.buttons.fastForward, "click", this.player.forward, "fastForward"), e(this.player.elements.buttons.mute, "click", function() {
                            a.player.muted = !a.player.muted
                        }, "mute"), e(this.player.elements.buttons.captions, "click", function() {
                            return a.player.toggleCaptions()
                        }), e(this.player.elements.buttons.fullscreen, "click", function() {
                            a.player.fullscreen.toggle()
                        }, "fullscreen"), e(this.player.elements.buttons.pip, "click", function() {
                            a.player.pip = "toggle"
                        }, "pip"), e(this.player.elements.buttons.airplay, "click", this.player.airplay, "airplay"), e(this.player.elements.buttons.settings, "click", function(b) {
                            eg.toggleMenu.call(a.player, b)
                        }), e(this.player.elements.settings.form, "click", function(b) {
                            b.stopPropagation();
                            var d = function() {
                                var b = "plyr-settings-" + a.player.id + "-home";
                                eg.showTab.call(a.player, b)
                            };
                            if (s(b.target, a.player.config.selectors.inputs.language)) c(b, function() {
                                a.player.currentTrack = Number(b.target.value), d()
                            }, "language");
                            else if (s(b.target, a.player.config.selectors.inputs.quality)) c(b, function() {
                                a.player.quality = b.target.value, d()
                            }, "quality");
                            else if (s(b.target, a.player.config.selectors.inputs.speed)) c(b, function() {
                                a.player.speed = parseFloat(b.target.value), d()
                            }, "speed");
                            else {
                                var e = b.target;
                                eg.showTab.call(a.player, e.getAttribute("aria-controls"))
                            }
                        }), e(this.player.elements.inputs.seek, "mousedown mousemove", function(b) {
                            var c = a.player.elements.progress.getBoundingClientRect(),
                                d = 100 / c.width * (b.pageX - c.left);
                            b.currentTarget.setAttribute("seek-value", d)
                        }), e(this.player.elements.inputs.seek, "mousedown mouseup keydown keyup touchstart touchend", function(b) {
                            var c = b.currentTarget,
                                d = b.keyCode ? b.keyCode : b.which,
                                e = b.type;
                            if ("keydown" !== e && "keyup" !== e || 39 === d || 37 === d) {
                                var f = c.hasAttribute("play-on-seeked"),
                                    g = ["mouseup", "touchend", "keyup"].includes(b.type);
                                f && g ? (c.removeAttribute("play-on-seeked"), a.player.play()) : !g && a.player.playing && (c.setAttribute("play-on-seeked", ""), a.player.pause())
                            }
                        }), e(this.player.elements.inputs.seek, b, function(b) {
                            var c = b.currentTarget,
                                d = c.getAttribute("seek-value");
                            Qf.empty(d) && (d = c.value), c.removeAttribute("seek-value"), a.player.currentTime = d / c.max * a.player.duration
                        }, "seek"), this.player.config.toggleInvert && !Qf.element(this.player.elements.display.duration) && e(this.player.elements.display.currentTime, "click", function() {
                            0 !== a.player.currentTime && (a.player.config.invertTime = !a.player.config.invertTime, eg.timeUpdate.call(a.player))
                        }), e(this.player.elements.inputs.volume, b, function(b) {
                            a.player.volume = b.target.value
                        }, "volume"), Xf.isWebkit && Array.from(t.call(this.player, 'input[type="range"]')).forEach(function(b) {
                            e(b, "input", function(b) {
                                return eg.updateRangeFill.call(a.player, b.target)
                            })
                        }), e(this.player.elements.progress, "mouseenter mouseleave mousemove", function(b) {
                            return eg.updateSeekTooltip.call(a.player, b)
                        }), e(this.player.elements.controls, "mouseenter mouseleave", function(b) {
                            a.player.elements.controls.hover = !a.player.touch && "mouseenter" === b.type
                        }), e(this.player.elements.controls, "mousedown mouseup touchstart touchend touchcancel", function(b) {
                            a.player.elements.controls.pressed = ["mousedown", "touchstart"].includes(b.type)
                        }), e(this.player.elements.controls, "focusin focusout", function(b) {
                            var c = a.player,
                                d = c.config,
                                e = c.elements,
                                f = c.timers;
                            if (q(e.controls, d.classNames.noTransition, "focusin" === b.type), mg.toggleControls.call(a.player, "focusin" === b.type), "focusin" === b.type) {
                                setTimeout(function() {
                                    q(e.controls, d.classNames.noTransition, !1)
                                }, 0);
                                var g = a.touch ? 3e3 : 4e3;
                                clearTimeout(f.controls), f.controls = setTimeout(function() {
                                    return mg.toggleControls.call(a.player, !1)
                                }, g)
                            }
                        }), e(this.player.elements.inputs.volume, "wheel", function(b) {
                            var c = b.webkitDirectionInvertedFromDevice,
                                d = [b.deltaX, -b.deltaY].map(function(a) {
                                    return c ? -a : a
                                }),
                                e = Vf(d, 2),
                                f = e[0],
                                g = e[1],
                                h = Math.sign(Math.abs(f) > Math.abs(g) ? f : g);
                            a.player.increaseVolume(h / 50);
                            var i = a.player.media.volume;
                            (1 === h && i < 1 || -1 === h && i > 0) && b.preventDefault()
                        }, "volume", !1)
                    }
                }]), a
            }(),
            og = a(function(a, b) {
                var c;
                c = function() {
                    function a(a, b) {
                        if (a) {
                            var c = h[a];
                            if (g[a] = b, c)
                                for (; c.length;) c[0](a, b), c.splice(0, 1)
                        }
                    }

                    function b(a, b) {
                        a.call && (a = {
                            success: a
                        }), b.length ? (a.error || e)(b) : (a.success || e)(a)
                    }

                    function c(a, b, d, f) {
                        var g, h, i = document,
                            j = d.async,
                            k = (d.numRetries || 0) + 1,
                            l = d.before || e,
                            m = a.replace(/^(css|img)!/, "");
                        f = f || 0, /(^css!|\.css$)/.test(a) ? (g = !0, (h = i.createElement("link")).rel = "stylesheet", h.href = m) : /(^img!|\.(png|gif|jpg|svg)$)/.test(a) ? (h = i.createElement("img")).src = m : ((h = i.createElement("script")).src = a, h.async = void 0 === j || j), h.onload = h.onerror = h.onbeforeload = function(e) {
                            var i = e.type[0];
                            if (g && "hideFocus" in h) try {
                                h.sheet.cssText.length || (i = "e")
                            } catch (e) {
                                i = "e"
                            }
                            if ("e" == i && (f += 1) < k) return c(a, b, d, f);
                            b(a, i, e.defaultPrevented)
                        }, !1 !== l(a, h) && i.head.appendChild(h)
                    }

                    function d(d, e, g) {
                        var h, i;
                        if (e && e.trim && (h = e), i = (h ? g : e) || {}, h) {
                            if (h in f) throw "LoadJS";
                            f[h] = !0
                        }! function(a, b, d) {
                            var e, f, g = (a = a.push ? a : [a]).length,
                                h = g,
                                i = [];
                            for (e = function(a, c, d) {
                                    if ("e" == c && i.push(a), "b" == c) {
                                        if (!d) return;
                                        i.push(a)
                                    }--g || b(i)
                                }, f = 0; f < h; f++) c(a[f], e, d)
                        }(d, function(c) {
                            b(i, c), a(h, c)
                        }, i)
                    }
                    var e = function() {},
                        f = {},
                        g = {},
                        h = {};
                    return d.ready = function(a, c) {
                        return function(a, b) {
                            a = a.push ? a : [a];
                            var c, d, e, f = [],
                                i = a.length,
                                j = i;
                            for (c = function(a, c) {
                                    c.length && f.push(a), --j || b(f)
                                }; i--;) d = a[i], (e = g[d]) ? c(d, e) : (h[d] = h[d] || []).push(c)
                        }(a, function(a) {
                            b(c, a)
                        }), d
                    }, d.done = function(b) {
                        a(b, [])
                    }, d.reset = function() {
                        f = {}, g = {}, h = {}
                    }, d.isDefined = function(a) {
                        return a in f
                    }, d
                }, a.exports = c()
            }),
            pg = {
                setup: function() {
                    var a = this;
                    q(this.elements.wrapper, this.config.classNames.embed, !0), pg.setAspectRatio.call(this), Qf.object(window.Vimeo) ? pg.ready.call(this) : M(this.config.urls.vimeo.sdk).then(function() {
                        pg.ready.call(a)
                    }).catch(function(b) {
                        a.debug.warn("Vimeo API failed to load", b)
                    })
                },
                setAspectRatio: function(a) {
                    var b = (Qf.string(a) ? a : this.config.ratio).split(":"),
                        c = Vf(b, 2),
                        d = 100 / c[0] * c[1];
                    if (this.elements.wrapper.style.paddingBottom = d + "%", this.supported.ui) {
                        var e = (240 - d) / 4.8;
                        this.media.style.transform = "translateY(-" + e + "%)"
                    }
                },
                ready: function() {
                    var a = this,
                        b = this,
                        c = I({
                            loop: b.config.loop.active,
                            autoplay: b.autoplay,
                            byline: !1,
                            portrait: !1,
                            title: !1,
                            speed: !0,
                            transparent: 0,
                            gesture: "media",
                            playsinline: !this.config.fullscreen.iosNative
                        }),
                        d = b.media.getAttribute("src");
                    Qf.empty(d) && (d = b.media.getAttribute(b.config.attributes.embed.id));
                    var e, f = (e = d, Qf.empty(e) ? null : Qf.number(Number(e)) ? e : e.match(/^.*(vimeo.com\/|video\/)(\d+).*/) ? RegExp.$2 : e),
                        h = j("iframe"),
                        i = y(b.config.urls.vimeo.iframe, f, c);
                    h.setAttribute("src", i), h.setAttribute("allowfullscreen", ""), h.setAttribute("allowtransparency", ""), h.setAttribute("allow", "autoplay");
                    var k = j("div", {
                        poster: b.poster,
                        class: b.config.classNames.embedContainer
                    });
                    k.appendChild(h), b.media = n(k, b.media), E(y(b.config.urls.vimeo.api, f), "json").then(function(a) {
                        if (!Qf.empty(a)) {
                            var c = new URL(a[0].thumbnail_large);
                            c.pathname = c.pathname.split("_")[0] + ".jpg", mg.setPoster.call(b, c.href).catch(function() {})
                        }
                    }), b.embed = new window.Vimeo.Player(h, {
                        autopause: b.config.autopause,
                        muted: b.muted
                    }), b.media.paused = !0, b.media.currentTime = 0, b.supported.ui && b.embed.disableTextTrack(), b.media.play = function() {
                        return N.call(b, !0), b.embed.play()
                    }, b.media.pause = function() {
                        return N.call(b, !1), b.embed.pause()
                    }, b.media.stop = function() {
                        b.pause(), b.currentTime = 0
                    };
                    var l = b.media.currentTime;
                    Object.defineProperty(b.media, "currentTime", {
                        get: function() {
                            return l
                        },
                        set: function(a) {
                            var c = b.embed,
                                d = b.media,
                                e = b.paused,
                                f = b.volume,
                                h = e && !c.hasPlayed;
                            d.seeking = !0, g.call(b, d, "seeking"), Promise.resolve(h && c.setVolume(0)).then(function() {
                                return c.setCurrentTime(a)
                            }).then(function() {
                                return h && c.pause()
                            }).then(function() {
                                return h && c.setVolume(f)
                            }).catch(function() {})
                        }
                    });
                    var m = b.config.speed.selected;
                    Object.defineProperty(b.media, "playbackRate", {
                        get: function() {
                            return m
                        },
                        set: function(a) {
                            b.embed.setPlaybackRate(a).then(function() {
                                m = a, g.call(b, b.media, "ratechange")
                            }).catch(function(a) {
                                "Error" === a.name && eg.setSpeedMenu.call(b, [])
                            })
                        }
                    });
                    var o = b.config.volume;
                    Object.defineProperty(b.media, "volume", {
                        get: function() {
                            return o
                        },
                        set: function(a) {
                            b.embed.setVolume(a).then(function() {
                                o = a, g.call(b, b.media, "volumechange")
                            })
                        }
                    });
                    var p = b.config.muted;
                    Object.defineProperty(b.media, "muted", {
                        get: function() {
                            return p
                        },
                        set: function(a) {
                            var c = !!Qf.boolean(a) && a;
                            b.embed.setVolume(c ? 0 : b.config.volume).then(function() {
                                p = c, g.call(b, b.media, "volumechange")
                            })
                        }
                    });
                    var q = b.config.loop;
                    Object.defineProperty(b.media, "loop", {
                        get: function() {
                            return q
                        },
                        set: function(a) {
                            var c = Qf.boolean(a) ? a : b.config.loop.active;
                            b.embed.setLoop(c).then(function() {
                                q = c
                            })
                        }
                    });
                    var r = void 0;
                    b.embed.getVideoUrl().then(function(a) {
                        r = a
                    }).catch(function(b) {
                        a.debug.warn(b)
                    }), Object.defineProperty(b.media, "currentSrc", {
                        get: function() {
                            return r
                        }
                    }), Object.defineProperty(b.media, "ended", {
                        get: function() {
                            return b.currentTime === b.duration
                        }
                    }), Promise.all([b.embed.getVideoWidth(), b.embed.getVideoHeight()]).then(function(b) {
                        var c = function(a, b) {
                            var c = function a(b, c) {
                                return 0 === c ? b : a(c, b % c)
                            }(a, b);
                            return a / c + ":" + b / c
                        }(b[0], b[1]);
                        pg.setAspectRatio.call(a, c)
                    }), b.embed.setAutopause(b.config.autopause).then(function(a) {
                        b.config.autopause = a
                    }), b.embed.getVideoTitle().then(function(c) {
                        b.config.title = c, mg.setTitle.call(a)
                    }), b.embed.getCurrentTime().then(function(a) {
                        l = a, g.call(b, b.media, "timeupdate")
                    }), b.embed.getDuration().then(function(a) {
                        b.media.duration = a, g.call(b, b.media, "durationchange")
                    }), b.embed.getTextTracks().then(function(a) {
                        b.media.textTracks = a, fg.setup.call(b)
                    }), b.embed.on("cuechange", function(a) {
                        var c = a.cues,
                            d = (void 0 === c ? [] : c).map(function(a) {
                                return b = a.text, c = document.createDocumentFragment(), d = document.createElement("div"), c.appendChild(d), d.innerHTML = b, c.firstChild.innerText;
                                var b, c, d
                            });
                        fg.updateCues.call(b, d)
                    }), b.embed.on("loaded", function() {
                        b.embed.getPaused().then(function(a) {
                            N.call(b, !a), a || g.call(b, b.media, "playing")
                        }), Qf.element(b.embed.element) && b.supported.ui && b.embed.element.setAttribute("tabindex", -1)
                    }), b.embed.on("play", function() {
                        N.call(b, !0), g.call(b, b.media, "playing")
                    }), b.embed.on("pause", function() {
                        N.call(b, !1)
                    }), b.embed.on("timeupdate", function(a) {
                        b.media.seeking = !1, l = a.seconds, g.call(b, b.media, "timeupdate")
                    }), b.embed.on("progress", function(a) {
                        b.media.buffered = a.percent, g.call(b, b.media, "progress"), 1 === parseInt(a.percent, 10) && g.call(b, b.media, "canplaythrough"), b.embed.getDuration().then(function(a) {
                            a !== b.media.duration && (b.media.duration = a, g.call(b, b.media, "durationchange"))
                        })
                    }), b.embed.on("seeked", function() {
                        b.media.seeking = !1, g.call(b, b.media, "seeked")
                    }), b.embed.on("ended", function() {
                        b.media.paused = !0, g.call(b, b.media, "ended")
                    }), b.embed.on("error", function(a) {
                        b.media.error = a, g.call(b, b.media, "error")
                    }), setTimeout(function() {
                        return mg.build.call(b)
                    }, 0)
                }
            },
            qg = {
                setup: function() {
                    var a = this;
                    q(this.elements.wrapper, this.config.classNames.embed, !0), qg.setAspectRatio.call(this), Qf.object(window.YT) && Qf.function(window.YT.Player) ? qg.ready.call(this) : (M(this.config.urls.youtube.sdk).catch(function(b) {
                        a.debug.warn("YouTube API failed to load", b)
                    }), window.onYouTubeReadyCallbacks = window.onYouTubeReadyCallbacks || [], window.onYouTubeReadyCallbacks.push(function() {
                        qg.ready.call(a)
                    }), window.onYouTubeIframeAPIReady = function() {
                        window.onYouTubeReadyCallbacks.forEach(function(a) {
                            a()
                        })
                    })
                },
                getTitle: function(a) {
                    var b = this;
                    if (Qf.function(this.embed.getVideoData)) {
                        var c = this.embed.getVideoData().title;
                        if (Qf.empty(c)) return this.config.title = c, void mg.setTitle.call(this)
                    }
                    var d = this.config.keys.google;
                    Qf.string(d) && !Qf.empty(d) && E(y(this.config.urls.youtube.api, a, d)).then(function(a) {
                        Qf.object(a) && (b.config.title = a.items[0].snippet.title, mg.setTitle.call(b))
                    }).catch(function() {})
                },
                setAspectRatio: function() {
                    var a = this.config.ratio.split(":");
                    this.elements.wrapper.style.paddingBottom = 100 / a[0] * a[1] + "%"
                },
                ready: function() {
                    var a = this,
                        b = a.media.getAttribute("id");
                    if (Qf.empty(b) || !b.startsWith("youtube-")) {
                        var c = a.media.getAttribute("src");
                        Qf.empty(c) && (c = a.media.getAttribute(this.config.attributes.embed.id));
                        var d, e = (d = c, Qf.empty(d) ? null : d.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/) ? RegExp.$2 : d),
                            f = a.provider + "-" + Math.floor(1e4 * Math.random()),
                            h = j("div", {
                                id: f,
                                poster: a.poster
                            });
                        a.media = n(h, a.media);
                        var i = function(a) {
                            return "https://img.youtube.com/vi/" + e + "/" + a + "default.jpg"
                        };
                        L(i("maxres"), 121).catch(function() {
                            return L(i("sd"), 121)
                        }).catch(function() {
                            return L(i("hq"))
                        }).then(function(b) {
                            return mg.setPoster.call(a, b.src)
                        }).then(function(b) {
                            b.includes("maxres") || (a.elements.poster.style.backgroundSize = "cover")
                        }).catch(function() {}), a.embed = new window.YT.Player(f, {
                            videoId: e,
                            playerVars: {
                                autoplay: a.config.autoplay ? 1 : 0,
                                controls: a.supported.ui ? 0 : 1,
                                rel: 0,
                                showinfo: 0,
                                iv_load_policy: 3,
                                modestbranding: 1,
                                disablekb: 1,
                                playsinline: 1,
                                widget_referrer: window ? window.location.href : null,
                                cc_load_policy: a.captions.active ? 1 : 0,
                                cc_lang_pref: a.config.captions.language
                            },
                            events: {
                                onError: function(b) {
                                    if (!a.media.error) {
                                        var c = b.data,
                                            d = {
                                                2: "The request contains an invalid parameter value. For example, this error occurs if you specify a video ID that does not have 11 characters, or if the video ID contains invalid characters, such as exclamation points or asterisks.",
                                                5: "The requested content cannot be played in an HTML5 player or another error related to the HTML5 player has occurred.",
                                                100: "The video requested was not found. This error occurs when a video has been removed (for any reason) or has been marked as private.",
                                                101: "The owner of the requested video does not allow it to be played in embedded players.",
                                                150: "The owner of the requested video does not allow it to be played in embedded players."
                                            } [c] || "An unknown error occured";
                                        a.media.error = {
                                            code: c,
                                            message: d
                                        }, g.call(a, a.media, "error")
                                    }
                                },
                                onPlaybackQualityChange: function() {
                                    g.call(a, a.media, "qualitychange", !1, {
                                        quality: a.media.quality
                                    })
                                },
                                onPlaybackRateChange: function(b) {
                                    var c = b.target;
                                    a.media.playbackRate = c.getPlaybackRate(), g.call(a, a.media, "ratechange")
                                },
                                onReady: function(b) {
                                    var c = b.target;
                                    qg.getTitle.call(a, e), a.media.play = function() {
                                        P.call(a, !0), c.playVideo()
                                    }, a.media.pause = function() {
                                        P.call(a, !1), c.pauseVideo()
                                    }, a.media.stop = function() {
                                        c.stopVideo()
                                    }, a.media.duration = c.getDuration(), a.media.paused = !0, a.media.currentTime = 0, Object.defineProperty(a.media, "currentTime", {
                                        get: function() {
                                            return Number(c.getCurrentTime())
                                        },
                                        set: function(b) {
                                            a.paused && !a.embed.hasPlayed && a.embed.mute(), a.media.seeking = !0, g.call(a, a.media, "seeking"), c.seekTo(b)
                                        }
                                    }), Object.defineProperty(a.media, "playbackRate", {
                                        get: function() {
                                            return c.getPlaybackRate()
                                        },
                                        set: function(a) {
                                            c.setPlaybackRate(a)
                                        }
                                    }), Object.defineProperty(a.media, "quality", {
                                        get: function() {
                                            return O(c.getPlaybackQuality())
                                        },
                                        set: function(a) {
                                            c.setPlaybackQuality(O(a))
                                        }
                                    });
                                    var d = a.config.volume;
                                    Object.defineProperty(a.media, "volume", {
                                        get: function() {
                                            return d
                                        },
                                        set: function(b) {
                                            d = b, c.setVolume(100 * d), g.call(a, a.media, "volumechange")
                                        }
                                    });
                                    var f = a.config.muted;
                                    Object.defineProperty(a.media, "muted", {
                                        get: function() {
                                            return f
                                        },
                                        set: function(b) {
                                            var d = Qf.boolean(b) ? b : f;
                                            f = d, c[d ? "mute" : "unMute"](), g.call(a, a.media, "volumechange")
                                        }
                                    }), Object.defineProperty(a.media, "currentSrc", {
                                        get: function() {
                                            return c.getVideoUrl()
                                        }
                                    }), Object.defineProperty(a.media, "ended", {
                                        get: function() {
                                            return a.currentTime === a.duration
                                        }
                                    }), a.options.speed = c.getAvailablePlaybackRates(), a.supported.ui && a.media.setAttribute("tabindex", -1), g.call(a, a.media, "timeupdate"), g.call(a, a.media, "durationchange"), clearInterval(a.timers.buffering), a.timers.buffering = setInterval(function() {
                                        a.media.buffered = c.getVideoLoadedFraction(), (null === a.media.lastBuffered || a.media.lastBuffered < a.media.buffered) && g.call(a, a.media, "progress"), a.media.lastBuffered = a.media.buffered, 1 === a.media.buffered && (clearInterval(a.timers.buffering), g.call(a, a.media, "canplaythrough"))
                                    }, 200), setTimeout(function() {
                                        return mg.build.call(a)
                                    }, 50)
                                },
                                onStateChange: function(b) {
                                    var c, d = b.target;
                                    switch (clearInterval(a.timers.playing), a.media.seeking && [1, 2].includes(b.data) && (a.media.seeking = !1, g.call(a, a.media, "seeked")), b.data) {
                                        case -1:
                                            g.call(a, a.media, "timeupdate"), a.media.buffered = d.getVideoLoadedFraction(), g.call(a, a.media, "progress");
                                            break;
                                        case 0:
                                            P.call(a, !1), a.media.loop ? (d.stopVideo(), d.playVideo()) : g.call(a, a.media, "ended");
                                            break;
                                        case 1:
                                            a.media.paused && !a.embed.hasPlayed ? a.media.pause() : (P.call(a, !0), g.call(a, a.media, "playing"), a.timers.playing = setInterval(function() {
                                                g.call(a, a.media, "timeupdate")
                                            }, 50), a.media.duration !== d.getDuration() && (a.media.duration = d.getDuration(), g.call(a, a.media, "durationchange")), eg.setQualityMenu.call(a, (c = d.getAvailableQualityLevels(), Qf.empty(c) ? c : D(c.map(function(a) {
                                                return O(a)
                                            })))));
                                            break;
                                        case 2:
                                            a.muted || a.embed.unMute(), P.call(a, !1)
                                    }
                                    g.call(a, a.elements.container, "statechange", !1, {
                                        code: b.data
                                    })
                                }
                            }
                        })
                    }
                }
            },
            rg = {
                setup: function() {
                    this.media ? (q(this.elements.container, this.config.classNames.type.replace("{0}", this.type), !0), q(this.elements.container, this.config.classNames.provider.replace("{0}", this.provider), !0), this.isEmbed && q(this.elements.container, this.config.classNames.type.replace("{0}", "video"), !0), this.isVideo && (this.elements.wrapper = j("div", {
                        class: this.config.classNames.video
                    }), h(this.media, this.elements.wrapper), this.elements.poster = j("div", {
                        class: this.config.classNames.poster
                    }), this.elements.wrapper.appendChild(this.elements.poster)), this.isHTML5 ? $f.extend.call(this) : this.isYouTube ? qg.setup.call(this) : this.isVimeo && pg.setup.call(this)) : this.debug.warn("No media element found!")
                }
            },
            sg = function() {
                function a(b) {
                    var c = this;
                    Sf(this, a), this.player = b, this.publisherId = b.config.ads.publisherId, this.playing = !1, this.initialized = !1, this.elements = {
                        container: null,
                        displayContainer: null
                    }, this.manager = null, this.loader = null, this.cuePoints = null, this.events = {}, this.safetyTimer = null, this.countdownTimer = null, this.managerPromise = new Promise(function(a, b) {
                        c.on("loaded", a), c.on("error", b)
                    }), this.load()
                }
                return Tf(a, [{
                    key: "load",
                    value: function() {
                        var a = this;
                        this.enabled && (Qf.object(window.google) && Qf.object(window.google.ima) ? this.ready() : M(this.player.config.urls.googleIMA.sdk).then(function() {
                            a.ready()
                        }).catch(function() {
                            a.trigger("error", new Error("Google IMA SDK failed to load"))
                        }))
                    }
                }, {
                    key: "ready",
                    value: function() {
                        var a = this;
                        this.startSafetyTimer(12e3, "ready()"), this.managerPromise.then(function() {
                            a.clearSafetyTimer("onAdsManagerLoaded()")
                        }), this.listeners(), this.setupIMA()
                    }
                }, {
                    key: "setupIMA",
                    value: function() {
                        this.elements.container = j("div", {
                            class: this.player.config.classNames.ads
                        }), this.player.elements.container.appendChild(this.elements.container), google.ima.settings.setVpaidMode(google.ima.ImaSdkSettings.VpaidMode.ENABLED), google.ima.settings.setLocale(this.player.config.ads.language), this.elements.displayContainer = new google.ima.AdDisplayContainer(this.elements.container), this.requestAds()
                    }
                }, {
                    key: "requestAds",
                    value: function() {
                        var a = this,
                            b = this.player.elements.container;
                        try {
                            this.loader = new google.ima.AdsLoader(this.elements.displayContainer), this.loader.addEventListener(google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, function(b) {
                                return a.onAdsManagerLoaded(b)
                            }, !1), this.loader.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, function(b) {
                                return a.onAdError(b)
                            }, !1);
                            var c = new google.ima.AdsRequest;
                            c.adTagUrl = this.tagUrl, c.linearAdSlotWidth = b.offsetWidth, c.linearAdSlotHeight = b.offsetHeight, c.nonLinearAdSlotWidth = b.offsetWidth, c.nonLinearAdSlotHeight = b.offsetHeight, c.forceNonLinearFullSlot = !1, c.setAdWillPlayMuted(!this.player.muted), this.loader.requestAds(c)
                        } catch (a) {
                            this.onAdError(a)
                        }
                    }
                }, {
                    key: "pollCountdown",
                    value: function() {
                        var a = this;
                        if (!(arguments.length > 0 && void 0 !== arguments[0] && arguments[0])) return clearInterval(this.countdownTimer), void this.elements.container.removeAttribute("data-badge-text");
                        this.countdownTimer = setInterval(function() {
                            var b = G(Math.max(a.manager.getRemainingTime(), 0)),
                                c = _f("advertisement", a.player.config) + " - " + b;
                            a.elements.container.setAttribute("data-badge-text", c)
                        }, 100)
                    }
                }, {
                    key: "onAdsManagerLoaded",
                    value: function(a) {
                        var b = this,
                            c = new google.ima.AdsRenderingSettings;
                        c.restoreCustomPlaybackStateOnAdBreakComplete = !0, c.enablePreloading = !0, this.manager = a.getAdsManager(this.player, c), this.cuePoints = this.manager.getCuePoints(), Qf.empty(this.cuePoints) || this.cuePoints.forEach(function(a) {
                            if (0 !== a && -1 !== a && a < b.player.duration) {
                                var c = b.player.elements.progress;
                                if (Qf.element(c)) {
                                    var d = 100 / b.player.duration * a,
                                        e = j("span", {
                                            class: b.player.config.classNames.cues
                                        });
                                    e.style.left = d.toString() + "%", c.appendChild(e)
                                }
                            }
                        }), this.manager.setVolume(this.player.volume), this.manager.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, function(a) {
                            return b.onAdError(a)
                        }), Object.keys(google.ima.AdEvent.Type).forEach(function(a) {
                            b.manager.addEventListener(google.ima.AdEvent.Type[a], function(a) {
                                return b.onAdEvent(a)
                            })
                        }), this.trigger("loaded")
                    }
                }, {
                    key: "onAdEvent",
                    value: function(a) {
                        var b = this,
                            c = this.player.elements.container,
                            d = a.getAd(),
                            e = function(a) {
                                var c = "ads" + a.replace(/_/g, "").toLowerCase();
                                g.call(b.player, b.player.media, c)
                            };
                        switch (a.type) {
                            case google.ima.AdEvent.Type.LOADED:
                                this.trigger("loaded"), e(a.type), this.pollCountdown(!0), d.isLinear() || (d.width = c.offsetWidth, d.height = c.offsetHeight);
                                break;
                            case google.ima.AdEvent.Type.ALL_ADS_COMPLETED:
                                e(a.type), this.loadAds();
                                break;
                            case google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED:
                                e(a.type), this.pauseContent();
                                break;
                            case google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED:
                                e(a.type), this.pollCountdown(), this.resumeContent();
                                break;
                            case google.ima.AdEvent.Type.STARTED:
                            case google.ima.AdEvent.Type.MIDPOINT:
                            case google.ima.AdEvent.Type.COMPLETE:
                            case google.ima.AdEvent.Type.IMPRESSION:
                            case google.ima.AdEvent.Type.CLICK:
                                e(a.type)
                        }
                    }
                }, {
                    key: "onAdError",
                    value: function(a) {
                        this.cancel(), this.player.debug.warn("Ads error", a)
                    }
                }, {
                    key: "listeners",
                    value: function() {
                        var a = this,
                            b = this.player.elements.container,
                            c = void 0;
                        this.player.on("ended", function() {
                            a.loader.contentComplete()
                        }), this.player.on("seeking", function() {
                            return c = a.player.currentTime
                        }), this.player.on("seeked", function() {
                            var b = a.player.currentTime;
                            Qf.empty(a.cuePoints) || a.cuePoints.forEach(function(d, e) {
                                c < d && d < b && (a.manager.discardAdBreak(), a.cuePoints.splice(e, 1))
                            })
                        }), window.addEventListener("resize", function() {
                            a.manager && a.manager.resize(b.offsetWidth, b.offsetHeight, google.ima.ViewMode.NORMAL)
                        })
                    }
                }, {
                    key: "play",
                    value: function() {
                        var a = this,
                            b = this.player.elements.container;
                        this.managerPromise || this.resumeContent(), this.managerPromise.then(function() {
                            a.elements.displayContainer.initialize();
                            try {
                                a.initialized || (a.manager.init(b.offsetWidth, b.offsetHeight, google.ima.ViewMode.NORMAL), a.manager.start()), a.initialized = !0
                            } catch (b) {
                                a.onAdError(b)
                            }
                        }).catch(function() {})
                    }
                }, {
                    key: "resumeContent",
                    value: function() {
                        this.elements.container.style.zIndex = "", this.playing = !1, this.player.currentTime < this.player.duration && this.player.play()
                    }
                }, {
                    key: "pauseContent",
                    value: function() {
                        this.elements.container.style.zIndex = 3, this.playing = !0, this.player.pause()
                    }
                }, {
                    key: "cancel",
                    value: function() {
                        this.initialized && this.resumeContent(), this.trigger("error"), this.loadAds()
                    }
                }, {
                    key: "loadAds",
                    value: function() {
                        var a = this;
                        this.managerPromise.then(function() {
                            a.manager && a.manager.destroy(), a.managerPromise = new Promise(function(b) {
                                a.on("loaded", b), a.player.debug.log(a.manager)
                            }), a.requestAds()
                        }).catch(function() {})
                    }
                }, {
                    key: "trigger",
                    value: function(a) {
                        for (var b = this, c = arguments.length, d = Array(c > 1 ? c - 1 : 0), e = 1; e < c; e++) d[e - 1] = arguments[e];
                        var f = this.events[a];
                        Qf.array(f) && f.forEach(function(a) {
                            Qf.function(a) && a.apply(b, d)
                        })
                    }
                }, {
                    key: "on",
                    value: function(a, b) {
                        return Qf.array(this.events[a]) || (this.events[a] = []), this.events[a].push(b), this
                    }
                }, {
                    key: "startSafetyTimer",
                    value: function(a, b) {
                        var c = this;
                        this.player.debug.log("Safety timer invoked from: " + b), this.safetyTimer = setTimeout(function() {
                            c.cancel(), c.clearSafetyTimer("startSafetyTimer()")
                        }, a)
                    }
                }, {
                    key: "clearSafetyTimer",
                    value: function(a) {
                        Qf.nullOrUndefined(this.safetyTimer) || (this.player.debug.log("Safety timer cleared from: " + a), clearTimeout(this.safetyTimer), this.safetyTimer = null)
                    }
                }, {
                    key: "enabled",
                    get: function() {
                        return this.player.isHTML5 && this.player.isVideo && this.player.config.ads.enabled && !Qf.empty(this.publisherId)
                    }
                }, {
                    key: "tagUrl",
                    get: function() {
                        return "https://go.aniview.com/api/adserver6/vast/?" + I({
                            AV_PUBLISHERID: "58c25bb0073ef448b1087ad6",
                            AV_CHANNELID: "5a0458dc28a06145e4519d21",
                            AV_URL: window.location.hostname,
                            cb: Date.now(),
                            AV_WIDTH: 640,
                            AV_HEIGHT: 480,
                            AV_CDIM2: this.publisherId
                        })
                    }
                }]), a
            }(),
            tg = {
                insertElements: function(a, b) {
                    var c = this;
                    Qf.string(b) ? k(a, this.media, {
                        src: b
                    }) : Qf.array(b) && b.forEach(function(b) {
                        k(a, c.media, b)
                    })
                },
                change: function(a) {
                    var b = this;
                    w(a, "sources.length") ? ($f.cancelRequests.call(this), this.destroy.call(this, function() {
                        b.options.quality = [], l(b.media), b.media = null, Qf.element(b.elements.container) && b.elements.container.removeAttribute("class");
                        var c = a.sources,
                            d = a.type,
                            e = Vf(c, 1)[0],
                            f = e.provider,
                            g = void 0 === f ? hg.html5 : f,
                            h = e.src,
                            i = "html5" === g ? d : "div",
                            k = "html5" === g ? {} : {
                                src: h
                            };
                        Object.assign(b, {
                            provider: g,
                            type: d,
                            supported: Zf.check(d, g, b.config.playsinline),
                            media: j(i, k)
                        }), b.elements.container.appendChild(b.media), Qf.boolean(a.autoplay) && (b.config.autoplay = a.autoplay), b.isHTML5 && (b.config.crossorigin && b.media.setAttribute("crossorigin", ""), b.config.autoplay && b.media.setAttribute("autoplay", ""), Qf.empty(a.poster) || (b.poster = a.poster), b.config.loop.active && b.media.setAttribute("loop", ""), b.config.muted && b.media.setAttribute("muted", ""), b.config.playsinline && b.media.setAttribute("playsinline", "")), mg.addStyleHook.call(b), b.isHTML5 && tg.insertElements.call(b, "source", c), b.config.title = a.title, rg.setup.call(b), b.isHTML5 && ("tracks" in a && tg.insertElements.call(b, "track", a.tracks), b.media.load()), (b.isHTML5 || b.isEmbed && !b.supported.ui) && mg.build.call(b), b.fullscreen.update()
                    }, !0)) : this.debug.warn("Invalid source format")
                }
            },
            ug = function() {
                function a(b, c) {
                    var e = this;
                    if (Sf(this, a), this.timers = {}, this.ready = !1, this.loading = !1, this.failed = !1, this.touch = Zf.touch, this.media = b, Qf.string(this.media) && (this.media = document.querySelectorAll(this.media)), (window.jQuery && this.media instanceof jQuery || Qf.nodeList(this.media) || Qf.array(this.media)) && (this.media = this.media[0]), this.config = x({}, gg, a.defaults, c || {}, function() {
                            try {
                                return JSON.parse(e.media.getAttribute("data-plyr-config"))
                            } catch (a) {
                                return {}
                            }
                        }()), this.elements = {
                            container: null,
                            buttons: {},
                            display: {},
                            progress: {},
                            inputs: {},
                            settings: {
                                menu: null,
                                panes: {},
                                tabs: {}
                            },
                            captions: null
                        }, this.captions = {
                            active: null,
                            currentTrack: -1,
                            meta: new WeakMap
                        }, this.fullscreen = {
                            active: !1
                        }, this.options = {
                            speed: [],
                            quality: []
                        }, this.debug = new kg(this.config.debug), this.debug.log("Config", this.config), this.debug.log("Support", Zf), !Qf.nullOrUndefined(this.media) && Qf.element(this.media))
                        if (this.media.plyr) this.debug.warn("Target already setup");
                        else if (this.config.enabled)
                        if (Zf.check().api) {
                            var f = this.media.cloneNode(!0);
                            f.autoplay = !1, this.elements.original = f;
                            var g = this.media.tagName.toLowerCase(),
                                i = null,
                                k = null;
                            switch (g) {
                                case "div":
                                    if (i = this.media.querySelector("iframe"), Qf.element(i)) {
                                        if (k = H(i.getAttribute("src")), this.provider = function(a) {
                                                return /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+$/.test(a) ? hg.youtube : /^https?:\/\/player.vimeo.com\/video\/\d{0,9}(?=\b|\/)/.test(a) ? hg.vimeo : null
                                            }(k.toString()), this.elements.container = this.media, this.media = i, this.elements.container.className = "", k.searchParams.length) {
                                            var l = ["1", "true"];
                                            l.includes(k.searchParams.get("autoplay")) && (this.config.autoplay = !0), l.includes(k.searchParams.get("loop")) && (this.config.loop.active = !0), this.isYouTube ? this.config.playsinline = l.includes(k.searchParams.get("playsinline")) : this.config.playsinline = !0
                                        }
                                    } else this.provider = this.media.getAttribute(this.config.attributes.embed.provider), this.media.removeAttribute(this.config.attributes.embed.provider);
                                    if (Qf.empty(this.provider) || !Object.keys(hg).includes(this.provider)) return void this.debug.error("Setup failed: Invalid provider");
                                    this.type = ig.video;
                                    break;
                                case "video":
                                case "audio":
                                    this.type = g, this.provider = hg.html5, this.media.hasAttribute("crossorigin") && (this.config.crossorigin = !0), this.media.hasAttribute("autoplay") && (this.config.autoplay = !0), this.media.hasAttribute("playsinline") && (this.config.playsinline = !0), this.media.hasAttribute("muted") && (this.config.muted = !0), this.media.hasAttribute("loop") && (this.config.loop.active = !0);
                                    break;
                                default:
                                    return void this.debug.error("Setup failed: unsupported type")
                            }
                            this.supported = Zf.check(this.type, this.provider, this.config.playsinline), this.supported.api ? (this.eventListeners = [], this.listeners = new ng(this), this.storage = new ag(this), this.media.plyr = this, Qf.element(this.elements.container) || (this.elements.container = j("div"), h(this.media, this.elements.container)), mg.addStyleHook.call(this), rg.setup.call(this), this.config.debug && d.call(this, this.elements.container, this.config.events.join(" "), function(a) {
                                e.debug.log("event: " + a.type)
                            }), (this.isHTML5 || this.isEmbed && !this.supported.ui) && mg.build.call(this), this.listeners.container(), this.listeners.global(), this.fullscreen = new lg(this), this.ads = new sg(this), this.config.autoplay && this.play()) : this.debug.error("Setup failed: no support")
                        } else this.debug.error("Setup failed: no support");
                    else this.debug.error("Setup failed: disabled by config");
                    else this.debug.error("Setup failed: no suitable element passed")
                }
                return Tf(a, [{
                    key: "play",
                    value: function() {
                        return Qf.function(this.media.play) ? this.media.play() : null
                    }
                }, {
                    key: "pause",
                    value: function() {
                        this.playing && Qf.function(this.media.pause) && this.media.pause()
                    }
                }, {
                    key: "togglePlay",
                    value: function(a) {
                        (Qf.boolean(a) ? a : !this.playing) ? this.play(): this.pause()
                    }
                }, {
                    key: "stop",
                    value: function() {
                        this.isHTML5 ? (this.pause(), this.restart()) : Qf.function(this.media.stop) && this.media.stop()
                    }
                }, {
                    key: "restart",
                    value: function() {
                        this.currentTime = 0
                    }
                }, {
                    key: "rewind",
                    value: function(a) {
                        this.currentTime = this.currentTime - (Qf.number(a) ? a : this.config.seekTime)
                    }
                }, {
                    key: "forward",
                    value: function(a) {
                        this.currentTime = this.currentTime + (Qf.number(a) ? a : this.config.seekTime)
                    }
                }, {
                    key: "increaseVolume",
                    value: function(a) {
                        var b = this.media.muted ? 0 : this.volume;
                        this.volume = b + (Qf.number(a) ? a : 0)
                    }
                }, {
                    key: "decreaseVolume",
                    value: function(a) {
                        this.increaseVolume(-a)
                    }
                }, {
                    key: "toggleCaptions",
                    value: function(a) {
                        fg.toggle.call(this, a, !1)
                    }
                }, {
                    key: "airplay",
                    value: function() {
                        Zf.airplay && this.media.webkitShowPlaybackTargetPicker()
                    }
                }, {
                    key: "toggleControls",
                    value: function(a) {
                        if (this.supported.ui && !this.isAudio) {
                            var b = r(this.elements.container, this.config.classNames.hideControls),
                                c = void 0 === a ? void 0 : !a,
                                d = q(this.elements.container, this.config.classNames.hideControls, c);
                            if (d && this.config.controls.includes("settings") && !Qf.empty(this.config.settings) && eg.toggleMenu.call(this, !1), d !== b) {
                                var e = d ? "controlshidden" : "controlsshown";
                                g.call(this, this.media, e)
                            }
                            return !d
                        }
                        return !1
                    }
                }, {
                    key: "on",
                    value: function(a, b) {
                        d.call(this, this.elements.container, a, b)
                    }
                }, {
                    key: "once",
                    value: function(a, b) {
                        f.call(this, this.elements.container, a, b)
                    }
                }, {
                    key: "off",
                    value: function(a, b) {
                        e(this.elements.container, a, b)
                    }
                }, {
                    key: "destroy",
                    value: function(a) {
                        var b = this,
                            c = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                        if (this.ready) {
                            var d = function() {
                                document.body.style.overflow = "", b.embed = null, c ? (Object.keys(b.elements).length && (l(b.elements.buttons.play), l(b.elements.captions), l(b.elements.controls), l(b.elements.wrapper), b.elements.buttons.play = null, b.elements.captions = null, b.elements.controls = null, b.elements.wrapper = null), Qf.function(a) && a()) : (function() {
                                    this && this.eventListeners && (this.eventListeners.forEach(function(a) {
                                        var b = a.element,
                                            c = a.type,
                                            d = a.callback,
                                            e = a.options;
                                        b.removeEventListener(c, d, e)
                                    }), this.eventListeners = [])
                                }.call(b), n(b.elements.original, b.elements.container), g.call(b, b.elements.original, "destroyed", !0), Qf.function(a) && a.call(b.elements.original), b.ready = !1, setTimeout(function() {
                                    b.elements = null, b.media = null
                                }, 200))
                            };
                            this.stop(), this.isHTML5 ? (clearTimeout(this.timers.loading), mg.toggleNativeControls.call(this, !0), d()) : this.isYouTube ? (clearInterval(this.timers.buffering), clearInterval(this.timers.playing), null !== this.embed && Qf.function(this.embed.destroy) && this.embed.destroy(), d()) : this.isVimeo && (null !== this.embed && this.embed.unload().then(d), setTimeout(d, 200))
                        }
                    }
                }, {
                    key: "supports",
                    value: function(a) {
                        return Zf.mime.call(this, a)
                    }
                }, {
                    key: "isHTML5",
                    get: function() {
                        return Boolean(this.provider === hg.html5)
                    }
                }, {
                    key: "isEmbed",
                    get: function() {
                        return Boolean(this.isYouTube || this.isVimeo)
                    }
                }, {
                    key: "isYouTube",
                    get: function() {
                        return Boolean(this.provider === hg.youtube)
                    }
                }, {
                    key: "isVimeo",
                    get: function() {
                        return Boolean(this.provider === hg.vimeo)
                    }
                }, {
                    key: "isVideo",
                    get: function() {
                        return Boolean(this.type === ig.video)
                    }
                }, {
                    key: "isAudio",
                    get: function() {
                        return Boolean(this.type === ig.audio)
                    }
                }, {
                    key: "playing",
                    get: function() {
                        return Boolean(this.ready && !this.paused && !this.ended)
                    }
                }, {
                    key: "paused",
                    get: function() {
                        return Boolean(this.media.paused)
                    }
                }, {
                    key: "stopped",
                    get: function() {
                        return Boolean(this.paused && 0 === this.currentTime)
                    }
                }, {
                    key: "ended",
                    get: function() {
                        return Boolean(this.media.ended)
                    }
                }, {
                    key: "currentTime",
                    set: function(a) {
                        if (this.duration) {
                            var b = Qf.number(a) && a > 0;
                            this.media.currentTime = b ? Math.min(a, this.duration) : 0, this.debug.log("Seeking to " + this.currentTime + " seconds")
                        }
                    },
                    get: function() {
                        return Number(this.media.currentTime)
                    }
                }, {
                    key: "buffered",
                    get: function() {
                        var a = this.media.buffered;
                        return Qf.number(a) ? a : a && a.length && this.duration > 0 ? a.end(0) / this.duration : 0
                    }
                }, {
                    key: "seeking",
                    get: function() {
                        return Boolean(this.media.seeking)
                    }
                }, {
                    key: "duration",
                    get: function() {
                        var a = parseFloat(this.config.duration),
                            b = (this.media || {}).duration,
                            c = Qf.number(b) && b !== 1 / 0 ? b : 0;
                        return a || c
                    }
                }, {
                    key: "volume",
                    set: function(a) {
                        var b = a;
                        Qf.string(b) && (b = Number(b)), Qf.number(b) || (b = this.storage.get("volume")), Qf.number(b) || (b = this.config.volume), b > 1 && (b = 1), b < 0 && (b = 0), this.config.volume = b, this.media.volume = b, !Qf.empty(a) && this.muted && b > 0 && (this.muted = !1)
                    },
                    get: function() {
                        return Number(this.media.volume)
                    }
                }, {
                    key: "muted",
                    set: function(a) {
                        var b = a;
                        Qf.boolean(b) || (b = this.storage.get("muted")), Qf.boolean(b) || (b = this.config.muted), this.config.muted = b, this.media.muted = b
                    },
                    get: function() {
                        return Boolean(this.media.muted)
                    }
                }, {
                    key: "hasAudio",
                    get: function() {
                        return !this.isHTML5 || !!this.isAudio || Boolean(this.media.mozHasAudio) || Boolean(this.media.webkitAudioDecodedByteCount) || Boolean(this.media.audioTracks && this.media.audioTracks.length)
                    }
                }, {
                    key: "speed",
                    set: function(a) {
                        var b = null;
                        Qf.number(a) && (b = a), Qf.number(b) || (b = this.storage.get("speed")), Qf.number(b) || (b = this.config.speed.selected), b < .1 && (b = .1), b > 2 && (b = 2), this.config.speed.options.includes(b) ? (this.config.speed.selected = b, this.media.playbackRate = b) : this.debug.warn("Unsupported speed (" + b + ")")
                    },
                    get: function() {
                        return Number(this.media.playbackRate)
                    }
                }, {
                    key: "quality",
                    set: function(a) {
                        var b = this.config.quality,
                            c = this.options.quality;
                        if (c.length) {
                            var d = [!Qf.empty(a) && Number(a), this.storage.get("quality"), b.selected, b.default].find(Qf.number);
                            if (!c.includes(d)) {
                                var e = function(a, b) {
                                    return Qf.array(a) && a.length ? a.reduce(function(a, c) {
                                        return Math.abs(c - b) < Math.abs(a - b) ? c : a
                                    }) : null
                                }(c, d);
                                this.debug.warn("Unsupported quality option: " + d + ", using " + e + " instead"), d = e
                            }
                            g.call(this, this.media, "qualityrequested", !1, {
                                quality: d
                            }), b.selected = d, this.media.quality = d
                        }
                    },
                    get: function() {
                        return this.media.quality
                    }
                }, {
                    key: "loop",
                    set: function(a) {
                        var b = Qf.boolean(a) ? a : this.config.loop.active;
                        this.config.loop.active = b, this.media.loop = b
                    },
                    get: function() {
                        return Boolean(this.media.loop)
                    }
                }, {
                    key: "source",
                    set: function(a) {
                        tg.change.call(this, a)
                    },
                    get: function() {
                        return this.media.currentSrc
                    }
                }, {
                    key: "poster",
                    set: function(a) {
                        this.isVideo ? mg.setPoster.call(this, a, !1).catch(function() {}) : this.debug.warn("Poster can only be set for video")
                    },
                    get: function() {
                        return this.isVideo ? this.media.getAttribute("poster") : null
                    }
                }, {
                    key: "autoplay",
                    set: function(a) {
                        var b = Qf.boolean(a) ? a : this.config.autoplay;
                        this.config.autoplay = b
                    },
                    get: function() {
                        return Boolean(this.config.autoplay)
                    }
                }, {
                    key: "currentTrack",
                    set: function(a) {
                        fg.set.call(this, a, !1)
                    },
                    get: function() {
                        var a = this.captions,
                            b = a.toggled,
                            c = a.currentTrack;
                        return b ? c : -1
                    }
                }, {
                    key: "language",
                    set: function(a) {
                        fg.setLanguage.call(this, a, !1)
                    },
                    get: function() {
                        return (fg.getCurrentTrack.call(this) || {}).language
                    }
                }, {
                    key: "pip",
                    set: function(a) {
                        var b = "inline";
                        if (Zf.pip) {
                            var c = Qf.boolean(a) ? a : this.pip === b;
                            this.media.webkitSetPresentationMode(c ? "picture-in-picture" : b)
                        }
                    },
                    get: function() {
                        return Zf.pip ? this.media.webkitPresentationMode : null
                    }
                }], [{
                    key: "supported",
                    value: function(a, b, c) {
                        return Zf.check(a, b, c)
                    }
                }, {
                    key: "loadSprite",
                    value: function(a, b) {
                        return F(a, b)
                    }
                }, {
                    key: "setup",
                    value: function(b) {
                        var c = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                            d = null;
                        return Qf.string(b) ? d = Array.from(document.querySelectorAll(b)) : Qf.nodeList(b) ? d = Array.from(b) : Qf.array(b) && (d = b.filter(Qf.element)), Qf.empty(d) ? null : d.map(function(b) {
                            return new a(b, c)
                        })
                    }
                }]), a
            }();
        return ug.defaults = (Hf = gg, JSON.parse(JSON.stringify(Hf))), ug
    }),
    function(a, b) {
        "object" == typeof exports && "undefined" != typeof module ? module.exports = b() : "function" == typeof define && define.amd ? define(b) : a.moment = b()
    }(this, function() {
        "use strict";

        function a() {
            return od.apply(null, arguments)
        }

        function b(a) {
            od = a
        }

        function c(a) {
            return a instanceof Array || "[object Array]" === Object.prototype.toString.call(a)
        }

        function d(a) {
            return null != a && "[object Object]" === Object.prototype.toString.call(a)
        }

        function e(a) {
            var b;
            for (b in a) return !1;
            return !0
        }

        function f(a) {
            return "number" == typeof a || "[object Number]" === Object.prototype.toString.call(a)
        }

        function g(a) {
            return a instanceof Date || "[object Date]" === Object.prototype.toString.call(a)
        }

        function h(a, b) {
            var c, d = [];
            for (c = 0; c < a.length; ++c) d.push(b(a[c], c));
            return d
        }

        function i(a, b) {
            return Object.prototype.hasOwnProperty.call(a, b)
        }

        function j(a, b) {
            for (var c in b) i(b, c) && (a[c] = b[c]);
            return i(b, "toString") && (a.toString = b.toString), i(b, "valueOf") && (a.valueOf = b.valueOf), a
        }

        function k(a, b, c, d) {
            return rb(a, b, c, d, !0).utc()
        }

        function l() {
            return {
                empty: !1,
                unusedTokens: [],
                unusedInput: [],
                overflow: -2,
                charsLeftOver: 0,
                nullInput: !1,
                invalidMonth: null,
                invalidFormat: !1,
                userInvalidated: !1,
                iso: !1,
                parsedDateParts: [],
                meridiem: null
            }
        }

        function m(a) {
            return null == a._pf && (a._pf = l()), a._pf
        }

        function n(a) {
            if (null == a._isValid) {
                var b = m(a),
                    c = qd.call(b.parsedDateParts, function(a) {
                        return null != a
                    }),
                    d = !isNaN(a._d.getTime()) && b.overflow < 0 && !b.empty && !b.invalidMonth && !b.invalidWeekday && !b.nullInput && !b.invalidFormat && !b.userInvalidated && (!b.meridiem || b.meridiem && c);
                if (a._strict && (d = d && 0 === b.charsLeftOver && 0 === b.unusedTokens.length && void 0 === b.bigHour), null != Object.isFrozen && Object.isFrozen(a)) return d;
                a._isValid = d
            }
            return a._isValid
        }

        function o(a) {
            var b = k(NaN);
            return null != a ? j(m(b), a) : m(b).userInvalidated = !0, b
        }

        function p(a) {
            return void 0 === a
        }

        function q(a, b) {
            var c, d, e;
            if (p(b._isAMomentObject) || (a._isAMomentObject = b._isAMomentObject), p(b._i) || (a._i = b._i), p(b._f) || (a._f = b._f), p(b._l) || (a._l = b._l), p(b._strict) || (a._strict = b._strict), p(b._tzm) || (a._tzm = b._tzm), p(b._isUTC) || (a._isUTC = b._isUTC), p(b._offset) || (a._offset = b._offset), p(b._pf) || (a._pf = m(b)), p(b._locale) || (a._locale = b._locale), rd.length > 0)
                for (c in rd) d = rd[c], e = b[d], p(e) || (a[d] = e);
            return a
        }

        function r(b) {
            q(this, b), this._d = new Date(null != b._d ? b._d.getTime() : NaN), this.isValid() || (this._d = new Date(NaN)), !1 === sd && (sd = !0, a.updateOffset(this), sd = !1)
        }

        function s(a) {
            return a instanceof r || null != a && null != a._isAMomentObject
        }

        function t(a) {
            return a < 0 ? Math.ceil(a) || 0 : Math.floor(a)
        }

        function u(a) {
            var b = +a,
                c = 0;
            return 0 !== b && isFinite(b) && (c = t(b)), c
        }

        function v(a, b, c) {
            var d, e = Math.min(a.length, b.length),
                f = Math.abs(a.length - b.length),
                g = 0;
            for (d = 0; d < e; d++)(c && a[d] !== b[d] || !c && u(a[d]) !== u(b[d])) && g++;
            return g + f
        }

        function w(b) {
            !1 === a.suppressDeprecationWarnings && "undefined" != typeof console && console.warn && console.warn("Deprecation warning: " + b)
        }

        function x(b, c) {
            var d = !0;
            return j(function() {
                if (null != a.deprecationHandler && a.deprecationHandler(null, b), d) {
                    for (var e, f = [], g = 0; g < arguments.length; g++) {
                        if (e = "", "object" == typeof arguments[g]) {
                            e += "\n[" + g + "] ";
                            for (var h in arguments[0]) e += h + ": " + arguments[0][h] + ", ";
                            e = e.slice(0, -2)
                        } else e = arguments[g];
                        f.push(e)
                    }
                    w(b + "\nArguments: " + Array.prototype.slice.call(f).join("") + "\n" + (new Error).stack), d = !1
                }
                return c.apply(this, arguments)
            }, c)
        }

        function y(b, c) {
            null != a.deprecationHandler && a.deprecationHandler(b, c), td[b] || (w(c), td[b] = !0)
        }

        function z(a) {
            return a instanceof Function || "[object Function]" === Object.prototype.toString.call(a)
        }

        function A(a) {
            var b, c;
            for (c in a) b = a[c], z(b) ? this[c] = b : this["_" + c] = b;
            this._config = a, this._ordinalParseLenient = new RegExp(this._ordinalParse.source + "|" + /\d{1,2}/.source)
        }

        function B(a, b) {
            var c, e = j({}, a);
            for (c in b) i(b, c) && (d(a[c]) && d(b[c]) ? (e[c] = {}, j(e[c], a[c]), j(e[c], b[c])) : null != b[c] ? e[c] = b[c] : delete e[c]);
            for (c in a) i(a, c) && !i(b, c) && d(a[c]) && (e[c] = j({}, e[c]));
            return e
        }

        function C(a) {
            null != a && this.set(a)
        }

        function D(a, b, c) {
            var d = this._calendar[a] || this._calendar.sameElse;
            return z(d) ? d.call(b, c) : d
        }

        function E(a) {
            var b = this._longDateFormat[a],
                c = this._longDateFormat[a.toUpperCase()];
            return b || !c ? b : (this._longDateFormat[a] = c.replace(/MMMM|MM|DD|dddd/g, function(a) {
                return a.slice(1)
            }), this._longDateFormat[a])
        }

        function F() {
            return this._invalidDate
        }

        function G(a) {
            return this._ordinal.replace("%d", a)
        }

        function H(a, b, c, d) {
            var e = this._relativeTime[c];
            return z(e) ? e(a, b, c, d) : e.replace(/%d/i, a)
        }

        function I(a, b) {
            var c = this._relativeTime[a > 0 ? "future" : "past"];
            return z(c) ? c(b) : c.replace(/%s/i, b)
        }

        function J(a, b) {
            var c = a.toLowerCase();
            Dd[c] = Dd[c + "s"] = Dd[b] = a
        }

        function K(a) {
            return "string" == typeof a ? Dd[a] || Dd[a.toLowerCase()] : void 0
        }

        function L(a) {
            var b, c, d = {};
            for (c in a) i(a, c) && (b = K(c)) && (d[b] = a[c]);
            return d
        }

        function M(a, b) {
            Ed[a] = b
        }

        function N(a) {
            var b = [];
            for (var c in a) b.push({
                unit: c,
                priority: Ed[c]
            });
            return b.sort(function(a, b) {
                return a.priority - b.priority
            }), b
        }

        function O(b, c) {
            return function(d) {
                return null != d ? (Q(this, b, d), a.updateOffset(this, c), this) : P(this, b)
            }
        }

        function P(a, b) {
            return a.isValid() ? a._d["get" + (a._isUTC ? "UTC" : "") + b]() : NaN
        }

        function Q(a, b, c) {
            a.isValid() && a._d["set" + (a._isUTC ? "UTC" : "") + b](c)
        }

        function R(a) {
            return a = K(a), z(this[a]) ? this[a]() : this
        }

        function S(a, b) {
            if ("object" == typeof a) {
                a = L(a);
                for (var c = N(a), d = 0; d < c.length; d++) this[c[d].unit](a[c[d].unit])
            } else if (a = K(a), z(this[a])) return this[a](b);
            return this
        }

        function T(a, b, c) {
            var d = "" + Math.abs(a),
                e = b - d.length;
            return (a >= 0 ? c ? "+" : "" : "-") + Math.pow(10, Math.max(0, e)).toString().substr(1) + d
        }

        function U(a, b, c, d) {
            var e = d;
            "string" == typeof d && (e = function() {
                return this[d]()
            }), a && (Id[a] = e), b && (Id[b[0]] = function() {
                return T(e.apply(this, arguments), b[1], b[2])
            }), c && (Id[c] = function() {
                return this.localeData().ordinal(e.apply(this, arguments), a)
            })
        }

        function V(a) {
            return a.match(/\[[\s\S]/) ? a.replace(/^\[|\]$/g, "") : a.replace(/\\/g, "")
        }

        function W(a) {
            var b, c, d = a.match(Fd);
            for (b = 0, c = d.length; b < c; b++) Id[d[b]] ? d[b] = Id[d[b]] : d[b] = V(d[b]);
            return function(b) {
                var e, f = "";
                for (e = 0; e < c; e++) f += d[e] instanceof Function ? d[e].call(b, a) : d[e];
                return f
            }
        }

        function X(a, b) {
            return a.isValid() ? (b = Y(b, a.localeData()), Hd[b] = Hd[b] || W(b), Hd[b](a)) : a.localeData().invalidDate()
        }

        function Y(a, b) {
            function c(a) {
                return b.longDateFormat(a) || a
            }
            var d = 5;
            for (Gd.lastIndex = 0; d >= 0 && Gd.test(a);) a = a.replace(Gd, c), Gd.lastIndex = 0, d -= 1;
            return a
        }

        function Z(a, b, c) {
            $d[a] = z(b) ? b : function(a, d) {
                return a && c ? c : b
            }
        }

        function $(a, b) {
            return i($d, a) ? $d[a](b._strict, b._locale) : new RegExp(_(a))
        }

        function _(a) {
            return aa(a.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(a, b, c, d, e) {
                return b || c || d || e
            }))
        }

        function aa(a) {
            return a.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&")
        }

        function ba(a, b) {
            var c, d = b;
            for ("string" == typeof a && (a = [a]), f(b) && (d = function(a, c) {
                    c[b] = u(a)
                }), c = 0; c < a.length; c++) _d[a[c]] = d
        }

        function ca(a, b) {
            ba(a, function(a, c, d, e) {
                d._w = d._w || {}, b(a, d._w, d, e)
            })
        }

        function da(a, b, c) {
            null != b && i(_d, a) && _d[a](b, c._a, c, a)
        }

        function ea(a, b) {
            return new Date(Date.UTC(a, b + 1, 0)).getUTCDate()
        }

        function fa(a, b) {
            return a ? c(this._months) ? this._months[a.month()] : this._months[(this._months.isFormat || ke).test(b) ? "format" : "standalone"][a.month()] : this._months
        }

        function ga(a, b) {
            return a ? c(this._monthsShort) ? this._monthsShort[a.month()] : this._monthsShort[ke.test(b) ? "format" : "standalone"][a.month()] : this._monthsShort
        }

        function ha(a, b, c) {
            var d, e, f, g = a.toLocaleLowerCase();
            if (!this._monthsParse)
                for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], d = 0; d < 12; ++d) f = k([2e3, d]), this._shortMonthsParse[d] = this.monthsShort(f, "").toLocaleLowerCase(), this._longMonthsParse[d] = this.months(f, "").toLocaleLowerCase();
            return c ? "MMM" === b ? (e = je.call(this._shortMonthsParse, g), -1 !== e ? e : null) : (e = je.call(this._longMonthsParse, g), -1 !== e ? e : null) : "MMM" === b ? (e = je.call(this._shortMonthsParse, g), -1 !== e ? e : (e = je.call(this._longMonthsParse, g), -1 !== e ? e : null)) : (e = je.call(this._longMonthsParse, g), -1 !== e ? e : (e = je.call(this._shortMonthsParse, g), -1 !== e ? e : null))
        }

        function ia(a, b, c) {
            var d, e, f;
            if (this._monthsParseExact) return ha.call(this, a, b, c);
            for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), d = 0; d < 12; d++) {
                if (e = k([2e3, d]), c && !this._longMonthsParse[d] && (this._longMonthsParse[d] = new RegExp("^" + this.months(e, "").replace(".", "") + "$", "i"), this._shortMonthsParse[d] = new RegExp("^" + this.monthsShort(e, "").replace(".", "") + "$", "i")), c || this._monthsParse[d] || (f = "^" + this.months(e, "") + "|^" + this.monthsShort(e, ""), this._monthsParse[d] = new RegExp(f.replace(".", ""), "i")), c && "MMMM" === b && this._longMonthsParse[d].test(a)) return d;
                if (c && "MMM" === b && this._shortMonthsParse[d].test(a)) return d;
                if (!c && this._monthsParse[d].test(a)) return d
            }
        }

        function ja(a, b) {
            var c;
            if (!a.isValid()) return a;
            if ("string" == typeof b)
                if (/^\d+$/.test(b)) b = u(b);
                else if (b = a.localeData().monthsParse(b), !f(b)) return a;
            return c = Math.min(a.date(), ea(a.year(), b)), a._d["set" + (a._isUTC ? "UTC" : "") + "Month"](b, c), a
        }

        function ka(b) {
            return null != b ? (ja(this, b), a.updateOffset(this, !0), this) : P(this, "Month")
        }

        function la() {
            return ea(this.year(), this.month())
        }

        function ma(a) {
            return this._monthsParseExact ? (i(this, "_monthsRegex") || oa.call(this), a ? this._monthsShortStrictRegex : this._monthsShortRegex) : (i(this, "_monthsShortRegex") || (this._monthsShortRegex = ne), this._monthsShortStrictRegex && a ? this._monthsShortStrictRegex : this._monthsShortRegex)
        }

        function na(a) {
            return this._monthsParseExact ? (i(this, "_monthsRegex") || oa.call(this), a ? this._monthsStrictRegex : this._monthsRegex) : (i(this, "_monthsRegex") || (this._monthsRegex = oe), this._monthsStrictRegex && a ? this._monthsStrictRegex : this._monthsRegex)
        }

        function oa() {
            function a(a, b) {
                return b.length - a.length
            }
            var b, c, d = [],
                e = [],
                f = [];
            for (b = 0; b < 12; b++) c = k([2e3, b]), d.push(this.monthsShort(c, "")), e.push(this.months(c, "")), f.push(this.months(c, "")), f.push(this.monthsShort(c, ""));
            for (d.sort(a), e.sort(a), f.sort(a), b = 0; b < 12; b++) d[b] = aa(d[b]), e[b] = aa(e[b]);
            for (b = 0; b < 24; b++) f[b] = aa(f[b]);
            this._monthsRegex = new RegExp("^(" + f.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp("^(" + e.join("|") + ")", "i"), this._monthsShortStrictRegex = new RegExp("^(" + d.join("|") + ")", "i")
        }

        function pa(a) {
            return qa(a) ? 366 : 365
        }

        function qa(a) {
            return a % 4 == 0 && a % 100 != 0 || a % 400 == 0
        }

        function ra() {
            return qa(this.year())
        }

        function sa(a, b, c, d, e, f, g) {
            var h = new Date(a, b, c, d, e, f, g);
            return a < 100 && a >= 0 && isFinite(h.getFullYear()) && h.setFullYear(a), h
        }

        function ta(a) {
            var b = new Date(Date.UTC.apply(null, arguments));
            return a < 100 && a >= 0 && isFinite(b.getUTCFullYear()) && b.setUTCFullYear(a), b
        }

        function ua(a, b, c) {
            var d = 7 + b - c;
            return -(7 + ta(a, 0, d).getUTCDay() - b) % 7 + d - 1
        }

        function va(a, b, c, d, e) {
            var f, g, h = (7 + c - d) % 7,
                i = ua(a, d, e),
                j = 1 + 7 * (b - 1) + h + i;
            return j <= 0 ? (f = a - 1, g = pa(f) + j) : j > pa(a) ? (f = a + 1, g = j - pa(a)) : (f = a, g = j), {
                year: f,
                dayOfYear: g
            }
        }

        function wa(a, b, c) {
            var d, e, f = ua(a.year(), b, c),
                g = Math.floor((a.dayOfYear() - f - 1) / 7) + 1;
            return g < 1 ? (e = a.year() - 1, d = g + xa(e, b, c)) : g > xa(a.year(), b, c) ? (d = g - xa(a.year(), b, c), e = a.year() + 1) : (e = a.year(), d = g), {
                week: d,
                year: e
            }
        }

        function xa(a, b, c) {
            var d = ua(a, b, c),
                e = ua(a + 1, b, c);
            return (pa(a) - d + e) / 7
        }

        function ya(a) {
            return wa(a, this._week.dow, this._week.doy).week
        }

        function za() {
            return this._week.dow
        }

        function Aa() {
            return this._week.doy
        }

        function Ba(a) {
            var b = this.localeData().week(this);
            return null == a ? b : this.add(7 * (a - b), "d")
        }

        function Ca(a) {
            var b = wa(this, 1, 4).week;
            return null == a ? b : this.add(7 * (a - b), "d")
        }

        function Da(a, b) {
            return "string" != typeof a ? a : isNaN(a) ? (a = b.weekdaysParse(a), "number" == typeof a ? a : null) : parseInt(a, 10)
        }

        function Ea(a, b) {
            return "string" == typeof a ? b.weekdaysParse(a) % 7 || 7 : isNaN(a) ? null : a
        }

        function Fa(a, b) {
            return a ? c(this._weekdays) ? this._weekdays[a.day()] : this._weekdays[this._weekdays.isFormat.test(b) ? "format" : "standalone"][a.day()] : this._weekdays
        }

        function Ga(a) {
            return a ? this._weekdaysShort[a.day()] : this._weekdaysShort
        }

        function Ha(a) {
            return a ? this._weekdaysMin[a.day()] : this._weekdaysMin
        }

        function Ia(a, b, c) {
            var d, e, f, g = a.toLocaleLowerCase();
            if (!this._weekdaysParse)
                for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], d = 0; d < 7; ++d) f = k([2e3, 1]).day(d), this._minWeekdaysParse[d] = this.weekdaysMin(f, "").toLocaleLowerCase(), this._shortWeekdaysParse[d] = this.weekdaysShort(f, "").toLocaleLowerCase(), this._weekdaysParse[d] = this.weekdays(f, "").toLocaleLowerCase();
            return c ? "dddd" === b ? (e = je.call(this._weekdaysParse, g), -1 !== e ? e : null) : "ddd" === b ? (e = je.call(this._shortWeekdaysParse, g), -1 !== e ? e : null) : (e = je.call(this._minWeekdaysParse, g), -1 !== e ? e : null) : "dddd" === b ? (e = je.call(this._weekdaysParse, g), -1 !== e ? e : (e = je.call(this._shortWeekdaysParse, g), -1 !== e ? e : (e = je.call(this._minWeekdaysParse, g), -1 !== e ? e : null))) : "ddd" === b ? (e = je.call(this._shortWeekdaysParse, g), -1 !== e ? e : (e = je.call(this._weekdaysParse, g), -1 !== e ? e : (e = je.call(this._minWeekdaysParse, g), -1 !== e ? e : null))) : (e = je.call(this._minWeekdaysParse, g), -1 !== e ? e : (e = je.call(this._weekdaysParse, g), -1 !== e ? e : (e = je.call(this._shortWeekdaysParse, g), -1 !== e ? e : null)))
        }

        function Ja(a, b, c) {
            var d, e, f;
            if (this._weekdaysParseExact) return Ia.call(this, a, b, c);
            for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), d = 0; d < 7; d++) {
                if (e = k([2e3, 1]).day(d), c && !this._fullWeekdaysParse[d] && (this._fullWeekdaysParse[d] = new RegExp("^" + this.weekdays(e, "").replace(".", ".?") + "$", "i"), this._shortWeekdaysParse[d] = new RegExp("^" + this.weekdaysShort(e, "").replace(".", ".?") + "$", "i"), this._minWeekdaysParse[d] = new RegExp("^" + this.weekdaysMin(e, "").replace(".", ".?") + "$", "i")), this._weekdaysParse[d] || (f = "^" + this.weekdays(e, "") + "|^" + this.weekdaysShort(e, "") + "|^" + this.weekdaysMin(e, ""), this._weekdaysParse[d] = new RegExp(f.replace(".", ""), "i")), c && "dddd" === b && this._fullWeekdaysParse[d].test(a)) return d;
                if (c && "ddd" === b && this._shortWeekdaysParse[d].test(a)) return d;
                if (c && "dd" === b && this._minWeekdaysParse[d].test(a)) return d;
                if (!c && this._weekdaysParse[d].test(a)) return d
            }
        }

        function Ka(a) {
            if (!this.isValid()) return null != a ? this : NaN;
            var b = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
            return null != a ? (a = Da(a, this.localeData()), this.add(a - b, "d")) : b
        }

        function La(a) {
            if (!this.isValid()) return null != a ? this : NaN;
            var b = (this.day() + 7 - this.localeData()._week.dow) % 7;
            return null == a ? b : this.add(a - b, "d")
        }

        function Ma(a) {
            if (!this.isValid()) return null != a ? this : NaN;
            if (null != a) {
                var b = Ea(a, this.localeData());
                return this.day(this.day() % 7 ? b : b - 7)
            }
            return this.day() || 7
        }

        function Na(a) {
            return this._weekdaysParseExact ? (i(this, "_weekdaysRegex") || Qa.call(this), a ? this._weekdaysStrictRegex : this._weekdaysRegex) : (i(this, "_weekdaysRegex") || (this._weekdaysRegex = ue), this._weekdaysStrictRegex && a ? this._weekdaysStrictRegex : this._weekdaysRegex)
        }

        function Oa(a) {
            return this._weekdaysParseExact ? (i(this, "_weekdaysRegex") || Qa.call(this), a ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (i(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = ve), this._weekdaysShortStrictRegex && a ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex)
        }

        function Pa(a) {
            return this._weekdaysParseExact ? (i(this, "_weekdaysRegex") || Qa.call(this), a ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (i(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = we), this._weekdaysMinStrictRegex && a ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex)
        }

        function Qa() {
            function a(a, b) {
                return b.length - a.length
            }
            var b, c, d, e, f, g = [],
                h = [],
                i = [],
                j = [];
            for (b = 0; b < 7; b++) c = k([2e3, 1]).day(b), d = this.weekdaysMin(c, ""), e = this.weekdaysShort(c, ""), f = this.weekdays(c, ""), g.push(d), h.push(e), i.push(f), j.push(d), j.push(e), j.push(f);
            for (g.sort(a), h.sort(a), i.sort(a), j.sort(a), b = 0; b < 7; b++) h[b] = aa(h[b]), i[b] = aa(i[b]), j[b] = aa(j[b]);
            this._weekdaysRegex = new RegExp("^(" + j.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp("^(" + i.join("|") + ")", "i"), this._weekdaysShortStrictRegex = new RegExp("^(" + h.join("|") + ")", "i"), this._weekdaysMinStrictRegex = new RegExp("^(" + g.join("|") + ")", "i")
        }

        function Ra() {
            return this.hours() % 12 || 12
        }

        function Sa() {
            return this.hours() || 24
        }

        function Ta(a, b) {
            U(a, 0, 0, function() {
                return this.localeData().meridiem(this.hours(), this.minutes(), b)
            })
        }

        function Ua(a, b) {
            return b._meridiemParse
        }

        function Va(a) {
            return "p" === (a + "").toLowerCase().charAt(0)
        }

        function Wa(a, b, c) {
            return a > 11 ? c ? "pm" : "PM" : c ? "am" : "AM"
        }

        function Xa(a) {
            return a ? a.toLowerCase().replace("_", "-") : a
        }

        function Ya(a) {
            for (var b, c, d, e, f = 0; f < a.length;) {
                for (e = Xa(a[f]).split("-"), b = e.length, c = Xa(a[f + 1]), c = c ? c.split("-") : null; b > 0;) {
                    if (d = Za(e.slice(0, b).join("-"))) return d;
                    if (c && c.length >= b && v(e, c, !0) >= b - 1) break;
                    b--
                }
                f++
            }
            return null
        }

        function Za(a) {
            var b = null;
            if (!Be[a] && "undefined" != typeof module && module && module.exports) try {
                b = xe._abbr, require("./locale/" + a), $a(b)
            } catch (a) {}
            return Be[a]
        }

        function $a(a, b) {
            var c;
            return a && (c = p(b) ? bb(a) : _a(a, b)) && (xe = c), xe._abbr
        }

        function _a(a, b) {
            if (null !== b) {
                var c = Ae;
                if (b.abbr = a, null != Be[a]) y("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."), c = Be[a]._config;
                else if (null != b.parentLocale) {
                    if (null == Be[b.parentLocale]) return Ce[b.parentLocale] || (Ce[b.parentLocale] = []), Ce[b.parentLocale].push({
                        name: a,
                        config: b
                    }), null;
                    c = Be[b.parentLocale]._config
                }
                return Be[a] = new C(B(c, b)), Ce[a] && Ce[a].forEach(function(a) {
                    _a(a.name, a.config)
                }), $a(a), Be[a]
            }
            return delete Be[a], null
        }

        function ab(a, b) {
            if (null != b) {
                var c, d = Ae;
                null != Be[a] && (d = Be[a]._config), b = B(d, b), c = new C(b), c.parentLocale = Be[a], Be[a] = c, $a(a)
            } else null != Be[a] && (null != Be[a].parentLocale ? Be[a] = Be[a].parentLocale : null != Be[a] && delete Be[a]);
            return Be[a]
        }

        function bb(a) {
            var b;
            if (a && a._locale && a._locale._abbr && (a = a._locale._abbr), !a) return xe;
            if (!c(a)) {
                if (b = Za(a)) return b;
                a = [a]
            }
            return Ya(a)
        }

        function cb() {
            return wd(Be)
        }

        function db(a) {
            var b, c = a._a;
            return c && -2 === m(a).overflow && (b = c[be] < 0 || c[be] > 11 ? be : c[ce] < 1 || c[ce] > ea(c[ae], c[be]) ? ce : c[de] < 0 || c[de] > 24 || 24 === c[de] && (0 !== c[ee] || 0 !== c[fe] || 0 !== c[ge]) ? de : c[ee] < 0 || c[ee] > 59 ? ee : c[fe] < 0 || c[fe] > 59 ? fe : c[ge] < 0 || c[ge] > 999 ? ge : -1, m(a)._overflowDayOfYear && (b < ae || b > ce) && (b = ce), m(a)._overflowWeeks && -1 === b && (b = he), m(a)._overflowWeekday && -1 === b && (b = ie), m(a).overflow = b), a
        }

        function eb(a) {
            var b, c, d, e, f, g, h = a._i,
                i = De.exec(h) || Ee.exec(h);
            if (i) {
                for (m(a).iso = !0, b = 0, c = Ge.length; b < c; b++)
                    if (Ge[b][1].exec(i[1])) {
                        e = Ge[b][0], d = !1 !== Ge[b][2];
                        break
                    } if (null == e) return void(a._isValid = !1);
                if (i[3]) {
                    for (b = 0, c = He.length; b < c; b++)
                        if (He[b][1].exec(i[3])) {
                            f = (i[2] || " ") + He[b][0];
                            break
                        } if (null == f) return void(a._isValid = !1)
                }
                if (!d && null != f) return void(a._isValid = !1);
                if (i[4]) {
                    if (!Fe.exec(i[4])) return void(a._isValid = !1);
                    g = "Z"
                }
                a._f = e + (f || "") + (g || ""), kb(a)
            } else a._isValid = !1
        }

        function fb(b) {
            var c = Ie.exec(b._i);
            return null !== c ? void(b._d = new Date(+c[1])) : (eb(b), void(!1 === b._isValid && (delete b._isValid, a.createFromInputFallback(b))))
        }

        function gb(a, b, c) {
            return null != a ? a : null != b ? b : c
        }

        function hb(b) {
            var c = new Date(a.now());
            return b._useUTC ? [c.getUTCFullYear(), c.getUTCMonth(), c.getUTCDate()] : [c.getFullYear(), c.getMonth(), c.getDate()]
        }

        function ib(a) {
            var b, c, d, e, f = [];
            if (!a._d) {
                for (d = hb(a), a._w && null == a._a[ce] && null == a._a[be] && jb(a), a._dayOfYear && (e = gb(a._a[ae], d[ae]), a._dayOfYear > pa(e) && (m(a)._overflowDayOfYear = !0), c = ta(e, 0, a._dayOfYear), a._a[be] = c.getUTCMonth(), a._a[ce] = c.getUTCDate()), b = 0; b < 3 && null == a._a[b]; ++b) a._a[b] = f[b] = d[b];
                for (; b < 7; b++) a._a[b] = f[b] = null == a._a[b] ? 2 === b ? 1 : 0 : a._a[b];
                24 === a._a[de] && 0 === a._a[ee] && 0 === a._a[fe] && 0 === a._a[ge] && (a._nextDay = !0, a._a[de] = 0), a._d = (a._useUTC ? ta : sa).apply(null, f), null != a._tzm && a._d.setUTCMinutes(a._d.getUTCMinutes() - a._tzm), a._nextDay && (a._a[de] = 24)
            }
        }

        function jb(a) {
            var b, c, d, e, f, g, h, i;
            if (b = a._w, null != b.GG || null != b.W || null != b.E) f = 1, g = 4, c = gb(b.GG, a._a[ae], wa(sb(), 1, 4).year), d = gb(b.W, 1), ((e = gb(b.E, 1)) < 1 || e > 7) && (i = !0);
            else {
                f = a._locale._week.dow, g = a._locale._week.doy;
                var j = wa(sb(), f, g);
                c = gb(b.gg, a._a[ae], j.year), d = gb(b.w, j.week), null != b.d ? ((e = b.d) < 0 || e > 6) && (i = !0) : null != b.e ? (e = b.e + f, (b.e < 0 || b.e > 6) && (i = !0)) : e = f
            }
            d < 1 || d > xa(c, f, g) ? m(a)._overflowWeeks = !0 : null != i ? m(a)._overflowWeekday = !0 : (h = va(c, d, e, f, g), a._a[ae] = h.year, a._dayOfYear = h.dayOfYear)
        }

        function kb(b) {
            if (b._f === a.ISO_8601) return void eb(b);
            b._a = [], m(b).empty = !0;
            var c, d, e, f, g, h = "" + b._i,
                i = h.length,
                j = 0;
            for (e = Y(b._f, b._locale).match(Fd) || [], c = 0; c < e.length; c++) f = e[c], d = (h.match($(f, b)) || [])[0], d && (g = h.substr(0, h.indexOf(d)), g.length > 0 && m(b).unusedInput.push(g), h = h.slice(h.indexOf(d) + d.length), j += d.length), Id[f] ? (d ? m(b).empty = !1 : m(b).unusedTokens.push(f), da(f, d, b)) : b._strict && !d && m(b).unusedTokens.push(f);
            m(b).charsLeftOver = i - j, h.length > 0 && m(b).unusedInput.push(h), b._a[de] <= 12 && !0 === m(b).bigHour && b._a[de] > 0 && (m(b).bigHour = void 0), m(b).parsedDateParts = b._a.slice(0), m(b).meridiem = b._meridiem, b._a[de] = lb(b._locale, b._a[de], b._meridiem), ib(b), db(b)
        }

        function lb(a, b, c) {
            var d;
            return null == c ? b : null != a.meridiemHour ? a.meridiemHour(b, c) : null != a.isPM ? (d = a.isPM(c), d && b < 12 && (b += 12), d || 12 !== b || (b = 0), b) : b
        }

        function mb(a) {
            var b, c, d, e, f;
            if (0 === a._f.length) return m(a).invalidFormat = !0, void(a._d = new Date(NaN));
            for (e = 0; e < a._f.length; e++) f = 0, b = q({}, a), null != a._useUTC && (b._useUTC = a._useUTC), b._f = a._f[e], kb(b), n(b) && (f += m(b).charsLeftOver, f += 10 * m(b).unusedTokens.length, m(b).score = f, (null == d || f < d) && (d = f, c = b));
            j(a, c || b)
        }

        function nb(a) {
            if (!a._d) {
                var b = L(a._i);
                a._a = h([b.year, b.month, b.day || b.date, b.hour, b.minute, b.second, b.millisecond], function(a) {
                    return a && parseInt(a, 10)
                }), ib(a)
            }
        }

        function ob(a) {
            var b = new r(db(pb(a)));
            return b._nextDay && (b.add(1, "d"), b._nextDay = void 0), b
        }

        function pb(a) {
            var b = a._i,
                d = a._f;
            return a._locale = a._locale || bb(a._l), null === b || void 0 === d && "" === b ? o({
                nullInput: !0
            }) : ("string" == typeof b && (a._i = b = a._locale.preparse(b)), s(b) ? new r(db(b)) : (g(b) ? a._d = b : c(d) ? mb(a) : d ? kb(a) : qb(a), n(a) || (a._d = null), a))
        }

        function qb(b) {
            var d = b._i;
            void 0 === d ? b._d = new Date(a.now()) : g(d) ? b._d = new Date(d.valueOf()) : "string" == typeof d ? fb(b) : c(d) ? (b._a = h(d.slice(0), function(a) {
                return parseInt(a, 10)
            }), ib(b)) : "object" == typeof d ? nb(b) : f(d) ? b._d = new Date(d) : a.createFromInputFallback(b)
        }

        function rb(a, b, f, g, h) {
            var i = {};
            return !0 !== f && !1 !== f || (g = f, f = void 0), (d(a) && e(a) || c(a) && 0 === a.length) && (a = void 0), i._isAMomentObject = !0, i._useUTC = i._isUTC = h, i._l = f, i._i = a, i._f = b, i._strict = g, ob(i)
        }

        function sb(a, b, c, d) {
            return rb(a, b, c, d, !1)
        }

        function tb(a, b) {
            var d, e;
            if (1 === b.length && c(b[0]) && (b = b[0]), !b.length) return sb();
            for (d = b[0], e = 1; e < b.length; ++e) b[e].isValid() && !b[e][a](d) || (d = b[e]);
            return d
        }

        function ub() {
            return tb("isBefore", [].slice.call(arguments, 0))
        }

        function vb() {
            return tb("isAfter", [].slice.call(arguments, 0))
        }

        function wb(a) {
            var b = L(a),
                c = b.year || 0,
                d = b.quarter || 0,
                e = b.month || 0,
                f = b.week || 0,
                g = b.day || 0,
                h = b.hour || 0,
                i = b.minute || 0,
                j = b.second || 0,
                k = b.millisecond || 0;
            this._milliseconds = +k + 1e3 * j + 6e4 * i + 1e3 * h * 60 * 60, this._days = +g + 7 * f, this._months = +e + 3 * d + 12 * c, this._data = {}, this._locale = bb(), this._bubble()
        }

        function xb(a) {
            return a instanceof wb
        }

        function yb(a) {
            return a < 0 ? -1 * Math.round(-1 * a) : Math.round(a)
        }

        function zb(a, b) {
            U(a, 0, 0, function() {
                var a = this.utcOffset(),
                    c = "+";
                return a < 0 && (a = -a, c = "-"), c + T(~~(a / 60), 2) + b + T(~~a % 60, 2)
            })
        }

        function Ab(a, b) {
            var c = (b || "").match(a);
            if (null === c) return null;
            var d = c[c.length - 1] || [],
                e = (d + "").match(Me) || ["-", 0, 0],
                f = 60 * e[1] + u(e[2]);
            return 0 === f ? 0 : "+" === e[0] ? f : -f
        }

        function Bb(b, c) {
            var d, e;
            return c._isUTC ? (d = c.clone(), e = (s(b) || g(b) ? b.valueOf() : sb(b).valueOf()) - d.valueOf(), d._d.setTime(d._d.valueOf() + e), a.updateOffset(d, !1), d) : sb(b).local()
        }

        function Cb(a) {
            return 15 * -Math.round(a._d.getTimezoneOffset() / 15)
        }

        function Db(b, c) {
            var d, e = this._offset || 0;
            if (!this.isValid()) return null != b ? this : NaN;
            if (null != b) {
                if ("string" == typeof b) {
                    if (null === (b = Ab(Xd, b))) return this
                } else Math.abs(b) < 16 && (b *= 60);
                return !this._isUTC && c && (d = Cb(this)), this._offset = b, this._isUTC = !0, null != d && this.add(d, "m"), e !== b && (!c || this._changeInProgress ? Tb(this, Ob(b - e, "m"), 1, !1) : this._changeInProgress || (this._changeInProgress = !0, a.updateOffset(this, !0), this._changeInProgress = null)), this
            }
            return this._isUTC ? e : Cb(this)
        }

        function Eb(a, b) {
            return null != a ? ("string" != typeof a && (a = -a), this.utcOffset(a, b), this) : -this.utcOffset()
        }

        function Fb(a) {
            return this.utcOffset(0, a)
        }

        function Gb(a) {
            return this._isUTC && (this.utcOffset(0, a), this._isUTC = !1, a && this.subtract(Cb(this), "m")), this
        }

        function Hb() {
            if (null != this._tzm) this.utcOffset(this._tzm);
            else if ("string" == typeof this._i) {
                var a = Ab(Wd, this._i);
                null != a ? this.utcOffset(a) : this.utcOffset(0, !0)
            }
            return this
        }

        function Ib(a) {
            return !!this.isValid() && (a = a ? sb(a).utcOffset() : 0, (this.utcOffset() - a) % 60 == 0)
        }

        function Jb() {
            return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset()
        }

        function Kb() {
            if (!p(this._isDSTShifted)) return this._isDSTShifted;
            var a = {};
            if (q(a, this), a = pb(a), a._a) {
                var b = a._isUTC ? k(a._a) : sb(a._a);
                this._isDSTShifted = this.isValid() && v(a._a, b.toArray()) > 0
            } else this._isDSTShifted = !1;
            return this._isDSTShifted
        }

        function Lb() {
            return !!this.isValid() && !this._isUTC
        }

        function Mb() {
            return !!this.isValid() && this._isUTC
        }

        function Nb() {
            return !!this.isValid() && this._isUTC && 0 === this._offset
        }

        function Ob(a, b) {
            var c, d, e, g = a,
                h = null;
            return xb(a) ? g = {
                ms: a._milliseconds,
                d: a._days,
                M: a._months
            } : f(a) ? (g = {}, b ? g[b] = a : g.milliseconds = a) : (h = Ne.exec(a)) ? (c = "-" === h[1] ? -1 : 1, g = {
                y: 0,
                d: u(h[ce]) * c,
                h: u(h[de]) * c,
                m: u(h[ee]) * c,
                s: u(h[fe]) * c,
                ms: u(yb(1e3 * h[ge])) * c
            }) : (h = Oe.exec(a)) ? (c = "-" === h[1] ? -1 : 1, g = {
                y: Pb(h[2], c),
                M: Pb(h[3], c),
                w: Pb(h[4], c),
                d: Pb(h[5], c),
                h: Pb(h[6], c),
                m: Pb(h[7], c),
                s: Pb(h[8], c)
            }) : null == g ? g = {} : "object" == typeof g && ("from" in g || "to" in g) && (e = Rb(sb(g.from), sb(g.to)), g = {},
                g.ms = e.milliseconds, g.M = e.months), d = new wb(g), xb(a) && i(a, "_locale") && (d._locale = a._locale), d
        }

        function Pb(a, b) {
            var c = a && parseFloat(a.replace(",", "."));
            return (isNaN(c) ? 0 : c) * b
        }

        function Qb(a, b) {
            var c = {
                milliseconds: 0,
                months: 0
            };
            return c.months = b.month() - a.month() + 12 * (b.year() - a.year()), a.clone().add(c.months, "M").isAfter(b) && --c.months, c.milliseconds = +b - +a.clone().add(c.months, "M"), c
        }

        function Rb(a, b) {
            var c;
            return a.isValid() && b.isValid() ? (b = Bb(b, a), a.isBefore(b) ? c = Qb(a, b) : (c = Qb(b, a), c.milliseconds = -c.milliseconds, c.months = -c.months), c) : {
                milliseconds: 0,
                months: 0
            }
        }

        function Sb(a, b) {
            return function(c, d) {
                var e, f;
                return null === d || isNaN(+d) || (y(b, "moment()." + b + "(period, number) is deprecated. Please use moment()." + b + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."), f = c, c = d, d = f), c = "string" == typeof c ? +c : c, e = Ob(c, d), Tb(this, e, a), this
            }
        }

        function Tb(b, c, d, e) {
            var f = c._milliseconds,
                g = yb(c._days),
                h = yb(c._months);
            b.isValid() && (e = null == e || e, f && b._d.setTime(b._d.valueOf() + f * d), g && Q(b, "Date", P(b, "Date") + g * d), h && ja(b, P(b, "Month") + h * d), e && a.updateOffset(b, g || h))
        }

        function Ub(a, b) {
            var c = a.diff(b, "days", !0);
            return c < -6 ? "sameElse" : c < -1 ? "lastWeek" : c < 0 ? "lastDay" : c < 1 ? "sameDay" : c < 2 ? "nextDay" : c < 7 ? "nextWeek" : "sameElse"
        }

        function Vb(b, c) {
            var d = b || sb(),
                e = Bb(d, this).startOf("day"),
                f = a.calendarFormat(this, e) || "sameElse",
                g = c && (z(c[f]) ? c[f].call(this, d) : c[f]);
            return this.format(g || this.localeData().calendar(f, this, sb(d)))
        }

        function Wb() {
            return new r(this)
        }

        function Xb(a, b) {
            var c = s(a) ? a : sb(a);
            return !(!this.isValid() || !c.isValid()) && (b = K(p(b) ? "millisecond" : b), "millisecond" === b ? this.valueOf() > c.valueOf() : c.valueOf() < this.clone().startOf(b).valueOf())
        }

        function Yb(a, b) {
            var c = s(a) ? a : sb(a);
            return !(!this.isValid() || !c.isValid()) && (b = K(p(b) ? "millisecond" : b), "millisecond" === b ? this.valueOf() < c.valueOf() : this.clone().endOf(b).valueOf() < c.valueOf())
        }

        function Zb(a, b, c, d) {
            return d = d || "()", ("(" === d[0] ? this.isAfter(a, c) : !this.isBefore(a, c)) && (")" === d[1] ? this.isBefore(b, c) : !this.isAfter(b, c))
        }

        function $b(a, b) {
            var c, d = s(a) ? a : sb(a);
            return !(!this.isValid() || !d.isValid()) && (b = K(b || "millisecond"), "millisecond" === b ? this.valueOf() === d.valueOf() : (c = d.valueOf(), this.clone().startOf(b).valueOf() <= c && c <= this.clone().endOf(b).valueOf()))
        }

        function _b(a, b) {
            return this.isSame(a, b) || this.isAfter(a, b)
        }

        function ac(a, b) {
            return this.isSame(a, b) || this.isBefore(a, b)
        }

        function bc(a, b, c) {
            var d, e, f, g;
            return this.isValid() ? (d = Bb(a, this), d.isValid() ? (e = 6e4 * (d.utcOffset() - this.utcOffset()), b = K(b), "year" === b || "month" === b || "quarter" === b ? (g = cc(this, d), "quarter" === b ? g /= 3 : "year" === b && (g /= 12)) : (f = this - d, g = "second" === b ? f / 1e3 : "minute" === b ? f / 6e4 : "hour" === b ? f / 36e5 : "day" === b ? (f - e) / 864e5 : "week" === b ? (f - e) / 6048e5 : f), c ? g : t(g)) : NaN) : NaN
        }

        function cc(a, b) {
            var c, d, e = 12 * (b.year() - a.year()) + (b.month() - a.month()),
                f = a.clone().add(e, "months");
            return b - f < 0 ? (c = a.clone().add(e - 1, "months"), d = (b - f) / (f - c)) : (c = a.clone().add(e + 1, "months"), d = (b - f) / (c - f)), -(e + d) || 0
        }

        function dc() {
            return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ")
        }

        function ec() {
            var a = this.clone().utc();
            return 0 < a.year() && a.year() <= 9999 ? z(Date.prototype.toISOString) ? this.toDate().toISOString() : X(a, "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]") : X(a, "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]")
        }

        function fc() {
            if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
            var a = "moment",
                b = "";
            this.isLocal() || (a = 0 === this.utcOffset() ? "moment.utc" : "moment.parseZone", b = "Z");
            var c = "[" + a + '("]',
                d = 0 < this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY",
                e = b + '[")]';
            return this.format(c + d + "-MM-DD[T]HH:mm:ss.SSS" + e)
        }

        function gc(b) {
            b || (b = this.isUtc() ? a.defaultFormatUtc : a.defaultFormat);
            var c = X(this, b);
            return this.localeData().postformat(c)
        }

        function hc(a, b) {
            return this.isValid() && (s(a) && a.isValid() || sb(a).isValid()) ? Ob({
                to: this,
                from: a
            }).locale(this.locale()).humanize(!b) : this.localeData().invalidDate()
        }

        function ic(a) {
            return this.from(sb(), a)
        }

        function jc(a, b) {
            return this.isValid() && (s(a) && a.isValid() || sb(a).isValid()) ? Ob({
                from: this,
                to: a
            }).locale(this.locale()).humanize(!b) : this.localeData().invalidDate()
        }

        function kc(a) {
            return this.to(sb(), a)
        }

        function lc(a) {
            var b;
            return void 0 === a ? this._locale._abbr : (b = bb(a), null != b && (this._locale = b), this)
        }

        function mc() {
            return this._locale
        }

        function nc(a) {
            switch (a = K(a)) {
                case "year":
                    this.month(0);
                case "quarter":
                case "month":
                    this.date(1);
                case "week":
                case "isoWeek":
                case "day":
                case "date":
                    this.hours(0);
                case "hour":
                    this.minutes(0);
                case "minute":
                    this.seconds(0);
                case "second":
                    this.milliseconds(0)
            }
            return "week" === a && this.weekday(0), "isoWeek" === a && this.isoWeekday(1), "quarter" === a && this.month(3 * Math.floor(this.month() / 3)), this
        }

        function oc(a) {
            return a = K(a), void 0 === a || "millisecond" === a ? this : ("date" === a && (a = "day"), this.startOf(a).add(1, "isoWeek" === a ? "week" : a).subtract(1, "ms"))
        }

        function pc() {
            return this._d.valueOf() - 6e4 * (this._offset || 0)
        }

        function qc() {
            return Math.floor(this.valueOf() / 1e3)
        }

        function rc() {
            return new Date(this.valueOf())
        }

        function sc() {
            var a = this;
            return [a.year(), a.month(), a.date(), a.hour(), a.minute(), a.second(), a.millisecond()]
        }

        function tc() {
            var a = this;
            return {
                years: a.year(),
                months: a.month(),
                date: a.date(),
                hours: a.hours(),
                minutes: a.minutes(),
                seconds: a.seconds(),
                milliseconds: a.milliseconds()
            }
        }

        function uc() {
            return this.isValid() ? this.toISOString() : null
        }

        function vc() {
            return n(this)
        }

        function wc() {
            return j({}, m(this))
        }

        function xc() {
            return m(this).overflow
        }

        function yc() {
            return {
                input: this._i,
                format: this._f,
                locale: this._locale,
                isUTC: this._isUTC,
                strict: this._strict
            }
        }

        function zc(a, b) {
            U(0, [a, a.length], 0, b)
        }

        function Ac(a) {
            return Ec.call(this, a, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy)
        }

        function Bc(a) {
            return Ec.call(this, a, this.isoWeek(), this.isoWeekday(), 1, 4)
        }

        function Cc() {
            return xa(this.year(), 1, 4)
        }

        function Dc() {
            var a = this.localeData()._week;
            return xa(this.year(), a.dow, a.doy)
        }

        function Ec(a, b, c, d, e) {
            var f;
            return null == a ? wa(this, d, e).year : (f = xa(a, d, e), b > f && (b = f), Fc.call(this, a, b, c, d, e))
        }

        function Fc(a, b, c, d, e) {
            var f = va(a, b, c, d, e),
                g = ta(f.year, 0, f.dayOfYear);
            return this.year(g.getUTCFullYear()), this.month(g.getUTCMonth()), this.date(g.getUTCDate()), this
        }

        function Gc(a) {
            return null == a ? Math.ceil((this.month() + 1) / 3) : this.month(3 * (a - 1) + this.month() % 3)
        }

        function Hc(a) {
            var b = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
            return null == a ? b : this.add(a - b, "d")
        }

        function Ic(a, b) {
            b[ge] = u(1e3 * ("0." + a))
        }

        function Jc() {
            return this._isUTC ? "UTC" : ""
        }

        function Kc() {
            return this._isUTC ? "Coordinated Universal Time" : ""
        }

        function Lc(a) {
            return sb(1e3 * a)
        }

        function Mc() {
            return sb.apply(null, arguments).parseZone()
        }

        function Nc(a) {
            return a
        }

        function Oc(a, b, c, d) {
            var e = bb(),
                f = k().set(d, b);
            return e[c](f, a)
        }

        function Pc(a, b, c) {
            if (f(a) && (b = a, a = void 0), a = a || "", null != b) return Oc(a, b, c, "month");
            var d, e = [];
            for (d = 0; d < 12; d++) e[d] = Oc(a, d, c, "month");
            return e
        }

        function Qc(a, b, c, d) {
            "boolean" == typeof a ? (f(b) && (c = b, b = void 0), b = b || "") : (b = a, c = b, a = !1, f(b) && (c = b, b = void 0), b = b || "");
            var e = bb(),
                g = a ? e._week.dow : 0;
            if (null != c) return Oc(b, (c + g) % 7, d, "day");
            var h, i = [];
            for (h = 0; h < 7; h++) i[h] = Oc(b, (h + g) % 7, d, "day");
            return i
        }

        function Rc(a, b) {
            return Pc(a, b, "months")
        }

        function Sc(a, b) {
            return Pc(a, b, "monthsShort")
        }

        function Tc(a, b, c) {
            return Qc(a, b, c, "weekdays")
        }

        function Uc(a, b, c) {
            return Qc(a, b, c, "weekdaysShort")
        }

        function Vc(a, b, c) {
            return Qc(a, b, c, "weekdaysMin")
        }

        function Wc() {
            var a = this._data;
            return this._milliseconds = Ze(this._milliseconds), this._days = Ze(this._days), this._months = Ze(this._months), a.milliseconds = Ze(a.milliseconds), a.seconds = Ze(a.seconds), a.minutes = Ze(a.minutes), a.hours = Ze(a.hours), a.months = Ze(a.months), a.years = Ze(a.years), this
        }

        function Xc(a, b, c, d) {
            var e = Ob(b, c);
            return a._milliseconds += d * e._milliseconds, a._days += d * e._days, a._months += d * e._months, a._bubble()
        }

        function Yc(a, b) {
            return Xc(this, a, b, 1)
        }

        function Zc(a, b) {
            return Xc(this, a, b, -1)
        }

        function $c(a) {
            return a < 0 ? Math.floor(a) : Math.ceil(a)
        }

        function _c() {
            var a, b, c, d, e, f = this._milliseconds,
                g = this._days,
                h = this._months,
                i = this._data;
            return f >= 0 && g >= 0 && h >= 0 || f <= 0 && g <= 0 && h <= 0 || (f += 864e5 * $c(bd(h) + g), g = 0, h = 0), i.milliseconds = f % 1e3, a = t(f / 1e3), i.seconds = a % 60, b = t(a / 60), i.minutes = b % 60, c = t(b / 60), i.hours = c % 24, g += t(c / 24), e = t(ad(g)), h += e, g -= $c(bd(e)), d = t(h / 12), h %= 12, i.days = g, i.months = h, i.years = d, this
        }

        function ad(a) {
            return 4800 * a / 146097
        }

        function bd(a) {
            return 146097 * a / 4800
        }

        function cd(a) {
            var b, c, d = this._milliseconds;
            if ("month" === (a = K(a)) || "year" === a) return b = this._days + d / 864e5, c = this._months + ad(b), "month" === a ? c : c / 12;
            switch (b = this._days + Math.round(bd(this._months)), a) {
                case "week":
                    return b / 7 + d / 6048e5;
                case "day":
                    return b + d / 864e5;
                case "hour":
                    return 24 * b + d / 36e5;
                case "minute":
                    return 1440 * b + d / 6e4;
                case "second":
                    return 86400 * b + d / 1e3;
                case "millisecond":
                    return Math.floor(864e5 * b) + d;
                default:
                    throw new Error("Unknown unit " + a)
            }
        }

        function dd() {
            return this._milliseconds + 864e5 * this._days + this._months % 12 * 2592e6 + 31536e6 * u(this._months / 12)
        }

        function ed(a) {
            return function() {
                return this.as(a)
            }
        }

        function fd(a) {
            return a = K(a), this[a + "s"]()
        }

        function gd(a) {
            return function() {
                return this._data[a]
            }
        }

        function hd() {
            return t(this.days() / 7)
        }

        function id(a, b, c, d, e) {
            return e.relativeTime(b || 1, !!c, a, d)
        }

        function jd(a, b, c) {
            var d = Ob(a).abs(),
                e = of(d.as("s")),
                f = of(d.as("m")),
                g = of(d.as("h")),
                h = of(d.as("d")),
                i = of(d.as("M")),
                j = of(d.as("y")),
                k = e < pf.s && ["s", e] || f <= 1 && ["m"] || f < pf.m && ["mm", f] || g <= 1 && ["h"] || g < pf.h && ["hh", g] || h <= 1 && ["d"] || h < pf.d && ["dd", h] || i <= 1 && ["M"] || i < pf.M && ["MM", i] || j <= 1 && ["y"] || ["yy", j];
            return k[2] = b, k[3] = +a > 0, k[4] = c, id.apply(null, k)
        }

        function kd(a) {
            return void 0 === a ? of : "function" == typeof a && (of = a, !0)
        }

        function ld(a, b) {
            return void 0 !== pf[a] && (void 0 === b ? pf[a] : (pf[a] = b, !0))
        }

        function md(a) {
            var b = this.localeData(),
                c = jd(this, !a, b);
            return a && (c = b.pastFuture(+this, c)), b.postformat(c)
        }

        function nd() {
            var a, b, c, d = qf(this._milliseconds) / 1e3,
                e = qf(this._days),
                f = qf(this._months);
            a = t(d / 60), b = t(a / 60), d %= 60, a %= 60, c = t(f / 12), f %= 12;
            var g = c,
                h = f,
                i = e,
                j = b,
                k = a,
                l = d,
                m = this.asSeconds();
            return m ? (m < 0 ? "-" : "") + "P" + (g ? g + "Y" : "") + (h ? h + "M" : "") + (i ? i + "D" : "") + (j || k || l ? "T" : "") + (j ? j + "H" : "") + (k ? k + "M" : "") + (l ? l + "S" : "") : "P0D"
        }
        var od, pd;
        pd = Array.prototype.some ? Array.prototype.some : function(a) {
            for (var b = Object(this), c = b.length >>> 0, d = 0; d < c; d++)
                if (d in b && a.call(this, b[d], d, b)) return !0;
            return !1
        };
        var qd = pd,
            rd = a.momentProperties = [],
            sd = !1,
            td = {};
        a.suppressDeprecationWarnings = !1, a.deprecationHandler = null;
        var ud;
        ud = Object.keys ? Object.keys : function(a) {
            var b, c = [];
            for (b in a) i(a, b) && c.push(b);
            return c
        };
        var vd, wd = ud,
            xd = {
                sameDay: "[Today at] LT",
                nextDay: "[Tomorrow at] LT",
                nextWeek: "dddd [at] LT",
                lastDay: "[Yesterday at] LT",
                lastWeek: "[Last] dddd [at] LT",
                sameElse: "L"
            },
            yd = {
                LTS: "h:mm:ss A",
                LT: "h:mm A",
                L: "MM/DD/YYYY",
                LL: "MMMM D, YYYY",
                LLL: "MMMM D, YYYY h:mm A",
                LLLL: "dddd, MMMM D, YYYY h:mm A"
            },
            zd = "Invalid date",
            Ad = "%d",
            Bd = /\d{1,2}/,
            Cd = {
                future: "in %s",
                past: "%s ago",
                s: "a few seconds",
                m: "a minute",
                mm: "%d minutes",
                h: "an hour",
                hh: "%d hours",
                d: "a day",
                dd: "%d days",
                M: "a month",
                MM: "%d months",
                y: "a year",
                yy: "%d years"
            },
            Dd = {},
            Ed = {},
            Fd = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
            Gd = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
            Hd = {},
            Id = {},
            Jd = /\d/,
            Kd = /\d\d/,
            Ld = /\d{3}/,
            Md = /\d{4}/,
            Nd = /[+-]?\d{6}/,
            Od = /\d\d?/,
            Pd = /\d\d\d\d?/,
            Qd = /\d\d\d\d\d\d?/,
            Rd = /\d{1,3}/,
            Sd = /\d{1,4}/,
            Td = /[+-]?\d{1,6}/,
            Ud = /\d+/,
            Vd = /[+-]?\d+/,
            Wd = /Z|[+-]\d\d:?\d\d/gi,
            Xd = /Z|[+-]\d\d(?::?\d\d)?/gi,
            Yd = /[+-]?\d+(\.\d{1,3})?/,
            Zd = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i,
            $d = {},
            _d = {},
            ae = 0,
            be = 1,
            ce = 2,
            de = 3,
            ee = 4,
            fe = 5,
            ge = 6,
            he = 7,
            ie = 8;
        vd = Array.prototype.indexOf ? Array.prototype.indexOf : function(a) {
            var b;
            for (b = 0; b < this.length; ++b)
                if (this[b] === a) return b;
            return -1
        };
        var je = vd;
        U("M", ["MM", 2], "Mo", function() {
            return this.month() + 1
        }), U("MMM", 0, 0, function(a) {
            return this.localeData().monthsShort(this, a)
        }), U("MMMM", 0, 0, function(a) {
            return this.localeData().months(this, a)
        }), J("month", "M"), M("month", 8), Z("M", Od), Z("MM", Od, Kd), Z("MMM", function(a, b) {
            return b.monthsShortRegex(a)
        }), Z("MMMM", function(a, b) {
            return b.monthsRegex(a)
        }), ba(["M", "MM"], function(a, b) {
            b[be] = u(a) - 1
        }), ba(["MMM", "MMMM"], function(a, b, c, d) {
            var e = c._locale.monthsParse(a, d, c._strict);
            null != e ? b[be] = e : m(c).invalidMonth = a
        });
        var ke = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
            le = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
            me = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
            ne = Zd,
            oe = Zd;
        U("Y", 0, 0, function() {
            var a = this.year();
            return a <= 9999 ? "" + a : "+" + a
        }), U(0, ["YY", 2], 0, function() {
            return this.year() % 100
        }), U(0, ["YYYY", 4], 0, "year"), U(0, ["YYYYY", 5], 0, "year"), U(0, ["YYYYYY", 6, !0], 0, "year"), J("year", "y"), M("year", 1), Z("Y", Vd), Z("YY", Od, Kd), Z("YYYY", Sd, Md), Z("YYYYY", Td, Nd), Z("YYYYYY", Td, Nd), ba(["YYYYY", "YYYYYY"], ae), ba("YYYY", function(b, c) {
            c[ae] = 2 === b.length ? a.parseTwoDigitYear(b) : u(b)
        }), ba("YY", function(b, c) {
            c[ae] = a.parseTwoDigitYear(b)
        }), ba("Y", function(a, b) {
            b[ae] = parseInt(a, 10)
        }), a.parseTwoDigitYear = function(a) {
            return u(a) + (u(a) > 68 ? 1900 : 2e3)
        };
        var pe = O("FullYear", !0);
        U("w", ["ww", 2], "wo", "week"), U("W", ["WW", 2], "Wo", "isoWeek"), J("week", "w"), J("isoWeek", "W"), M("week", 5), M("isoWeek", 5), Z("w", Od), Z("ww", Od, Kd), Z("W", Od), Z("WW", Od, Kd), ca(["w", "ww", "W", "WW"], function(a, b, c, d) {
            b[d.substr(0, 1)] = u(a)
        });
        var qe = {
            dow: 0,
            doy: 6
        };
        U("d", 0, "do", "day"), U("dd", 0, 0, function(a) {
            return this.localeData().weekdaysMin(this, a)
        }), U("ddd", 0, 0, function(a) {
            return this.localeData().weekdaysShort(this, a)
        }), U("dddd", 0, 0, function(a) {
            return this.localeData().weekdays(this, a)
        }), U("e", 0, 0, "weekday"), U("E", 0, 0, "isoWeekday"), J("day", "d"), J("weekday", "e"), J("isoWeekday", "E"), M("day", 11), M("weekday", 11), M("isoWeekday", 11), Z("d", Od), Z("e", Od), Z("E", Od), Z("dd", function(a, b) {
            return b.weekdaysMinRegex(a)
        }), Z("ddd", function(a, b) {
            return b.weekdaysShortRegex(a)
        }), Z("dddd", function(a, b) {
            return b.weekdaysRegex(a)
        }), ca(["dd", "ddd", "dddd"], function(a, b, c, d) {
            var e = c._locale.weekdaysParse(a, d, c._strict);
            null != e ? b.d = e : m(c).invalidWeekday = a
        }), ca(["d", "e", "E"], function(a, b, c, d) {
            b[d] = u(a)
        });
        var re = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
            se = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
            te = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
            ue = Zd,
            ve = Zd,
            we = Zd;
        U("H", ["HH", 2], 0, "hour"), U("h", ["hh", 2], 0, Ra), U("k", ["kk", 2], 0, Sa), U("hmm", 0, 0, function() {
            return "" + Ra.apply(this) + T(this.minutes(), 2)
        }), U("hmmss", 0, 0, function() {
            return "" + Ra.apply(this) + T(this.minutes(), 2) + T(this.seconds(), 2)
        }), U("Hmm", 0, 0, function() {
            return "" + this.hours() + T(this.minutes(), 2)
        }), U("Hmmss", 0, 0, function() {
            return "" + this.hours() + T(this.minutes(), 2) + T(this.seconds(), 2)
        }), Ta("a", !0), Ta("A", !1), J("hour", "h"), M("hour", 13), Z("a", Ua), Z("A", Ua), Z("H", Od), Z("h", Od), Z("HH", Od, Kd), Z("hh", Od, Kd), Z("hmm", Pd), Z("hmmss", Qd), Z("Hmm", Pd), Z("Hmmss", Qd), ba(["H", "HH"], de), ba(["a", "A"], function(a, b, c) {
            c._isPm = c._locale.isPM(a), c._meridiem = a
        }), ba(["h", "hh"], function(a, b, c) {
            b[de] = u(a), m(c).bigHour = !0
        }), ba("hmm", function(a, b, c) {
            var d = a.length - 2;
            b[de] = u(a.substr(0, d)), b[ee] = u(a.substr(d)), m(c).bigHour = !0
        }), ba("hmmss", function(a, b, c) {
            var d = a.length - 4,
                e = a.length - 2;
            b[de] = u(a.substr(0, d)), b[ee] = u(a.substr(d, 2)), b[fe] = u(a.substr(e)), m(c).bigHour = !0
        }), ba("Hmm", function(a, b, c) {
            var d = a.length - 2;
            b[de] = u(a.substr(0, d)), b[ee] = u(a.substr(d))
        }), ba("Hmmss", function(a, b, c) {
            var d = a.length - 4,
                e = a.length - 2;
            b[de] = u(a.substr(0, d)), b[ee] = u(a.substr(d, 2)), b[fe] = u(a.substr(e))
        });
        var xe, ye = /[ap]\.?m?\.?/i,
            ze = O("Hours", !0),
            Ae = {
                calendar: xd,
                longDateFormat: yd,
                invalidDate: zd,
                ordinal: Ad,
                ordinalParse: Bd,
                relativeTime: Cd,
                months: le,
                monthsShort: me,
                week: qe,
                weekdays: re,
                weekdaysMin: te,
                weekdaysShort: se,
                meridiemParse: ye
            },
            Be = {},
            Ce = {},
            De = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
            Ee = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
            Fe = /Z|[+-]\d\d(?::?\d\d)?/,
            Ge = [
                ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
                ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
                ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
                ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
                ["YYYY-DDD", /\d{4}-\d{3}/],
                ["YYYY-MM", /\d{4}-\d\d/, !1],
                ["YYYYYYMMDD", /[+-]\d{10}/],
                ["YYYYMMDD", /\d{8}/],
                ["GGGG[W]WWE", /\d{4}W\d{3}/],
                ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
                ["YYYYDDD", /\d{7}/]
            ],
            He = [
                ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
                ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
                ["HH:mm:ss", /\d\d:\d\d:\d\d/],
                ["HH:mm", /\d\d:\d\d/],
                ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
                ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
                ["HHmmss", /\d\d\d\d\d\d/],
                ["HHmm", /\d\d\d\d/],
                ["HH", /\d\d/]
            ],
            Ie = /^\/?Date\((\-?\d+)/i;
        a.createFromInputFallback = x("value provided is not in a recognized ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non ISO date formats are discouraged and will be removed in an upcoming major release. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(a) {
            a._d = new Date(a._i + (a._useUTC ? " UTC" : ""))
        }), a.ISO_8601 = function() {};
        var Je = x("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
                var a = sb.apply(null, arguments);
                return this.isValid() && a.isValid() ? a < this ? this : a : o()
            }),
            Ke = x("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
                var a = sb.apply(null, arguments);
                return this.isValid() && a.isValid() ? a > this ? this : a : o()
            }),
            Le = function() {
                return Date.now ? Date.now() : +new Date
            };
        zb("Z", ":"), zb("ZZ", ""), Z("Z", Xd), Z("ZZ", Xd), ba(["Z", "ZZ"], function(a, b, c) {
            c._useUTC = !0, c._tzm = Ab(Xd, a)
        });
        var Me = /([\+\-]|\d\d)/gi;
        a.updateOffset = function() {};
        var Ne = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/,
            Oe = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;
        Ob.fn = wb.prototype;
        var Pe = Sb(1, "add"),
            Qe = Sb(-1, "subtract");
        a.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ", a.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
        var Re = x("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(a) {
            return void 0 === a ? this.localeData() : this.locale(a)
        });
        U(0, ["gg", 2], 0, function() {
            return this.weekYear() % 100
        }), U(0, ["GG", 2], 0, function() {
            return this.isoWeekYear() % 100
        }), zc("gggg", "weekYear"), zc("ggggg", "weekYear"), zc("GGGG", "isoWeekYear"), zc("GGGGG", "isoWeekYear"), J("weekYear", "gg"), J("isoWeekYear", "GG"), M("weekYear", 1), M("isoWeekYear", 1), Z("G", Vd), Z("g", Vd), Z("GG", Od, Kd), Z("gg", Od, Kd), Z("GGGG", Sd, Md), Z("gggg", Sd, Md), Z("GGGGG", Td, Nd), Z("ggggg", Td, Nd), ca(["gggg", "ggggg", "GGGG", "GGGGG"], function(a, b, c, d) {
            b[d.substr(0, 2)] = u(a)
        }), ca(["gg", "GG"], function(b, c, d, e) {
            c[e] = a.parseTwoDigitYear(b)
        }), U("Q", 0, "Qo", "quarter"), J("quarter", "Q"), M("quarter", 7), Z("Q", Jd), ba("Q", function(a, b) {
            b[be] = 3 * (u(a) - 1)
        }), U("D", ["DD", 2], "Do", "date"), J("date", "D"), M("date", 9), Z("D", Od), Z("DD", Od, Kd), Z("Do", function(a, b) {
            return a ? b._ordinalParse : b._ordinalParseLenient
        }), ba(["D", "DD"], ce), ba("Do", function(a, b) {
            b[ce] = u(a.match(Od)[0], 10)
        });
        var Se = O("Date", !0);
        U("DDD", ["DDDD", 3], "DDDo", "dayOfYear"), J("dayOfYear", "DDD"), M("dayOfYear", 4), Z("DDD", Rd), Z("DDDD", Ld), ba(["DDD", "DDDD"], function(a, b, c) {
            c._dayOfYear = u(a)
        }), U("m", ["mm", 2], 0, "minute"), J("minute", "m"), M("minute", 14), Z("m", Od), Z("mm", Od, Kd), ba(["m", "mm"], ee);
        var Te = O("Minutes", !1);
        U("s", ["ss", 2], 0, "second"), J("second", "s"), M("second", 15), Z("s", Od), Z("ss", Od, Kd), ba(["s", "ss"], fe);
        var Ue = O("Seconds", !1);
        U("S", 0, 0, function() {
            return ~~(this.millisecond() / 100)
        }), U(0, ["SS", 2], 0, function() {
            return ~~(this.millisecond() / 10)
        }), U(0, ["SSS", 3], 0, "millisecond"), U(0, ["SSSS", 4], 0, function() {
            return 10 * this.millisecond()
        }), U(0, ["SSSSS", 5], 0, function() {
            return 100 * this.millisecond()
        }), U(0, ["SSSSSS", 6], 0, function() {
            return 1e3 * this.millisecond()
        }), U(0, ["SSSSSSS", 7], 0, function() {
            return 1e4 * this.millisecond()
        }), U(0, ["SSSSSSSS", 8], 0, function() {
            return 1e5 * this.millisecond()
        }), U(0, ["SSSSSSSSS", 9], 0, function() {
            return 1e6 * this.millisecond()
        }), J("millisecond", "ms"), M("millisecond", 16), Z("S", Rd, Jd), Z("SS", Rd, Kd), Z("SSS", Rd, Ld);
        var Ve;
        for (Ve = "SSSS"; Ve.length <= 9; Ve += "S") Z(Ve, Ud);
        for (Ve = "S"; Ve.length <= 9; Ve += "S") ba(Ve, Ic);
        var We = O("Milliseconds", !1);
        U("z", 0, 0, "zoneAbbr"), U("zz", 0, 0, "zoneName");
        var Xe = r.prototype;
        Xe.add = Pe, Xe.calendar = Vb, Xe.clone = Wb, Xe.diff = bc, Xe.endOf = oc, Xe.format = gc, Xe.from = hc, Xe.fromNow = ic, Xe.to = jc, Xe.toNow = kc, Xe.get = R, Xe.invalidAt = xc, Xe.isAfter = Xb, Xe.isBefore = Yb, Xe.isBetween = Zb, Xe.isSame = $b, Xe.isSameOrAfter = _b, Xe.isSameOrBefore = ac, Xe.isValid = vc, Xe.lang = Re, Xe.locale = lc, Xe.localeData = mc, Xe.max = Ke, Xe.min = Je, Xe.parsingFlags = wc, Xe.set = S, Xe.startOf = nc, Xe.subtract = Qe, Xe.toArray = sc, Xe.toObject = tc, Xe.toDate = rc, Xe.toISOString = ec, Xe.inspect = fc, Xe.toJSON = uc, Xe.toString = dc, Xe.unix = qc, Xe.valueOf = pc, Xe.creationData = yc, Xe.year = pe, Xe.isLeapYear = ra, Xe.weekYear = Ac, Xe.isoWeekYear = Bc, Xe.quarter = Xe.quarters = Gc, Xe.month = ka, Xe.daysInMonth = la, Xe.week = Xe.weeks = Ba, Xe.isoWeek = Xe.isoWeeks = Ca, Xe.weeksInYear = Dc, Xe.isoWeeksInYear = Cc, Xe.date = Se, Xe.day = Xe.days = Ka, Xe.weekday = La, Xe.isoWeekday = Ma, Xe.dayOfYear = Hc, Xe.hour = Xe.hours = ze, Xe.minute = Xe.minutes = Te, Xe.second = Xe.seconds = Ue, Xe.millisecond = Xe.milliseconds = We, Xe.utcOffset = Db, Xe.utc = Fb, Xe.local = Gb, Xe.parseZone = Hb, Xe.hasAlignedHourOffset = Ib, Xe.isDST = Jb, Xe.isLocal = Lb, Xe.isUtcOffset = Mb, Xe.isUtc = Nb, Xe.isUTC = Nb, Xe.zoneAbbr = Jc, Xe.zoneName = Kc, Xe.dates = x("dates accessor is deprecated. Use date instead.", Se), Xe.months = x("months accessor is deprecated. Use month instead", ka), Xe.years = x("years accessor is deprecated. Use year instead", pe), Xe.zone = x("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", Eb), Xe.isDSTShifted = x("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", Kb);
        var Ye = C.prototype;
        Ye.calendar = D, Ye.longDateFormat = E, Ye.invalidDate = F, Ye.ordinal = G, Ye.preparse = Nc, Ye.postformat = Nc, Ye.relativeTime = H, Ye.pastFuture = I, Ye.set = A, Ye.months = fa, Ye.monthsShort = ga, Ye.monthsParse = ia, Ye.monthsRegex = na, Ye.monthsShortRegex = ma, Ye.week = ya, Ye.firstDayOfYear = Aa, Ye.firstDayOfWeek = za, Ye.weekdays = Fa, Ye.weekdaysMin = Ha, Ye.weekdaysShort = Ga, Ye.weekdaysParse = Ja, Ye.weekdaysRegex = Na, Ye.weekdaysShortRegex = Oa, Ye.weekdaysMinRegex = Pa, Ye.isPM = Va, Ye.meridiem = Wa, $a("en", {
            ordinalParse: /\d{1,2}(th|st|nd|rd)/,
            ordinal: function(a) {
                var b = a % 10;
                return a + (1 === u(a % 100 / 10) ? "th" : 1 === b ? "st" : 2 === b ? "nd" : 3 === b ? "rd" : "th")
            }
        }), a.lang = x("moment.lang is deprecated. Use moment.locale instead.", $a), a.langData = x("moment.langData is deprecated. Use moment.localeData instead.", bb);
        var Ze = Math.abs,
            $e = ed("ms"),
            _e = ed("s"),
            af = ed("m"),
            bf = ed("h"),
            cf = ed("d"),
            df = ed("w"),
            ef = ed("M"),
            ff = ed("y"),
            gf = gd("milliseconds"),
            hf = gd("seconds"),
            jf = gd("minutes"),
            kf = gd("hours"),
            lf = gd("days"),
            mf = gd("months"),
            nf = gd("years"),
            of = Math.round,
            pf = {
                s: 45,
                m: 45,
                h: 22,
                d: 26,
                M: 11
            },
            qf = Math.abs,
            rf = wb.prototype;
        return rf.abs = Wc, rf.add = Yc, rf.subtract = Zc, rf.as = cd, rf.asMilliseconds = $e, rf.asSeconds = _e, rf.asMinutes = af, rf.asHours = bf, rf.asDays = cf, rf.asWeeks = df, rf.asMonths = ef, rf.asYears = ff, rf.valueOf = dd, rf._bubble = _c, rf.get = fd, rf.milliseconds = gf, rf.seconds = hf, rf.minutes = jf, rf.hours = kf, rf.days = lf, rf.weeks = hd, rf.months = mf, rf.years = nf, rf.humanize = md, rf.toISOString = nd, rf.toString = nd, rf.toJSON = nd, rf.locale = lc, rf.localeData = mc, rf.toIsoString = x("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", nd), rf.lang = Re, U("X", 0, 0, "unix"), U("x", 0, 0, "valueOf"), Z("x", Vd), Z("X", Yd), ba("X", function(a, b, c) {
            c._d = new Date(1e3 * parseFloat(a, 10))
        }), ba("x", function(a, b, c) {
            c._d = new Date(u(a))
        }), a.version = "2.17.1", b(sb), a.fn = Xe, a.min = ub, a.max = vb, a.now = Le, a.utc = k, a.unix = Lc, a.months = Rc, a.isDate = g, a.locale = $a, a.invalid = o, a.duration = Ob, a.isMoment = s, a.weekdays = Tc, a.parseZone = Mc, a.localeData = bb, a.isDuration = xb, a.monthsShort = Sc, a.weekdaysMin = Vc, a.defineLocale = _a, a.updateLocale = ab, a.locales = cb, a.weekdaysShort = Uc, a.normalizeUnits = K, a.relativeTimeRounding = kd, a.relativeTimeThreshold = ld, a.calendarFormat = Ub, a.prototype = Xe, a
    }),
    function(a) {
        a.fn.appendAround = function() {
            return this.each(function() {
                function b(b) {
                    return "none" === a(b).css("display")
                }

                function c() {
                    if (b(g)) {
                        var a = 0;
                        i.each(function() {
                            b(this) || a || (d.appendTo(this), a++, g = this)
                        })
                    }
                }
                var d = a(this),
                    e = "data-set",
                    f = d.parent(),
                    g = f[0],
                    h = f.attr(e),
                    i = a("[" + e + "='" + h + "']");
                c(), a(window).bind("resize", c)
            })
        }
    }(jQuery);
var Handlebars = function() {
    var a = function() {
            "use strict";

            function a(a) {
                this.string = a
            }
            return a.prototype.toString = function() {
                return "" + this.string
            }, a
        }(),
        b = function(a) {
            "use strict";

            function b(a) {
                return h[a] || "&"
            }

            function c(a, b) {
                for (var c in b) Object.prototype.hasOwnProperty.call(b, c) && (a[c] = b[c])
            }

            function d(a) {
                return a instanceof g ? a.toString() : a || 0 === a ? (a = "" + a, j.test(a) ? a.replace(i, b) : a) : ""
            }

            function e(a) {
                return !a && 0 !== a || !(!m(a) || 0 !== a.length)
            }
            var f = {},
                g = a,
                h = {
                    "&": "&",
                    "<": "&lt;",
                    ">": "&gt;",
                    '"': "&quot;",
                    "'": "&#x27;",
                    "`": "&#x60;"
                },
                i = /[&<>"'`]/g,
                j = /[&<>"'`]/;
            f.extend = c;
            var k = Object.prototype.toString;
            f.toString = k;
            var l = function(a) {
                return "function" == typeof a
            };
            l(/x/) && (l = function(a) {
                return "function" == typeof a && "[object Function]" === k.call(a)
            });
            var l;
            f.isFunction = l;
            var m = Array.isArray || function(a) {
                return !(!a || "object" != typeof a) && "[object Array]" === k.call(a)
            };
            return f.isArray = m, f.escapeExpression = d, f.isEmpty = e, f
        }(a),
        c = function() {
            "use strict";

            function a(a, c) {
                var d;
                c && c.firstLine && (d = c.firstLine, a += " - " + d + ":" + c.firstColumn);
                for (var e = Error.prototype.constructor.call(this, a), f = 0; f < b.length; f++) this[b[f]] = e[b[f]];
                d && (this.lineNumber = d, this.column = c.firstColumn)
            }
            var b = ["description", "fileName", "lineNumber", "message", "name", "number", "stack"];
            return a.prototype = new Error, a
        }(),
        d = function(a, b) {
            "use strict";

            function c(a, b) {
                this.helpers = a || {}, this.partials = b || {}, d(this)
            }

            function d(a) {
                a.registerHelper("helperMissing", function(a) {
                    if (2 !== arguments.length) throw new h("Missing helper: '" + a + "'")
                }), a.registerHelper("blockHelperMissing", function(b, c) {
                    var d = c.inverse || function() {},
                        e = c.fn;
                    return k(b) && (b = b.call(this)), !0 === b ? e(this) : !1 === b || null == b ? d(this) : j(b) ? b.length > 0 ? a.helpers.each(b, c) : d(this) : e(b)
                }), a.registerHelper("each", function(a, b) {
                    var c, d = b.fn,
                        e = b.inverse,
                        f = 0,
                        g = "";
                    if (k(a) && (a = a.call(this)), b.data && (c = o(b.data)), a && "object" == typeof a)
                        if (j(a))
                            for (var h = a.length; f < h; f++) c && (c.index = f, c.first = 0 === f, c.last = f === a.length - 1), g += d(a[f], {
                                data: c
                            });
                        else
                            for (var i in a) a.hasOwnProperty(i) && (c && (c.key = i, c.index = f, c.first = 0 === f), g += d(a[i], {
                                data: c
                            }), f++);
                    return 0 === f && (g = e(this)), g
                }), a.registerHelper("if", function(a, b) {
                    return k(a) && (a = a.call(this)), !b.hash.includeZero && !a || g.isEmpty(a) ? b.inverse(this) : b.fn(this)
                }), a.registerHelper("unless", function(b, c) {
                    return a.helpers.if.call(this, b, {
                        fn: c.inverse,
                        inverse: c.fn,
                        hash: c.hash
                    })
                }), a.registerHelper("with", function(a, b) {
                    if (k(a) && (a = a.call(this)), !g.isEmpty(a)) return b.fn(a)
                }), a.registerHelper("log", function(b, c) {
                    var d = c.data && null != c.data.level ? parseInt(c.data.level, 10) : 1;
                    a.log(d, b)
                })
            }

            function e(a, b) {
                n.log(a, b)
            }
            var f = {},
                g = a,
                h = b;
            f.VERSION = "1.3.0", f.COMPILER_REVISION = 4;
            var i = {
                1: "<= 1.0.rc.2",
                2: "== 1.0.0-rc.3",
                3: "== 1.0.0-rc.4",
                4: ">= 1.0.0"
            };
            f.REVISION_CHANGES = i;
            var j = g.isArray,
                k = g.isFunction,
                l = g.toString,
                m = "[object Object]";
            f.HandlebarsEnvironment = c, c.prototype = {
                constructor: c,
                logger: n,
                log: e,
                registerHelper: function(a, b, c) {
                    if (l.call(a) === m) {
                        if (c || b) throw new h("Arg not supported with multiple helpers");
                        g.extend(this.helpers, a)
                    } else c && (b.not = c), this.helpers[a] = b
                },
                registerPartial: function(a, b) {
                    l.call(a) === m ? g.extend(this.partials, a) : this.partials[a] = b
                }
            };
            var n = {
                methodMap: {
                    0: "debug",
                    1: "info",
                    2: "warn",
                    3: "error"
                },
                DEBUG: 0,
                INFO: 1,
                WARN: 2,
                ERROR: 3,
                level: 3,
                log: function(a, b) {
                    if (n.level <= a) {
                        var c = n.methodMap[a];
                        "undefined" != typeof console && console[c] && console[c].call(console, b)
                    }
                }
            };
            f.logger = n, f.log = e;
            var o = function(a) {
                var b = {};
                return g.extend(b, a), b
            };
            return f.createFrame = o, f
        }(b, c),
        e = function(a, b, c) {
            "use strict";

            function d(a) {
                var b = a && a[0] || 1,
                    c = m;
                if (b !== c) {
                    if (b < c) {
                        var d = n[c],
                            e = n[b];
                        throw new l("Template was precompiled with an older version of Handlebars than the current runtime. Please update your precompiler to a newer version (" + d + ") or downgrade your runtime to an older version (" + e + ").")
                    }
                    throw new l("Template was precompiled with a newer version of Handlebars than the current runtime. Please update your runtime to a newer version (" + a[1] + ").")
                }
            }

            function e(a, b) {
                if (!b) throw new l("No environment passed to template");
                var c = function(a, c, d, e, f, g) {
                        var h = b.VM.invokePartial.apply(this, arguments);
                        if (null != h) return h;
                        if (b.compile) {
                            var i = {
                                helpers: e,
                                partials: f,
                                data: g
                            };
                            return f[c] = b.compile(a, {
                                data: void 0 !== g
                            }, b), f[c](d, i)
                        }
                        throw new l("The partial " + c + " could not be compiled when running in runtime-only mode")
                    },
                    d = {
                        escapeExpression: k.escapeExpression,
                        invokePartial: c,
                        programs: [],
                        program: function(a, b, c) {
                            var d = this.programs[a];
                            return c ? d = g(a, b, c) : d || (d = this.programs[a] = g(a, b)), d
                        },
                        merge: function(a, b) {
                            var c = a || b;
                            return a && b && a !== b && (c = {}, k.extend(c, b), k.extend(c, a)), c
                        },
                        programWithDepth: b.VM.programWithDepth,
                        noop: b.VM.noop,
                        compilerInfo: null
                    };
                return function(c, e) {
                    e = e || {};
                    var f, g, h = e.partial ? e : b;
                    e.partial || (f = e.helpers, g = e.partials);
                    var i = a.call(d, h, c, f, g, e.data);
                    return e.partial || b.VM.checkRevision(d.compilerInfo), i
                }
            }

            function f(a, b, c) {
                var d = Array.prototype.slice.call(arguments, 3),
                    e = function(a, e) {
                        return e = e || {}, b.apply(this, [a, e.data || c].concat(d))
                    };
                return e.program = a, e.depth = d.length, e
            }

            function g(a, b, c) {
                var d = function(a, d) {
                    return d = d || {}, b(a, d.data || c)
                };
                return d.program = a, d.depth = 0, d
            }

            function h(a, b, c, d, e, f) {
                var g = {
                    partial: !0,
                    helpers: d,
                    partials: e,
                    data: f
                };
                if (void 0 === a) throw new l("The partial " + b + " could not be found");
                if (a instanceof Function) return a(c, g)
            }

            function i() {
                return ""
            }
            var j = {},
                k = a,
                l = b,
                m = c.COMPILER_REVISION,
                n = c.REVISION_CHANGES;
            return j.checkRevision = d, j.template = e, j.programWithDepth = f, j.program = g, j.invokePartial = h, j.noop = i, j
        }(b, c, d),
        f = function(a, b, c, d, e) {
            "use strict";
            var f = a,
                g = b,
                h = c,
                i = d,
                j = e,
                k = function() {
                    var a = new f.HandlebarsEnvironment;
                    return i.extend(a, f), a.SafeString = g, a.Exception = h, a.Utils = i, a.VM = j, a.template = function(b) {
                        return j.template(b, a)
                    }, a
                },
                l = k();
            return l.create = k, l
        }(d, a, c, b, e),
        g = function(a) {
            "use strict";

            function b(a) {
                a = a || {}, this.firstLine = a.first_line, this.firstColumn = a.first_column, this.lastColumn = a.last_column, this.lastLine = a.last_line
            }
            var c = a,
                d = {
                    ProgramNode: function(a, c, e, f) {
                        var g, h;
                        3 === arguments.length ? (f = e, e = null) : 2 === arguments.length && (f = c, c = null), b.call(this, f), this.type = "program", this.statements = a, this.strip = {}, e ? (h = e[0], h ? (g = {
                            first_line: h.firstLine,
                            last_line: h.lastLine,
                            last_column: h.lastColumn,
                            first_column: h.firstColumn
                        }, this.inverse = new d.ProgramNode(e, c, g)) : this.inverse = new d.ProgramNode(e, c), this.strip.right = c.left) : c && (this.strip.left = c.right)
                    },
                    MustacheNode: function(a, c, e, f, g) {
                        if (b.call(this, g), this.type = "mustache", this.strip = f, null != e && e.charAt) {
                            var h = e.charAt(3) || e.charAt(2);
                            this.escaped = "{" !== h && "&" !== h
                        } else this.escaped = !!e;
                        a instanceof d.SexprNode ? this.sexpr = a : this.sexpr = new d.SexprNode(a, c), this.sexpr.isRoot = !0, this.id = this.sexpr.id, this.params = this.sexpr.params, this.hash = this.sexpr.hash, this.eligibleHelper = this.sexpr.eligibleHelper, this.isHelper = this.sexpr.isHelper
                    },
                    SexprNode: function(a, c, d) {
                        b.call(this, d), this.type = "sexpr", this.hash = c;
                        var e = this.id = a[0],
                            f = this.params = a.slice(1),
                            g = this.eligibleHelper = e.isSimple;
                        this.isHelper = g && (f.length || c)
                    },
                    PartialNode: function(a, c, d, e) {
                        b.call(this, e), this.type = "partial", this.partialName = a, this.context = c, this.strip = d
                    },
                    BlockNode: function(a, d, e, f, g) {
                        if (b.call(this, g), a.sexpr.id.original !== f.path.original) throw new c(a.sexpr.id.original + " doesn't match " + f.path.original, this);
                        this.type = "block", this.mustache = a, this.program = d, this.inverse = e, this.strip = {
                            left: a.strip.left,
                            right: f.strip.right
                        }, (d || e).strip.left = a.strip.right, (e || d).strip.right = f.strip.left, e && !d && (this.isInverse = !0)
                    },
                    ContentNode: function(a, c) {
                        b.call(this, c), this.type = "content", this.string = a
                    },
                    HashNode: function(a, c) {
                        b.call(this, c), this.type = "hash", this.pairs = a
                    },
                    IdNode: function(a, d) {
                        b.call(this, d), this.type = "ID";
                        for (var e = "", f = [], g = 0, h = 0, i = a.length; h < i; h++) {
                            var j = a[h].part;
                            if (e += (a[h].separator || "") + j, ".." === j || "." === j || "this" === j) {
                                if (f.length > 0) throw new c("Invalid path: " + e, this);
                                ".." === j ? g++ : this.isScoped = !0
                            } else f.push(j)
                        }
                        this.original = e, this.parts = f, this.string = f.join("."),
                            this.depth = g, this.isSimple = 1 === a.length && !this.isScoped && 0 === g, this.stringModeValue = this.string
                    },
                    PartialNameNode: function(a, c) {
                        b.call(this, c), this.type = "PARTIAL_NAME", this.name = a.original
                    },
                    DataNode: function(a, c) {
                        b.call(this, c), this.type = "DATA", this.id = a
                    },
                    StringNode: function(a, c) {
                        b.call(this, c), this.type = "STRING", this.original = this.string = this.stringModeValue = a
                    },
                    IntegerNode: function(a, c) {
                        b.call(this, c), this.type = "INTEGER", this.original = this.integer = a, this.stringModeValue = Number(a)
                    },
                    BooleanNode: function(a, c) {
                        b.call(this, c), this.type = "BOOLEAN", this.bool = a, this.stringModeValue = "true" === a
                    },
                    CommentNode: function(a, c) {
                        b.call(this, c), this.type = "comment", this.comment = a
                    }
                };
            return d
        }(c),
        h = function() {
            "use strict";
            var a = function() {
                function a(a, b) {
                    return {
                        left: "~" === a.charAt(2),
                        right: "~" === b.charAt(0) || "~" === b.charAt(1)
                    }
                }

                function b() {
                    this.yy = {}
                }
                var c = {
                        trace: function() {},
                        yy: {},
                        symbols_: {
                            error: 2,
                            root: 3,
                            statements: 4,
                            EOF: 5,
                            program: 6,
                            simpleInverse: 7,
                            statement: 8,
                            openInverse: 9,
                            closeBlock: 10,
                            openBlock: 11,
                            mustache: 12,
                            partial: 13,
                            CONTENT: 14,
                            COMMENT: 15,
                            OPEN_BLOCK: 16,
                            sexpr: 17,
                            CLOSE: 18,
                            OPEN_INVERSE: 19,
                            OPEN_ENDBLOCK: 20,
                            path: 21,
                            OPEN: 22,
                            OPEN_UNESCAPED: 23,
                            CLOSE_UNESCAPED: 24,
                            OPEN_PARTIAL: 25,
                            partialName: 26,
                            partial_option0: 27,
                            sexpr_repetition0: 28,
                            sexpr_option0: 29,
                            dataName: 30,
                            param: 31,
                            STRING: 32,
                            INTEGER: 33,
                            BOOLEAN: 34,
                            OPEN_SEXPR: 35,
                            CLOSE_SEXPR: 36,
                            hash: 37,
                            hash_repetition_plus0: 38,
                            hashSegment: 39,
                            ID: 40,
                            EQUALS: 41,
                            DATA: 42,
                            pathSegments: 43,
                            SEP: 44,
                            $accept: 0,
                            $end: 1
                        },
                        terminals_: {
                            2: "error",
                            5: "EOF",
                            14: "CONTENT",
                            15: "COMMENT",
                            16: "OPEN_BLOCK",
                            18: "CLOSE",
                            19: "OPEN_INVERSE",
                            20: "OPEN_ENDBLOCK",
                            22: "OPEN",
                            23: "OPEN_UNESCAPED",
                            24: "CLOSE_UNESCAPED",
                            25: "OPEN_PARTIAL",
                            32: "STRING",
                            33: "INTEGER",
                            34: "BOOLEAN",
                            35: "OPEN_SEXPR",
                            36: "CLOSE_SEXPR",
                            40: "ID",
                            41: "EQUALS",
                            42: "DATA",
                            44: "SEP"
                        },
                        productions_: [0, [3, 2],
                            [3, 1],
                            [6, 2],
                            [6, 3],
                            [6, 2],
                            [6, 1],
                            [6, 1],
                            [6, 0],
                            [4, 1],
                            [4, 2],
                            [8, 3],
                            [8, 3],
                            [8, 1],
                            [8, 1],
                            [8, 1],
                            [8, 1],
                            [11, 3],
                            [9, 3],
                            [10, 3],
                            [12, 3],
                            [12, 3],
                            [13, 4],
                            [7, 2],
                            [17, 3],
                            [17, 1],
                            [31, 1],
                            [31, 1],
                            [31, 1],
                            [31, 1],
                            [31, 1],
                            [31, 3],
                            [37, 1],
                            [39, 3],
                            [26, 1],
                            [26, 1],
                            [26, 1],
                            [30, 2],
                            [21, 1],
                            [43, 3],
                            [43, 1],
                            [27, 0],
                            [27, 1],
                            [28, 0],
                            [28, 2],
                            [29, 0],
                            [29, 1],
                            [38, 1],
                            [38, 2]
                        ],
                        performAction: function(b, c, d, e, f, g, h) {
                            var i = g.length - 1;
                            switch (f) {
                                case 1:
                                    return new e.ProgramNode(g[i - 1], this._$);
                                case 2:
                                    return new e.ProgramNode([], this._$);
                                case 3:
                                    this.$ = new e.ProgramNode([], g[i - 1], g[i], this._$);
                                    break;
                                case 4:
                                    this.$ = new e.ProgramNode(g[i - 2], g[i - 1], g[i], this._$);
                                    break;
                                case 5:
                                    this.$ = new e.ProgramNode(g[i - 1], g[i], [], this._$);
                                    break;
                                case 6:
                                    this.$ = new e.ProgramNode(g[i], this._$);
                                    break;
                                case 7:
                                case 8:
                                    this.$ = new e.ProgramNode([], this._$);
                                    break;
                                case 9:
                                    this.$ = [g[i]];
                                    break;
                                case 10:
                                    g[i - 1].push(g[i]), this.$ = g[i - 1];
                                    break;
                                case 11:
                                    this.$ = new e.BlockNode(g[i - 2], g[i - 1].inverse, g[i - 1], g[i], this._$);
                                    break;
                                case 12:
                                    this.$ = new e.BlockNode(g[i - 2], g[i - 1], g[i - 1].inverse, g[i], this._$);
                                    break;
                                case 13:
                                case 14:
                                    this.$ = g[i];
                                    break;
                                case 15:
                                    this.$ = new e.ContentNode(g[i], this._$);
                                    break;
                                case 16:
                                    this.$ = new e.CommentNode(g[i], this._$);
                                    break;
                                case 17:
                                case 18:
                                    this.$ = new e.MustacheNode(g[i - 1], null, g[i - 2], a(g[i - 2], g[i]), this._$);
                                    break;
                                case 19:
                                    this.$ = {
                                        path: g[i - 1],
                                        strip: a(g[i - 2], g[i])
                                    };
                                    break;
                                case 20:
                                case 21:
                                    this.$ = new e.MustacheNode(g[i - 1], null, g[i - 2], a(g[i - 2], g[i]), this._$);
                                    break;
                                case 22:
                                    this.$ = new e.PartialNode(g[i - 2], g[i - 1], a(g[i - 3], g[i]), this._$);
                                    break;
                                case 23:
                                    this.$ = a(g[i - 1], g[i]);
                                    break;
                                case 24:
                                    this.$ = new e.SexprNode([g[i - 2]].concat(g[i - 1]), g[i], this._$);
                                    break;
                                case 25:
                                    this.$ = new e.SexprNode([g[i]], null, this._$);
                                    break;
                                case 26:
                                    this.$ = g[i];
                                    break;
                                case 27:
                                    this.$ = new e.StringNode(g[i], this._$);
                                    break;
                                case 28:
                                    this.$ = new e.IntegerNode(g[i], this._$);
                                    break;
                                case 29:
                                    this.$ = new e.BooleanNode(g[i], this._$);
                                    break;
                                case 30:
                                    this.$ = g[i];
                                    break;
                                case 31:
                                    g[i - 1].isHelper = !0, this.$ = g[i - 1];
                                    break;
                                case 32:
                                    this.$ = new e.HashNode(g[i], this._$);
                                    break;
                                case 33:
                                    this.$ = [g[i - 2], g[i]];
                                    break;
                                case 34:
                                    this.$ = new e.PartialNameNode(g[i], this._$);
                                    break;
                                case 35:
                                    this.$ = new e.PartialNameNode(new e.StringNode(g[i], this._$), this._$);
                                    break;
                                case 36:
                                    this.$ = new e.PartialNameNode(new e.IntegerNode(g[i], this._$));
                                    break;
                                case 37:
                                    this.$ = new e.DataNode(g[i], this._$);
                                    break;
                                case 38:
                                    this.$ = new e.IdNode(g[i], this._$);
                                    break;
                                case 39:
                                    g[i - 2].push({
                                        part: g[i],
                                        separator: g[i - 1]
                                    }), this.$ = g[i - 2];
                                    break;
                                case 40:
                                    this.$ = [{
                                        part: g[i]
                                    }];
                                    break;
                                case 43:
                                    this.$ = [];
                                    break;
                                case 44:
                                    g[i - 1].push(g[i]);
                                    break;
                                case 47:
                                    this.$ = [g[i]];
                                    break;
                                case 48:
                                    g[i - 1].push(g[i])
                            }
                        },
                        table: [{
                            3: 1,
                            4: 2,
                            5: [1, 3],
                            8: 4,
                            9: 5,
                            11: 6,
                            12: 7,
                            13: 8,
                            14: [1, 9],
                            15: [1, 10],
                            16: [1, 12],
                            19: [1, 11],
                            22: [1, 13],
                            23: [1, 14],
                            25: [1, 15]
                        }, {
                            1: [3]
                        }, {
                            5: [1, 16],
                            8: 17,
                            9: 5,
                            11: 6,
                            12: 7,
                            13: 8,
                            14: [1, 9],
                            15: [1, 10],
                            16: [1, 12],
                            19: [1, 11],
                            22: [1, 13],
                            23: [1, 14],
                            25: [1, 15]
                        }, {
                            1: [2, 2]
                        }, {
                            5: [2, 9],
                            14: [2, 9],
                            15: [2, 9],
                            16: [2, 9],
                            19: [2, 9],
                            20: [2, 9],
                            22: [2, 9],
                            23: [2, 9],
                            25: [2, 9]
                        }, {
                            4: 20,
                            6: 18,
                            7: 19,
                            8: 4,
                            9: 5,
                            11: 6,
                            12: 7,
                            13: 8,
                            14: [1, 9],
                            15: [1, 10],
                            16: [1, 12],
                            19: [1, 21],
                            20: [2, 8],
                            22: [1, 13],
                            23: [1, 14],
                            25: [1, 15]
                        }, {
                            4: 20,
                            6: 22,
                            7: 19,
                            8: 4,
                            9: 5,
                            11: 6,
                            12: 7,
                            13: 8,
                            14: [1, 9],
                            15: [1, 10],
                            16: [1, 12],
                            19: [1, 21],
                            20: [2, 8],
                            22: [1, 13],
                            23: [1, 14],
                            25: [1, 15]
                        }, {
                            5: [2, 13],
                            14: [2, 13],
                            15: [2, 13],
                            16: [2, 13],
                            19: [2, 13],
                            20: [2, 13],
                            22: [2, 13],
                            23: [2, 13],
                            25: [2, 13]
                        }, {
                            5: [2, 14],
                            14: [2, 14],
                            15: [2, 14],
                            16: [2, 14],
                            19: [2, 14],
                            20: [2, 14],
                            22: [2, 14],
                            23: [2, 14],
                            25: [2, 14]
                        }, {
                            5: [2, 15],
                            14: [2, 15],
                            15: [2, 15],
                            16: [2, 15],
                            19: [2, 15],
                            20: [2, 15],
                            22: [2, 15],
                            23: [2, 15],
                            25: [2, 15]
                        }, {
                            5: [2, 16],
                            14: [2, 16],
                            15: [2, 16],
                            16: [2, 16],
                            19: [2, 16],
                            20: [2, 16],
                            22: [2, 16],
                            23: [2, 16],
                            25: [2, 16]
                        }, {
                            17: 23,
                            21: 24,
                            30: 25,
                            40: [1, 28],
                            42: [1, 27],
                            43: 26
                        }, {
                            17: 29,
                            21: 24,
                            30: 25,
                            40: [1, 28],
                            42: [1, 27],
                            43: 26
                        }, {
                            17: 30,
                            21: 24,
                            30: 25,
                            40: [1, 28],
                            42: [1, 27],
                            43: 26
                        }, {
                            17: 31,
                            21: 24,
                            30: 25,
                            40: [1, 28],
                            42: [1, 27],
                            43: 26
                        }, {
                            21: 33,
                            26: 32,
                            32: [1, 34],
                            33: [1, 35],
                            40: [1, 28],
                            43: 26
                        }, {
                            1: [2, 1]
                        }, {
                            5: [2, 10],
                            14: [2, 10],
                            15: [2, 10],
                            16: [2, 10],
                            19: [2, 10],
                            20: [2, 10],
                            22: [2, 10],
                            23: [2, 10],
                            25: [2, 10]
                        }, {
                            10: 36,
                            20: [1, 37]
                        }, {
                            4: 38,
                            8: 4,
                            9: 5,
                            11: 6,
                            12: 7,
                            13: 8,
                            14: [1, 9],
                            15: [1, 10],
                            16: [1, 12],
                            19: [1, 11],
                            20: [2, 7],
                            22: [1, 13],
                            23: [1, 14],
                            25: [1, 15]
                        }, {
                            7: 39,
                            8: 17,
                            9: 5,
                            11: 6,
                            12: 7,
                            13: 8,
                            14: [1, 9],
                            15: [1, 10],
                            16: [1, 12],
                            19: [1, 21],
                            20: [2, 6],
                            22: [1, 13],
                            23: [1, 14],
                            25: [1, 15]
                        }, {
                            17: 23,
                            18: [1, 40],
                            21: 24,
                            30: 25,
                            40: [1, 28],
                            42: [1, 27],
                            43: 26
                        }, {
                            10: 41,
                            20: [1, 37]
                        }, {
                            18: [1, 42]
                        }, {
                            18: [2, 43],
                            24: [2, 43],
                            28: 43,
                            32: [2, 43],
                            33: [2, 43],
                            34: [2, 43],
                            35: [2, 43],
                            36: [2, 43],
                            40: [2, 43],
                            42: [2, 43]
                        }, {
                            18: [2, 25],
                            24: [2, 25],
                            36: [2, 25]
                        }, {
                            18: [2, 38],
                            24: [2, 38],
                            32: [2, 38],
                            33: [2, 38],
                            34: [2, 38],
                            35: [2, 38],
                            36: [2, 38],
                            40: [2, 38],
                            42: [2, 38],
                            44: [1, 44]
                        }, {
                            21: 45,
                            40: [1, 28],
                            43: 26
                        }, {
                            18: [2, 40],
                            24: [2, 40],
                            32: [2, 40],
                            33: [2, 40],
                            34: [2, 40],
                            35: [2, 40],
                            36: [2, 40],
                            40: [2, 40],
                            42: [2, 40],
                            44: [2, 40]
                        }, {
                            18: [1, 46]
                        }, {
                            18: [1, 47]
                        }, {
                            24: [1, 48]
                        }, {
                            18: [2, 41],
                            21: 50,
                            27: 49,
                            40: [1, 28],
                            43: 26
                        }, {
                            18: [2, 34],
                            40: [2, 34]
                        }, {
                            18: [2, 35],
                            40: [2, 35]
                        }, {
                            18: [2, 36],
                            40: [2, 36]
                        }, {
                            5: [2, 11],
                            14: [2, 11],
                            15: [2, 11],
                            16: [2, 11],
                            19: [2, 11],
                            20: [2, 11],
                            22: [2, 11],
                            23: [2, 11],
                            25: [2, 11]
                        }, {
                            21: 51,
                            40: [1, 28],
                            43: 26
                        }, {
                            8: 17,
                            9: 5,
                            11: 6,
                            12: 7,
                            13: 8,
                            14: [1, 9],
                            15: [1, 10],
                            16: [1, 12],
                            19: [1, 11],
                            20: [2, 3],
                            22: [1, 13],
                            23: [1, 14],
                            25: [1, 15]
                        }, {
                            4: 52,
                            8: 4,
                            9: 5,
                            11: 6,
                            12: 7,
                            13: 8,
                            14: [1, 9],
                            15: [1, 10],
                            16: [1, 12],
                            19: [1, 11],
                            20: [2, 5],
                            22: [1, 13],
                            23: [1, 14],
                            25: [1, 15]
                        }, {
                            14: [2, 23],
                            15: [2, 23],
                            16: [2, 23],
                            19: [2, 23],
                            20: [2, 23],
                            22: [2, 23],
                            23: [2, 23],
                            25: [2, 23]
                        }, {
                            5: [2, 12],
                            14: [2, 12],
                            15: [2, 12],
                            16: [2, 12],
                            19: [2, 12],
                            20: [2, 12],
                            22: [2, 12],
                            23: [2, 12],
                            25: [2, 12]
                        }, {
                            14: [2, 18],
                            15: [2, 18],
                            16: [2, 18],
                            19: [2, 18],
                            20: [2, 18],
                            22: [2, 18],
                            23: [2, 18],
                            25: [2, 18]
                        }, {
                            18: [2, 45],
                            21: 56,
                            24: [2, 45],
                            29: 53,
                            30: 60,
                            31: 54,
                            32: [1, 57],
                            33: [1, 58],
                            34: [1, 59],
                            35: [1, 61],
                            36: [2, 45],
                            37: 55,
                            38: 62,
                            39: 63,
                            40: [1, 64],
                            42: [1, 27],
                            43: 26
                        }, {
                            40: [1, 65]
                        }, {
                            18: [2, 37],
                            24: [2, 37],
                            32: [2, 37],
                            33: [2, 37],
                            34: [2, 37],
                            35: [2, 37],
                            36: [2, 37],
                            40: [2, 37],
                            42: [2, 37]
                        }, {
                            14: [2, 17],
                            15: [2, 17],
                            16: [2, 17],
                            19: [2, 17],
                            20: [2, 17],
                            22: [2, 17],
                            23: [2, 17],
                            25: [2, 17]
                        }, {
                            5: [2, 20],
                            14: [2, 20],
                            15: [2, 20],
                            16: [2, 20],
                            19: [2, 20],
                            20: [2, 20],
                            22: [2, 20],
                            23: [2, 20],
                            25: [2, 20]
                        }, {
                            5: [2, 21],
                            14: [2, 21],
                            15: [2, 21],
                            16: [2, 21],
                            19: [2, 21],
                            20: [2, 21],
                            22: [2, 21],
                            23: [2, 21],
                            25: [2, 21]
                        }, {
                            18: [1, 66]
                        }, {
                            18: [2, 42]
                        }, {
                            18: [1, 67]
                        }, {
                            8: 17,
                            9: 5,
                            11: 6,
                            12: 7,
                            13: 8,
                            14: [1, 9],
                            15: [1, 10],
                            16: [1, 12],
                            19: [1, 11],
                            20: [2, 4],
                            22: [1, 13],
                            23: [1, 14],
                            25: [1, 15]
                        }, {
                            18: [2, 24],
                            24: [2, 24],
                            36: [2, 24]
                        }, {
                            18: [2, 44],
                            24: [2, 44],
                            32: [2, 44],
                            33: [2, 44],
                            34: [2, 44],
                            35: [2, 44],
                            36: [2, 44],
                            40: [2, 44],
                            42: [2, 44]
                        }, {
                            18: [2, 46],
                            24: [2, 46],
                            36: [2, 46]
                        }, {
                            18: [2, 26],
                            24: [2, 26],
                            32: [2, 26],
                            33: [2, 26],
                            34: [2, 26],
                            35: [2, 26],
                            36: [2, 26],
                            40: [2, 26],
                            42: [2, 26]
                        }, {
                            18: [2, 27],
                            24: [2, 27],
                            32: [2, 27],
                            33: [2, 27],
                            34: [2, 27],
                            35: [2, 27],
                            36: [2, 27],
                            40: [2, 27],
                            42: [2, 27]
                        }, {
                            18: [2, 28],
                            24: [2, 28],
                            32: [2, 28],
                            33: [2, 28],
                            34: [2, 28],
                            35: [2, 28],
                            36: [2, 28],
                            40: [2, 28],
                            42: [2, 28]
                        }, {
                            18: [2, 29],
                            24: [2, 29],
                            32: [2, 29],
                            33: [2, 29],
                            34: [2, 29],
                            35: [2, 29],
                            36: [2, 29],
                            40: [2, 29],
                            42: [2, 29]
                        }, {
                            18: [2, 30],
                            24: [2, 30],
                            32: [2, 30],
                            33: [2, 30],
                            34: [2, 30],
                            35: [2, 30],
                            36: [2, 30],
                            40: [2, 30],
                            42: [2, 30]
                        }, {
                            17: 68,
                            21: 24,
                            30: 25,
                            40: [1, 28],
                            42: [1, 27],
                            43: 26
                        }, {
                            18: [2, 32],
                            24: [2, 32],
                            36: [2, 32],
                            39: 69,
                            40: [1, 70]
                        }, {
                            18: [2, 47],
                            24: [2, 47],
                            36: [2, 47],
                            40: [2, 47]
                        }, {
                            18: [2, 40],
                            24: [2, 40],
                            32: [2, 40],
                            33: [2, 40],
                            34: [2, 40],
                            35: [2, 40],
                            36: [2, 40],
                            40: [2, 40],
                            41: [1, 71],
                            42: [2, 40],
                            44: [2, 40]
                        }, {
                            18: [2, 39],
                            24: [2, 39],
                            32: [2, 39],
                            33: [2, 39],
                            34: [2, 39],
                            35: [2, 39],
                            36: [2, 39],
                            40: [2, 39],
                            42: [2, 39],
                            44: [2, 39]
                        }, {
                            5: [2, 22],
                            14: [2, 22],
                            15: [2, 22],
                            16: [2, 22],
                            19: [2, 22],
                            20: [2, 22],
                            22: [2, 22],
                            23: [2, 22],
                            25: [2, 22]
                        }, {
                            5: [2, 19],
                            14: [2, 19],
                            15: [2, 19],
                            16: [2, 19],
                            19: [2, 19],
                            20: [2, 19],
                            22: [2, 19],
                            23: [2, 19],
                            25: [2, 19]
                        }, {
                            36: [1, 72]
                        }, {
                            18: [2, 48],
                            24: [2, 48],
                            36: [2, 48],
                            40: [2, 48]
                        }, {
                            41: [1, 71]
                        }, {
                            21: 56,
                            30: 60,
                            31: 73,
                            32: [1, 57],
                            33: [1, 58],
                            34: [1, 59],
                            35: [1, 61],
                            40: [1, 28],
                            42: [1, 27],
                            43: 26
                        }, {
                            18: [2, 31],
                            24: [2, 31],
                            32: [2, 31],
                            33: [2, 31],
                            34: [2, 31],
                            35: [2, 31],
                            36: [2, 31],
                            40: [2, 31],
                            42: [2, 31]
                        }, {
                            18: [2, 33],
                            24: [2, 33],
                            36: [2, 33],
                            40: [2, 33]
                        }],
                        defaultActions: {
                            3: [2, 2],
                            16: [2, 1],
                            50: [2, 42]
                        },
                        parseError: function(a, b) {
                            throw new Error(a)
                        },
                        parse: function(a) {
                            function b() {
                                var a;
                                return a = c.lexer.lex() || 1, "number" != typeof a && (a = c.symbols_[a] || a), a
                            }
                            var c = this,
                                d = [0],
                                e = [null],
                                f = [],
                                g = this.table,
                                h = "",
                                i = 0,
                                j = 0,
                                k = 0;
                            this.lexer.setInput(a), this.lexer.yy = this.yy, this.yy.lexer = this.lexer, this.yy.parser = this, void 0 === this.lexer.yylloc && (this.lexer.yylloc = {});
                            var l = this.lexer.yylloc;
                            f.push(l);
                            var m = this.lexer.options && this.lexer.options.ranges;
                            "function" == typeof this.yy.parseError && (this.parseError = this.yy.parseError);
                            for (var n, o, p, q, r, s, t, u, v, w = {};;) {
                                if (p = d[d.length - 1], this.defaultActions[p] ? q = this.defaultActions[p] : (null !== n && void 0 !== n || (n = b()), q = g[p] && g[p][n]), void 0 === q || !q.length || !q[0]) {
                                    var x = "";
                                    if (!k) {
                                        v = [];
                                        for (s in g[p]) this.terminals_[s] && s > 2 && v.push("'" + this.terminals_[s] + "'");
                                        x = this.lexer.showPosition ? "Parse error on line " + (i + 1) + ":\n" + this.lexer.showPosition() + "\nExpecting " + v.join(", ") + ", got '" + (this.terminals_[n] || n) + "'" : "Parse error on line " + (i + 1) + ": Unexpected " + (1 == n ? "end of input" : "'" + (this.terminals_[n] || n) + "'"), this.parseError(x, {
                                            text: this.lexer.match,
                                            token: this.terminals_[n] || n,
                                            line: this.lexer.yylineno,
                                            loc: l,
                                            expected: v
                                        })
                                    }
                                }
                                if (q[0] instanceof Array && q.length > 1) throw new Error("Parse Error: multiple actions possible at state: " + p + ", token: " + n);
                                switch (q[0]) {
                                    case 1:
                                        d.push(n), e.push(this.lexer.yytext), f.push(this.lexer.yylloc), d.push(q[1]), n = null, o ? (n = o, o = null) : (j = this.lexer.yyleng, h = this.lexer.yytext, i = this.lexer.yylineno, l = this.lexer.yylloc, k > 0 && k--);
                                        break;
                                    case 2:
                                        if (t = this.productions_[q[1]][1], w.$ = e[e.length - t], w._$ = {
                                                first_line: f[f.length - (t || 1)].first_line,
                                                last_line: f[f.length - 1].last_line,
                                                first_column: f[f.length - (t || 1)].first_column,
                                                last_column: f[f.length - 1].last_column
                                            }, m && (w._$.range = [f[f.length - (t || 1)].range[0], f[f.length - 1].range[1]]), void 0 !== (r = this.performAction.call(w, h, j, i, this.yy, q[1], e, f))) return r;
                                        t && (d = d.slice(0, -1 * t * 2), e = e.slice(0, -1 * t), f = f.slice(0, -1 * t)), d.push(this.productions_[q[1]][0]), e.push(w.$), f.push(w._$), u = g[d[d.length - 2]][d[d.length - 1]], d.push(u);
                                        break;
                                    case 3:
                                        return !0
                                }
                            }
                            return !0
                        }
                    },
                    d = function() {
                        var a = {
                            EOF: 1,
                            parseError: function(a, b) {
                                if (!this.yy.parser) throw new Error(a);
                                this.yy.parser.parseError(a, b)
                            },
                            setInput: function(a) {
                                return this._input = a, this._more = this._less = this.done = !1, this.yylineno = this.yyleng = 0, this.yytext = this.matched = this.match = "", this.conditionStack = ["INITIAL"], this.yylloc = {
                                    first_line: 1,
                                    first_column: 0,
                                    last_line: 1,
                                    last_column: 0
                                }, this.options.ranges && (this.yylloc.range = [0, 0]), this.offset = 0, this
                            },
                            input: function() {
                                var a = this._input[0];
                                return this.yytext += a, this.yyleng++, this.offset++, this.match += a, this.matched += a, a.match(/(?:\r\n?|\n).*/g) ? (this.yylineno++, this.yylloc.last_line++) : this.yylloc.last_column++, this.options.ranges && this.yylloc.range[1]++, this._input = this._input.slice(1), a
                            },
                            unput: function(a) {
                                var b = a.length,
                                    c = a.split(/(?:\r\n?|\n)/g);
                                this._input = a + this._input, this.yytext = this.yytext.substr(0, this.yytext.length - b - 1), this.offset -= b;
                                var d = this.match.split(/(?:\r\n?|\n)/g);
                                this.match = this.match.substr(0, this.match.length - 1), this.matched = this.matched.substr(0, this.matched.length - 1), c.length - 1 && (this.yylineno -= c.length - 1);
                                var e = this.yylloc.range;
                                return this.yylloc = {
                                    first_line: this.yylloc.first_line,
                                    last_line: this.yylineno + 1,
                                    first_column: this.yylloc.first_column,
                                    last_column: c ? (c.length === d.length ? this.yylloc.first_column : 0) + d[d.length - c.length].length - c[0].length : this.yylloc.first_column - b
                                }, this.options.ranges && (this.yylloc.range = [e[0], e[0] + this.yyleng - b]), this
                            },
                            more: function() {
                                return this._more = !0, this
                            },
                            less: function(a) {
                                this.unput(this.match.slice(a))
                            },
                            pastInput: function() {
                                var a = this.matched.substr(0, this.matched.length - this.match.length);
                                return (a.length > 20 ? "..." : "") + a.substr(-20).replace(/\n/g, "")
                            },
                            upcomingInput: function() {
                                var a = this.match;
                                return a.length < 20 && (a += this._input.substr(0, 20 - a.length)), (a.substr(0, 20) + (a.length > 20 ? "..." : "")).replace(/\n/g, "")
                            },
                            showPosition: function() {
                                var a = this.pastInput(),
                                    b = new Array(a.length + 1).join("-");
                                return a + this.upcomingInput() + "\n" + b + "^"
                            },
                            next: function() {
                                if (this.done) return this.EOF;
                                this._input || (this.done = !0);
                                var a, b, c, d, e;
                                this._more || (this.yytext = "", this.match = "");
                                for (var f = this._currentRules(), g = 0; g < f.length && (!(c = this._input.match(this.rules[f[g]])) || b && !(c[0].length > b[0].length) || (b = c, d = g, this.options.flex)); g++);
                                return b ? (e = b[0].match(/(?:\r\n?|\n).*/g), e && (this.yylineno += e.length), this.yylloc = {
                                    first_line: this.yylloc.last_line,
                                    last_line: this.yylineno + 1,
                                    first_column: this.yylloc.last_column,
                                    last_column: e ? e[e.length - 1].length - e[e.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + b[0].length
                                }, this.yytext += b[0], this.match += b[0], this.matches = b, this.yyleng = this.yytext.length, this.options.ranges && (this.yylloc.range = [this.offset, this.offset += this.yyleng]), this._more = !1, this._input = this._input.slice(b[0].length), this.matched += b[0], a = this.performAction.call(this, this.yy, this, f[d], this.conditionStack[this.conditionStack.length - 1]), this.done && this._input && (this.done = !1), a || void 0) : "" === this._input ? this.EOF : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), {
                                    text: "",
                                    token: null,
                                    line: this.yylineno
                                })
                            },
                            lex: function() {
                                var a = this.next();
                                return void 0 !== a ? a : this.lex()
                            },
                            begin: function(a) {
                                this.conditionStack.push(a)
                            },
                            popState: function() {
                                return this.conditionStack.pop()
                            },
                            _currentRules: function() {
                                return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules
                            },
                            topState: function() {
                                return this.conditionStack[this.conditionStack.length - 2]
                            },
                            pushState: function(a) {
                                this.begin(a)
                            }
                        };
                        return a.options = {}, a.performAction = function(a, b, c, d) {
                            function e(a, c) {
                                return b.yytext = b.yytext.substr(a, b.yyleng - c)
                            }
                            switch (c) {
                                case 0:
                                    if ("\\\\" === b.yytext.slice(-2) ? (e(0, 1), this.begin("mu")) : "\\" === b.yytext.slice(-1) ? (e(0, 1), this.begin("emu")) : this.begin("mu"), b.yytext) return 14;
                                    break;
                                case 1:
                                    return 14;
                                case 2:
                                    return this.popState(), 14;
                                case 3:
                                    return e(0, 4), this.popState(), 15;
                                case 4:
                                    return 35;
                                case 5:
                                    return 36;
                                case 6:
                                    return 25;
                                case 7:
                                    return 16;
                                case 8:
                                    return 20;
                                case 9:
                                case 10:
                                    return 19;
                                case 11:
                                    return 23;
                                case 12:
                                    return 22;
                                case 13:
                                    this.popState(), this.begin("com");
                                    break;
                                case 14:
                                    return e(3, 5), this.popState(), 15;
                                case 15:
                                    return 22;
                                case 16:
                                    return 41;
                                case 17:
                                case 18:
                                    return 40;
                                case 19:
                                    return 44;
                                case 20:
                                    break;
                                case 21:
                                    return this.popState(), 24;
                                case 22:
                                    return this.popState(), 18;
                                case 23:
                                    return b.yytext = e(1, 2).replace(/\\"/g, '"'), 32;
                                case 24:
                                    return b.yytext = e(1, 2).replace(/\\'/g, "'"), 32;
                                case 25:
                                    return 42;
                                case 26:
                                case 27:
                                    return 34;
                                case 28:
                                    return 33;
                                case 29:
                                    return 40;
                                case 30:
                                    return b.yytext = e(1, 2), 40;
                                case 31:
                                    return "INVALID";
                                case 32:
                                    return 5
                            }
                        }, a.rules = [/^(?:[^\x00]*?(?=(\{\{)))/, /^(?:[^\x00]+)/, /^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/, /^(?:[\s\S]*?--\}\})/, /^(?:\()/, /^(?:\))/, /^(?:\{\{(~)?>)/, /^(?:\{\{(~)?#)/, /^(?:\{\{(~)?\/)/, /^(?:\{\{(~)?\^)/, /^(?:\{\{(~)?\s*else\b)/, /^(?:\{\{(~)?\{)/, /^(?:\{\{(~)?&)/, /^(?:\{\{!--)/, /^(?:\{\{![\s\S]*?\}\})/, /^(?:\{\{(~)?)/, /^(?:=)/, /^(?:\.\.)/, /^(?:\.(?=([=~}\s\/.)])))/, /^(?:[\/.])/, /^(?:\s+)/, /^(?:\}(~)?\}\})/, /^(?:(~)?\}\})/, /^(?:"(\\["]|[^"])*")/, /^(?:'(\\[']|[^'])*')/, /^(?:@)/, /^(?:true(?=([~}\s)])))/, /^(?:false(?=([~}\s)])))/, /^(?:-?[0-9]+(?=([~}\s)])))/, /^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)]))))/, /^(?:\[[^\]]*\])/, /^(?:.)/, /^(?:$)/], a.conditions = {
                            mu: {
                                rules: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32],
                                inclusive: !1
                            },
                            emu: {
                                rules: [2],
                                inclusive: !1
                            },
                            com: {
                                rules: [3],
                                inclusive: !1
                            },
                            INITIAL: {
                                rules: [0, 1, 32],
                                inclusive: !0
                            }
                        }, a
                    }();
                return c.lexer = d, b.prototype = c, c.Parser = b, new b
            }();
            return a
        }(),
        i = function(a, b) {
            "use strict";

            function c(a) {
                return a.constructor === f.ProgramNode ? a : (e.yy = f, e.parse(a))
            }
            var d = {},
                e = a,
                f = b;
            return d.parser = e, d.parse = c, d
        }(h, g),
        j = function(a) {
            "use strict";

            function b() {}

            function c(a, b, c) {
                if (null == a || "string" != typeof a && a.constructor !== c.AST.ProgramNode) throw new f("You must pass a string or Handlebars AST to Handlebars.precompile. You passed " + a);
                "data" in (b = b || {}) || (b.data = !0);
                var d = c.parse(a),
                    e = (new c.Compiler).compile(d, b);
                return (new c.JavaScriptCompiler).compile(e, b)
            }

            function d(a, b, c) {
                function d() {
                    var d = c.parse(a),
                        e = (new c.Compiler).compile(d, b),
                        f = (new c.JavaScriptCompiler).compile(e, b, void 0, !0);
                    return c.template(f)
                }
                if (null == a || "string" != typeof a && a.constructor !== c.AST.ProgramNode) throw new f("You must pass a string or Handlebars AST to Handlebars.compile. You passed " + a);
                "data" in (b = b || {}) || (b.data = !0);
                var e;
                return function(a, b) {
                    return e || (e = d()), e.call(this, a, b)
                }
            }
            var e = {},
                f = a;
            return e.Compiler = b, b.prototype = {
                compiler: b,
                disassemble: function() {
                    for (var a, b, c, d = this.opcodes, e = [], f = 0, g = d.length; f < g; f++)
                        if (a = d[f], "DECLARE" === a.opcode) e.push("DECLARE " + a.name + "=" + a.value);
                        else {
                            b = [];
                            for (var h = 0; h < a.args.length; h++) c = a.args[h], "string" == typeof c && (c = '"' + c.replace("\n", "\\n") + '"'), b.push(c);
                            e.push(a.opcode + " " + b.join(" "))
                        } return e.join("\n")
                },
                equals: function(a) {
                    var b = this.opcodes.length;
                    if (a.opcodes.length !== b) return !1;
                    for (var c = 0; c < b; c++) {
                        var d = this.opcodes[c],
                            e = a.opcodes[c];
                        if (d.opcode !== e.opcode || d.args.length !== e.args.length) return !1;
                        for (var f = 0; f < d.args.length; f++)
                            if (d.args[f] !== e.args[f]) return !1
                    }
                    if (b = this.children.length, a.children.length !== b) return !1;
                    for (c = 0; c < b; c++)
                        if (!this.children[c].equals(a.children[c])) return !1;
                    return !0
                },
                guid: 0,
                compile: function(a, b) {
                    this.opcodes = [], this.children = [], this.depths = {
                        list: []
                    }, this.options = b;
                    var c = this.options.knownHelpers;
                    if (this.options.knownHelpers = {
                            helperMissing: !0,
                            blockHelperMissing: !0,
                            each: !0,
                            if: !0,
                            unless: !0,
                            with: !0,
                            log: !0
                        }, c)
                        for (var d in c) this.options.knownHelpers[d] = c[d];
                    return this.accept(a)
                },
                accept: function(a) {
                    var b, c = a.strip || {};
                    return c.left && this.opcode("strip"), b = this[a.type](a), c.right && this.opcode("strip"), b
                },
                program: function(a) {
                    for (var b = a.statements, c = 0, d = b.length; c < d; c++) this.accept(b[c]);
                    return this.isSimple = 1 === d, this.depths.list = this.depths.list.sort(function(a, b) {
                        return a - b
                    }), this
                },
                compileProgram: function(a) {
                    var b, c = (new this.compiler).compile(a, this.options),
                        d = this.guid++;
                    this.usePartial = this.usePartial || c.usePartial, this.children[d] = c;
                    for (var e = 0, f = c.depths.list.length; e < f; e++)(b = c.depths.list[e]) < 2 || this.addDepth(b - 1);
                    return d
                },
                block: function(a) {
                    var b = a.mustache,
                        c = a.program,
                        d = a.inverse;
                    c && (c = this.compileProgram(c)), d && (d = this.compileProgram(d));
                    var e = b.sexpr,
                        f = this.classifySexpr(e);
                    "helper" === f ? this.helperSexpr(e, c, d) : "simple" === f ? (this.simpleSexpr(e), this.opcode("pushProgram", c), this.opcode("pushProgram", d), this.opcode("emptyHash"), this.opcode("blockValue")) : (this.ambiguousSexpr(e, c, d), this.opcode("pushProgram", c), this.opcode("pushProgram", d), this.opcode("emptyHash"), this.opcode("ambiguousBlockValue")), this.opcode("append")
                },
                hash: function(a) {
                    var b, c, d = a.pairs;
                    this.opcode("pushHash");
                    for (var e = 0, f = d.length; e < f; e++) b = d[e], c = b[1], this.options.stringParams ? (c.depth && this.addDepth(c.depth), this.opcode("getContext", c.depth || 0), this.opcode("pushStringParam", c.stringModeValue, c.type), "sexpr" === c.type && this.sexpr(c)) : this.accept(c), this.opcode("assignToHash", b[0]);
                    this.opcode("popHash")
                },
                partial: function(a) {
                    var b = a.partialName;
                    this.usePartial = !0, a.context ? this.ID(a.context) : this.opcode("push", "depth0"), this.opcode("invokePartial", b.name), this.opcode("append")
                },
                content: function(a) {
                    this.opcode("appendContent", a.string)
                },
                mustache: function(a) {
                    this.sexpr(a.sexpr), a.escaped && !this.options.noEscape ? this.opcode("appendEscaped") : this.opcode("append")
                },
                ambiguousSexpr: function(a, b, c) {
                    var d = a.id,
                        e = d.parts[0],
                        f = null != b || null != c;
                    this.opcode("getContext", d.depth), this.opcode("pushProgram", b), this.opcode("pushProgram", c), this.opcode("invokeAmbiguous", e, f)
                },
                simpleSexpr: function(a) {
                    var b = a.id;
                    "DATA" === b.type ? this.DATA(b) : b.parts.length ? this.ID(b) : (this.addDepth(b.depth), this.opcode("getContext", b.depth), this.opcode("pushContext")), this.opcode("resolvePossibleLambda")
                },
                helperSexpr: function(a, b, c) {
                    var d = this.setupFullMustacheParams(a, b, c),
                        e = a.id.parts[0];
                    if (this.options.knownHelpers[e]) this.opcode("invokeKnownHelper", d.length, e);
                    else {
                        if (this.options.knownHelpersOnly) throw new f("You specified knownHelpersOnly, but used the unknown helper " + e, a);
                        this.opcode("invokeHelper", d.length, e, a.isRoot)
                    }
                },
                sexpr: function(a) {
                    var b = this.classifySexpr(a);
                    "simple" === b ? this.simpleSexpr(a) : "helper" === b ? this.helperSexpr(a) : this.ambiguousSexpr(a)
                },
                ID: function(a) {
                    this.addDepth(a.depth), this.opcode("getContext", a.depth), a.parts[0] ? this.opcode("lookupOnContext", a.parts[0]) : this.opcode("pushContext");
                    for (var b = 1, c = a.parts.length; b < c; b++) this.opcode("lookup", a.parts[b])
                },
                DATA: function(a) {
                    if (this.options.data = !0, a.id.isScoped || a.id.depth) throw new f("Scoped data references are not supported: " + a.original, a);
                    this.opcode("lookupData");
                    for (var b = a.id.parts, c = 0, d = b.length; c < d; c++) this.opcode("lookup", b[c])
                },
                STRING: function(a) {
                    this.opcode("pushString", a.string)
                },
                INTEGER: function(a) {
                    this.opcode("pushLiteral", a.integer)
                },
                BOOLEAN: function(a) {
                    this.opcode("pushLiteral", a.bool)
                },
                comment: function() {},
                opcode: function(a) {
                    this.opcodes.push({
                        opcode: a,
                        args: [].slice.call(arguments, 1)
                    })
                },
                declare: function(a, b) {
                    this.opcodes.push({
                        opcode: "DECLARE",
                        name: a,
                        value: b
                    })
                },
                addDepth: function(a) {
                    0 !== a && (this.depths[a] || (this.depths[a] = !0, this.depths.list.push(a)))
                },
                classifySexpr: function(a) {
                    var b = a.isHelper,
                        c = a.eligibleHelper,
                        d = this.options;
                    if (c && !b) {
                        var e = a.id.parts[0];
                        d.knownHelpers[e] ? b = !0 : d.knownHelpersOnly && (c = !1)
                    }
                    return b ? "helper" : c ? "ambiguous" : "simple"
                },
                pushParams: function(a) {
                    for (var b, c = a.length; c--;) b = a[c], this.options.stringParams ? (b.depth && this.addDepth(b.depth), this.opcode("getContext", b.depth || 0), this.opcode("pushStringParam", b.stringModeValue, b.type), "sexpr" === b.type && this.sexpr(b)) : this[b.type](b)
                },
                setupFullMustacheParams: function(a, b, c) {
                    var d = a.params;
                    return this.pushParams(d), this.opcode("pushProgram", b), this.opcode("pushProgram", c), a.hash ? this.hash(a.hash) : this.opcode("emptyHash"), d
                }
            }, e.precompile = c, e.compile = d, e
        }(c),
        k = function(a, b) {
            "use strict";

            function c(a) {
                this.value = a
            }

            function d() {}
            var e = a.COMPILER_REVISION,
                f = a.REVISION_CHANGES,
                g = a.log,
                h = b;
            d.prototype = {
                nameLookup: function(a, b) {
                    var c, e;
                    return 0 === a.indexOf("depth") && (c = !0), e = /^[0-9]+$/.test(b) ? a + "[" + b + "]" : d.isValidJavaScriptVariableName(b) ? a + "." + b : a + "['" + b + "']", c ? "(" + a + " && " + e + ")" : e
                },
                compilerInfo: function() {
                    var a = e;
                    return "this.compilerInfo = [" + a + ",'" + f[a] + "'];\n"
                },
                appendToBuffer: function(a) {
                    return this.environment.isSimple ? "return " + a + ";" : {
                        appendToBuffer: !0,
                        content: a,
                        toString: function() {
                            return "buffer += " + a + ";"
                        }
                    }
                },
                initializeBuffer: function() {
                    return this.quotedString("")
                },
                namespace: "Handlebars",
                compile: function(a, b, c, d) {
                    this.environment = a, this.options = b || {}, g("debug", this.environment.disassemble() + "\n\n"), this.name = this.environment.name, this.isChild = !!c, this.context = c || {
                        programs: [],
                        environments: [],
                        aliases: {}
                    }, this.preamble(), this.stackSlot = 0, this.stackVars = [], this.registers = {
                        list: []
                    }, this.hashes = [], this.compileStack = [], this.inlineStack = [], this.compileChildren(a, b);
                    var e, f = a.opcodes;
                    this.i = 0;
                    for (var i = f.length; this.i < i; this.i++) e = f[this.i], "DECLARE" === e.opcode ? this[e.name] = e.value : this[e.opcode].apply(this, e.args), e.opcode !== this.stripNext && (this.stripNext = !1);
                    if (this.pushSource(""), this.stackSlot || this.inlineStack.length || this.compileStack.length) throw new h("Compile completed with content left on stack");
                    return this.createFunctionContext(d)
                },
                preamble: function() {
                    var a = [];
                    if (this.isChild) a.push("");
                    else {
                        var b = this.namespace,
                            c = "helpers = this.merge(helpers, " + b + ".helpers);";
                        this.environment.usePartial && (c = c + " partials = this.merge(partials, " + b + ".partials);"), this.options.data && (c += " data = data || {};"), a.push(c)
                    }
                    this.environment.isSimple ? a.push("") : a.push(", buffer = " + this.initializeBuffer()), this.lastContext = 0, this.source = a
                },
                createFunctionContext: function(a) {
                    var b = this.stackVars.concat(this.registers.list);
                    if (b.length > 0 && (this.source[1] = this.source[1] + ", " + b.join(", ")), !this.isChild)
                        for (var c in this.context.aliases) this.context.aliases.hasOwnProperty(c) && (this.source[1] = this.source[1] + ", " + c + "=" + this.context.aliases[c]);
                    this.source[1] && (this.source[1] = "var " + this.source[1].substring(2) + ";"), this.isChild || (this.source[1] += "\n" + this.context.programs.join("\n") + "\n"), this.environment.isSimple || this.pushSource("return buffer;");
                    for (var d = this.isChild ? ["depth0", "data"] : ["Handlebars", "depth0", "helpers", "partials", "data"], e = 0, f = this.environment.depths.list.length; e < f; e++) d.push("depth" + this.environment.depths.list[e]);
                    var h = this.mergeSource();
                    if (this.isChild || (h = this.compilerInfo() + h), a) return d.push(h), Function.apply(this, d);
                    var i = "function " + (this.name || "") + "(" + d.join(",") + ") {\n  " + h + "}";
                    return g("debug", i + "\n\n"), i
                },
                mergeSource: function() {
                    for (var a, b = "", c = 0, d = this.source.length; c < d; c++) {
                        var e = this.source[c];
                        e.appendToBuffer ? a = a ? a + "\n    + " + e.content : e.content : (a && (b += "buffer += " + a + ";\n  ", a = void 0), b += e + "\n  ")
                    }
                    return b
                },
                blockValue: function() {
                    this.context.aliases.blockHelperMissing = "helpers.blockHelperMissing";
                    var a = ["depth0"];
                    this.setupParams(0, a), this.replaceStack(function(b) {
                        return a.splice(1, 0, b), "blockHelperMissing.call(" + a.join(", ") + ")"
                    })
                },
                ambiguousBlockValue: function() {
                    this.context.aliases.blockHelperMissing = "helpers.blockHelperMissing";
                    var a = ["depth0"];
                    this.setupParams(0, a);
                    var b = this.topStack();
                    a.splice(1, 0, b), this.pushSource("if (!" + this.lastHelper + ") { " + b + " = blockHelperMissing.call(" + a.join(", ") + "); }")
                },
                appendContent: function(a) {
                    this.pendingContent && (a = this.pendingContent + a), this.stripNext && (a = a.replace(/^\s+/, "")), this.pendingContent = a
                },
                strip: function() {
                    this.pendingContent && (this.pendingContent = this.pendingContent.replace(/\s+$/, "")), this.stripNext = "strip"
                },
                append: function() {
                    this.flushInline();
                    var a = this.popStack();
                    this.pushSource("if(" + a + " || " + a + " === 0) { " + this.appendToBuffer(a) + " }"), this.environment.isSimple && this.pushSource("else { " + this.appendToBuffer("''") + " }")
                },
                appendEscaped: function() {
                    this.context.aliases.escapeExpression = "this.escapeExpression", this.pushSource(this.appendToBuffer("escapeExpression(" + this.popStack() + ")"))
                },
                getContext: function(a) {
                    this.lastContext !== a && (this.lastContext = a)
                },
                lookupOnContext: function(a) {
                    this.push(this.nameLookup("depth" + this.lastContext, a, "context"))
                },
                pushContext: function() {
                    this.pushStackLiteral("depth" + this.lastContext)
                },
                resolvePossibleLambda: function() {
                    this.context.aliases.functionType = '"function"', this.replaceStack(function(a) {
                        return "typeof " + a + " === functionType ? " + a + ".apply(depth0) : " + a
                    })
                },
                lookup: function(a) {
                    this.replaceStack(function(b) {
                        return b + " == null || " + b + " === false ? " + b + " : " + this.nameLookup(b, a, "context")
                    })
                },
                lookupData: function() {
                    this.pushStackLiteral("data")
                },
                pushStringParam: function(a, b) {
                    this.pushStackLiteral("depth" + this.lastContext), this.pushString(b), "sexpr" !== b && ("string" == typeof a ? this.pushString(a) : this.pushStackLiteral(a))
                },
                emptyHash: function() {
                    this.pushStackLiteral("{}"), this.options.stringParams && (this.push("{}"), this.push("{}"))
                },
                pushHash: function() {
                    this.hash && this.hashes.push(this.hash), this.hash = {
                        values: [],
                        types: [],
                        contexts: []
                    }
                },
                popHash: function() {
                    var a = this.hash;
                    this.hash = this.hashes.pop(), this.options.stringParams && (this.push("{" + a.contexts.join(",") + "}"), this.push("{" + a.types.join(",") + "}")), this.push("{\n    " + a.values.join(",\n    ") + "\n  }")
                },
                pushString: function(a) {
                    this.pushStackLiteral(this.quotedString(a))
                },
                push: function(a) {
                    return this.inlineStack.push(a), a
                },
                pushLiteral: function(a) {
                    this.pushStackLiteral(a)
                },
                pushProgram: function(a) {
                    null != a ? this.pushStackLiteral(this.programExpression(a)) : this.pushStackLiteral(null)
                },
                invokeHelper: function(a, b, c) {
                    this.context.aliases.helperMissing = "helpers.helperMissing", this.useRegister("helper");
                    var d = this.lastHelper = this.setupHelper(a, b, !0),
                        e = this.nameLookup("depth" + this.lastContext, b, "context"),
                        f = "helper = " + d.name + " || " + e;
                    d.paramsInit && (f += "," + d.paramsInit), this.push("(" + f + ",helper ? helper.call(" + d.callParams + ") : helperMissing.call(" + d.helperMissingParams + "))"), c || this.flushInline()
                },
                invokeKnownHelper: function(a, b) {
                    var c = this.setupHelper(a, b);
                    this.push(c.name + ".call(" + c.callParams + ")")
                },
                invokeAmbiguous: function(a, b) {
                    this.context.aliases.functionType = '"function"', this.useRegister("helper"), this.emptyHash();
                    var c = this.setupHelper(0, a, b),
                        d = this.lastHelper = this.nameLookup("helpers", a, "helper"),
                        e = this.nameLookup("depth" + this.lastContext, a, "context"),
                        f = this.nextStack();
                    c.paramsInit && this.pushSource(c.paramsInit), this.pushSource("if (helper = " + d + ") { " + f + " = helper.call(" + c.callParams + "); }"), this.pushSource("else { helper = " + e + "; " + f + " = typeof helper === functionType ? helper.call(" + c.callParams + ") : helper; }")
                },
                invokePartial: function(a) {
                    var b = [this.nameLookup("partials", a, "partial"), "'" + a + "'", this.popStack(), "helpers", "partials"];
                    this.options.data && b.push("data"), this.context.aliases.self = "this", this.push("self.invokePartial(" + b.join(", ") + ")")
                },
                assignToHash: function(a) {
                    var b, c, d = this.popStack();
                    this.options.stringParams && (c = this.popStack(), b = this.popStack());
                    var e = this.hash;
                    b && e.contexts.push("'" + a + "': " + b), c && e.types.push("'" + a + "': " + c), e.values.push("'" + a + "': (" + d + ")")
                },
                compiler: d,
                compileChildren: function(a, b) {
                    for (var c, d, e = a.children, f = 0, g = e.length; f < g; f++) {
                        c = e[f], d = new this.compiler;
                        var h = this.matchExistingProgram(c);
                        null == h ? (this.context.programs.push(""), h = this.context.programs.length, c.index = h, c.name = "program" + h, this.context.programs[h] = d.compile(c, b, this.context), this.context.environments[h] = c) : (c.index = h, c.name = "program" + h)
                    }
                },
                matchExistingProgram: function(a) {
                    for (var b = 0, c = this.context.environments.length; b < c; b++) {
                        var d = this.context.environments[b];
                        if (d && d.equals(a)) return b
                    }
                },
                programExpression: function(a) {
                    if (this.context.aliases.self = "this", null == a) return "self.noop";
                    for (var b, c = this.environment.children[a], d = c.depths.list, e = [c.index, c.name, "data"], f = 0, g = d.length; f < g; f++) b = d[f], 1 === b ? e.push("depth0") : e.push("depth" + (b - 1));
                    return (0 === d.length ? "self.program(" : "self.programWithDepth(") + e.join(", ") + ")"
                },
                register: function(a, b) {
                    this.useRegister(a), this.pushSource(a + " = " + b + ";")
                },
                useRegister: function(a) {
                    this.registers[a] || (this.registers[a] = !0, this.registers.list.push(a))
                },
                pushStackLiteral: function(a) {
                    return this.push(new c(a))
                },
                pushSource: function(a) {
                    this.pendingContent && (this.source.push(this.appendToBuffer(this.quotedString(this.pendingContent))), this.pendingContent = void 0), a && this.source.push(a)
                },
                pushStack: function(a) {
                    this.flushInline();
                    var b = this.incrStack();
                    return a && this.pushSource(b + " = " + a + ";"), this.compileStack.push(b), b
                },
                replaceStack: function(a) {
                    var b, d, e, f = "",
                        g = this.isInline();
                    if (g) {
                        var h = this.popStack(!0);
                        if (h instanceof c) b = h.value, e = !0;
                        else {
                            d = !this.stackSlot;
                            var i = d ? this.incrStack() : this.topStackName();
                            f = "(" + this.push(i) + " = " + h + "),", b = this.topStack()
                        }
                    } else b = this.topStack();
                    var j = a.call(this, b);
                    return g ? (e || this.popStack(), d && this.stackSlot--, this.push("(" + f + j + ")")) : (/^stack/.test(b) || (b = this.nextStack()), this.pushSource(b + " = (" + f + j + ");")), b
                },
                nextStack: function() {
                    return this.pushStack()
                },
                incrStack: function() {
                    return this.stackSlot++, this.stackSlot > this.stackVars.length && this.stackVars.push("stack" + this.stackSlot), this.topStackName()
                },
                topStackName: function() {
                    return "stack" + this.stackSlot
                },
                flushInline: function() {
                    var a = this.inlineStack;
                    if (a.length) {
                        this.inlineStack = [];
                        for (var b = 0, d = a.length; b < d; b++) {
                            var e = a[b];
                            e instanceof c ? this.compileStack.push(e) : this.pushStack(e)
                        }
                    }
                },
                isInline: function() {
                    return this.inlineStack.length
                },
                popStack: function(a) {
                    var b = this.isInline(),
                        d = (b ? this.inlineStack : this.compileStack).pop();
                    if (!a && d instanceof c) return d.value;
                    if (!b) {
                        if (!this.stackSlot) throw new h("Invalid stack pop");
                        this.stackSlot--
                    }
                    return d
                },
                topStack: function(a) {
                    var b = this.isInline() ? this.inlineStack : this.compileStack,
                        d = b[b.length - 1];
                    return !a && d instanceof c ? d.value : d
                },
                quotedString: function(a) {
                    return '"' + a.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029") + '"'
                },
                setupHelper: function(a, b, c) {
                    var d = [];
                    return {
                        params: d,
                        paramsInit: this.setupParams(a, d, c),
                        name: this.nameLookup("helpers", b, "helper"),
                        callParams: ["depth0"].concat(d).join(", "),
                        helperMissingParams: c && ["depth0", this.quotedString(b)].concat(d).join(", ")
                    }
                },
                setupOptions: function(a, b) {
                    var c, d, e, f = [],
                        g = [],
                        h = [];
                    f.push("hash:" + this.popStack()), this.options.stringParams && (f.push("hashTypes:" + this.popStack()), f.push("hashContexts:" + this.popStack())), d = this.popStack(), ((e = this.popStack()) || d) && (e || (this.context.aliases.self = "this", e = "self.noop"), d || (this.context.aliases.self = "this", d = "self.noop"), f.push("inverse:" + d), f.push("fn:" + e));
                    for (var i = 0; i < a; i++) c = this.popStack(), b.push(c), this.options.stringParams && (h.push(this.popStack()), g.push(this.popStack()));
                    return this.options.stringParams && (f.push("contexts:[" + g.join(",") + "]"), f.push("types:[" + h.join(",") + "]")), this.options.data && f.push("data:data"), f
                },
                setupParams: function(a, b, c) {
                    var d = "{" + this.setupOptions(a, b).join(",") + "}";
                    return c ? (this.useRegister("options"), b.push("options"), "options=" + d) : (b.push(d), "")
                }
            };
            for (var i = "break else new var case finally return void catch for switch while continue function this with default if throw delete in try do instanceof typeof abstract enum int short boolean export interface static byte extends long super char final native synchronized class float package throws const goto private transient debugger implements protected volatile double import public let yield".split(" "), j = d.RESERVED_WORDS = {}, k = 0, l = i.length; k < l; k++) j[i[k]] = !0;
            return d.isValidJavaScriptVariableName = function(a) {
                return !(d.RESERVED_WORDS[a] || !/^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(a))
            }, d
        }(d, c);
    return function(a, b, c, d, e) {
        "use strict";
        var f = a,
            g = b,
            h = c.parser,
            i = c.parse,
            j = d.Compiler,
            k = d.compile,
            l = d.precompile,
            m = e,
            n = f.create,
            o = function() {
                var a = n();
                return a.compile = function(b, c) {
                    return k(b, c, a)
                }, a.precompile = function(b, c) {
                    return l(b, c, a)
                }, a.AST = g, a.Compiler = j, a.JavaScriptCompiler = m, a.Parser = h, a.parse = i, a
            };
        return f = o(), f.create = o, f
    }(f, g, i, j, k)
}();
! function(a) {
    var b = [],
        c = [],
        d = {};
    Array.prototype.insert = function(a, b) {
        this.splice(a, 0, b)
    }, d.passwordListener = function(c, d) {
        var e = "" == d.passwordFiled ? ".disabledAutoFillPassword" : d.passwordFiled;
        c.find("[type=password]").length > 0 && c.find("[type=password]").attr("type", "text").addClass("disabledAutoFillPassword"), a(c).on("keyup", e, function() {
            for (var c = a(this).val(), e = c.length, f = this.selectionStart, g = 0; g < e; g++) "*" != c[g] && (void 0 === b[g] ? b[g] = c[g] : f != e && b.insert(f - 1, c[g]));
            a(this).val(c.replace(/./g, "*")), d.debugMode && (console.log("Current keyup position: " + f), console.log("Password length: " + e), console.log("Real password:"), console.log(b))
        })
    }, d.formSubmitListener = function(b, c) {
        var e = "" == c.submitButton ? ".disableAutoFillSubmit" : c.submitButton;
        a(b).on("click", e, function(a) {
            d.restoreInput(b, c), c.callback.call() && (c.debugMode ? console.log(b.serialize()) : b.submit()), c.randomizeInputName && d.randomizeInput(b, c), d.passwordListener(b, c)
        })
    }, d.randomizeInput = function(b, d) {
        b.find("input").each(function(b) {
            c[b] = a(this).attr("name"), a(this).attr("name", Math.random().toString(36).replace(/[^a-z]+/g, ""))
        })
    }, d.restoreInput = function(d, e) {
        e.randomizeInputName && d.find("input").each(function(b) {
            a(this).attr("name", c[b])
        }), e.textToPassword && d.find(e.passwordFiled).attr("type", "password"), d.find(e.passwordFiled).val(b.join(""))
    }, a.fn.disableAutoFill = function(b) {
        var c = a.extend({}, a.fn.disableAutoFill.defaults, b);
        this.find("[type=submit]").length > 0 && this.find("[type=submit]").attr("type", "button").addClass("disableAutoFillSubmit"), this.attr("autocomplete", "off"), c.randomizeInputName && d.randomizeInput(this, c), d.passwordListener(this, c), d.formSubmitListener(this, c)
    }, a.fn.disableAutoFill.defaults = {
        debugMode: !1,
        textToPassword: !0,
        randomizeInputName: !0,
        passwordFiled: "",
        submitButton: "",
        callback: function() {
            return !0
        }
    }
}(jQuery),
function(a) {
    "use strict";
    "function" == typeof define && define.amd ? define(["jquery"], a) : a("object" == typeof exports && "function" == typeof require ? require("jquery") : jQuery)
}(function(a) {
    "use strict";

    function b(c, d) {
        var e = this;
        e.element = c, e.el = a(c), e.suggestions = [], e.badQueries = [], e.selectedIndex = -1, e.currentValue = e.element.value, e.timeoutId = null, e.cachedResponse = {}, e.onChangeTimeout = null, e.onChange = null, e.isLocal = !1, e.suggestionsContainer = null, e.noSuggestionsContainer = null, e.options = a.extend(!0, {}, b.defaults, d), e.classes = {
            selected: "autocomplete-selected",
            suggestion: "autocomplete-suggestion"
        }, e.hint = null, e.hintValue = "", e.selection = null, e.initialize(), e.setOptions(d)
    }

    function c(a, b, c) {
        return -1 !== a.value.toLowerCase().indexOf(c)
    }

    function d(b) {
        return "string" == typeof b ? a.parseJSON(b) : b
    }

    function e(a, b) {
        if (!b) return a.value;
        var c = "(" + g.escapeRegExChars(b) + ")";
        return a.value.replace(new RegExp(c, "gi"), "<strong>$1</strong>").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/&lt;(\/?strong)&gt;/g, "<$1>")
    }

    function f(a, b) {
        return '<div class="autocomplete-group">' + b + "</div>"
    }
    var g = function() {
            return {
                escapeRegExChars: function(a) {
                    return a.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&")
                },
                createNode: function(a) {
                    var b = document.createElement("div");
                    return b.className = a, b.style.position = "absolute", b.style.display = "none", b
                }
            }
        }(),
        h = {
            ESC: 27,
            TAB: 9,
            RETURN: 13,
            LEFT: 37,
            UP: 38,
            RIGHT: 39,
            DOWN: 40
        },
        i = a.noop;
    b.utils = g, a.Autocomplete = b, b.defaults = {
        ajaxSettings: {},
        autoSelectFirst: !1,
        appendTo: "body",
        serviceUrl: null,
        lookup: null,
        onSelect: null,
        width: "auto",
        minChars: 1,
        maxHeight: 300,
        deferRequestBy: 0,
        params: {},
        formatResult: e,
        formatGroup: f,
        delimiter: null,
        zIndex: 9999,
        type: "GET",
        noCache: !1,
        onSearchStart: i,
        onSearchComplete: i,
        onSearchError: i,
        preserveInput: !1,
        containerClass: "autocomplete-suggestions",
        tabDisabled: !1,
        dataType: "text",
        currentRequest: null,
        triggerSelectOnValidInput: !0,
        preventBadQueries: !0,
        lookupFilter: c,
        paramName: "query",
        transformResult: d,
        showNoSuggestionNotice: !1,
        noSuggestionNotice: "No results",
        orientation: "bottom",
        forceFixPosition: !1
    }, b.prototype = {
        initialize: function() {
            var c, d = this,
                e = "." + d.classes.suggestion,
                f = d.classes.selected,
                g = d.options;
            d.element.setAttribute("autocomplete", "nope"), d.noSuggestionsContainer = a('<div class="autocomplete-no-suggestion"></div>').html(this.options.noSuggestionNotice).get(0), d.suggestionsContainer = b.utils.createNode(g.containerClass), c = a(d.suggestionsContainer), c.appendTo(g.appendTo || "body"), "auto" !== g.width && c.css("width", g.width), c.on("mouseover.autocomplete", e, function() {
                d.activate(a(this).data("index"))
            }), c.on("mouseout.autocomplete", function() {
                d.selectedIndex = -1, c.children("." + f).removeClass(f)
            }), c.on("click.autocomplete", e, function() {
                d.select(a(this).data("index"))
            }), c.on("click.autocomplete", function() {
                clearTimeout(d.blurTimeoutId)
            }), d.fixPositionCapture = function() {
                d.visible && d.fixPosition()
            }, a(window).on("resize.autocomplete", d.fixPositionCapture), d.el.on("keydown.autocomplete", function(a) {
                d.onKeyPress(a)
            }), d.el.on("keyup.autocomplete", function(a) {
                d.onKeyUp(a)
            }), d.el.on("blur.autocomplete", function() {
                d.onBlur()
            }), d.el.on("focus.autocomplete", function() {
                d.onFocus()
            }), d.el.on("change.autocomplete", function(a) {
                d.onKeyUp(a)
            }), d.el.on("input.autocomplete", function(a) {
                d.onKeyUp(a)
            })
        },
        onFocus: function() {
            var a = this;
            a.fixPosition(), a.el.val().length >= a.options.minChars && a.onValueChange()
        },
        onBlur: function() {
            var a = this;
            a.blurTimeoutId = setTimeout(function() {
                a.hide()
            }, 200)
        },
        abortAjax: function() {
            var a = this;
            a.currentRequest && (a.currentRequest.abort(), a.currentRequest = null)
        },
        setOptions: function(b) {
            var c = this,
                d = a.extend({}, c.options, b);
            c.isLocal = Array.isArray(d.lookup), c.isLocal && (d.lookup = c.verifySuggestionsFormat(d.lookup)), d.orientation = c.validateOrientation(d.orientation, "bottom"), a(c.suggestionsContainer).css({
                "max-height": d.maxHeight + "px",
                width: d.width + "px",
                "z-index": d.zIndex
            }), this.options = d
        },
        clearCache: function() {
            this.cachedResponse = {}, this.badQueries = []
        },
        clear: function() {
            this.clearCache(), this.currentValue = "", this.suggestions = []
        },
        disable: function() {
            var a = this;
            a.disabled = !0, clearTimeout(a.onChangeTimeout), a.abortAjax()
        },
        enable: function() {
            this.disabled = !1
        },
        fixPosition: function() {
            var b = this,
                c = a(b.suggestionsContainer),
                d = c.parent().get(0);
            if (d === document.body || b.options.forceFixPosition) {
                var e = b.options.orientation,
                    f = c.outerHeight(),
                    g = b.el.outerHeight(),
                    h = b.el.offset(),
                    i = {
                        top: h.top,
                        left: h.left
                    };
                if ("auto" === e) {
                    var j = a(window).height(),
                        k = a(window).scrollTop(),
                        l = -k + h.top - f,
                        m = k + j - (h.top + g + f);
                    e = Math.max(l, m) === l ? "top" : "bottom"
                }
                if (i.top += "top" === e ? -f : g, d !== document.body) {
                    var n, o = c.css("opacity");
                    b.visible || c.css("opacity", 0).show(), n = c.offsetParent().offset(), i.top -= n.top, i.top += d.scrollTop, i.left -= n.left, b.visible || c.css("opacity", o).hide()
                }
                "auto" === b.options.width && (i.width = b.el.outerWidth() + "px"), c.css(i)
            }
        },
        isCursorAtEnd: function() {
            var a, b = this,
                c = b.el.val().length,
                d = b.element.selectionStart;
            return "number" == typeof d ? d === c : !document.selection || (a = document.selection.createRange(), a.moveStart("character", -c), c === a.text.length)
        },
        onKeyPress: function(a) {
            var b = this;
            if (!b.disabled && !b.visible && a.which === h.DOWN && b.currentValue) return void b.suggest();
            if (!b.disabled && b.visible) {
                switch (a.which) {
                    case h.ESC:
                        b.el.val(b.currentValue), b.hide();
                        break;
                    case h.RIGHT:
                        if (b.hint && b.options.onHint && b.isCursorAtEnd()) {
                            b.selectHint();
                            break
                        }
                        return;
                    case h.TAB:
                        if (b.hint && b.options.onHint) return void b.selectHint();
                        if (-1 === b.selectedIndex) return void b.hide();
                        if (b.select(b.selectedIndex), !1 === b.options.tabDisabled) return;
                        break;
                    case h.RETURN:
                        if (-1 === b.selectedIndex) return void b.hide();
                        b.select(b.selectedIndex);
                        break;
                    case h.UP:
                        b.moveUp();
                        break;
                    case h.DOWN:
                        b.moveDown();
                        break;
                    default:
                        return
                }
                a.stopImmediatePropagation(), a.preventDefault()
            }
        },
        onKeyUp: function(a) {
            var b = this;
            if (!b.disabled) {
                switch (a.which) {
                    case h.UP:
                    case h.DOWN:
                        return
                }
                clearTimeout(b.onChangeTimeout), b.currentValue !== b.el.val() && (b.findBestHint(), b.options.deferRequestBy > 0 ? b.onChangeTimeout = setTimeout(function() {
                    b.onValueChange()
                }, b.options.deferRequestBy) : b.onValueChange())
            }
        },
        onValueChange: function() {
            if (this.ignoreValueChange) return void(this.ignoreValueChange = !1);
            var b = this,
                c = b.options,
                d = b.el.val(),
                e = b.getQuery(d);
            return b.selection && b.currentValue !== e && (b.selection = null, (c.onInvalidateSelection || a.noop).call(b.element)), clearTimeout(b.onChangeTimeout), b.currentValue = d, b.selectedIndex = -1, c.triggerSelectOnValidInput && b.isExactMatch(e) ? void b.select(0) : void(e.length < c.minChars ? b.hide() : b.getSuggestions(e))
        },
        isExactMatch: function(a) {
            var b = this.suggestions;
            return 1 === b.length && b[0].value.toLowerCase() === a.toLowerCase()
        },
        getQuery: function(b) {
            var c, d = this.options.delimiter;
            return d ? (c = b.split(d), a.trim(c[c.length - 1])) : b
        },
        getSuggestionsLocal: function(b) {
            var c, d = this,
                e = d.options,
                f = b.toLowerCase(),
                g = e.lookupFilter,
                h = parseInt(e.lookupLimit, 10);
            return c = {
                suggestions: a.grep(e.lookup, function(a) {
                    return g(a, b, f)
                })
            }, h && c.suggestions.length > h && (c.suggestions = c.suggestions.slice(0, h)), c
        },
        getSuggestions: function(b) {
            var c, d, e, f, g = this,
                h = g.options,
                i = h.serviceUrl;
            if (h.params[h.paramName] = b, !1 !== h.onSearchStart.call(g.element, h.params)) {
                if (d = h.ignoreParams ? null : h.params, a.isFunction(h.lookup)) return void h.lookup(b, function(a) {
                    g.suggestions = a.suggestions, g.suggest(), h.onSearchComplete.call(g.element, b, a.suggestions)
                });
                g.isLocal ? c = g.getSuggestionsLocal(b) : (a.isFunction(i) && (i = i.call(g.element, b)), e = i + "?" + a.param(d || {}), c = g.cachedResponse[e]), c && Array.isArray(c.suggestions) ? (g.suggestions = c.suggestions, g.suggest(), h.onSearchComplete.call(g.element, b, c.suggestions)) : g.isBadQuery(b) ? h.onSearchComplete.call(g.element, b, []) : (g.abortAjax(), f = {
                    url: i,
                    data: d,
                    type: h.type,
                    dataType: h.dataType
                }, a.extend(f, h.ajaxSettings), g.currentRequest = a.ajax(f).done(function(a) {
                    var c;
                    g.currentRequest = null, c = h.transformResult(a, b), g.processResponse(c, b, e), h.onSearchComplete.call(g.element, b, c.suggestions)
                }).fail(function(a, c, d) {
                    h.onSearchError.call(g.element, b, a, c, d)
                }))
            }
        },
        isBadQuery: function(a) {
            if (!this.options.preventBadQueries) return !1;
            for (var b = this.badQueries, c = b.length; c--;)
                if (0 === a.indexOf(b[c])) return !0;
            return !1
        },
        hide: function() {
            var b = this,
                c = a(b.suggestionsContainer);
            a.isFunction(b.options.onHide) && b.visible && b.options.onHide.call(b.element, c), b.visible = !1, b.selectedIndex = -1, clearTimeout(b.onChangeTimeout), a(b.suggestionsContainer).hide(), b.signalHint(null)
        },
        suggest: function() {
            if (!this.suggestions.length) return void(this.options.showNoSuggestionNotice ? this.noSuggestions() : this.hide());
            var b, c = this,
                d = c.options,
                e = d.groupBy,
                f = d.formatResult,
                g = c.getQuery(c.currentValue),
                h = c.classes.suggestion,
                i = c.classes.selected,
                j = a(c.suggestionsContainer),
                k = a(c.noSuggestionsContainer),
                l = d.beforeRender,
                m = "",
                n = function(a, c) {
                    var f = a.data[e];
                    return b === f ? "" : (b = f, d.formatGroup(a, b))
                };
            return d.triggerSelectOnValidInput && c.isExactMatch(g) ? void c.select(0) : (a.each(c.suggestions, function(a, b) {
                e && (m += n(b, g, a)), m += '<div class="' + h + '" data-index="' + a + '">' + f(b, g, a) + "</div>"
            }), this.adjustContainerWidth(), k.detach(), j.html(m), a.isFunction(l) && l.call(c.element, j, c.suggestions), c.fixPosition(), j.show(), d.autoSelectFirst && (c.selectedIndex = 0, j.scrollTop(0), j.children("." + h).first().addClass(i)), c.visible = !0, void c.findBestHint())
        },
        noSuggestions: function() {
            var b = this,
                c = b.options.beforeRender,
                d = a(b.suggestionsContainer),
                e = a(b.noSuggestionsContainer);
            this.adjustContainerWidth(), e.detach(), d.empty(), d.append(e), a.isFunction(c) && c.call(b.element, d, b.suggestions), b.fixPosition(), d.show(), b.visible = !0
        },
        adjustContainerWidth: function() {
            var b, c = this,
                d = c.options,
                e = a(c.suggestionsContainer);
            "auto" === d.width ? (b = c.el.outerWidth(), e.css("width", b > 0 ? b : 300)) : "flex" === d.width && e.css("width", "")
        },
        findBestHint: function() {
            var b = this,
                c = b.el.val().toLowerCase(),
                d = null;
            c && (a.each(b.suggestions, function(a, b) {
                var e = 0 === b.value.toLowerCase().indexOf(c);
                return e && (d = b), !e
            }), b.signalHint(d))
        },
        signalHint: function(b) {
            var c = "",
                d = this;
            b && (c = d.currentValue + b.value.substr(d.currentValue.length)), d.hintValue !== c && (d.hintValue = c, d.hint = b, (this.options.onHint || a.noop)(c))
        },
        verifySuggestionsFormat: function(b) {
            return b.length && "string" == typeof b[0] ? a.map(b, function(a) {
                return {
                    value: a,
                    data: null
                }
            }) : b
        },
        validateOrientation: function(b, c) {
            return b = a.trim(b || "").toLowerCase(), -1 === a.inArray(b, ["auto", "bottom", "top"]) && (b = c), b
        },
        processResponse: function(a, b, c) {
            var d = this,
                e = d.options;
            a.suggestions = d.verifySuggestionsFormat(a.suggestions), e.noCache || (d.cachedResponse[c] = a, e.preventBadQueries && !a.suggestions.length && d.badQueries.push(b)), b === d.getQuery(d.currentValue) && (d.suggestions = a.suggestions, d.suggest())
        },
        activate: function(b) {
            var c, d = this,
                e = d.classes.selected,
                f = a(d.suggestionsContainer),
                g = f.find("." + d.classes.suggestion);
            return f.find("." + e).removeClass(e), d.selectedIndex = b, -1 !== d.selectedIndex && g.length > d.selectedIndex ? (c = g.get(d.selectedIndex), a(c).addClass(e), c) : null
        },
        selectHint: function() {
            var b = this,
                c = a.inArray(b.hint, b.suggestions);
            b.select(c)
        },
        select: function(a) {
            var b = this;
            b.hide(), b.onSelect(a)
        },
        moveUp: function() {
            var b = this;
            if (-1 !== b.selectedIndex) return 0 === b.selectedIndex ? (a(b.suggestionsContainer).children("." + b.classes.suggestion).first().removeClass(b.classes.selected), b.selectedIndex = -1, b.ignoreValueChange = !1, b.el.val(b.currentValue), void b.findBestHint()) : void b.adjustScroll(b.selectedIndex - 1)
        },
        moveDown: function() {
            var a = this;
            a.selectedIndex !== a.suggestions.length - 1 && a.adjustScroll(a.selectedIndex + 1)
        },
        adjustScroll: function(b) {
            var c = this,
                d = c.activate(b);
            if (d) {
                var e, f, g, h = a(d).outerHeight();
                e = d.offsetTop, f = a(c.suggestionsContainer).scrollTop(), g = f + c.options.maxHeight - h, e < f ? a(c.suggestionsContainer).scrollTop(e) : e > g && a(c.suggestionsContainer).scrollTop(e - c.options.maxHeight + h), c.options.preserveInput || (c.ignoreValueChange = !0, c.el.val(c.getValue(c.suggestions[b].value))), c.signalHint(null)
            }
        },
        onSelect: function(b) {
            var c = this,
                d = c.options.onSelect,
                e = c.suggestions[b];
            c.currentValue = c.getValue(e.value), c.currentValue === c.el.val() || c.options.preserveInput || c.el.val(c.currentValue), c.signalHint(null), c.suggestions = [], c.selection = e, a.isFunction(d) && d.call(c.element, e)
        },
        getValue: function(a) {
            var b, c, d = this,
                e = d.options.delimiter;
            return e ? (b = d.currentValue, c = b.split(e), 1 === c.length ? a : b.substr(0, b.length - c[c.length - 1].length) + a) : a
        },
        dispose: function() {
            var b = this;
            b.el.off(".autocomplete").removeData("autocomplete"), a(window).off("resize.autocomplete", b.fixPositionCapture), a(b.suggestionsContainer).remove()
        }
    }, a.fn.devbridgeAutocomplete = function(c, d) {
        var e = "autocomplete";
        return arguments.length ? this.each(function() {
            var f = a(this),
                g = f.data(e);
            "string" == typeof c ? g && "function" == typeof g[c] && g[c](d) : (g && g.dispose && g.dispose(), g = new b(this, c), f.data(e, g))
        }) : this.first().data(e)
    }, a.fn.autocomplete || (a.fn.autocomplete = a.fn.devbridgeAutocomplete)
});